(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode('._modal_p4suz_1{background-color:#fff;border-radius:8px;bottom:auto;left:50%;position:absolute;right:auto;top:50%;transform:translate(-50%,-50%);height:100%;width:100%;overflow-y:scroll}[dir=rtl] ._modal_p4suz_1{right:50%;left:auto;transform:translate(50%,-50%)}@media (min-width: 768px){._modal_p4suz_1{width:initial;height:auto}}._modal_p4suz_1:focus{outline:none}._container_p4suz_24{padding:40px 16px 16px;max-width:680px;position:relative;margin:0 auto}._container_p4suz_24 ul{padding-inline-start:0}@media (min-width: 768px){._container_p4suz_24{padding:40px 80px;width:680px;height:415px}}._overlay_p4suz_41{background-color:#121b4566;bottom:0;left:0;position:fixed;right:0;top:0;z-index:40}._closeIcon_p4suz_51{position:absolute;top:24px;left:10px;width:24px;height:24px;z-index:10;cursor:pointer}[dir=rtl] ._closeIcon_p4suz_51{left:auto;right:10px}@media (min-width: 768px){._closeIcon_p4suz_51{top:24px;left:auto;right:10px}[dir=rtl] ._closeIcon_p4suz_51{right:auto;left:10px}._closeIcon_p4suz_51:before,._closeIcon_p4suz_51:after{position:absolute;content:"";width:18px;height:3px;background:#102d6f}._closeIcon_p4suz_51:before{transform:rotate(45deg)}[dir=rtl] ._closeIcon_p4suz_51:before{transform:rotate(-45deg)}._closeIcon_p4suz_51:after{transform:rotate(-45deg)}[dir=rtl] ._closeIcon_p4suz_51:after{transform:rotate(45deg)}}._tabs_p4suz_81{list-style:none;display:flex;justify-content:center;align-items:center}._tabs_p4suz_81 li{flex:1;cursor:pointer;color:#b3b6c6;text-align:center;font-size:16px;font-weight:500;padding-bottom:12px;border-bottom:2px solid #C8D4FC}._tabs_p4suz_81 li span{margin-left:10px}[dir=rtl] ._tabs_p4suz_81 li span{margin-left:0;margin-right:10px}@media (max-width: 431px){._tabs_p4suz_81 li:first-child{padding-bottom:30px}._tabs_p4suz_81 li:last-child{display:flex;align-items:center}}._tabs_p4suz_81 ._selectedCurr_p4suz_109{background-color:#ebf1ff;border-radius:4px;padding:4px;width:24px;height:24px}._tabs_p4suz_81 ._active_p4suz_116{color:#4972f4;border-bottom:2px solid #4972F4}._languageContainer_p4suz_121{margin-top:24px;display:grid;gap:12px;grid-template-columns:repeat(2,1fr)}@media (max-width: 767px){._languageContainer_p4suz_121{grid-template-columns:1fr}}._languageContainer_p4suz_121 li{cursor:pointer;padding:16px 24px;border:1px solid #E6E8F0;border-radius:8px;display:flex;align-items:center}._languageContainer_p4suz_121 li svg{margin-right:16px}[dir=rtl] ._languageContainer_p4suz_121 li svg{margin-right:0;margin-left:16px}._currencyContainer_p4suz_144{margin-top:24px;display:grid;gap:12px;grid-template-columns:repeat(1,1fr)}._currencyContainer_p4suz_144 li{cursor:pointer;padding:16px 24px;border:1px solid #E6E8F0;border-radius:8px;display:flex;align-items:center;font-size:16px}._currencyContainer_p4suz_144 li span{font-size:14px;color:#b3b6c6}._currencyContainer_p4suz_144 li svg{width:32px;height:32px;margin-right:16px;border-radius:50%}[dir=rtl] ._currencyContainer_p4suz_144 li svg{margin-right:0;margin-left:16px}._activeOption_p4suz_170{border:2px solid #4972F4!important}._profileComponent_dm8r0_1{background-color:#e6e9f0;position:relative;transition:all .1s,visibility 0s;display:flex;flex-flow:row;justify-content:center;align-items:center;margin-right:10px;z-index:20;gap:8px;border-radius:18px;padding-right:12px;max-width:200px}[dir=rtl] ._profileComponent_dm8r0_1{margin-right:0;margin-left:10px;padding-right:0;padding-left:12px}._profileComponent_dm8r0_1._noPadding_dm8r0_16{padding:0}._profileComponent_dm8r0_1:after{top:25px;left:52%;border:14px solid transparent;content:" ";height:0;width:0;position:absolute;pointer-events:none;opacity:0;border-bottom-color:#fff;margin-left:-15px;filter:drop-shadow(0 -2px 5px rgba(0,0,0,.1019607843))}[dir=rtl] ._profileComponent_dm8r0_1:after{left:auto;right:52%;margin-left:0;margin-right:-15px}@media (min-width: 992px){._profileComponent_dm8r0_1:after{top:32px}}._profileComponent_dm8r0_1:hover,._profileComponent_dm8r0_1:focus,._profileComponent_dm8r0_1._open_dm8r0_38{cursor:pointer}._profileComponent_dm8r0_1:hover ._dropdownIcon_dm8r0_41,._profileComponent_dm8r0_1:focus ._dropdownIcon_dm8r0_41,._profileComponent_dm8r0_1._open_dm8r0_38 ._dropdownIcon_dm8r0_41{fill:#305cea}._profileComponent_dm8r0_1:hover ._profileIcon_dm8r0_44,._profileComponent_dm8r0_1:focus ._profileIcon_dm8r0_44,._profileComponent_dm8r0_1._open_dm8r0_38 ._profileIcon_dm8r0_44{fill:#305cea}._profileComponent_dm8r0_1._open_dm8r0_38:after{opacity:1}._profileComponent_dm8r0_1._open_dm8r0_38 ._dropdownIcon_dm8r0_41{transform:rotate(180deg)}[dir=rtl] ._profileComponent_dm8r0_1._open_dm8r0_38 ._dropdownIcon_dm8r0_41{transform:rotate(-180deg)}._profileComponent_dm8r0_1._open_dm8r0_38 ._list_dm8r0_53{display:block}._profileComponent_dm8r0_1 ._username_dm8r0_56{color:#305cea;font-size:12px;font-weight:700}._profileComponent_dm8r0_1 ._dropdownIcon_dm8r0_41{transition:all .1s,visibility 0s;fill:#102d6f;position:absolute;right:-19px;width:12px}[dir=rtl] ._profileComponent_dm8r0_1 ._dropdownIcon_dm8r0_41{right:auto;left:-19px}._profileComponent_dm8r0_1 ._list_dm8r0_53{display:none;border-radius:4px;box-shadow:0 3px 10px #00000029;list-style:none;position:absolute;padding:0;margin:0;right:0;top:53px;font-size:0;background-color:#fff;width:288px}[dir=rtl] ._profileComponent_dm8r0_1 ._list_dm8r0_53{right:auto;left:0}@media (min-width: 992px){._profileComponent_dm8r0_1 ._list_dm8r0_53{top:60px}}._profileComponent_dm8r0_1 ._userMail_dm8r0_87{display:flex;align-items:center;justify-content:center;padding:16px;gap:8px}._profileComponent_dm8r0_1 ._userMail_dm8r0_87 ._profileIcon_dm8r0_44{background-color:#ebf1ff}._profileComponent_dm8r0_1 ._userMail_dm8r0_87 ._profileIcon_dm8r0_44 svg{color:#4972f4}._profileComponent_dm8r0_1 ._profileIcon_dm8r0_44{background-color:#4972f4}._separator_dm8r0_104{margin:0 8px;border:0;border-top:1px solid #f1f1f3}._listItem_dm8r0_110{padding:0}._listItem_dm8r0_110._logoutButton_dm8r0_113{display:flex;align-items:center;height:72px}._listItem_dm8r0_110._logoutButton_dm8r0_113>*{font-size:14px;font-weight:500;color:#112d6f!important;gap:16px;padding:0 26px}._listItem_dm8r0_110._logoutButton_dm8r0_113 svg{width:15px;height:13px;color:#8695b6}._listItem_dm8r0_110._logoutButton_dm8r0_113:hover{background-color:#f5f8ff}._listItem_dm8r0_110._logoutButton_dm8r0_113:hover>*{color:#305cea!important}._listItem_dm8r0_110._logoutButton_dm8r0_113:hover svg{color:#305cea}._listItem_dm8r0_110._addAccountButton_dm8r0_139{display:flex;gap:12px;align-items:center;height:52px;padding:0 24px}._listItem_dm8r0_110._addAccountButton_dm8r0_139>*{font-size:14px;font-weight:500;color:#112d6f!important;gap:12px;padding:0}._listItem_dm8r0_110._addAccountButton_dm8r0_139 svg{height:24px;width:24px}._listItem_dm8r0_110:last-child{border-bottom:none}._listItem_dm8r0_110:focus,._listItem_dm8r0_110:hover{color:#305cea;background-color:#f5f8ff;text-decoration:none}._listItem_dm8r0_110:focus ._icon_dm8r0_165 path,._listItem_dm8r0_110:hover ._icon_dm8r0_165 path{fill:#305cea!important}._listItem_dm8r0_110:focus ._profile-component__icon_dm8r0_168 path,._listItem_dm8r0_110:hover ._profile-component__icon_dm8r0_168 path{fill:#305cea!important}._button_dm8r0_172{margin:15px 0;max-height:46px}._rows_dm8r0_177{display:flex;flex-flow:column;align-items:flex-start}._grow_dm8r0_183{flex:1}._overflow_dm8r0_187{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._name_dm8r0_194{font-size:14px;font-weight:500;color:#102d6f}._email_dm8r0_200{font-size:10px;font-weight:400;color:#4e4e4e}._listItem_1c7ms_1{padding:0}._listItem_1c7ms_1 ._link_1c7ms_4{display:flex;gap:16px;align-items:center;color:#102d6f;font-size:13px;font-weight:500;padding:16px 24px;text-align:left;text-decoration:none;transition:all .1s,visibility 0s;height:50px}[dir=rtl] ._listItem_1c7ms_1 ._link_1c7ms_4{text-align:right}._listItem_1c7ms_1 ._link_1c7ms_4:focus{text-decoration:none}._listItem_1c7ms_1 ._link_1c7ms_4:hover{color:#305cea;text-decoration:none}._listItem_1c7ms_1._logoutButton_1c7ms_24{display:flex;align-items:center;justify-content:center}._listItem_1c7ms_1._logoutButton_1c7ms_24:hover{background-color:#fff;cursor:auto}._listItem_1c7ms_1:last-child{border-bottom:none}._listItem_1c7ms_1:focus,._listItem_1c7ms_1:hover{color:#305cea;background-color:#f5f8ff;text-decoration:none}._listItem_1c7ms_1:focus ._icon_1c7ms_41 path,._listItem_1c7ms_1:hover ._icon_1c7ms_41 path{fill:#305cea!important}._listItem_1c7ms_1:focus ._profile-component__icon_1c7ms_44 path,._listItem_1c7ms_1:hover ._profile-component__icon_1c7ms_44 path{fill:#305cea!important}._icon_1c7ms_41{width:18px}._icon_1c7ms_41 path{fill:#8695b6}._notificationIcon_1c7ms_55{width:22px}._separator_1c7ms_59{margin:0 8px;border:0;border-top:1px solid #f1f1f3}._button_1c7ms_65{margin:15px 0;max-height:46px}._notification_1c7ms_55{display:flex;align-items:center;justify-content:space-between;width:100%}._notificationCount_1c7ms_77{align-items:center;background-color:#305cea;color:#fff;border-radius:4px;font-size:11px;font-weight:700;height:22px;justify-content:center;width:22px;display:flex}._listItem_1d6w1_1{display:flex;gap:12px;align-items:center;height:52px;padding:0 24px}._listItem_1d6w1_1:hover{background-color:#f5f8ff}._listItem_1d6w1_1:hover ._text_1d6w1_11,._listItem_1d6w1_1._active_1d6w1_14 ._text_1d6w1_11{color:#4972f4}._listItem_1d6w1_1._disabled_1d6w1_17{pointer-events:none;opacity:.5;cursor:not-allowed}._text_1d6w1_11{font-size:14px;font-weight:500;color:#112d6f;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._icon_1d6w1_33{height:24px;width:24px}._icon_1c0n7_1{border-radius:50%;background-color:#8695b6;display:flex;align-items:center;justify-content:center;flex:0 0 auto}._icon_1c0n7_1._active_1c0n7_9{background-color:#4972f4}._icon_1c0n7_1 svg{color:#fff}._listItem_1dgax_1{display:flex;gap:12px;align-items:center;padding:20px 24px;font-size:14px;font-weight:500;color:#112d6f;border-bottom:1px solid #f1f1f3;border-top:1px solid #f1f1f3}._listItem_1dgax_1:hover{background-color:#f5f8ff}._listItem_1dgax_1:hover ._text_1dgax_15{color:#4972f4}._small_1dgax_19{font-size:10px;font-weight:400}._icon_1dgax_24{height:24px;width:24px}body[dir=rtl] ._chevron_1dgax_29{transform:rotate(180deg)}[dir=rtl] body[dir=rtl] ._chevron_1dgax_29{transform:rotate(-180deg)}._fliped_1dgax_33{transform:rotate(180deg)}[dir=rtl] ._fliped_1dgax_33{transform:rotate(-180deg)}body[dir=rtl] ._fliped_1dgax_33{transform:rotate(0)}._rows_1dgax_40{display:flex;flex-flow:column;align-items:flex-start}._grow_1dgax_46{flex:1}._overflow_1dgax_50{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._button_1jru5_1{align-items:center;background:#305cea;border-radius:4px;border:2px solid #305cea;color:#fff;cursor:pointer;display:inline-flex;font-size:16px;font-weight:500;justify-content:center;outline:none;padding:15px 45px;text-decoration:none;transition:all .1s,visibility 0s}._button_1jru5_1._primary_1jru5_17{text-transform:capitalize}._button_1jru5_1._primary_1jru5_17:hover{background-color:#6c8bf5;border-color:#6c8bf5}._button_1jru5_1._primary_1jru5_17:focus{background-color:#3656c0;border-color:#3656c0}._button_1jru5_1._primary_1jru5_17:disabled{background-color:#c6d2fa;border-color:#c6d2fa;cursor:not-allowed;pointer-events:none}._button_1jru5_1._secondary_1jru5_34{background:#fff;color:#305cea;text-transform:capitalize}._button_1jru5_1._secondary_1jru5_34:hover{border-color:#6c8bf5;color:#6c8bf5}._button_1jru5_1._secondary_1jru5_34:focus{background-color:#3656c0;border-color:#3656c0;color:#fff}._button_1jru5_1._secondary_1jru5_34:disabled{border-color:#c6d2fa;color:#c6d2fa;cursor:not-allowed}._button_1jru5_1._tertiary_1jru5_53{color:#305cea;background-color:#ebf1ff;border-color:#ebf1ff}._button_1jru5_1._tertiary_1jru5_53:hover{background-color:#305cea;color:#fff;border-color:#305cea}._button_1jru5_1._borderless_1jru5_63,._button_1jru5_1._link_1jru5_63{background:transparent;border:none;color:#305cea}._button_1jru5_1._borderless_1jru5_63:hover,._button_1jru5_1._link_1jru5_63:hover{color:#6c8bf5}._button_1jru5_1._borderless_1jru5_63:hover._hasTransition_1jru5_71 ._icon_1jru5_74,._button_1jru5_1._link_1jru5_63:hover._hasTransition_1jru5_71 ._icon_1jru5_74{transform:rotate(90deg);transition:transform .2s ease-in-out}[dir=rtl] ._button_1jru5_1._borderless_1jru5_63:hover._hasTransition_1jru5_71 ._icon_1jru5_74,[dir=rtl] ._button_1jru5_1._link_1jru5_63:hover._hasTransition_1jru5_71 ._icon_1jru5_74{transform:rotate(-90deg)}._button_1jru5_1._borderless_1jru5_63:focus,._button_1jru5_1._link_1jru5_63:focus{color:#3656c0}._button_1jru5_1._borderless_1jru5_63:disabled,._button_1jru5_1._link_1jru5_63:disabled{color:#c6d2fa;cursor:not-allowed}._button_1jru5_1._borderless_1jru5_63:disabled ._icon_1jru5_74,._button_1jru5_1._link_1jru5_63:disabled ._icon_1jru5_74{transform:rotate(0);transition:unset}[dir=rtl] ._button_1jru5_1._borderless_1jru5_63:disabled ._icon_1jru5_74,[dir=rtl] ._button_1jru5_1._link_1jru5_63:disabled ._icon_1jru5_74{transform:rotate(180deg)}._button_1jru5_1._link_1jru5_63{font-weight:700}._icon_1jru5_74{margin:0 0 0 8px;transform:rotate(0);transition:unset;width:14px}[dir=rtl] ._icon_1jru5_74{margin:0 8px 0 0;transform:rotate(180deg)}._ldsRing_xh4nr_1{display:inline-block;position:relative;width:24px;height:24px;border-radius:50%;overflow:hidden}._ldsRing_xh4nr_1 div{box-sizing:border-box;display:block;position:absolute;width:24px;height:24px;border:3px solid #3d72fc;border-radius:50%;animation:_lds-ring_xh4nr_1 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:#3d72fc transparent transparent transparent}._ldsRing_xh4nr_1 div:nth-child(1){animation-delay:-.45s}._ldsRing_xh4nr_1 div:nth-child(2){animation-delay:-.3s}._ldsRing_xh4nr_1 div:nth-child(3){animation-delay:-.15s}@keyframes _lds-ring_xh4nr_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}._container_feg5d_1{background:#fff;font-family:Red Hat Text,sans-serif;box-shadow:0 6px 10px #4972f40d;color:#fff;width:100%;display:flex;justify-content:center;position:relative}._container_feg5d_1 ._header_feg5d_11{width:100%;max-width:1440px;top:0;z-index:21;padding:14px 16px;display:flex;align-items:center;height:78px;grid-row:1/2}@media (min-width: 992px){._container_feg5d_1{margin-bottom:40px}}@media (min-width: 1040px){._container_feg5d_1{height:auto}}._logo_feg5d_33{display:flex;height:51px;width:197px}._componentsRow_feg5d_39{display:flex;align-items:center;margin:0 0 0 auto}[dir=rtl] ._componentsRow_feg5d_39{margin:0 auto 0 0}@media (min-width: 1024px){._componentsRow_feg5d_39{margin:0}}._navMenu_feg5d_50{text-align:right;margin:0 5px 0 auto;display:none;position:absolute;top:78px;left:0;width:100%;z-index:11;background-color:#fff}[dir=rtl] ._navMenu_feg5d_50{text-align:left;margin:0 auto 0 5px;left:auto;right:0}@media (min-width: 1024px){._navMenu_feg5d_50{display:block;position:static;width:auto}}._navMenu_feg5d_50._open_feg5d_68{display:block;z-index:20}._navMenu_feg5d_50._open_feg5d_68 ._navMenulist_feg5d_72{display:block}._navMenuList_feg5d_76{font-size:0;margin:0;list-style:none;display:block;position:absolute;background-color:#fff;left:0;top:100%;width:100%;text-align:left;padding:60px 40px 20px;box-shadow:0 6px 10px #4972f40d}[dir=rtl] ._navMenuList_feg5d_76{left:auto;right:0;text-align:right}._navMenuList_feg5d_76 li:last-child{position:absolute;content:"";bottom:100%;right:0;width:60px;height:60px;background-color:transparent;cursor:pointer}[dir=rtl] ._navMenuList_feg5d_76 li:last-child{right:auto;left:0}@media (min-width: 1024px){._navMenuList_feg5d_76 li:last-child{display:none}}@media (min-width: 1024px){._navMenuList_feg5d_76{display:flex;width:auto;text-align:left;position:static;padding:0;box-shadow:none}[dir=rtl] ._navMenuList_feg5d_76{text-align:right}}._navTrigger_feg5d_116{height:48px;width:48px;flex:0 0 48px;margin-left:5px;border:2px solid #fff;background:none;transition:all .1s,visibility 0s;display:block;padding:0;cursor:pointer}[dir=rtl] ._navTrigger_feg5d_116{margin-left:0;margin-right:5px}@media (min-width: 1024px){._navTrigger_feg5d_116{display:none}}._navTrigger_feg5d_116 span{background:#102d6f;display:block;height:2px;width:16px;margin:3px auto;transition:all .1s,visibility 0s}._navTrigger_feg5d_116._open_feg5d_68{position:relative;top:2px}._navTrigger_feg5d_116._open_feg5d_68 span{background:#305cea}._navTrigger_feg5d_116._open_feg5d_68 span:nth-child(1){transform:translateY(3px) rotate(45deg)}[dir=rtl] ._navTrigger_feg5d_116._open_feg5d_68 span:nth-child(1){transform:translateY(3px) rotate(-45deg)}._navTrigger_feg5d_116._open_feg5d_68 span:nth-child(2){opacity:0}._navTrigger_feg5d_116._open_feg5d_68 span:nth-child(3){transform:translateY(-7px) rotate(-45deg)}[dir=rtl] ._navTrigger_feg5d_116._open_feg5d_68 span:nth-child(3){transform:translateY(-7px) rotate(45deg)}._languageSwitcher_feg5d_158{margin-right:10px;margin-top:3px}[dir=rtl] ._languageSwitcher_feg5d_158{margin-right:0;margin-left:10px}._languageSwitcher_feg5d_158 ._icon_feg5d_162{cursor:pointer;background-color:#e6e9f0;padding:7px;border-radius:50%}._languageSwitcher_feg5d_158 svg{width:36px;height:36px}@media (max-width: 1024px){._languageSwitcher_feg5d_158{display:none}}._navlistItem_feg5d_178{display:flex;align-items:center;padding:12px 0;text-align:left;font-size:16px;font-weight:500;line-height:18px;color:#102d6f}[dir=rtl] ._navlistItem_feg5d_178{text-align:right}@media (min-width: 1024px){._navlistItem_feg5d_178{display:none}}._navlistItem_feg5d_178 img,._navlistItem_feg5d_178 svg{width:22px;margin-right:10px}[dir=rtl] ._navlistItem_feg5d_178 img,[dir=rtl] ._navlistItem_feg5d_178 svg{margin-right:0;margin-left:10px}._navlistItem_feg5d_178:hover,._navlistItem_feg5d_178:focus{color:#305cea;text-decoration:none}._borderTop_feg5d_202{padding-top:24px;border-top:1px solid #e6e8f0;margin-top:12px}._fullScreen_feg5d_208{height:calc(100vh - 78px)}._container_1ioxp_1 ._header_1ioxp_1{display:grid;gap:8px;grid-template-columns:minmax(57px,1fr) 1fr}@media (min-width: 1024px){._container_1ioxp_1 ._header_1ioxp_1{grid-template-columns:minmax(57px,1fr) auto 1fr}}._container_1ioxp_1 ._header_1ioxp_1>*:last-child{justify-self:flex-end}._container_1ioxp_1 ._reactiveLogo_1ioxp_14{width:100%}._container_1ioxp_1 ._logoWrapper_1ioxp_17{display:flex;align-items:center}._container_1ioxp_1 ._logo_1ioxp_17{height:51px;width:197px}._container_1ioxp_1 ._logoSmall_1ioxp_25{height:51px}._navlistItem_1tl7r_1{display:block;padding:12px 0;text-align:left;width:100%}[dir=rtl] ._navlistItem_1tl7r_1{text-align:right}._navlistItem_1tl7r_1._active_1tl7r_7 ._link_1tl7r_7{color:#305cea}@media (min-width: 1024px){._navlistItem_1tl7r_1{display:inline-flex;align-items:center;padding:12px 16px}}@media (min-width: 1100px){._navlistItem_1tl7r_1{padding:12px 20px}}._link_1tl7r_7{display:block;font-size:16px;font-weight:500;color:#102d6f;text-decoration:none;transition:all .1s,visibility 0s;line-height:18px}@media (min-width: 1024px){._link_1tl7r_7{display:inline;font-weight:500;font-size:16px}}._link_1tl7r_7._active_1tl7r_7,._link_1tl7r_7:hover,._link_1tl7r_7:focus{color:#305cea;text-decoration:none}._banner_82yj4_1{background-color:#102d6f}._text_82yj4_5{font-size:16px;font-weight:400;color:#fff}._icon_82yj4_11{display:inline-flex;color:#f7931a}._button_82yj4_16{text-decoration:none;font-weight:500;color:#f7931a!important;padding:0 8px}._content_roug8_1{line-height:22px;align-items:center;display:flex;justify-content:center}@media (min-width: 991px){._content_roug8_1{margin:-40px auto 40px}}._contentWrapper_roug8_13{display:flex;align-items:center;justify-content:center;gap:16px;padding:16px}._text_roug8_21{font-size:16px;font-weight:400;color:#000}._icon_roug8_27,._action_roug8_31{display:flex}._profileComponent_1k3rt_1{background-color:#e6e9f0;position:relative;transition:all .1s,visibility 0s;width:36px;height:36px;border-radius:18px;display:flex;justify-content:center;align-items:center;margin-right:10px;z-index:20;color:#000}[dir=rtl] ._profileComponent_1k3rt_1{margin-right:0;margin-left:10px}._profileComponent_1k3rt_1:after{top:25px;left:52%;border:14px solid transparent;content:" ";height:0;width:0;position:absolute;pointer-events:none;opacity:0;border-bottom-color:#fff;margin-left:-15px;filter:drop-shadow(0 -2px 5px rgba(0,0,0,.1019607843))}[dir=rtl] ._profileComponent_1k3rt_1:after{left:auto;right:52%;margin-left:0;margin-right:-15px}@media (min-width: 992px){._profileComponent_1k3rt_1:after{top:32px}}._profileComponent_1k3rt_1:hover,._profileComponent_1k3rt_1:focus,._profileComponent_1k3rt_1._open_1k3rt_34{cursor:pointer}._profileComponent_1k3rt_1._open_1k3rt_34:after{opacity:1}._profileComponent_1k3rt_1._open_1k3rt_34 ._body_1k3rt_40{display:flex;flex-flow:column}._profileComponent_1k3rt_1 ._body_1k3rt_40{display:none;border-radius:4px;box-shadow:0 3px 10px #00000029;list-style:none;position:absolute;padding:12px 0;margin:0;right:-56px;top:53px;font-size:0;background-color:#fff;width:392px;word-break:break-word;align-items:center}[dir=rtl] ._profileComponent_1k3rt_1 ._body_1k3rt_40{right:auto;left:-56px}@media (min-width: 992px){._profileComponent_1k3rt_1 ._body_1k3rt_40{right:-18px;top:60px}[dir=rtl] ._profileComponent_1k3rt_1 ._body_1k3rt_40{right:auto;left:-18px}}._profileComponent_1k3rt_1 ._button_1k3rt_66{margin:15px 0;max-height:46px}._profileComponent_1k3rt_1 ._profileIcon_1k3rt_70{width:22px;height:22px}._profileComponent_1k3rt_1 ._count_1k3rt_74{position:absolute;background-color:#ff8770;color:#fff;border-radius:50%;width:24px;height:24px;top:-8px;right:-8px;align-items:center;display:flex;justify-content:center;font-weight:500;font-size:14px}[dir=rtl] ._profileComponent_1k3rt_1 ._count_1k3rt_74{right:auto;left:-8px}._list_1k3rt_90{display:flex;flex-flow:column}._row_1k3rt_95{display:flex;align-items:center;padding:12px;margin:0 8px;gap:12px}._row_1k3rt_95 ul{display:block;list-style-type:disc;margin-block-start:1em;margin-block-end:1em;margin-inline-start:0px;margin-inline-end:0px;padding-inline-start:40px}._row_1k3rt_95 div[class^=_content]{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}._row_1k3rt_95:not(:last-child){border-bottom:1px solid #e6e6e6}._header_1k3rt_122{display:flex;align-items:center;justify-content:space-between;padding:8px 18px 16px;width:100%}._header_1k3rt_122 ._title_1k3rt_129{font-size:16px;font-weight:500}._header_1k3rt_122 ._action_1k3rt_133{display:flex;font-size:14px;font-weight:500;padding:0}._header_1k3rt_122 ._action_1k3rt_133 ._withIcon_1k3rt_139{display:flex;align-items:center;gap:4px}._button_1k3rt_66{font-size:14px;font-weight:500}._empty_1k3rt_150{display:flex;flex-flow:column;gap:16px;padding:16px 0;color:#b3b6c6;font-size:14px}._container_1h8zt_1{padding:0 32px 32px;display:flex;flex-flow:column;gap:8px}._container_1h8zt_1 ._header_1h8zt_7{display:flex;justify-content:flex-end}._container_1h8zt_1 ._header_1h8zt_7 ._closeIcon_1h8zt_11{cursor:pointer}._container_1h8zt_1 ._icon_1h8zt_14{display:flex;justify-content:center}._container_1h8zt_1 ._icon_1h8zt_14 img{width:96px;height:96px}._container_1h8zt_1 ._body_1h8zt_22{display:flex;flex-flow:column;justify-content:center;text-align:center;gap:32px}._container_1h8zt_1 ._body_1h8zt_22 ._title_1h8zt_29{color:#102d6f;font-size:28px;font-weight:500;display:flex;flex-flow:column;gap:16px}._container_1h8zt_1 ._body_1h8zt_22 ._title_1h8zt_29 ._date_1h8zt_37{color:#757575;font-size:14px;font-weight:400}._container_1h8zt_1 ._body_1h8zt_22 ._message_1h8zt_42{text-align:left;line-height:22px}[dir=rtl] ._container_1h8zt_1 ._body_1h8zt_22 ._message_1h8zt_42{text-align:right}._container_1h8zt_1 ._body_1h8zt_22 ._message_1h8zt_42 ul{display:block;list-style-type:disc;margin-block-start:1em;margin-block-end:1em;margin-inline-start:0px;margin-inline-end:0px;padding-inline-start:40px}._container_1h8zt_1 ._body_1h8zt_22 ._message_1h8zt_42 a{color:#4972f4;text-decoration:none;font-weight:500}._modal_1h8zt_61{background-color:#fff;border-radius:8px;left:50%;top:50%;position:absolute;right:auto;transform:translate(-50%,-50%);max-width:680px;padding:32px;max-height:100vh;overflow-y:auto}[dir=rtl] ._modal_1h8zt_61{right:50%;left:auto;transform:translate(50%,-50%)}._modal_1h8zt_61:focus{outline:none}._overlay_1h8zt_78{background-color:#121b4566;bottom:0;left:0;position:fixed;right:0;top:0;z-index:40}._banner_1izyc_1{background-color:#fcea81}._text_1izyc_5{font-size:16px;font-weight:400;color:#000}._icon_1izyc_11{display:inline-flex;color:#102d6f}._button_1izyc_16{text-decoration:none;font-weight:500;color:#102d6f!important;padding:0 8px}._list_19bxa_1{display:flex;flex-direction:column;list-style-type:none;margin:0;padding:0}._list_19bxa_1 ._listItem_19bxa_8{margin:0 0 24px}._list_19bxa_1 ._listItem_19bxa_8:last-child{margin:0}._listItem_19bxa_8{position:relative}._listItemContent_19bxa_19{align-items:center;display:flex}._icon_19bxa_24{height:40px;width:40px;margin:0 16px 0 0}[dir=rtl] ._icon_19bxa_24{margin:0 0 0 16px}._name_19bxa_30{color:#122e70;font-size:16px;font-weight:500;line-height:21px}._listItem_19bxa_8:hover ._name_19bxa_30{color:#305cea}._link_19bxa_40{bottom:0;left:0;position:absolute;right:0;top:0;transition:all .3s ease,visibility 0s;z-index:999}._header_e2z05_1{padding:16px}._header_e2z05_1._open_e2z05_4{overflow-x:hidden;overflow-y:auto;padding:20px 16px;height:100vh;height:calc(var(--vh, 1vh) * 100)}@media (min-width: 1024px){._header_e2z05_1{display:none}}._content_e2z05_17{align-items:center;display:flex;justify-content:space-between}._buttons_e2z05_23{align-items:center;display:flex;opacity:0;transition:opacity .3s ease-in-out}._buttons_e2z05_23._visible_e2z05_29{opacity:1}._buttonWrapper_e2z05_33{display:flex;flex-direction:column;margin:0 24px;justify-content:center;row-gap:20px}._button_e2z05_23{align-items:center;display:flex;justify-content:center;min-width:100px;padding:11px 27px!important;max-height:44px}._overlayButton_e2z05_50{padding:15px 68px}._logo_e2z05_54{display:flex;height:36px;width:139px}._menuIcon_e2z05_60{font-size:20px;margin:0 0 0 20px;width:14px}[dir=rtl] ._menuIcon_e2z05_60{margin:0 20px 0 0}._list_e2z05_66{list-style-type:none;margin:0 24px;padding:0}._overlay_e2z05_50{background-color:#fff;left:0;padding:70px 16px 15px;width:100%;z-index:999}[dir=rtl] ._overlay_e2z05_50{left:auto;right:0}._languageSwitcher_e2z05_80{padding:12px 0 44px}._externalProducts_e2z05_84{margin:0 24px}._externalProductsHeading_e2z05_88{color:#102d6f;font-weight:500;font-size:24px;margin:44px 0 20px}._changeContainer_e2z05_95{padding-top:15px;margin:20px 24px 40px;border-top:1px solid #e6e8f0;font-size:16px;font-weight:500;color:#102d6f}._changeContainer_e2z05_95 li{display:flex;align-items:center}._changeContainer_e2z05_95 li:first-child{margin-bottom:20px}._changeContainer_e2z05_95 li img,._changeContainer_e2z05_95 li svg{width:22px;margin-right:10px}[dir=rtl] ._changeContainer_e2z05_95 li img,[dir=rtl] ._changeContainer_e2z05_95 li svg{margin-right:0;margin-left:10px}._container_edf0k_1{position:relative}._moreOptionsMenu_edf0k_5{cursor:pointer;height:16px;margin:0 20px;position:relative;transition:all .1s,visibility 0s;width:16px}._square_edf0k_14{background-color:#102d6f;border-radius:1px;display:block;float:left;height:6px;margin:1px;position:absolute;transition:all .1s,visibility 0s;width:6px}[dir=rtl] ._square_edf0k_14{float:right}._moreOptionsMenu_edf0k_5:hover ._square_edf0k_14{background-color:#305cea}._square_edf0k_14:nth-child(1){animation:_topLeftSquareMove_edf0k_1 9s 2s cubic-bezier(.51,.1,.3,.97) infinite;left:0;top:0}[dir=rtl] ._square_edf0k_14:nth-child(1){left:auto;right:0}._square_edf0k_14:nth-child(2){animation:_topRightSquareMove_edf0k_1 9s 2s cubic-bezier(.51,.1,.3,.97) infinite;left:50%;top:0}[dir=rtl] ._square_edf0k_14:nth-child(2){left:auto;right:50%}._square_edf0k_14:nth-child(3){animation:_bottomRightSquareMove_edf0k_1 9s 2s cubic-bezier(.51,.1,.3,.97) infinite;left:50%;top:50%}[dir=rtl] ._square_edf0k_14:nth-child(3){left:auto;right:50%}._square_edf0k_14:nth-child(4){animation:_bottomLeftSquareMove_edf0k_1 9s 2s cubic-bezier(.51,.1,.3,.97) infinite;left:0;top:50%}[dir=rtl] ._square_edf0k_14:nth-child(4){left:auto;right:0}@keyframes _topLeftSquareMove_edf0k_1{2%{left:50%;top:0}4%{left:50%;top:50%}6%{left:0;top:50%}8%{left:0;top:0}}@keyframes _topRightSquareMove_edf0k_1{2%{left:50%;top:0}4%{left:50%;top:50%}6%{left:0;top:50%}8%{left:0;top:0}10%{left:50%;top:0}}@keyframes _bottomRightSquareMove_edf0k_1{2%{left:50%;top:50%}4%{left:50%;top:50%}6%{left:0;top:50%}8%{left:0;top:0}10%{left:50%;top:0}12%{left:50%;top:50%}}@keyframes _bottomLeftSquareMove_edf0k_1{2%{left:0;top:50%}4%{left:0;top:50%}6%{left:0;top:50%}8%{left:0;top:0}10%{left:50%;top:0}12%{left:50%;top:50%}14%{left:0;top:50%}}._externalProducts_edf0k_145{background:#fff;border-radius:10px;box-shadow:0 20px 50px #00000029;list-style-type:none;opacity:0;position:absolute;right:-21px;top:42px;transform:translate(-4px,42px);visibility:hidden;width:280px;padding:24px;z-index:1}[dir=rtl] ._externalProducts_edf0k_145{right:auto;left:-21px;transform:translate(4px,42px)}._externalProducts_edf0k_145:after{border-color:transparent transparent #ffffff transparent;border-style:solid;border-width:0 20px 20px 20px;content:"";position:absolute;right:25px;top:-15px;transition:transform .3s;z-index:-1}[dir=rtl] ._externalProducts_edf0k_145:after{right:auto;left:25px}._externalProducts_edf0k_145._visible_edf0k_171{z-index:10;opacity:1;visibility:visible;transition:all .5s cubic-bezier(.75,-.02,.2,.97);transform:translate(-4px,10px)}[dir=rtl] ._externalProducts_edf0k_145._visible_edf0k_171{transform:translate(4px,10px)}._header_1qgg9_1{display:none;padding:1px 16px}@media (min-width: 1024px){._header_1qgg9_1{display:block;padding:16px 20px}}._navContainer_1qgg9_12{align-items:center;display:flex;transition:opacity .3s ease-in-out}._content_1qgg9_18{align-items:center;display:flex;justify-content:space-between;max-width:1440px;margin:0 auto}._buttons_1qgg9_26{align-items:center;display:flex}._button_1qgg9_26{align-items:center;display:flex;justify-content:center;min-width:100px;padding:10px 16px!important;white-space:nowrap}@media (min-width: 1200px){._button_1qgg9_26{margin:0 8px;padding:10px 16px}}._button_1qgg9_26+._button_1qgg9_26{margin-left:10px}[dir=rtl] ._button_1qgg9_26+._button_1qgg9_26{margin-left:0;margin-right:10px}._moreOptionsButton_1qgg9_50{margin:0 20px}._logo_1qgg9_54{display:flex;height:36px;width:139px}@media (min-width: 1200px){._logo_1qgg9_54{height:51px;width:197px}}._list_1qgg9_66{align-items:center;display:flex;list-style-type:none;margin-left:20px;margin-right:20px;padding-left:0}[dir=rtl] ._list_1qgg9_66{padding-left:0;padding-right:0}@media (min-width: 1280px){._list_1qgg9_66{margin-right:55px}[dir=rtl] ._list_1qgg9_66{margin-right:0;margin-left:55px}}._listItem_1qgg9_80{padding:0 10px;text-align:center}@media (min-width: 1280px){._listItem_1qgg9_80{padding:0 20px}}._link_1qgg9_90{color:#102d6f;display:flex;font-size:16px;font-weight:500;padding:12px 0;text-align:center;text-decoration:none;transition:all .1s,visibility 0s}@media (min-width: 767px){._link_1qgg9_90{justify-content:center}}._link_1qgg9_90:hover,._activeLink_1qgg9_109{color:#305cea}._languageSwitcher_1qgg9_113 ._icon_1qgg9_113{cursor:pointer;background-color:#e6e9f0;padding:7px;border-radius:50%}._languageSwitcher_1qgg9_113 svg{width:32px;height:32px}._container_1uo4l_1 ._header_1uo4l_1{display:grid;gap:8px;grid-template-columns:minmax(57px,1fr) 1fr}._container_1uo4l_1 ._header_1uo4l_1>*:last-child{justify-self:flex-end}._container_1uo4l_1 ._logoWrapper_1uo4l_9{display:flex;align-items:center}._container_1uo4l_1 ._logoWrapper_1uo4l_9 ._logoContainer_1uo4l_13{width:100%;text-align:left}[dir=rtl] ._container_1uo4l_1 ._logoWrapper_1uo4l_9 ._logoContainer_1uo4l_13{text-align:right}._container_1uo4l_1 ._logoWrapper_1uo4l_9 ._leftIcon_1uo4l_17{display:flex;margin:0 8px 0 0}[dir=rtl] ._container_1uo4l_1 ._logoWrapper_1uo4l_9 ._leftIcon_1uo4l_17{margin:0 0 0 8px}body[dir=rtl] ._container_1uo4l_1 ._logoWrapper_1uo4l_9 ._leftIcon_1uo4l_17{transform:rotate(180deg);margin:0 0 0 8px}[dir=rtl] body[dir=rtl] ._container_1uo4l_1 ._logoWrapper_1uo4l_9 ._leftIcon_1uo4l_17{transform:rotate(-180deg);margin:0 8px 0 0}')),document.head.appendChild(t)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import * as h from "react";
import Rr, { useState as Te, useEffect as et, useContext as Le, createContext as cc, useMemo as fc, useRef as St, useCallback as Fs, Fragment as dc, useLayoutEffect as mc } from "react";
import { CurrencyEnum as Lt } from "@spectrocoin/sc-currencies";
import hc from "react-dom";
import { getNotification as Us, Notification as pc } from "@spectrocoin/user-notifications";
function qt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function vc(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var ra = { exports: {} }, _r = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vo;
function gc() {
  if (vo)
    return _r;
  vo = 1;
  var e = Rr, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, u) {
    var c, d = {}, m = null, x = null;
    u !== void 0 && (m = "" + u), l.key !== void 0 && (m = "" + l.key), l.ref !== void 0 && (x = l.ref);
    for (c in l)
      n.call(l, c) && !i.hasOwnProperty(c) && (d[c] = l[c]);
    if (s && s.defaultProps)
      for (c in l = s.defaultProps, l)
        d[c] === void 0 && (d[c] = l[c]);
    return { $$typeof: t, type: s, key: m, ref: x, props: d, _owner: a.current };
  }
  return _r.Fragment = r, _r.jsx = o, _r.jsxs = o, _r;
}
var xr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var go;
function bc() {
  return go || (go = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Rr, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), x = Symbol.for("react.offscreen"), E = Symbol.iterator, P = "@@iterator";
    function w(v) {
      if (v === null || typeof v != "object")
        return null;
      var S = E && v[E] || v[P];
      return typeof S == "function" ? S : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function p(v) {
      {
        for (var S = arguments.length, M = new Array(S > 1 ? S - 1 : 0), W = 1; W < S; W++)
          M[W - 1] = arguments[W];
        g("error", v, M);
      }
    }
    function g(v, S, M) {
      {
        var W = b.ReactDebugCurrentFrame, ie = W.getStackAddendum();
        ie !== "" && (S += "%s", M = M.concat([ie]));
        var ue = M.map(function(te) {
          return String(te);
        });
        ue.unshift("Warning: " + S), Function.prototype.apply.call(console[v], console, ue);
      }
    }
    var _ = !1, y = !1, O = !1, j = !1, ne = !1, ae;
    ae = Symbol.for("react.module.reference");
    function Ee(v) {
      return !!(typeof v == "string" || typeof v == "function" || v === n || v === i || ne || v === a || v === u || v === c || j || v === x || _ || y || O || typeof v == "object" && v !== null && (v.$$typeof === m || v.$$typeof === d || v.$$typeof === o || v.$$typeof === s || v.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      v.$$typeof === ae || v.getModuleId !== void 0));
    }
    function Ie(v, S, M) {
      var W = v.displayName;
      if (W)
        return W;
      var ie = S.displayName || S.name || "";
      return ie !== "" ? M + "(" + ie + ")" : M;
    }
    function Ce(v) {
      return v.displayName || "Context";
    }
    function he(v) {
      if (v == null)
        return null;
      if (typeof v.tag == "number" && p("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof v == "function")
        return v.displayName || v.name || null;
      if (typeof v == "string")
        return v;
      switch (v) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case s:
            var S = v;
            return Ce(S) + ".Consumer";
          case o:
            var M = v;
            return Ce(M._context) + ".Provider";
          case l:
            return Ie(v, v.render, "ForwardRef");
          case d:
            var W = v.displayName || null;
            return W !== null ? W : he(v.type) || "Memo";
          case m: {
            var ie = v, ue = ie._payload, te = ie._init;
            try {
              return he(te(ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var I = Object.assign, L = 0, X, T, D, le, C, N, U;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function F() {
      {
        if (L === 0) {
          X = console.log, T = console.info, D = console.warn, le = console.error, C = console.group, N = console.groupCollapsed, U = console.groupEnd;
          var v = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: v,
            log: v,
            warn: v,
            error: v,
            group: v,
            groupCollapsed: v,
            groupEnd: v
          });
        }
        L++;
      }
    }
    function Z() {
      {
        if (L--, L === 0) {
          var v = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: I({}, v, {
              value: X
            }),
            info: I({}, v, {
              value: T
            }),
            warn: I({}, v, {
              value: D
            }),
            error: I({}, v, {
              value: le
            }),
            group: I({}, v, {
              value: C
            }),
            groupCollapsed: I({}, v, {
              value: N
            }),
            groupEnd: I({}, v, {
              value: U
            })
          });
        }
        L < 0 && p("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var G = b.ReactCurrentDispatcher, $;
    function z(v, S, M) {
      {
        if ($ === void 0)
          try {
            throw Error();
          } catch (ie) {
            var W = ie.stack.trim().match(/\n( *(at )?)/);
            $ = W && W[1] || "";
          }
        return `
` + $ + v;
      }
    }
    var K = !1, V;
    {
      var pe = typeof WeakMap == "function" ? WeakMap : Map;
      V = new pe();
    }
    function A(v, S) {
      if (!v || K)
        return "";
      {
        var M = V.get(v);
        if (M !== void 0)
          return M;
      }
      var W;
      K = !0;
      var ie = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ue;
      ue = G.current, G.current = null, F();
      try {
        if (S) {
          var te = function() {
            throw Error();
          };
          if (Object.defineProperty(te.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(te, []);
            } catch (dt) {
              W = dt;
            }
            Reflect.construct(v, [], te);
          } else {
            try {
              te.call();
            } catch (dt) {
              W = dt;
            }
            v.call(te.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (dt) {
            W = dt;
          }
          v();
        }
      } catch (dt) {
        if (dt && W && typeof dt.stack == "string") {
          for (var J = dt.stack.split(`
`), Se = W.stack.split(`
`), ve = J.length - 1, ye = Se.length - 1; ve >= 1 && ye >= 0 && J[ve] !== Se[ye]; )
            ye--;
          for (; ve >= 1 && ye >= 0; ve--, ye--)
            if (J[ve] !== Se[ye]) {
              if (ve !== 1 || ye !== 1)
                do
                  if (ve--, ye--, ye < 0 || J[ve] !== Se[ye]) {
                    var Ye = `
` + J[ve].replace(" at new ", " at ");
                    return v.displayName && Ye.includes("<anonymous>") && (Ye = Ye.replace("<anonymous>", v.displayName)), typeof v == "function" && V.set(v, Ye), Ye;
                  }
                while (ve >= 1 && ye >= 0);
              break;
            }
        }
      } finally {
        K = !1, G.current = ue, Z(), Error.prepareStackTrace = ie;
      }
      var Qt = v ? v.displayName || v.name : "", po = Qt ? z(Qt) : "";
      return typeof v == "function" && V.set(v, po), po;
    }
    function De(v, S, M) {
      return A(v, !1);
    }
    function xt(v) {
      var S = v.prototype;
      return !!(S && S.isReactComponent);
    }
    function ft(v, S, M) {
      if (v == null)
        return "";
      if (typeof v == "function")
        return A(v, xt(v));
      if (typeof v == "string")
        return z(v);
      switch (v) {
        case u:
          return z("Suspense");
        case c:
          return z("SuspenseList");
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case l:
            return De(v.render);
          case d:
            return ft(v.type, S, M);
          case m: {
            var W = v, ie = W._payload, ue = W._init;
            try {
              return ft(ue(ie), S, M);
            } catch {
            }
          }
        }
      return "";
    }
    var xe = Object.prototype.hasOwnProperty, Ze = {}, Mt = b.ReactDebugCurrentFrame;
    function Fr(v) {
      if (v) {
        var S = v._owner, M = ft(v.type, v._source, S ? S.type : null);
        Mt.setExtraStackFrame(M);
      } else
        Mt.setExtraStackFrame(null);
    }
    function Gu(v, S, M, W, ie) {
      {
        var ue = Function.call.bind(xe);
        for (var te in v)
          if (ue(v, te)) {
            var J = void 0;
            try {
              if (typeof v[te] != "function") {
                var Se = Error((W || "React class") + ": " + M + " type `" + te + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[te] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Se.name = "Invariant Violation", Se;
              }
              J = v[te](S, te, W, M, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ve) {
              J = ve;
            }
            J && !(J instanceof Error) && (Fr(ie), p("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", W || "React class", M, te, typeof J), Fr(null)), J instanceof Error && !(J.message in Ze) && (Ze[J.message] = !0, Fr(ie), p("Failed %s type: %s", M, J.message), Fr(null));
          }
      }
    }
    var Yu = Array.isArray;
    function On(v) {
      return Yu(v);
    }
    function zu(v) {
      {
        var S = typeof Symbol == "function" && Symbol.toStringTag, M = S && v[Symbol.toStringTag] || v.constructor.name || "Object";
        return M;
      }
    }
    function Vu(v) {
      try {
        return ao(v), !1;
      } catch {
        return !0;
      }
    }
    function ao(v) {
      return "" + v;
    }
    function io(v) {
      if (Vu(v))
        return p("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", zu(v)), ao(v);
    }
    var yr = b.ReactCurrentOwner, qu = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, oo, so, Nn;
    Nn = {};
    function Zu(v) {
      if (xe.call(v, "ref")) {
        var S = Object.getOwnPropertyDescriptor(v, "ref").get;
        if (S && S.isReactWarning)
          return !1;
      }
      return v.ref !== void 0;
    }
    function Xu(v) {
      if (xe.call(v, "key")) {
        var S = Object.getOwnPropertyDescriptor(v, "key").get;
        if (S && S.isReactWarning)
          return !1;
      }
      return v.key !== void 0;
    }
    function Ku(v, S) {
      if (typeof v.ref == "string" && yr.current && S && yr.current.stateNode !== S) {
        var M = he(yr.current.type);
        Nn[M] || (p('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', he(yr.current.type), v.ref), Nn[M] = !0);
      }
    }
    function Ju(v, S) {
      {
        var M = function() {
          oo || (oo = !0, p("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        M.isReactWarning = !0, Object.defineProperty(v, "key", {
          get: M,
          configurable: !0
        });
      }
    }
    function Qu(v, S) {
      {
        var M = function() {
          so || (so = !0, p("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        M.isReactWarning = !0, Object.defineProperty(v, "ref", {
          get: M,
          configurable: !0
        });
      }
    }
    var ec = function(v, S, M, W, ie, ue, te) {
      var J = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: v,
        key: S,
        ref: M,
        props: te,
        // Record the component responsible for creating this element.
        _owner: ue
      };
      return J._store = {}, Object.defineProperty(J._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(J, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: W
      }), Object.defineProperty(J, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ie
      }), Object.freeze && (Object.freeze(J.props), Object.freeze(J)), J;
    };
    function tc(v, S, M, W, ie) {
      {
        var ue, te = {}, J = null, Se = null;
        M !== void 0 && (io(M), J = "" + M), Xu(S) && (io(S.key), J = "" + S.key), Zu(S) && (Se = S.ref, Ku(S, ie));
        for (ue in S)
          xe.call(S, ue) && !qu.hasOwnProperty(ue) && (te[ue] = S[ue]);
        if (v && v.defaultProps) {
          var ve = v.defaultProps;
          for (ue in ve)
            te[ue] === void 0 && (te[ue] = ve[ue]);
        }
        if (J || Se) {
          var ye = typeof v == "function" ? v.displayName || v.name || "Unknown" : v;
          J && Ju(te, ye), Se && Qu(te, ye);
        }
        return ec(v, J, Se, ie, W, yr.current, te);
      }
    }
    var An = b.ReactCurrentOwner, lo = b.ReactDebugCurrentFrame;
    function Jt(v) {
      if (v) {
        var S = v._owner, M = ft(v.type, v._source, S ? S.type : null);
        lo.setExtraStackFrame(M);
      } else
        lo.setExtraStackFrame(null);
    }
    var Mn;
    Mn = !1;
    function Rn(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }
    function uo() {
      {
        if (An.current) {
          var v = he(An.current.type);
          if (v)
            return `

Check the render method of \`` + v + "`.";
        }
        return "";
      }
    }
    function rc(v) {
      {
        if (v !== void 0) {
          var S = v.fileName.replace(/^.*[\\\/]/, ""), M = v.lineNumber;
          return `

Check your code at ` + S + ":" + M + ".";
        }
        return "";
      }
    }
    var co = {};
    function nc(v) {
      {
        var S = uo();
        if (!S) {
          var M = typeof v == "string" ? v : v.displayName || v.name;
          M && (S = `

Check the top-level render call using <` + M + ">.");
        }
        return S;
      }
    }
    function fo(v, S) {
      {
        if (!v._store || v._store.validated || v.key != null)
          return;
        v._store.validated = !0;
        var M = nc(S);
        if (co[M])
          return;
        co[M] = !0;
        var W = "";
        v && v._owner && v._owner !== An.current && (W = " It was passed a child from " + he(v._owner.type) + "."), Jt(v), p('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', M, W), Jt(null);
      }
    }
    function mo(v, S) {
      {
        if (typeof v != "object")
          return;
        if (On(v))
          for (var M = 0; M < v.length; M++) {
            var W = v[M];
            Rn(W) && fo(W, S);
          }
        else if (Rn(v))
          v._store && (v._store.validated = !0);
        else if (v) {
          var ie = w(v);
          if (typeof ie == "function" && ie !== v.entries)
            for (var ue = ie.call(v), te; !(te = ue.next()).done; )
              Rn(te.value) && fo(te.value, S);
        }
      }
    }
    function ac(v) {
      {
        var S = v.type;
        if (S == null || typeof S == "string")
          return;
        var M;
        if (typeof S == "function")
          M = S.propTypes;
        else if (typeof S == "object" && (S.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        S.$$typeof === d))
          M = S.propTypes;
        else
          return;
        if (M) {
          var W = he(S);
          Gu(M, v.props, "prop", W, v);
        } else if (S.PropTypes !== void 0 && !Mn) {
          Mn = !0;
          var ie = he(S);
          p("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ie || "Unknown");
        }
        typeof S.getDefaultProps == "function" && !S.getDefaultProps.isReactClassApproved && p("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ic(v) {
      {
        for (var S = Object.keys(v.props), M = 0; M < S.length; M++) {
          var W = S[M];
          if (W !== "children" && W !== "key") {
            Jt(v), p("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", W), Jt(null);
            break;
          }
        }
        v.ref !== null && (Jt(v), p("Invalid attribute `ref` supplied to `React.Fragment`."), Jt(null));
      }
    }
    function ho(v, S, M, W, ie, ue) {
      {
        var te = Ee(v);
        if (!te) {
          var J = "";
          (v === void 0 || typeof v == "object" && v !== null && Object.keys(v).length === 0) && (J += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Se = rc(ie);
          Se ? J += Se : J += uo();
          var ve;
          v === null ? ve = "null" : On(v) ? ve = "array" : v !== void 0 && v.$$typeof === t ? (ve = "<" + (he(v.type) || "Unknown") + " />", J = " Did you accidentally export a JSX literal instead of a component?") : ve = typeof v, p("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ve, J);
        }
        var ye = tc(v, S, M, ie, ue);
        if (ye == null)
          return ye;
        if (te) {
          var Ye = S.children;
          if (Ye !== void 0)
            if (W)
              if (On(Ye)) {
                for (var Qt = 0; Qt < Ye.length; Qt++)
                  mo(Ye[Qt], v);
                Object.freeze && Object.freeze(Ye);
              } else
                p("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              mo(Ye, v);
        }
        return v === n ? ic(ye) : ac(ye), ye;
      }
    }
    function oc(v, S, M) {
      return ho(v, S, M, !0);
    }
    function sc(v, S, M) {
      return ho(v, S, M, !1);
    }
    var lc = sc, uc = oc;
    xr.Fragment = n, xr.jsx = lc, xr.jsxs = uc;
  }()), xr;
}
process.env.NODE_ENV === "production" ? ra.exports = gc() : ra.exports = bc();
var f = ra.exports, na = function(e, t) {
  return na = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n)
      Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, na(e, t);
};
function Ve(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  na(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var k = function() {
  return k = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, k.apply(this, arguments);
};
function ur(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function st(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, a = t.length, i; n < a; n++)
      (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var aa = { exports: {} }, oe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bo;
function yc() {
  if (bo)
    return oe;
  bo = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, p = e ? Symbol.for("react.scope") : 60119;
  function g(y) {
    if (typeof y == "object" && y !== null) {
      var O = y.$$typeof;
      switch (O) {
        case t:
          switch (y = y.type, y) {
            case l:
            case u:
            case n:
            case i:
            case a:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case c:
                case E:
                case x:
                case o:
                  return y;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  function _(y) {
    return g(y) === u;
  }
  return oe.AsyncMode = l, oe.ConcurrentMode = u, oe.ContextConsumer = s, oe.ContextProvider = o, oe.Element = t, oe.ForwardRef = c, oe.Fragment = n, oe.Lazy = E, oe.Memo = x, oe.Portal = r, oe.Profiler = i, oe.StrictMode = a, oe.Suspense = d, oe.isAsyncMode = function(y) {
    return _(y) || g(y) === l;
  }, oe.isConcurrentMode = _, oe.isContextConsumer = function(y) {
    return g(y) === s;
  }, oe.isContextProvider = function(y) {
    return g(y) === o;
  }, oe.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, oe.isForwardRef = function(y) {
    return g(y) === c;
  }, oe.isFragment = function(y) {
    return g(y) === n;
  }, oe.isLazy = function(y) {
    return g(y) === E;
  }, oe.isMemo = function(y) {
    return g(y) === x;
  }, oe.isPortal = function(y) {
    return g(y) === r;
  }, oe.isProfiler = function(y) {
    return g(y) === i;
  }, oe.isStrictMode = function(y) {
    return g(y) === a;
  }, oe.isSuspense = function(y) {
    return g(y) === d;
  }, oe.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === u || y === i || y === a || y === d || y === m || typeof y == "object" && y !== null && (y.$$typeof === E || y.$$typeof === x || y.$$typeof === o || y.$$typeof === s || y.$$typeof === c || y.$$typeof === w || y.$$typeof === b || y.$$typeof === p || y.$$typeof === P);
  }, oe.typeOf = g, oe;
}
var se = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yo;
function _c() {
  return yo || (yo = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, p = e ? Symbol.for("react.scope") : 60119;
    function g(A) {
      return typeof A == "string" || typeof A == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      A === n || A === u || A === i || A === a || A === d || A === m || typeof A == "object" && A !== null && (A.$$typeof === E || A.$$typeof === x || A.$$typeof === o || A.$$typeof === s || A.$$typeof === c || A.$$typeof === w || A.$$typeof === b || A.$$typeof === p || A.$$typeof === P);
    }
    function _(A) {
      if (typeof A == "object" && A !== null) {
        var De = A.$$typeof;
        switch (De) {
          case t:
            var xt = A.type;
            switch (xt) {
              case l:
              case u:
              case n:
              case i:
              case a:
              case d:
                return xt;
              default:
                var ft = xt && xt.$$typeof;
                switch (ft) {
                  case s:
                  case c:
                  case E:
                  case x:
                  case o:
                    return ft;
                  default:
                    return De;
                }
            }
          case r:
            return De;
        }
      }
    }
    var y = l, O = u, j = s, ne = o, ae = t, Ee = c, Ie = n, Ce = E, he = x, I = r, L = i, X = a, T = d, D = !1;
    function le(A) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), C(A) || _(A) === l;
    }
    function C(A) {
      return _(A) === u;
    }
    function N(A) {
      return _(A) === s;
    }
    function U(A) {
      return _(A) === o;
    }
    function H(A) {
      return typeof A == "object" && A !== null && A.$$typeof === t;
    }
    function F(A) {
      return _(A) === c;
    }
    function Z(A) {
      return _(A) === n;
    }
    function G(A) {
      return _(A) === E;
    }
    function $(A) {
      return _(A) === x;
    }
    function z(A) {
      return _(A) === r;
    }
    function K(A) {
      return _(A) === i;
    }
    function V(A) {
      return _(A) === a;
    }
    function pe(A) {
      return _(A) === d;
    }
    se.AsyncMode = y, se.ConcurrentMode = O, se.ContextConsumer = j, se.ContextProvider = ne, se.Element = ae, se.ForwardRef = Ee, se.Fragment = Ie, se.Lazy = Ce, se.Memo = he, se.Portal = I, se.Profiler = L, se.StrictMode = X, se.Suspense = T, se.isAsyncMode = le, se.isConcurrentMode = C, se.isContextConsumer = N, se.isContextProvider = U, se.isElement = H, se.isForwardRef = F, se.isFragment = Z, se.isLazy = G, se.isMemo = $, se.isPortal = z, se.isProfiler = K, se.isStrictMode = V, se.isSuspense = pe, se.isValidElementType = g, se.typeOf = _;
  }()), se;
}
process.env.NODE_ENV === "production" ? aa.exports = yc() : aa.exports = _c();
var Ti = aa.exports, $s = Ti, xc = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, wc = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Ws = {};
Ws[$s.ForwardRef] = xc;
Ws[$s.Memo] = wc;
function Ec(e, t, r) {
  if (r === void 0 && (r = Error), !e)
    throw new r(t);
}
var ee;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(ee || (ee = {}));
var fe;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(fe || (fe = {}));
var cr;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(cr || (cr = {}));
function _o(e) {
  return e.type === fe.literal;
}
function Tc(e) {
  return e.type === fe.argument;
}
function Gs(e) {
  return e.type === fe.number;
}
function Ys(e) {
  return e.type === fe.date;
}
function zs(e) {
  return e.type === fe.time;
}
function Vs(e) {
  return e.type === fe.select;
}
function qs(e) {
  return e.type === fe.plural;
}
function Pc(e) {
  return e.type === fe.pound;
}
function Zs(e) {
  return e.type === fe.tag;
}
function Xs(e) {
  return !!(e && typeof e == "object" && e.type === cr.number);
}
function ia(e) {
  return !!(e && typeof e == "object" && e.type === cr.dateTime);
}
var Ks = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, Cc = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function Sc(e) {
  var t = {};
  return e.replace(Cc, function(r) {
    var n = r.length;
    switch (r[0]) {
      case "G":
        t.era = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = n === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][n - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][n - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      case "e":
        if (n < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      case "c":
        if (n < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][n - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][n - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = n < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var Oc = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function Nc(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(Oc).filter(function(m) {
    return m.length > 0;
  }), r = [], n = 0, a = t; n < a.length; n++) {
    var i = a[n], o = i.split("/");
    if (o.length === 0)
      throw new Error("Invalid number skeleton");
    for (var s = o[0], l = o.slice(1), u = 0, c = l; u < c.length; u++) {
      var d = c[u];
      if (d.length === 0)
        throw new Error("Invalid number skeleton");
    }
    r.push({ stem: s, options: l });
  }
  return r;
}
function Ac(e) {
  return e.replace(/^(.*?)-/, "");
}
var xo = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, Js = /^(@+)?(\+|#+)?[rs]?$/g, Mc = /(\*)(0+)|(#+)(0+)|(0+)/g, Qs = /^(0+)$/;
function wo(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(Js, function(r, n, a) {
    return typeof a != "string" ? (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length) : a === "+" ? t.minimumSignificantDigits = n.length : n[0] === "#" ? t.maximumSignificantDigits = n.length : (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length + (typeof a == "string" ? a.length : 0)), "";
  }), t;
}
function el(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function Rc(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var r = e.slice(0, 2);
    if (r === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : r === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !Qs.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function Eo(e) {
  var t = {}, r = el(e);
  return r || t;
}
function kc(e) {
  for (var t = {}, r = 0, n = e; r < n.length; r++) {
    var a = n[r];
    switch (a.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = a.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = Ac(a.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = k(k(k({}, t), { notation: "scientific" }), a.options.reduce(function(l, u) {
          return k(k({}, l), Eo(u));
        }, {}));
        continue;
      case "engineering":
        t = k(k(k({}, t), { notation: "engineering" }), a.options.reduce(function(l, u) {
          return k(k({}, l), Eo(u));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(a.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (a.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        a.options[0].replace(Mc, function(l, u, c, d, m, x) {
          if (u)
            t.minimumIntegerDigits = c.length;
          else {
            if (d && m)
              throw new Error("We currently do not support maximum integer digits");
            if (x)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (Qs.test(a.stem)) {
      t.minimumIntegerDigits = a.stem.length;
      continue;
    }
    if (xo.test(a.stem)) {
      if (a.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      a.stem.replace(xo, function(l, u, c, d, m, x) {
        return c === "*" ? t.minimumFractionDigits = u.length : d && d[0] === "#" ? t.maximumFractionDigits = d.length : m && x ? (t.minimumFractionDigits = m.length, t.maximumFractionDigits = m.length + x.length) : (t.minimumFractionDigits = u.length, t.maximumFractionDigits = u.length), "";
      });
      var i = a.options[0];
      i === "w" ? t = k(k({}, t), { trailingZeroDisplay: "stripIfInteger" }) : i && (t = k(k({}, t), wo(i)));
      continue;
    }
    if (Js.test(a.stem)) {
      t = k(k({}, t), wo(a.stem));
      continue;
    }
    var o = el(a.stem);
    o && (t = k(k({}, t), o));
    var s = Rc(a.stem);
    s && (t = k(k({}, t), s));
  }
  return t;
}
var Ur = {
  "001": [
    "H",
    "h"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function Ic(e, t) {
  for (var r = "", n = 0; n < e.length; n++) {
    var a = e.charAt(n);
    if (a === "j") {
      for (var i = 0; n + 1 < e.length && e.charAt(n + 1) === a; )
        i++, n++;
      var o = 1 + (i & 1), s = i < 2 ? 1 : 3 + (i >> 1), l = "a", u = Dc(t);
      for ((u == "H" || u == "k") && (s = 0); s-- > 0; )
        r += l;
      for (; o-- > 0; )
        r = u + r;
    } else
      a === "J" ? r += "H" : r += a;
  }
  return r;
}
function Dc(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var r = e.language, n;
  r !== "root" && (n = e.maximize().region);
  var a = Ur[n || ""] || Ur[r || ""] || Ur["".concat(r, "-001")] || Ur["001"];
  return a[0];
}
var kn, Lc = new RegExp("^".concat(Ks.source, "*")), jc = new RegExp("".concat(Ks.source, "*$"));
function re(e, t) {
  return { start: e, end: t };
}
var Bc = !!String.prototype.startsWith && "_a".startsWith("a", 1), Hc = !!String.fromCodePoint, Fc = !!Object.fromEntries, Uc = !!String.prototype.codePointAt, $c = !!String.prototype.trimStart, Wc = !!String.prototype.trimEnd, Gc = !!Number.isSafeInteger, Yc = Gc ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, oa = !0;
try {
  var zc = rl("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  oa = ((kn = zc.exec("a")) === null || kn === void 0 ? void 0 : kn[0]) === "a";
} catch {
  oa = !1;
}
var To = Bc ? (
  // Native
  function(t, r, n) {
    return t.startsWith(r, n);
  }
) : (
  // For IE11
  function(t, r, n) {
    return t.slice(n, n + r.length) === r;
  }
), sa = Hc ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    for (var n = "", a = t.length, i = 0, o; a > i; ) {
      if (o = t[i++], o > 1114111)
        throw RangeError(o + " is not a valid code point");
      n += o < 65536 ? String.fromCharCode(o) : String.fromCharCode(((o -= 65536) >> 10) + 55296, o % 1024 + 56320);
    }
    return n;
  }
), Po = (
  // native
  Fc ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var r = {}, n = 0, a = t; n < a.length; n++) {
        var i = a[n], o = i[0], s = i[1];
        r[o] = s;
      }
      return r;
    }
  )
), tl = Uc ? (
  // Native
  function(t, r) {
    return t.codePointAt(r);
  }
) : (
  // IE 11
  function(t, r) {
    var n = t.length;
    if (!(r < 0 || r >= n)) {
      var a = t.charCodeAt(r), i;
      return a < 55296 || a > 56319 || r + 1 === n || (i = t.charCodeAt(r + 1)) < 56320 || i > 57343 ? a : (a - 55296 << 10) + (i - 56320) + 65536;
    }
  }
), Vc = $c ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(Lc, "");
  }
), qc = Wc ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(jc, "");
  }
);
function rl(e, t) {
  return new RegExp(e, t);
}
var la;
if (oa) {
  var Co = rl("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  la = function(t, r) {
    var n;
    Co.lastIndex = r;
    var a = Co.exec(t);
    return (n = a[1]) !== null && n !== void 0 ? n : "";
  };
} else
  la = function(t, r) {
    for (var n = []; ; ) {
      var a = tl(t, r);
      if (a === void 0 || nl(a) || Jc(a))
        break;
      n.push(a), r += a >= 65536 ? 2 : 1;
    }
    return sa.apply(void 0, n);
  };
var Zc = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!r.ignoreTag, this.locale = r.locale, this.requiresOtherClause = !!r.requiresOtherClause, this.shouldParseSkeletons = !!r.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, r, n) {
      for (var a = []; !this.isEOF(); ) {
        var i = this.char();
        if (i === 123) {
          var o = this.parseArgument(t, n);
          if (o.err)
            return o;
          a.push(o.val);
        } else {
          if (i === 125 && t > 0)
            break;
          if (i === 35 && (r === "plural" || r === "selectordinal")) {
            var s = this.clonePosition();
            this.bump(), a.push({
              type: fe.pound,
              location: re(s, this.clonePosition())
            });
          } else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
            if (n)
              break;
            return this.error(ee.UNMATCHED_CLOSING_TAG, re(this.clonePosition(), this.clonePosition()));
          } else if (i === 60 && !this.ignoreTag && ua(this.peek() || 0)) {
            var o = this.parseTag(t, r);
            if (o.err)
              return o;
            a.push(o.val);
          } else {
            var o = this.parseLiteral(t, r);
            if (o.err)
              return o;
            a.push(o.val);
          }
        }
      }
      return { val: a, err: null };
    }, e.prototype.parseTag = function(t, r) {
      var n = this.clonePosition();
      this.bump();
      var a = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: fe.literal,
            value: "<".concat(a, "/>"),
            location: re(n, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var i = this.parseMessage(t + 1, r, !0);
        if (i.err)
          return i;
        var o = i.val, s = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !ua(this.char()))
            return this.error(ee.INVALID_TAG, re(s, this.clonePosition()));
          var l = this.clonePosition(), u = this.parseTagName();
          return a !== u ? this.error(ee.UNMATCHED_CLOSING_TAG, re(l, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: fe.tag,
              value: a,
              children: o,
              location: re(n, this.clonePosition())
            },
            err: null
          } : this.error(ee.INVALID_TAG, re(s, this.clonePosition())));
        } else
          return this.error(ee.UNCLOSED_TAG, re(n, this.clonePosition()));
      } else
        return this.error(ee.INVALID_TAG, re(n, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && Kc(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, r) {
      for (var n = this.clonePosition(), a = ""; ; ) {
        var i = this.tryParseQuote(r);
        if (i) {
          a += i;
          continue;
        }
        var o = this.tryParseUnquoted(t, r);
        if (o) {
          a += o;
          continue;
        }
        var s = this.tryParseLeftAngleBracket();
        if (s) {
          a += s;
          continue;
        }
        break;
      }
      var l = re(n, this.clonePosition());
      return {
        val: { type: fe.literal, value: a, location: l },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !Xc(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var r = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var n = this.char();
        if (n === 39)
          if (this.peek() === 39)
            r.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          r.push(n);
        this.bump();
      }
      return sa.apply(void 0, r);
    }, e.prototype.tryParseUnquoted = function(t, r) {
      if (this.isEOF())
        return null;
      var n = this.char();
      return n === 60 || n === 123 || n === 35 && (r === "plural" || r === "selectordinal") || n === 125 && t > 0 ? null : (this.bump(), sa(n));
    }, e.prototype.parseArgument = function(t, r) {
      var n = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, re(n, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(ee.EMPTY_ARGUMENT, re(n, this.clonePosition()));
      var a = this.parseIdentifierIfPossible().value;
      if (!a)
        return this.error(ee.MALFORMED_ARGUMENT, re(n, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, re(n, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), {
            val: {
              type: fe.argument,
              // value does not include the opening and closing braces.
              value: a,
              location: re(n, this.clonePosition())
            },
            err: null
          };
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, re(n, this.clonePosition())) : this.parseArgumentOptions(t, r, a, n);
        default:
          return this.error(ee.MALFORMED_ARGUMENT, re(n, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), r = this.offset(), n = la(this.message, r), a = r + n.length;
      this.bumpTo(a);
      var i = this.clonePosition(), o = re(t, i);
      return { value: n, location: o };
    }, e.prototype.parseArgumentOptions = function(t, r, n, a) {
      var i, o = this.clonePosition(), s = this.parseIdentifierIfPossible().value, l = this.clonePosition();
      switch (s) {
        case "":
          return this.error(ee.EXPECT_ARGUMENT_TYPE, re(o, l));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var u = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var c = this.clonePosition(), d = this.parseSimpleArgStyleIfPossible();
            if (d.err)
              return d;
            var m = qc(d.val);
            if (m.length === 0)
              return this.error(ee.EXPECT_ARGUMENT_STYLE, re(this.clonePosition(), this.clonePosition()));
            var x = re(c, this.clonePosition());
            u = { style: m, styleLocation: x };
          }
          var E = this.tryParseArgumentClose(a);
          if (E.err)
            return E;
          var P = re(a, this.clonePosition());
          if (u && To(u == null ? void 0 : u.style, "::", 0)) {
            var w = Vc(u.style.slice(2));
            if (s === "number") {
              var d = this.parseNumberSkeletonFromString(w, u.styleLocation);
              return d.err ? d : {
                val: { type: fe.number, value: n, location: P, style: d.val },
                err: null
              };
            } else {
              if (w.length === 0)
                return this.error(ee.EXPECT_DATE_TIME_SKELETON, P);
              var b = w;
              this.locale && (b = Ic(w, this.locale));
              var m = {
                type: cr.dateTime,
                pattern: b,
                location: u.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? Sc(b) : {}
              }, p = s === "date" ? fe.date : fe.time;
              return {
                val: { type: p, value: n, location: P, style: m },
                err: null
              };
            }
          }
          return {
            val: {
              type: s === "number" ? fe.number : s === "date" ? fe.date : fe.time,
              value: n,
              location: P,
              style: (i = u == null ? void 0 : u.style) !== null && i !== void 0 ? i : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var g = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(ee.EXPECT_SELECT_ARGUMENT_OPTIONS, re(g, k({}, g)));
          this.bumpSpace();
          var _ = this.parseIdentifierIfPossible(), y = 0;
          if (s !== "select" && _.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(ee.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, re(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var d = this.tryParseDecimalInteger(ee.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ee.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (d.err)
              return d;
            this.bumpSpace(), _ = this.parseIdentifierIfPossible(), y = d.val;
          }
          var O = this.tryParsePluralOrSelectOptions(t, s, r, _);
          if (O.err)
            return O;
          var E = this.tryParseArgumentClose(a);
          if (E.err)
            return E;
          var j = re(a, this.clonePosition());
          return s === "select" ? {
            val: {
              type: fe.select,
              value: n,
              options: Po(O.val),
              location: j
            },
            err: null
          } : {
            val: {
              type: fe.plural,
              value: n,
              options: Po(O.val),
              offset: y,
              pluralType: s === "plural" ? "cardinal" : "ordinal",
              location: j
            },
            err: null
          };
        }
        default:
          return this.error(ee.INVALID_ARGUMENT_TYPE, re(o, l));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, re(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, r = this.clonePosition(); !this.isEOF(); ) {
        var n = this.char();
        switch (n) {
          case 39: {
            this.bump();
            var a = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(ee.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, re(a, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(r.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(r.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, r) {
      var n = [];
      try {
        n = Nc(t);
      } catch {
        return this.error(ee.INVALID_NUMBER_SKELETON, r);
      }
      return {
        val: {
          type: cr.number,
          tokens: n,
          location: r,
          parsedOptions: this.shouldParseSkeletons ? kc(n) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, r, n, a) {
      for (var i, o = !1, s = [], l = /* @__PURE__ */ new Set(), u = a.value, c = a.location; ; ) {
        if (u.length === 0) {
          var d = this.clonePosition();
          if (r !== "select" && this.bumpIf("=")) {
            var m = this.tryParseDecimalInteger(ee.EXPECT_PLURAL_ARGUMENT_SELECTOR, ee.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (m.err)
              return m;
            c = re(d, this.clonePosition()), u = this.message.slice(d.offset, this.offset());
          } else
            break;
        }
        if (l.has(u))
          return this.error(r === "select" ? ee.DUPLICATE_SELECT_ARGUMENT_SELECTOR : ee.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, c);
        u === "other" && (o = !0), this.bumpSpace();
        var x = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(r === "select" ? ee.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : ee.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, re(this.clonePosition(), this.clonePosition()));
        var E = this.parseMessage(t + 1, r, n);
        if (E.err)
          return E;
        var P = this.tryParseArgumentClose(x);
        if (P.err)
          return P;
        s.push([
          u,
          {
            value: E.val,
            location: re(x, this.clonePosition())
          }
        ]), l.add(u), this.bumpSpace(), i = this.parseIdentifierIfPossible(), u = i.value, c = i.location;
      }
      return s.length === 0 ? this.error(r === "select" ? ee.EXPECT_SELECT_ARGUMENT_SELECTOR : ee.EXPECT_PLURAL_ARGUMENT_SELECTOR, re(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !o ? this.error(ee.MISSING_OTHER_CLAUSE, re(this.clonePosition(), this.clonePosition())) : { val: s, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, r) {
      var n = 1, a = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (n = -1);
      for (var i = !1, o = 0; !this.isEOF(); ) {
        var s = this.char();
        if (s >= 48 && s <= 57)
          i = !0, o = o * 10 + (s - 48), this.bump();
        else
          break;
      }
      var l = re(a, this.clonePosition());
      return i ? (o *= n, Yc(o) ? { val: o, err: null } : this.error(r, l)) : this.error(t, l);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var r = tl(this.message, t);
      if (r === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return r;
    }, e.prototype.error = function(t, r) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: r
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (To(this.message, t, this.offset())) {
        for (var r = 0; r < t.length; r++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var r = this.offset(), n = this.message.indexOf(t, r);
      return n >= 0 ? (this.bumpTo(n), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var r = this.offset();
        if (r === t)
          break;
        if (r > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && nl(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), r = this.offset(), n = this.message.charCodeAt(r + (t >= 65536 ? 2 : 1));
      return n ?? null;
    }, e;
  }()
);
function ua(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function Xc(e) {
  return ua(e) || e === 47;
}
function Kc(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function nl(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function Jc(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function ca(e) {
  e.forEach(function(t) {
    if (delete t.location, Vs(t) || qs(t))
      for (var r in t.options)
        delete t.options[r].location, ca(t.options[r].value);
    else
      Gs(t) && Xs(t.style) || (Ys(t) || zs(t)) && ia(t.style) ? delete t.style.location : Zs(t) && ca(t.children);
  });
}
function Qc(e, t) {
  t === void 0 && (t = {}), t = k({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var r = new Zc(e, t).parse();
  if (r.err) {
    var n = SyntaxError(ee[r.err.kind]);
    throw n.location = r.err.location, n.originalMessage = r.err.message, n;
  }
  return t != null && t.captureLocation || ca(r.val), r.val;
}
function it(e, t) {
  var r = t && t.cache ? t.cache : of, n = t && t.serializer ? t.serializer : af, a = t && t.strategy ? t.strategy : tf;
  return a(e, {
    cache: r,
    serializer: n
  });
}
function ef(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function al(e, t, r, n) {
  var a = ef(n) ? n : r(n), i = t.get(a);
  return typeof i > "u" && (i = e.call(this, n), t.set(a, i)), i;
}
function il(e, t, r) {
  var n = Array.prototype.slice.call(arguments, 3), a = r(n), i = t.get(a);
  return typeof i > "u" && (i = e.apply(this, n), t.set(a, i)), i;
}
function Pi(e, t, r, n, a) {
  return r.bind(t, e, n, a);
}
function tf(e, t) {
  var r = e.length === 1 ? al : il;
  return Pi(e, this, r, t.cache.create(), t.serializer);
}
function rf(e, t) {
  return Pi(e, this, il, t.cache.create(), t.serializer);
}
function nf(e, t) {
  return Pi(e, this, al, t.cache.create(), t.serializer);
}
var af = function() {
  return JSON.stringify(arguments);
};
function Ci() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
Ci.prototype.get = function(e) {
  return this.cache[e];
};
Ci.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var of = {
  create: function() {
    return new Ci();
  }
}, ot = {
  variadic: rf,
  monadic: nf
}, ut;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(ut || (ut = {}));
var At = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t(r, n, a) {
      var i = e.call(this, r) || this;
      return i.code = n, i.originalMessage = a, i;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), So = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t(r, n, a, i) {
      return e.call(this, 'Invalid values for "'.concat(r, '": "').concat(n, '". Options are "').concat(Object.keys(a).join('", "'), '"'), ut.INVALID_VALUE, i) || this;
    }
    return t;
  }(At)
), sf = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t(r, n, a) {
      return e.call(this, 'Value for "'.concat(r, '" must be of type ').concat(n), ut.INVALID_VALUE, a) || this;
    }
    return t;
  }(At)
), lf = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t(r, n) {
      return e.call(this, 'The intl string context variable "'.concat(r, '" was not provided to the string "').concat(n, '"'), ut.MISSING_VALUE, n) || this;
    }
    return t;
  }(At)
), Ne;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(Ne || (Ne = {}));
function uf(e) {
  return e.length < 2 ? e : e.reduce(function(t, r) {
    var n = t[t.length - 1];
    return !n || n.type !== Ne.literal || r.type !== Ne.literal ? t.push(r) : n.value += r.value, t;
  }, []);
}
function ol(e) {
  return typeof e == "function";
}
function Xr(e, t, r, n, a, i, o) {
  if (e.length === 1 && _o(e[0]))
    return [
      {
        type: Ne.literal,
        value: e[0].value
      }
    ];
  for (var s = [], l = 0, u = e; l < u.length; l++) {
    var c = u[l];
    if (_o(c)) {
      s.push({
        type: Ne.literal,
        value: c.value
      });
      continue;
    }
    if (Pc(c)) {
      typeof i == "number" && s.push({
        type: Ne.literal,
        value: r.getNumberFormat(t).format(i)
      });
      continue;
    }
    var d = c.value;
    if (!(a && d in a))
      throw new lf(d, o);
    var m = a[d];
    if (Tc(c)) {
      (!m || typeof m == "string" || typeof m == "number") && (m = typeof m == "string" || typeof m == "number" ? String(m) : ""), s.push({
        type: typeof m == "string" ? Ne.literal : Ne.object,
        value: m
      });
      continue;
    }
    if (Ys(c)) {
      var x = typeof c.style == "string" ? n.date[c.style] : ia(c.style) ? c.style.parsedOptions : void 0;
      s.push({
        type: Ne.literal,
        value: r.getDateTimeFormat(t, x).format(m)
      });
      continue;
    }
    if (zs(c)) {
      var x = typeof c.style == "string" ? n.time[c.style] : ia(c.style) ? c.style.parsedOptions : n.time.medium;
      s.push({
        type: Ne.literal,
        value: r.getDateTimeFormat(t, x).format(m)
      });
      continue;
    }
    if (Gs(c)) {
      var x = typeof c.style == "string" ? n.number[c.style] : Xs(c.style) ? c.style.parsedOptions : void 0;
      x && x.scale && (m = m * (x.scale || 1)), s.push({
        type: Ne.literal,
        value: r.getNumberFormat(t, x).format(m)
      });
      continue;
    }
    if (Zs(c)) {
      var E = c.children, P = c.value, w = a[P];
      if (!ol(w))
        throw new sf(P, "function", o);
      var b = Xr(E, t, r, n, a, i), p = w(b.map(function(y) {
        return y.value;
      }));
      Array.isArray(p) || (p = [p]), s.push.apply(s, p.map(function(y) {
        return {
          type: typeof y == "string" ? Ne.literal : Ne.object,
          value: y
        };
      }));
    }
    if (Vs(c)) {
      var g = c.options[m] || c.options.other;
      if (!g)
        throw new So(c.value, m, Object.keys(c.options), o);
      s.push.apply(s, Xr(g.value, t, r, n, a));
      continue;
    }
    if (qs(c)) {
      var g = c.options["=".concat(m)];
      if (!g) {
        if (!Intl.PluralRules)
          throw new At(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, ut.MISSING_INTL_API, o);
        var _ = r.getPluralRules(t, { type: c.pluralType }).select(m - (c.offset || 0));
        g = c.options[_] || c.options.other;
      }
      if (!g)
        throw new So(c.value, m, Object.keys(c.options), o);
      s.push.apply(s, Xr(g.value, t, r, n, a, m - (c.offset || 0)));
      continue;
    }
  }
  return uf(s);
}
function cf(e, t) {
  return t ? k(k(k({}, e || {}), t || {}), Object.keys(e).reduce(function(r, n) {
    return r[n] = k(k({}, e[n]), t[n] || {}), r;
  }, {})) : e;
}
function ff(e, t) {
  return t ? Object.keys(e).reduce(function(r, n) {
    return r[n] = cf(e[n], t[n]), r;
  }, k({}, e)) : e;
}
function In(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, r) {
          e[t] = r;
        }
      };
    }
  };
}
function df(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: it(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.NumberFormat).bind.apply(t, st([void 0], r, !1)))();
    }, {
      cache: In(e.number),
      strategy: ot.variadic
    }),
    getDateTimeFormat: it(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, st([void 0], r, !1)))();
    }, {
      cache: In(e.dateTime),
      strategy: ot.variadic
    }),
    getPluralRules: it(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.PluralRules).bind.apply(t, st([void 0], r, !1)))();
    }, {
      cache: In(e.pluralRules),
      strategy: ot.variadic
    })
  };
}
var sl = (
  /** @class */
  function() {
    function e(t, r, n, a) {
      var i = this;
      if (r === void 0 && (r = e.defaultLocale), this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(l) {
        var u = i.formatToParts(l);
        if (u.length === 1)
          return u[0].value;
        var c = u.reduce(function(d, m) {
          return !d.length || m.type !== Ne.literal || typeof d[d.length - 1] != "string" ? d.push(m.value) : d[d.length - 1] += m.value, d;
        }, []);
        return c.length <= 1 ? c[0] || "" : c;
      }, this.formatToParts = function(l) {
        return Xr(i.ast, i.locales, i.formatters, i.formats, l, void 0, i.message);
      }, this.resolvedOptions = function() {
        var l;
        return {
          locale: ((l = i.resolvedLocale) === null || l === void 0 ? void 0 : l.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
        };
      }, this.getAst = function() {
        return i.ast;
      }, this.locales = r, this.resolvedLocale = e.resolveLocale(r), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var o = a || {};
        o.formatters;
        var s = ur(o, ["formatters"]);
        this.ast = e.__parse(t, k(k({}, s), { locale: this.resolvedLocale }));
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = ff(e.formats, n), this.formatters = a && a.formatters || df(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (!(typeof Intl.Locale > "u")) {
        var r = Intl.NumberFormat.supportedLocalesOf(t);
        return r.length > 0 ? new Intl.Locale(r[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = Qc, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }()
), $t;
(function(e) {
  e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION";
})($t || ($t = {}));
var kr = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t(r, n, a) {
      var i = this, o = a ? a instanceof Error ? a : new Error(String(a)) : void 0;
      return i = e.call(this, "[@formatjs/intl Error ".concat(r, "] ").concat(n, `
`).concat(o ? `
`.concat(o.message, `
`).concat(o.stack) : "")) || this, i.code = r, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(i, t), i;
    }
    return t;
  }(Error)
), mf = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t(r, n) {
      return e.call(this, $t.UNSUPPORTED_FORMATTER, r, n) || this;
    }
    return t;
  }(kr)
), hf = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t(r, n) {
      return e.call(this, $t.INVALID_CONFIG, r, n) || this;
    }
    return t;
  }(kr)
), Oo = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t(r, n) {
      return e.call(this, $t.MISSING_DATA, r, n) || this;
    }
    return t;
  }(kr)
), qe = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t(r, n, a) {
      var i = e.call(this, $t.FORMAT_ERROR, "".concat(r, `
Locale: `).concat(n, `
`), a) || this;
      return i.locale = n, i;
    }
    return t;
  }(kr)
), Dn = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t(r, n, a, i) {
      var o = e.call(this, "".concat(r, `
MessageID: `).concat(a == null ? void 0 : a.id, `
Default Message: `).concat(a == null ? void 0 : a.defaultMessage, `
Description: `).concat(a == null ? void 0 : a.description, `
`), n, i) || this;
      return o.descriptor = a, o.locale = n, o;
    }
    return t;
  }(qe)
), pf = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t(r, n) {
      var a = e.call(this, $t.MISSING_TRANSLATION, 'Missing message: "'.concat(r.id, '" for locale "').concat(n, '", using ').concat(r.defaultMessage ? "default message (".concat(typeof r.defaultMessage == "string" ? r.defaultMessage : r.defaultMessage.map(function(i) {
        var o;
        return (o = i.value) !== null && o !== void 0 ? o : JSON.stringify(i);
      }).join(), ")") : "id", " as fallback.")) || this;
      return a.descriptor = r, a;
    }
    return t;
  }(kr)
);
function Zt(e, t, r) {
  return r === void 0 && (r = {}), t.reduce(function(n, a) {
    return a in e ? n[a] = e[a] : a in r && (n[a] = r[a]), n;
  }, {});
}
var vf = function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
}, gf = function(e) {
  process.env.NODE_ENV !== "production" && console.warn(e);
}, ll = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: vf,
  onWarn: gf
};
function ul() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}
function Rt(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, r) {
          e[t] = r;
        }
      };
    }
  };
}
function bf(e) {
  e === void 0 && (e = ul());
  var t = Intl.RelativeTimeFormat, r = Intl.ListFormat, n = Intl.DisplayNames, a = it(function() {
    for (var s, l = [], u = 0; u < arguments.length; u++)
      l[u] = arguments[u];
    return new ((s = Intl.DateTimeFormat).bind.apply(s, st([void 0], l, !1)))();
  }, {
    cache: Rt(e.dateTime),
    strategy: ot.variadic
  }), i = it(function() {
    for (var s, l = [], u = 0; u < arguments.length; u++)
      l[u] = arguments[u];
    return new ((s = Intl.NumberFormat).bind.apply(s, st([void 0], l, !1)))();
  }, {
    cache: Rt(e.number),
    strategy: ot.variadic
  }), o = it(function() {
    for (var s, l = [], u = 0; u < arguments.length; u++)
      l[u] = arguments[u];
    return new ((s = Intl.PluralRules).bind.apply(s, st([void 0], l, !1)))();
  }, {
    cache: Rt(e.pluralRules),
    strategy: ot.variadic
  });
  return {
    getDateTimeFormat: a,
    getNumberFormat: i,
    getMessageFormat: it(function(s, l, u, c) {
      return new sl(s, l, u, k({ formatters: {
        getNumberFormat: i,
        getDateTimeFormat: a,
        getPluralRules: o
      } }, c || {}));
    }, {
      cache: Rt(e.message),
      strategy: ot.variadic
    }),
    getRelativeTimeFormat: it(function() {
      for (var s = [], l = 0; l < arguments.length; l++)
        s[l] = arguments[l];
      return new (t.bind.apply(t, st([void 0], s, !1)))();
    }, {
      cache: Rt(e.relativeTime),
      strategy: ot.variadic
    }),
    getPluralRules: o,
    getListFormat: it(function() {
      for (var s = [], l = 0; l < arguments.length; l++)
        s[l] = arguments[l];
      return new (r.bind.apply(r, st([void 0], s, !1)))();
    }, {
      cache: Rt(e.list),
      strategy: ot.variadic
    }),
    getDisplayNames: it(function() {
      for (var s = [], l = 0; l < arguments.length; l++)
        s[l] = arguments[l];
      return new (n.bind.apply(n, st([void 0], s, !1)))();
    }, {
      cache: Rt(e.displayNames),
      strategy: ot.variadic
    })
  };
}
function Si(e, t, r, n) {
  var a = e && e[t], i;
  if (a && (i = a[r]), i)
    return i;
  n(new mf("No ".concat(t, " format named: ").concat(r)));
}
function yf(e, t, r) {
  if (r === void 0 && (r = Error), !e)
    throw new r(t);
}
function $r(e, t) {
  return Object.keys(e).reduce(function(r, n) {
    return r[n] = k({ timeZone: t }, e[n]), r;
  }, {});
}
function No(e, t) {
  var r = Object.keys(k(k({}, e), t));
  return r.reduce(function(n, a) {
    return n[a] = k(k({}, e[a] || {}), t[a] || {}), n;
  }, {});
}
function Ao(e, t) {
  if (!t)
    return e;
  var r = sl.formats;
  return k(k(k({}, r), e), { date: No($r(r.date, t), $r(e.date || {}, t)), time: No($r(r.time, t), $r(e.time || {}, t)) });
}
var fa = function(e, t, r, n, a) {
  var i = e.locale, o = e.formats, s = e.messages, l = e.defaultLocale, u = e.defaultFormats, c = e.fallbackOnEmptyString, d = e.onError, m = e.timeZone, x = e.defaultRichTextElements;
  r === void 0 && (r = { id: "" });
  var E = r.id, P = r.defaultMessage;
  yf(!!E, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
  var w = String(E), b = (
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    s && Object.prototype.hasOwnProperty.call(s, w) && s[w]
  );
  if (Array.isArray(b) && b.length === 1 && b[0].type === fe.literal)
    return b[0].value;
  if (!n && b && typeof b == "string" && !x)
    return b.replace(/'\{(.*?)\}'/gi, "{$1}");
  if (n = k(k({}, x), n || {}), o = Ao(o, m), u = Ao(u, m), !b) {
    if (c === !1 && b === "")
      return b;
    if ((!P || i && i.toLowerCase() !== l.toLowerCase()) && d(new pf(r, i)), P)
      try {
        var p = t.getMessageFormat(P, l, u, a);
        return p.format(n);
      } catch (g) {
        return d(new Dn('Error formatting default message for: "'.concat(w, '", rendering default message verbatim'), i, r, g)), typeof P == "string" ? P : w;
      }
    return w;
  }
  try {
    var p = t.getMessageFormat(b, i, o, k({ formatters: t }, a || {}));
    return p.format(n);
  } catch (g) {
    d(new Dn('Error formatting message: "'.concat(w, '", using ').concat(P ? "default message" : "id", " as fallback."), i, r, g));
  }
  if (P)
    try {
      var p = t.getMessageFormat(P, l, u, a);
      return p.format(n);
    } catch (g) {
      d(new Dn('Error formatting the default message for: "'.concat(w, '", rendering message verbatim'), i, r, g));
    }
  return typeof b == "string" ? b : typeof P == "string" ? P : w;
}, cl = [
  "formatMatcher",
  "timeZone",
  "hour12",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "hourCycle",
  "dateStyle",
  "timeStyle",
  "calendar",
  // 'dayPeriod',
  "numberingSystem",
  "fractionalSecondDigits"
];
function bn(e, t, r, n) {
  var a = e.locale, i = e.formats, o = e.onError, s = e.timeZone;
  n === void 0 && (n = {});
  var l = n.format, u = k(k({}, s && { timeZone: s }), l && Si(i, t, l, o)), c = Zt(n, cl, u);
  return t === "time" && !c.hour && !c.minute && !c.second && !c.timeStyle && !c.dateStyle && (c = k(k({}, c), { hour: "numeric", minute: "numeric" })), r(a, c);
}
function _f(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var a = r[0], i = r[1], o = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return bn(e, "date", t, o).format(s);
  } catch (l) {
    e.onError(new qe("Error formatting date.", e.locale, l));
  }
  return String(s);
}
function xf(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var a = r[0], i = r[1], o = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return bn(e, "time", t, o).format(s);
  } catch (l) {
    e.onError(new qe("Error formatting time.", e.locale, l));
  }
  return String(s);
}
function wf(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var a = r[0], i = r[1], o = r[2], s = o === void 0 ? {} : o, l = e.timeZone, u = e.locale, c = e.onError, d = Zt(s, cl, l ? { timeZone: l } : {});
  try {
    return t(u, d).formatRange(a, i);
  } catch (m) {
    c(new qe("Error formatting date time range.", e.locale, m));
  }
  return String(a);
}
function Ef(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var a = r[0], i = r[1], o = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return bn(e, "date", t, o).formatToParts(s);
  } catch (l) {
    e.onError(new qe("Error formatting date.", e.locale, l));
  }
  return [];
}
function Tf(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var a = r[0], i = r[1], o = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return bn(e, "time", t, o).formatToParts(s);
  } catch (l) {
    e.onError(new qe("Error formatting time.", e.locale, l));
  }
  return [];
}
var Pf = [
  "style",
  "type",
  "fallback",
  "languageDisplay"
];
function Cf(e, t, r, n) {
  var a = e.locale, i = e.onError, o = Intl.DisplayNames;
  o || i(new At(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, ut.MISSING_INTL_API));
  var s = Zt(n, Pf);
  try {
    return t(a, s).of(r);
  } catch (l) {
    i(new qe("Error formatting display name.", a, l));
  }
}
var Sf = [
  "type",
  "style"
], Mo = Date.now();
function Of(e) {
  return "".concat(Mo, "_").concat(e, "_").concat(Mo);
}
function Nf(e, t, r, n) {
  n === void 0 && (n = {});
  var a = fl(e, t, r, n).reduce(function(i, o) {
    var s = o.value;
    return typeof s != "string" ? i.push(s) : typeof i[i.length - 1] == "string" ? i[i.length - 1] += s : i.push(s), i;
  }, []);
  return a.length === 1 ? a[0] : a.length === 0 ? "" : a;
}
function fl(e, t, r, n) {
  var a = e.locale, i = e.onError;
  n === void 0 && (n = {});
  var o = Intl.ListFormat;
  o || i(new At(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, ut.MISSING_INTL_API));
  var s = Zt(n, Sf);
  try {
    var l = {}, u = r.map(function(c, d) {
      if (typeof c == "object") {
        var m = Of(d);
        return l[m] = c, m;
      }
      return String(c);
    });
    return t(a, s).formatToParts(u).map(function(c) {
      return c.type === "literal" ? c : k(k({}, c), { value: l[c.value] || c.value });
    });
  } catch (c) {
    i(new qe("Error formatting list.", a, c));
  }
  return r;
}
var Af = ["type"];
function Mf(e, t, r, n) {
  var a = e.locale, i = e.onError;
  n === void 0 && (n = {}), Intl.PluralRules || i(new At(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, ut.MISSING_INTL_API));
  var o = Zt(n, Af);
  try {
    return t(a, o).select(r);
  } catch (s) {
    i(new qe("Error formatting plural.", a, s));
  }
  return "other";
}
var Rf = ["numeric", "style"];
function kf(e, t, r) {
  var n = e.locale, a = e.formats, i = e.onError;
  r === void 0 && (r = {});
  var o = r.format, s = !!o && Si(a, "relative", o, i) || {}, l = Zt(r, Rf, s);
  return t(n, l);
}
function If(e, t, r, n, a) {
  a === void 0 && (a = {}), n || (n = "second");
  var i = Intl.RelativeTimeFormat;
  i || e.onError(new At(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, ut.MISSING_INTL_API));
  try {
    return kf(e, t, a).format(r, n);
  } catch (o) {
    e.onError(new qe("Error formatting relative time.", e.locale, o));
  }
  return String(r);
}
var Df = [
  "style",
  "currency",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  // ES2020 NumberFormat
  "compactDisplay",
  "currencyDisplay",
  "currencySign",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "numberingSystem",
  // ES2023 NumberFormat
  "trailingZeroDisplay",
  "roundingPriority",
  "roundingIncrement",
  "roundingMode"
];
function dl(e, t, r) {
  var n = e.locale, a = e.formats, i = e.onError;
  r === void 0 && (r = {});
  var o = r.format, s = o && Si(a, "number", o, i) || {}, l = Zt(r, Df, s);
  return t(n, l);
}
function Lf(e, t, r, n) {
  n === void 0 && (n = {});
  try {
    return dl(e, t, n).format(r);
  } catch (a) {
    e.onError(new qe("Error formatting number.", e.locale, a));
  }
  return String(r);
}
function jf(e, t, r, n) {
  n === void 0 && (n = {});
  try {
    return dl(e, t, n).formatToParts(r);
  } catch (a) {
    e.onError(new qe("Error formatting number.", e.locale, a));
  }
  return [];
}
function Bf(e) {
  var t = e ? e[Object.keys(e)[0]] : void 0;
  return typeof t == "string";
}
function Hf(e) {
  e.onWarn && e.defaultRichTextElements && Bf(e.messages || {}) && e.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.io/docs/getting-started/message-distribution`);
}
function Ff(e, t) {
  var r = bf(t), n = k(k({}, ll), e), a = n.locale, i = n.defaultLocale, o = n.onError;
  return a ? !Intl.NumberFormat.supportedLocalesOf(a).length && o ? o(new Oo('Missing locale data for locale: "'.concat(a, '" in Intl.NumberFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : !Intl.DateTimeFormat.supportedLocalesOf(a).length && o && o(new Oo('Missing locale data for locale: "'.concat(a, '" in Intl.DateTimeFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : (o && o(new hf('"locale" was not configured, using "'.concat(i, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details'))), n.locale = n.defaultLocale || "en"), Hf(n), k(k({}, n), {
    formatters: r,
    formatNumber: Lf.bind(null, n, r.getNumberFormat),
    formatNumberToParts: jf.bind(null, n, r.getNumberFormat),
    formatRelativeTime: If.bind(null, n, r.getRelativeTimeFormat),
    formatDate: _f.bind(null, n, r.getDateTimeFormat),
    formatDateToParts: Ef.bind(null, n, r.getDateTimeFormat),
    formatTime: xf.bind(null, n, r.getDateTimeFormat),
    formatDateTimeRange: wf.bind(null, n, r.getDateTimeFormat),
    formatTimeToParts: Tf.bind(null, n, r.getDateTimeFormat),
    formatPlural: Mf.bind(null, n, r.getPluralRules),
    // @ts-expect-error TODO: will get to this later
    formatMessage: fa.bind(null, n, r),
    // @ts-expect-error TODO: will get to this later
    $t: fa.bind(null, n, r),
    formatList: Nf.bind(null, n, r.getListFormat),
    formatListToParts: fl.bind(null, n, r.getListFormat),
    formatDisplayName: Cf.bind(null, n, r.getDisplayNames)
  });
}
function ml(e) {
  Ec(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var hl = k(k({}, ll), { textComponent: h.Fragment });
function Uf(e) {
  return function(t) {
    return e(h.Children.toArray(t));
  };
}
function da(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var r = Object.keys(e), n = Object.keys(t), a = r.length;
  if (n.length !== a)
    return !1;
  for (var i = 0; i < a; i++) {
    var o = r[i];
    if (e[o] !== t[o] || !Object.prototype.hasOwnProperty.call(t, o))
      return !1;
  }
  return !0;
}
var Oi = typeof window < "u" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = h.createContext(null)) : h.createContext(null);
Oi.Consumer;
var $f = Oi.Provider, Wf = $f, Gf = Oi;
function be() {
  var e = h.useContext(Gf);
  return ml(e), e;
}
var ma;
(function(e) {
  e.formatDate = "FormattedDate", e.formatTime = "FormattedTime", e.formatNumber = "FormattedNumber", e.formatList = "FormattedList", e.formatDisplayName = "FormattedDisplayName";
})(ma || (ma = {}));
var ha;
(function(e) {
  e.formatDate = "FormattedDateParts", e.formatTime = "FormattedTimeParts", e.formatNumber = "FormattedNumberParts", e.formatList = "FormattedListParts";
})(ha || (ha = {}));
function pl(e) {
  var t = function(r) {
    var n = be(), a = r.value, i = r.children, o = ur(r, ["value", "children"]), s = typeof a == "string" ? new Date(a || 0) : a, l = e === "formatDate" ? n.formatDateToParts(s, o) : n.formatTimeToParts(s, o);
    return i(l);
  };
  return t.displayName = ha[e], t;
}
function Ir(e) {
  var t = function(r) {
    var n = be(), a = r.value, i = r.children, o = ur(
      r,
      ["value", "children"]
    ), s = n[e](a, o);
    if (typeof i == "function")
      return i(s);
    var l = n.textComponent || h.Fragment;
    return h.createElement(l, null, s);
  };
  return t.displayName = ma[e], t;
}
function vl(e) {
  return e && Object.keys(e).reduce(function(t, r) {
    var n = e[r];
    return t[r] = ol(n) ? Uf(n) : n, t;
  }, {});
}
var Ro = function(e, t, r, n) {
  for (var a = [], i = 4; i < arguments.length; i++)
    a[i - 4] = arguments[i];
  var o = vl(n), s = fa.apply(void 0, st([
    e,
    t,
    r,
    o
  ], a, !1));
  return Array.isArray(s) ? h.Children.toArray(s) : s;
}, ko = function(e, t) {
  var r = e.defaultRichTextElements, n = ur(e, ["defaultRichTextElements"]), a = vl(r), i = Ff(k(k(k({}, hl), n), { defaultRichTextElements: a }), t), o = {
    locale: i.locale,
    timeZone: i.timeZone,
    fallbackOnEmptyString: i.fallbackOnEmptyString,
    formats: i.formats,
    defaultLocale: i.defaultLocale,
    defaultFormats: i.defaultFormats,
    messages: i.messages,
    onError: i.onError,
    defaultRichTextElements: a
  };
  return k(k({}, i), {
    formatMessage: Ro.bind(
      null,
      o,
      // @ts-expect-error fix this
      i.formatters
    ),
    // @ts-expect-error fix this
    $t: Ro.bind(null, o, i.formatters)
  });
};
function Ln(e) {
  return {
    locale: e.locale,
    timeZone: e.timeZone,
    fallbackOnEmptyString: e.fallbackOnEmptyString,
    formats: e.formats,
    textComponent: e.textComponent,
    messages: e.messages,
    defaultLocale: e.defaultLocale,
    defaultFormats: e.defaultFormats,
    onError: e.onError,
    onWarn: e.onWarn,
    wrapRichTextChunksInFragment: e.wrapRichTextChunksInFragment,
    defaultRichTextElements: e.defaultRichTextElements
  };
}
var Yf = (
  /** @class */
  function(e) {
    Ve(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r.cache = ul(), r.state = {
        cache: r.cache,
        intl: ko(Ln(r.props), r.cache),
        prevConfig: Ln(r.props)
      }, r;
    }
    return t.getDerivedStateFromProps = function(r, n) {
      var a = n.prevConfig, i = n.cache, o = Ln(r);
      return da(a, o) ? null : {
        intl: ko(o, i),
        prevConfig: o
      };
    }, t.prototype.render = function() {
      return ml(this.state.intl), h.createElement(Wf, { value: this.state.intl }, this.props.children);
    }, t.displayName = "IntlProvider", t.defaultProps = hl, t;
  }(h.PureComponent)
);
const zf = Yf;
function Vf(e, t) {
  var r = e.values, n = ur(e, ["values"]), a = t.values, i = ur(t, ["values"]);
  return da(a, r) && da(n, i);
}
function gl(e) {
  var t = be(), r = t.formatMessage, n = t.textComponent, a = n === void 0 ? h.Fragment : n, i = e.id, o = e.description, s = e.defaultMessage, l = e.values, u = e.children, c = e.tagName, d = c === void 0 ? a : c, m = e.ignoreTag, x = { id: i, description: o, defaultMessage: s }, E = r(x, l, {
    ignoreTag: m
  });
  return typeof u == "function" ? u(Array.isArray(E) ? E : [E]) : d ? h.createElement(d, null, h.Children.toArray(E)) : h.createElement(h.Fragment, null, E);
}
gl.displayName = "FormattedMessage";
var bl = h.memo(gl, Vf);
bl.displayName = "MemoizedFormattedMessage";
const yl = bl;
Ir("formatDate");
Ir("formatTime");
Ir("formatNumber");
Ir("formatList");
Ir("formatDisplayName");
pl("formatDate");
pl("formatTime");
var pa = { exports: {} }, Wt = {}, va = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var jn, Io;
function qf() {
  if (Io)
    return jn;
  Io = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(c) {
        return o[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return jn = a() ? Object.assign : function(i, o) {
    for (var s, l = n(i), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        u = e(s);
        for (var m = 0; m < u.length; m++)
          r.call(s, u[m]) && (l[u[m]] = s[u[m]]);
      }
    }
    return l;
  }, jn;
}
var Bn, Do;
function Ni() {
  if (Do)
    return Bn;
  Do = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Bn = e, Bn;
}
var Hn, Lo;
function _l() {
  return Lo || (Lo = 1, Hn = Function.call.bind(Object.prototype.hasOwnProperty)), Hn;
}
var Fn, jo;
function Zf() {
  if (jo)
    return Fn;
  jo = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Ni(), r = {}, n = _l();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in i)
        if (n(i, c)) {
          var d;
          try {
            if (typeof i[c] != "function") {
              var m = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            d = i[c](o, c, l, s, null, t);
          } catch (E) {
            d = E;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in r)) {
            r[d.message] = !0;
            var x = u ? u() : "";
            e(
              "Failed " + s + " type: " + d.message + (x ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Fn = a, Fn;
}
var Un, Bo;
function Xf() {
  if (Bo)
    return Un;
  Bo = 1;
  var e = Ti, t = qf(), r = Ni(), n = _l(), a = Zf(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Un = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(C) {
      var N = C && (u && C[u] || C[c]);
      if (typeof N == "function")
        return N;
    }
    var m = "<<anonymous>>", x = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: p(),
      arrayOf: g,
      element: _(),
      elementType: y(),
      instanceOf: O,
      node: Ee(),
      objectOf: ne,
      oneOf: j,
      oneOfType: ae,
      shape: Ce,
      exact: he
    };
    function E(C, N) {
      return C === N ? C !== 0 || 1 / C === 1 / N : C !== C && N !== N;
    }
    function P(C, N) {
      this.message = C, this.data = N && typeof N == "object" ? N : {}, this.stack = "";
    }
    P.prototype = Error.prototype;
    function w(C) {
      if (process.env.NODE_ENV !== "production")
        var N = {}, U = 0;
      function H(Z, G, $, z, K, V, pe) {
        if (z = z || m, V = V || $, pe !== r) {
          if (l) {
            var A = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw A.name = "Invariant Violation", A;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var De = z + ":" + $;
            !N[De] && // Avoid spamming the console because they are often not actionable except for lib authors
            U < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + V + "` prop on `" + z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), N[De] = !0, U++);
          }
        }
        return G[$] == null ? Z ? G[$] === null ? new P("The " + K + " `" + V + "` is marked as required " + ("in `" + z + "`, but its value is `null`.")) : new P("The " + K + " `" + V + "` is marked as required in " + ("`" + z + "`, but its value is `undefined`.")) : null : C(G, $, z, K, V);
      }
      var F = H.bind(null, !1);
      return F.isRequired = H.bind(null, !0), F;
    }
    function b(C) {
      function N(U, H, F, Z, G, $) {
        var z = U[H], K = X(z);
        if (K !== C) {
          var V = T(z);
          return new P(
            "Invalid " + Z + " `" + G + "` of type " + ("`" + V + "` supplied to `" + F + "`, expected ") + ("`" + C + "`."),
            { expectedType: C }
          );
        }
        return null;
      }
      return w(N);
    }
    function p() {
      return w(o);
    }
    function g(C) {
      function N(U, H, F, Z, G) {
        if (typeof C != "function")
          return new P("Property `" + G + "` of component `" + F + "` has invalid PropType notation inside arrayOf.");
        var $ = U[H];
        if (!Array.isArray($)) {
          var z = X($);
          return new P("Invalid " + Z + " `" + G + "` of type " + ("`" + z + "` supplied to `" + F + "`, expected an array."));
        }
        for (var K = 0; K < $.length; K++) {
          var V = C($, K, F, Z, G + "[" + K + "]", r);
          if (V instanceof Error)
            return V;
        }
        return null;
      }
      return w(N);
    }
    function _() {
      function C(N, U, H, F, Z) {
        var G = N[U];
        if (!s(G)) {
          var $ = X(G);
          return new P("Invalid " + F + " `" + Z + "` of type " + ("`" + $ + "` supplied to `" + H + "`, expected a single ReactElement."));
        }
        return null;
      }
      return w(C);
    }
    function y() {
      function C(N, U, H, F, Z) {
        var G = N[U];
        if (!e.isValidElementType(G)) {
          var $ = X(G);
          return new P("Invalid " + F + " `" + Z + "` of type " + ("`" + $ + "` supplied to `" + H + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return w(C);
    }
    function O(C) {
      function N(U, H, F, Z, G) {
        if (!(U[H] instanceof C)) {
          var $ = C.name || m, z = le(U[H]);
          return new P("Invalid " + Z + " `" + G + "` of type " + ("`" + z + "` supplied to `" + F + "`, expected ") + ("instance of `" + $ + "`."));
        }
        return null;
      }
      return w(N);
    }
    function j(C) {
      if (!Array.isArray(C))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function N(U, H, F, Z, G) {
        for (var $ = U[H], z = 0; z < C.length; z++)
          if (E($, C[z]))
            return null;
        var K = JSON.stringify(C, function(pe, A) {
          var De = T(A);
          return De === "symbol" ? String(A) : A;
        });
        return new P("Invalid " + Z + " `" + G + "` of value `" + String($) + "` " + ("supplied to `" + F + "`, expected one of " + K + "."));
      }
      return w(N);
    }
    function ne(C) {
      function N(U, H, F, Z, G) {
        if (typeof C != "function")
          return new P("Property `" + G + "` of component `" + F + "` has invalid PropType notation inside objectOf.");
        var $ = U[H], z = X($);
        if (z !== "object")
          return new P("Invalid " + Z + " `" + G + "` of type " + ("`" + z + "` supplied to `" + F + "`, expected an object."));
        for (var K in $)
          if (n($, K)) {
            var V = C($, K, F, Z, G + "." + K, r);
            if (V instanceof Error)
              return V;
          }
        return null;
      }
      return w(N);
    }
    function ae(C) {
      if (!Array.isArray(C))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var N = 0; N < C.length; N++) {
        var U = C[N];
        if (typeof U != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + D(U) + " at index " + N + "."
          ), o;
      }
      function H(F, Z, G, $, z) {
        for (var K = [], V = 0; V < C.length; V++) {
          var pe = C[V], A = pe(F, Z, G, $, z, r);
          if (A == null)
            return null;
          A.data && n(A.data, "expectedType") && K.push(A.data.expectedType);
        }
        var De = K.length > 0 ? ", expected one of type [" + K.join(", ") + "]" : "";
        return new P("Invalid " + $ + " `" + z + "` supplied to " + ("`" + G + "`" + De + "."));
      }
      return w(H);
    }
    function Ee() {
      function C(N, U, H, F, Z) {
        return I(N[U]) ? null : new P("Invalid " + F + " `" + Z + "` supplied to " + ("`" + H + "`, expected a ReactNode."));
      }
      return w(C);
    }
    function Ie(C, N, U, H, F) {
      return new P(
        (C || "React class") + ": " + N + " type `" + U + "." + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + F + "`."
      );
    }
    function Ce(C) {
      function N(U, H, F, Z, G) {
        var $ = U[H], z = X($);
        if (z !== "object")
          return new P("Invalid " + Z + " `" + G + "` of type `" + z + "` " + ("supplied to `" + F + "`, expected `object`."));
        for (var K in C) {
          var V = C[K];
          if (typeof V != "function")
            return Ie(F, Z, G, K, T(V));
          var pe = V($, K, F, Z, G + "." + K, r);
          if (pe)
            return pe;
        }
        return null;
      }
      return w(N);
    }
    function he(C) {
      function N(U, H, F, Z, G) {
        var $ = U[H], z = X($);
        if (z !== "object")
          return new P("Invalid " + Z + " `" + G + "` of type `" + z + "` " + ("supplied to `" + F + "`, expected `object`."));
        var K = t({}, U[H], C);
        for (var V in K) {
          var pe = C[V];
          if (n(C, V) && typeof pe != "function")
            return Ie(F, Z, G, V, T(pe));
          if (!pe)
            return new P(
              "Invalid " + Z + " `" + G + "` key `" + V + "` supplied to `" + F + "`.\nBad object: " + JSON.stringify(U[H], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(C), null, "  ")
            );
          var A = pe($, V, F, Z, G + "." + V, r);
          if (A)
            return A;
        }
        return null;
      }
      return w(N);
    }
    function I(C) {
      switch (typeof C) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !C;
        case "object":
          if (Array.isArray(C))
            return C.every(I);
          if (C === null || s(C))
            return !0;
          var N = d(C);
          if (N) {
            var U = N.call(C), H;
            if (N !== C.entries) {
              for (; !(H = U.next()).done; )
                if (!I(H.value))
                  return !1;
            } else
              for (; !(H = U.next()).done; ) {
                var F = H.value;
                if (F && !I(F[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function L(C, N) {
      return C === "symbol" ? !0 : N ? N["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && N instanceof Symbol : !1;
    }
    function X(C) {
      var N = typeof C;
      return Array.isArray(C) ? "array" : C instanceof RegExp ? "object" : L(N, C) ? "symbol" : N;
    }
    function T(C) {
      if (typeof C > "u" || C === null)
        return "" + C;
      var N = X(C);
      if (N === "object") {
        if (C instanceof Date)
          return "date";
        if (C instanceof RegExp)
          return "regexp";
      }
      return N;
    }
    function D(C) {
      var N = T(C);
      switch (N) {
        case "array":
        case "object":
          return "an " + N;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + N;
        default:
          return N;
      }
    }
    function le(C) {
      return !C.constructor || !C.constructor.name ? m : C.constructor.name;
    }
    return x.checkPropTypes = a, x.resetWarningCache = a.resetWarningCache, x.PropTypes = x, x;
  }, Un;
}
var $n, Ho;
function Kf() {
  if (Ho)
    return $n;
  Ho = 1;
  var e = Ni();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, $n = function() {
    function n(o, s, l, u, c, d) {
      if (d !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, $n;
}
if (process.env.NODE_ENV !== "production") {
  var Jf = Ti, Qf = !0;
  va.exports = Xf()(Jf.isElement, Qf);
} else
  va.exports = Kf()();
var Ai = va.exports;
const Q = /* @__PURE__ */ qt(Ai);
var ga = { exports: {} }, rt = {}, ba = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var r = "none", n = "contents", a = /input|select|textarea|button|object|iframe/;
  function i(d, m) {
    return m.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    d.scrollWidth <= 0 && d.scrollHeight <= 0;
  }
  function o(d) {
    var m = d.offsetWidth <= 0 && d.offsetHeight <= 0;
    if (m && !d.innerHTML)
      return !0;
    try {
      var x = window.getComputedStyle(d), E = x.getPropertyValue("display");
      return m ? E !== n && i(d, x) : E === r;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function s(d) {
    for (var m = d, x = d.getRootNode && d.getRootNode(); m && m !== document.body; ) {
      if (x && m === x && (m = x.host.parentNode), o(m))
        return !1;
      m = m.parentNode;
    }
    return !0;
  }
  function l(d, m) {
    var x = d.nodeName.toLowerCase(), E = a.test(x) && !d.disabled || x === "a" && d.href || m;
    return E && s(d);
  }
  function u(d) {
    var m = d.getAttribute("tabindex");
    m === null && (m = void 0);
    var x = isNaN(m);
    return (x || m >= 0) && l(d, !x);
  }
  function c(d) {
    var m = [].slice.call(d.querySelectorAll("*"), 0).reduce(function(x, E) {
      return x.concat(E.shadowRoot ? c(E.shadowRoot) : [E]);
    }, []);
    return m.filter(u);
  }
  e.exports = t.default;
})(ba, ba.exports);
var xl = ba.exports;
Object.defineProperty(rt, "__esModule", {
  value: !0
});
rt.resetState = n0;
rt.log = a0;
rt.handleBlur = Nr;
rt.handleFocus = Ar;
rt.markForFocusLater = i0;
rt.returnFocus = o0;
rt.popWithoutFocus = s0;
rt.setupScopedFocus = l0;
rt.teardownScopedFocus = u0;
var e0 = xl, t0 = r0(e0);
function r0(e) {
  return e && e.__esModule ? e : { default: e };
}
var Gt = [], rr = null, ya = !1;
function n0() {
  Gt = [];
}
function a0() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), Gt.forEach(function(e) {
    var t = e || {};
    console.log(t.nodeName, t.className, t.id);
  }), console.log("end focusManager ----------"));
}
function Nr() {
  ya = !0;
}
function Ar() {
  if (ya) {
    if (ya = !1, !rr)
      return;
    setTimeout(function() {
      if (!rr.contains(document.activeElement)) {
        var e = (0, t0.default)(rr)[0] || rr;
        e.focus();
      }
    }, 0);
  }
}
function i0() {
  Gt.push(document.activeElement);
}
function o0() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = null;
  try {
    Gt.length !== 0 && (t = Gt.pop(), t.focus({ preventScroll: e }));
    return;
  } catch {
    console.warn(["You tried to return focus to", t, "but it is not in the DOM anymore"].join(" "));
  }
}
function s0() {
  Gt.length > 0 && Gt.pop();
}
function l0(e) {
  rr = e, window.addEventListener ? (window.addEventListener("blur", Nr, !1), document.addEventListener("focus", Ar, !0)) : (window.attachEvent("onBlur", Nr), document.attachEvent("onFocus", Ar));
}
function u0() {
  rr = null, window.addEventListener ? (window.removeEventListener("blur", Nr), document.removeEventListener("focus", Ar)) : (window.detachEvent("onBlur", Nr), document.detachEvent("onFocus", Ar));
}
var _a = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = xl, n = a(r);
  function a(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function i() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return s.activeElement.shadowRoot ? i(s.activeElement.shadowRoot) : s.activeElement;
  }
  function o(s, l) {
    var u = (0, n.default)(s);
    if (!u.length) {
      l.preventDefault();
      return;
    }
    var c = void 0, d = l.shiftKey, m = u[0], x = u[u.length - 1], E = i();
    if (s === E) {
      if (!d)
        return;
      c = x;
    }
    if (x === E && !d && (c = m), m === E && d && (c = x), c) {
      l.preventDefault(), c.focus();
      return;
    }
    var P = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), w = P != null && P[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (w) {
      var b = u.indexOf(E);
      if (b > -1 && (b += d ? -1 : 1), c = u[b], typeof c > "u") {
        l.preventDefault(), c = d ? x : m, c.focus();
        return;
      }
      l.preventDefault(), c.focus();
    }
  }
  e.exports = t.default;
})(_a, _a.exports);
var c0 = _a.exports, nt = {}, f0 = process.env.NODE_ENV !== "production", wl = function() {
};
if (f0) {
  var d0 = function(t, r) {
    var n = arguments.length;
    r = new Array(n > 1 ? n - 1 : 0);
    for (var a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    var i = 0, o = "Warning: " + t.replace(/%s/g, function() {
      return r[i++];
    });
    typeof console < "u" && console.error(o);
    try {
      throw new Error(o);
    } catch {
    }
  };
  wl = function(e, t, r) {
    var n = arguments.length;
    r = new Array(n > 2 ? n - 2 : 0);
    for (var a = 2; a < n; a++)
      r[a - 2] = arguments[a];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || d0.apply(null, [t].concat(r));
  };
}
var m0 = wl, tt = {}, El = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(e) {
  (function() {
    var t = !!(typeof window < "u" && window.document && window.document.createElement), r = {
      canUseDOM: t,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
      canUseViewport: t && !!window.screen
    };
    e.exports ? e.exports = r : window.ExecutionEnvironment = r;
  })();
})(El);
var h0 = El.exports;
Object.defineProperty(tt, "__esModule", {
  value: !0
});
tt.canUseDOM = tt.SafeNodeList = tt.SafeHTMLCollection = void 0;
var p0 = h0, v0 = g0(p0);
function g0(e) {
  return e && e.__esModule ? e : { default: e };
}
var yn = v0.default, b0 = yn.canUseDOM ? window.HTMLElement : {};
tt.SafeHTMLCollection = yn.canUseDOM ? window.HTMLCollection : {};
tt.SafeNodeList = yn.canUseDOM ? window.NodeList : {};
tt.canUseDOM = yn.canUseDOM;
tt.default = b0;
Object.defineProperty(nt, "__esModule", {
  value: !0
});
nt.resetState = E0;
nt.log = T0;
nt.assertNodeList = Tl;
nt.setElement = P0;
nt.validateElement = Mi;
nt.hide = C0;
nt.show = S0;
nt.documentNotReadyOrSSRTesting = O0;
var y0 = m0, _0 = w0(y0), x0 = tt;
function w0(e) {
  return e && e.__esModule ? e : { default: e };
}
var Fe = null;
function E0() {
  Fe && (Fe.removeAttribute ? Fe.removeAttribute("aria-hidden") : Fe.length != null ? Fe.forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(Fe).forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  })), Fe = null;
}
function T0() {
  if (process.env.NODE_ENV !== "production") {
    var e = Fe || {};
    console.log("ariaAppHider ----------"), console.log(e.nodeName, e.className, e.id), console.log("end ariaAppHider ----------");
  }
}
function Tl(e, t) {
  if (!e || !e.length)
    throw new Error("react-modal: No elements were found for selector " + t + ".");
}
function P0(e) {
  var t = e;
  if (typeof t == "string" && x0.canUseDOM) {
    var r = document.querySelectorAll(t);
    Tl(r, t), t = r;
  }
  return Fe = t || Fe, Fe;
}
function Mi(e) {
  var t = e || Fe;
  return t ? Array.isArray(t) || t instanceof HTMLCollection || t instanceof NodeList ? t : [t] : ((0, _0.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function C0(e) {
  var t = !0, r = !1, n = void 0;
  try {
    for (var a = Mi(e)[Symbol.iterator](), i; !(t = (i = a.next()).done); t = !0) {
      var o = i.value;
      o.setAttribute("aria-hidden", "true");
    }
  } catch (s) {
    r = !0, n = s;
  } finally {
    try {
      !t && a.return && a.return();
    } finally {
      if (r)
        throw n;
    }
  }
}
function S0(e) {
  var t = !0, r = !1, n = void 0;
  try {
    for (var a = Mi(e)[Symbol.iterator](), i; !(t = (i = a.next()).done); t = !0) {
      var o = i.value;
      o.removeAttribute("aria-hidden");
    }
  } catch (s) {
    r = !0, n = s;
  } finally {
    try {
      !t && a.return && a.return();
    } finally {
      if (r)
        throw n;
    }
  }
}
function O0() {
  Fe = null;
}
var mr = {};
Object.defineProperty(mr, "__esModule", {
  value: !0
});
mr.resetState = N0;
mr.log = A0;
var Ht = {}, Ft = {};
function Fo(e, t) {
  e.classList.remove(t);
}
function N0() {
  var e = document.getElementsByTagName("html")[0];
  for (var t in Ht)
    Fo(e, Ht[t]);
  var r = document.body;
  for (var n in Ft)
    Fo(r, Ft[n]);
  Ht = {}, Ft = {};
}
function A0() {
  if (process.env.NODE_ENV !== "production") {
    var e = document.getElementsByTagName("html")[0].className, t = `Show tracked classes:

`;
    t += "<html /> (" + e + `):
  `;
    for (var r in Ht)
      t += "  " + r + " " + Ht[r] + `
  `;
    e = document.body.className, t += `

doc.body (` + e + `):
  `;
    for (var n in Ft)
      t += "  " + n + " " + Ft[n] + `
  `;
    t += `
`, console.log(t);
  }
}
var M0 = function(t, r) {
  return t[r] || (t[r] = 0), t[r] += 1, r;
}, R0 = function(t, r) {
  return t[r] && (t[r] -= 1), r;
}, k0 = function(t, r, n) {
  n.forEach(function(a) {
    M0(r, a), t.add(a);
  });
}, I0 = function(t, r, n) {
  n.forEach(function(a) {
    R0(r, a), r[a] === 0 && t.remove(a);
  });
};
mr.add = function(t, r) {
  return k0(t.classList, t.nodeName.toLowerCase() == "html" ? Ht : Ft, r.split(" "));
};
mr.remove = function(t, r) {
  return I0(t.classList, t.nodeName.toLowerCase() == "html" ? Ht : Ft, r.split(" "));
};
var hr = {};
Object.defineProperty(hr, "__esModule", {
  value: !0
});
hr.log = L0;
hr.resetState = j0;
function D0(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var Pl = function e() {
  var t = this;
  D0(this, e), this.register = function(r) {
    if (t.openInstances.indexOf(r) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    t.openInstances.push(r), t.emit("register");
  }, this.deregister = function(r) {
    var n = t.openInstances.indexOf(r);
    if (n === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + r + " as it was never registered");
      return;
    }
    t.openInstances.splice(n, 1), t.emit("deregister");
  }, this.subscribe = function(r) {
    t.subscribers.push(r);
  }, this.emit = function(r) {
    t.subscribers.forEach(function(n) {
      return n(
        r,
        // shallow copy to avoid accidental mutation
        t.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, an = new Pl();
function L0() {
  console.log("portalOpenInstances ----------"), console.log(an.openInstances.length), an.openInstances.forEach(function(e) {
    return console.log(e);
  }), console.log("end portalOpenInstances ----------");
}
function j0() {
  an = new Pl();
}
hr.default = an;
var Ri = {};
Object.defineProperty(Ri, "__esModule", {
  value: !0
});
Ri.resetState = U0;
Ri.log = $0;
var B0 = hr, H0 = F0(B0);
function F0(e) {
  return e && e.__esModule ? e : { default: e };
}
var Pe = void 0, Ke = void 0, Ut = [];
function U0() {
  for (var e = [Pe, Ke], t = 0; t < e.length; t++) {
    var r = e[t];
    r && r.parentNode && r.parentNode.removeChild(r);
  }
  Pe = Ke = null, Ut = [];
}
function $0() {
  console.log("bodyTrap ----------"), console.log(Ut.length);
  for (var e = [Pe, Ke], t = 0; t < e.length; t++) {
    var r = e[t], n = r || {};
    console.log(n.nodeName, n.className, n.id);
  }
  console.log("edn bodyTrap ----------");
}
function Uo() {
  if (Ut.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  Ut[Ut.length - 1].focusContent();
}
function W0(e, t) {
  !Pe && !Ke && (Pe = document.createElement("div"), Pe.setAttribute("data-react-modal-body-trap", ""), Pe.style.position = "absolute", Pe.style.opacity = "0", Pe.setAttribute("tabindex", "0"), Pe.addEventListener("focus", Uo), Ke = Pe.cloneNode(), Ke.addEventListener("focus", Uo)), Ut = t, Ut.length > 0 ? (document.body.firstChild !== Pe && document.body.insertBefore(Pe, document.body.firstChild), document.body.lastChild !== Ke && document.body.appendChild(Ke)) : (Pe.parentElement && Pe.parentElement.removeChild(Pe), Ke.parentElement && Ke.parentElement.removeChild(Ke));
}
H0.default.subscribe(W0);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = Object.assign || function(I) {
    for (var L = 1; L < arguments.length; L++) {
      var X = arguments[L];
      for (var T in X)
        Object.prototype.hasOwnProperty.call(X, T) && (I[T] = X[T]);
    }
    return I;
  }, n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(I) {
    return typeof I;
  } : function(I) {
    return I && typeof Symbol == "function" && I.constructor === Symbol && I !== Symbol.prototype ? "symbol" : typeof I;
  }, a = /* @__PURE__ */ function() {
    function I(L, X) {
      for (var T = 0; T < X.length; T++) {
        var D = X[T];
        D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(L, D.key, D);
      }
    }
    return function(L, X, T) {
      return X && I(L.prototype, X), T && I(L, T), L;
    };
  }(), i = Rr, o = Ai, s = y(o), l = rt, u = _(l), c = c0, d = y(c), m = nt, x = _(m), E = mr, P = _(E), w = tt, b = y(w), p = hr, g = y(p);
  function _(I) {
    if (I && I.__esModule)
      return I;
    var L = {};
    if (I != null)
      for (var X in I)
        Object.prototype.hasOwnProperty.call(I, X) && (L[X] = I[X]);
    return L.default = I, L;
  }
  function y(I) {
    return I && I.__esModule ? I : { default: I };
  }
  function O(I, L) {
    if (!(I instanceof L))
      throw new TypeError("Cannot call a class as a function");
  }
  function j(I, L) {
    if (!I)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return L && (typeof L == "object" || typeof L == "function") ? L : I;
  }
  function ne(I, L) {
    if (typeof L != "function" && L !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof L);
    I.prototype = Object.create(L && L.prototype, { constructor: { value: I, enumerable: !1, writable: !0, configurable: !0 } }), L && (Object.setPrototypeOf ? Object.setPrototypeOf(I, L) : I.__proto__ = L);
  }
  var ae = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, Ee = function(L) {
    return L.code === "Tab" || L.keyCode === 9;
  }, Ie = function(L) {
    return L.code === "Escape" || L.keyCode === 27;
  }, Ce = 0, he = function(I) {
    ne(L, I);
    function L(X) {
      O(this, L);
      var T = j(this, (L.__proto__ || Object.getPrototypeOf(L)).call(this, X));
      return T.setOverlayRef = function(D) {
        T.overlay = D, T.props.overlayRef && T.props.overlayRef(D);
      }, T.setContentRef = function(D) {
        T.content = D, T.props.contentRef && T.props.contentRef(D);
      }, T.afterClose = function() {
        var D = T.props, le = D.appElement, C = D.ariaHideApp, N = D.htmlOpenClassName, U = D.bodyOpenClassName, H = D.parentSelector, F = H && H().ownerDocument || document;
        U && P.remove(F.body, U), N && P.remove(F.getElementsByTagName("html")[0], N), C && Ce > 0 && (Ce -= 1, Ce === 0 && x.show(le)), T.props.shouldFocusAfterRender && (T.props.shouldReturnFocusAfterClose ? (u.returnFocus(T.props.preventScroll), u.teardownScopedFocus()) : u.popWithoutFocus()), T.props.onAfterClose && T.props.onAfterClose(), g.default.deregister(T);
      }, T.open = function() {
        T.beforeOpen(), T.state.afterOpen && T.state.beforeClose ? (clearTimeout(T.closeTimer), T.setState({ beforeClose: !1 })) : (T.props.shouldFocusAfterRender && (u.setupScopedFocus(T.node), u.markForFocusLater()), T.setState({ isOpen: !0 }, function() {
          T.openAnimationFrame = requestAnimationFrame(function() {
            T.setState({ afterOpen: !0 }), T.props.isOpen && T.props.onAfterOpen && T.props.onAfterOpen({
              overlayEl: T.overlay,
              contentEl: T.content
            });
          });
        }));
      }, T.close = function() {
        T.props.closeTimeoutMS > 0 ? T.closeWithTimeout() : T.closeWithoutTimeout();
      }, T.focusContent = function() {
        return T.content && !T.contentHasFocus() && T.content.focus({ preventScroll: !0 });
      }, T.closeWithTimeout = function() {
        var D = Date.now() + T.props.closeTimeoutMS;
        T.setState({ beforeClose: !0, closesAt: D }, function() {
          T.closeTimer = setTimeout(T.closeWithoutTimeout, T.state.closesAt - Date.now());
        });
      }, T.closeWithoutTimeout = function() {
        T.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, T.afterClose);
      }, T.handleKeyDown = function(D) {
        Ee(D) && (0, d.default)(T.content, D), T.props.shouldCloseOnEsc && Ie(D) && (D.stopPropagation(), T.requestClose(D));
      }, T.handleOverlayOnClick = function(D) {
        T.shouldClose === null && (T.shouldClose = !0), T.shouldClose && T.props.shouldCloseOnOverlayClick && (T.ownerHandlesClose() ? T.requestClose(D) : T.focusContent()), T.shouldClose = null;
      }, T.handleContentOnMouseUp = function() {
        T.shouldClose = !1;
      }, T.handleOverlayOnMouseDown = function(D) {
        !T.props.shouldCloseOnOverlayClick && D.target == T.overlay && D.preventDefault();
      }, T.handleContentOnClick = function() {
        T.shouldClose = !1;
      }, T.handleContentOnMouseDown = function() {
        T.shouldClose = !1;
      }, T.requestClose = function(D) {
        return T.ownerHandlesClose() && T.props.onRequestClose(D);
      }, T.ownerHandlesClose = function() {
        return T.props.onRequestClose;
      }, T.shouldBeClosed = function() {
        return !T.state.isOpen && !T.state.beforeClose;
      }, T.contentHasFocus = function() {
        return document.activeElement === T.content || T.content.contains(document.activeElement);
      }, T.buildClassName = function(D, le) {
        var C = (typeof le > "u" ? "undefined" : n(le)) === "object" ? le : {
          base: ae[D],
          afterOpen: ae[D] + "--after-open",
          beforeClose: ae[D] + "--before-close"
        }, N = C.base;
        return T.state.afterOpen && (N = N + " " + C.afterOpen), T.state.beforeClose && (N = N + " " + C.beforeClose), typeof le == "string" && le ? N + " " + le : N;
      }, T.attributesFromObject = function(D, le) {
        return Object.keys(le).reduce(function(C, N) {
          return C[D + "-" + N] = le[N], C;
        }, {});
      }, T.state = {
        afterOpen: !1,
        beforeClose: !1
      }, T.shouldClose = null, T.moveFromContentToOverlay = null, T;
    }
    return a(L, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(T, D) {
        process.env.NODE_ENV !== "production" && (T.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), T.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !T.isOpen ? this.open() : !this.props.isOpen && T.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !D.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var T = this.props, D = T.appElement, le = T.ariaHideApp, C = T.htmlOpenClassName, N = T.bodyOpenClassName, U = T.parentSelector, H = U && U().ownerDocument || document;
        N && P.add(H.body, N), C && P.add(H.getElementsByTagName("html")[0], C), le && (Ce += 1, x.hide(D)), g.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var T = this.props, D = T.id, le = T.className, C = T.overlayClassName, N = T.defaultStyles, U = T.children, H = le ? {} : N.content, F = C ? {} : N.overlay;
        if (this.shouldBeClosed())
          return null;
        var Z = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", C),
          style: r({}, F, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, G = r({
          id: D,
          ref: this.setContentRef,
          style: r({}, H, this.props.style.content),
          className: this.buildClassName("content", le),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", r({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), $ = this.props.contentElement(G, U);
        return this.props.overlayElement(Z, $);
      }
    }]), L;
  }(i.Component);
  he.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, he.propTypes = {
    isOpen: s.default.bool.isRequired,
    defaultStyles: s.default.shape({
      content: s.default.object,
      overlay: s.default.object
    }),
    style: s.default.shape({
      content: s.default.object,
      overlay: s.default.object
    }),
    className: s.default.oneOfType([s.default.string, s.default.object]),
    overlayClassName: s.default.oneOfType([s.default.string, s.default.object]),
    parentSelector: s.default.func,
    bodyOpenClassName: s.default.string,
    htmlOpenClassName: s.default.string,
    ariaHideApp: s.default.bool,
    appElement: s.default.oneOfType([s.default.instanceOf(b.default), s.default.instanceOf(w.SafeHTMLCollection), s.default.instanceOf(w.SafeNodeList), s.default.arrayOf(s.default.instanceOf(b.default))]),
    onAfterOpen: s.default.func,
    onAfterClose: s.default.func,
    onRequestClose: s.default.func,
    closeTimeoutMS: s.default.number,
    shouldFocusAfterRender: s.default.bool,
    shouldCloseOnOverlayClick: s.default.bool,
    shouldReturnFocusAfterClose: s.default.bool,
    preventScroll: s.default.bool,
    role: s.default.string,
    contentLabel: s.default.string,
    aria: s.default.object,
    data: s.default.object,
    children: s.default.node,
    shouldCloseOnEsc: s.default.bool,
    overlayRef: s.default.func,
    contentRef: s.default.func,
    id: s.default.string,
    overlayElement: s.default.func,
    contentElement: s.default.func,
    testId: s.default.string
  }, t.default = he, e.exports = t.default;
})(ga, ga.exports);
var G0 = ga.exports;
function Cl() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function Sl(e) {
  function t(r) {
    var n = this.constructor.getDerivedStateFromProps(e, r);
    return n ?? null;
  }
  this.setState(t.bind(this));
}
function Ol(e, t) {
  try {
    var r = this.props, n = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      r,
      n
    );
  } finally {
    this.props = r, this.state = n;
  }
}
Cl.__suppressDeprecationWarning = !0;
Sl.__suppressDeprecationWarning = !0;
Ol.__suppressDeprecationWarning = !0;
function Y0(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var r = null, n = null, a = null;
  if (typeof t.componentWillMount == "function" ? r = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (r = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? n = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (n = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? a = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (a = "UNSAFE_componentWillUpdate"), r !== null || n !== null || a !== null) {
    var i = e.displayName || e.name, o = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + i + " uses " + o + " but also contains the following legacy lifecycles:" + (r !== null ? `
  ` + r : "") + (n !== null ? `
  ` + n : "") + (a !== null ? `
  ` + a : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = Cl, t.componentWillReceiveProps = Sl), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = Ol;
    var s = t.componentDidUpdate;
    t.componentDidUpdate = function(u, c, d) {
      var m = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : d;
      s.call(this, u, c, m);
    };
  }
  return e;
}
const z0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: Y0
}, Symbol.toStringTag, { value: "Module" })), V0 = /* @__PURE__ */ vc(z0);
Object.defineProperty(Wt, "__esModule", {
  value: !0
});
Wt.bodyOpenClassName = Wt.portalClassName = void 0;
var $o = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, q0 = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}(), Nl = Rr, on = Dr(Nl), Z0 = hc, sn = Dr(Z0), X0 = Ai, Y = Dr(X0), K0 = G0, Wo = Dr(K0), J0 = nt, Q0 = td(J0), Pt = tt, Go = Dr(Pt), ed = V0;
function td(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
  return t.default = e, t;
}
function Dr(e) {
  return e && e.__esModule ? e : { default: e };
}
function rd(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Yo(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function nd(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var ad = Wt.portalClassName = "ReactModalPortal", id = Wt.bodyOpenClassName = "ReactModal__Body--open", Dt = Pt.canUseDOM && sn.default.createPortal !== void 0, xa = function(t) {
  return document.createElement(t);
}, zo = function() {
  return Dt ? sn.default.createPortal : sn.default.unstable_renderSubtreeIntoContainer;
};
function Wr(e) {
  return e();
}
var pr = function(e) {
  nd(t, e);
  function t() {
    var r, n, a, i;
    rd(this, t);
    for (var o = arguments.length, s = Array(o), l = 0; l < o; l++)
      s[l] = arguments[l];
    return i = (n = (a = Yo(this, (r = t.__proto__ || Object.getPrototypeOf(t)).call.apply(r, [this].concat(s))), a), a.removePortal = function() {
      !Dt && sn.default.unmountComponentAtNode(a.node);
      var u = Wr(a.props.parentSelector);
      u && u.contains(a.node) ? u.removeChild(a.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, a.portalRef = function(u) {
      a.portal = u;
    }, a.renderPortal = function(u) {
      var c = zo(), d = c(a, on.default.createElement(Wo.default, $o({ defaultStyles: t.defaultStyles }, u)), a.node);
      a.portalRef(d);
    }, n), Yo(a, i);
  }
  return q0(t, [{
    key: "componentDidMount",
    value: function() {
      if (Pt.canUseDOM) {
        Dt || (this.node = xa("div")), this.node.className = this.props.portalClassName;
        var n = Wr(this.props.parentSelector);
        n.appendChild(this.node), !Dt && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(n) {
      var a = Wr(n.parentSelector), i = Wr(this.props.parentSelector);
      return { prevParent: a, nextParent: i };
    }
  }, {
    key: "componentDidUpdate",
    value: function(n, a, i) {
      if (Pt.canUseDOM) {
        var o = this.props, s = o.isOpen, l = o.portalClassName;
        n.portalClassName !== l && (this.node.className = l);
        var u = i.prevParent, c = i.nextParent;
        c !== u && (u.removeChild(this.node), c.appendChild(this.node)), !(!n.isOpen && !s) && !Dt && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!Pt.canUseDOM || !this.node || !this.portal)) {
        var n = this.portal.state, a = Date.now(), i = n.isOpen && this.props.closeTimeoutMS && (n.closesAt || a + this.props.closeTimeoutMS);
        i ? (n.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, i - a)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!Pt.canUseDOM || !Dt)
        return null;
      !this.node && Dt && (this.node = xa("div"));
      var n = zo();
      return n(on.default.createElement(Wo.default, $o({
        ref: this.portalRef,
        defaultStyles: t.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(n) {
      Q0.setElement(n);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), t;
}(Nl.Component);
pr.propTypes = {
  isOpen: Y.default.bool.isRequired,
  style: Y.default.shape({
    content: Y.default.object,
    overlay: Y.default.object
  }),
  portalClassName: Y.default.string,
  bodyOpenClassName: Y.default.string,
  htmlOpenClassName: Y.default.string,
  className: Y.default.oneOfType([Y.default.string, Y.default.shape({
    base: Y.default.string.isRequired,
    afterOpen: Y.default.string.isRequired,
    beforeClose: Y.default.string.isRequired
  })]),
  overlayClassName: Y.default.oneOfType([Y.default.string, Y.default.shape({
    base: Y.default.string.isRequired,
    afterOpen: Y.default.string.isRequired,
    beforeClose: Y.default.string.isRequired
  })]),
  appElement: Y.default.oneOfType([Y.default.instanceOf(Go.default), Y.default.instanceOf(Pt.SafeHTMLCollection), Y.default.instanceOf(Pt.SafeNodeList), Y.default.arrayOf(Y.default.instanceOf(Go.default))]),
  onAfterOpen: Y.default.func,
  onRequestClose: Y.default.func,
  closeTimeoutMS: Y.default.number,
  ariaHideApp: Y.default.bool,
  shouldFocusAfterRender: Y.default.bool,
  shouldCloseOnOverlayClick: Y.default.bool,
  shouldReturnFocusAfterClose: Y.default.bool,
  preventScroll: Y.default.bool,
  parentSelector: Y.default.func,
  aria: Y.default.object,
  data: Y.default.object,
  role: Y.default.string,
  contentLabel: Y.default.string,
  shouldCloseOnEsc: Y.default.bool,
  overlayRef: Y.default.func,
  contentRef: Y.default.func,
  id: Y.default.string,
  overlayElement: Y.default.func,
  contentElement: Y.default.func
};
pr.defaultProps = {
  isOpen: !1,
  portalClassName: ad,
  bodyOpenClassName: id,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(t, r) {
    return on.default.createElement(
      "div",
      t,
      r
    );
  },
  contentElement: function(t, r) {
    return on.default.createElement(
      "div",
      t,
      r
    );
  }
};
pr.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, ed.polyfill)(pr);
process.env.NODE_ENV !== "production" && (pr.setCreateHTMLElement = function(e) {
  return xa = e;
});
Wt.default = pr;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = Wt, n = a(r);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  t.default = n.default, e.exports = t.default;
})(pa, pa.exports);
var od = pa.exports;
const Al = /* @__PURE__ */ qt(od);
var Ml = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (i = a(i, n(s)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var s in i)
        t.call(i, s) && i[s] && (o = a(o, s));
      return o;
    }
    function a(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(Ml);
var sd = Ml.exports;
const q = /* @__PURE__ */ qt(sd);
/*!
 * Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2022 Fonticons, Inc.
 */
var ld = {
  prefix: "far",
  iconName: "arrow-left-long",
  icon: [512, 512, ["long-arrow-left"], "f177", "M176.1 103C181.7 107.7 184 113.8 184 120S181.7 132.3 176.1 136.1L81.94 232H488C501.3 232 512 242.8 512 256s-10.75 24-24 24H81.94l95.03 95.03c9.375 9.375 9.375 24.56 0 33.94s-24.56 9.375-33.94 0l-136-136c-9.375-9.375-9.375-24.56 0-33.94l136-136C152.4 93.66 167.6 93.66 176.1 103z"]
}, ud = ld, cd = {
  prefix: "far",
  iconName: "arrow-right-long",
  icon: [512, 512, ["long-arrow-right"], "f178", "M335 408.1C330.3 404.3 328 398.2 328 392s2.344-12.28 7.031-16.97L430.1 280H24C10.75 280 0 269.2 0 255.1C0 242.7 10.75 232 24 232h406.1l-95.03-95.03c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0l136 136c9.375 9.375 9.375 24.56 0 33.94l-136 136C359.6 418.3 344.4 418.3 335 408.1z"]
}, fd = cd, dd = {
  prefix: "far",
  iconName: "check",
  icon: [448, 512, [10004, 10003], "f00c", "M440.1 103C450.3 112.4 450.3 127.6 440.1 136.1L176.1 400.1C167.6 410.3 152.4 410.3 143 400.1L7.029 264.1C-2.343 255.6-2.343 240.4 7.029 231C16.4 221.7 31.6 221.7 40.97 231L160 350.1L407 103C416.4 93.66 431.6 93.66 440.1 103V103z"]
};
/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function Vo(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function R(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vo(Object(r), !0).forEach(function(n) {
      pd(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Vo(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ln(e) {
  "@babel/helpers - typeof";
  return ln = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ln(e);
}
function md(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qo(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function hd(e, t, r) {
  return t && qo(e.prototype, t), r && qo(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function pd(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function ki(e, t) {
  return gd(e) || yd(e, t) || Rl(e, t) || xd();
}
function _n(e) {
  return vd(e) || bd(e) || Rl(e) || _d();
}
function vd(e) {
  if (Array.isArray(e))
    return wa(e);
}
function gd(e) {
  if (Array.isArray(e))
    return e;
}
function bd(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function yd(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, o, s;
    try {
      for (r = r.call(e); !(a = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); a = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i)
          throw s;
      }
    }
    return n;
  }
}
function Rl(e, t) {
  if (e) {
    if (typeof e == "string")
      return wa(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return wa(e, t);
  }
}
function wa(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function _d() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xd() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Zo = function() {
}, Ii = {}, kl = {}, Il = null, Dl = {
  mark: Zo,
  measure: Zo
};
try {
  typeof window < "u" && (Ii = window), typeof document < "u" && (kl = document), typeof MutationObserver < "u" && (Il = MutationObserver), typeof performance < "u" && (Dl = performance);
} catch {
}
var wd = Ii.navigator || {}, Xo = wd.userAgent, Ko = Xo === void 0 ? "" : Xo, Ot = Ii, de = kl, Jo = Il, Gr = Dl;
Ot.document;
var bt = !!de.documentElement && !!de.head && typeof de.addEventListener == "function" && typeof de.createElement == "function", Ll = ~Ko.indexOf("MSIE") || ~Ko.indexOf("Trident/"), pt = "___FONT_AWESOME___", Ea = 16, jl = "fa", Bl = "svg-inline--fa", Yt = "data-fa-i2svg", Ta = "data-fa-pseudo-element", Ed = "data-fa-pseudo-element-pending", Di = "data-prefix", Li = "data-icon", Qo = "fontawesome-i2svg", Td = "async", Pd = ["HTML", "HEAD", "STYLE", "SCRIPT"], Hl = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), ji = {
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  "fa-kit": "kit",
  fa: "solid"
}, un = {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}, Fl = {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}, Cd = {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}, Sd = /fa[srltdbk\-\ ]/, Ul = "fa-layers-text", Od = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i, Nd = {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}, $l = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Ad = $l.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Md = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], jt = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Rd = [].concat(_n(Object.keys(un)), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", jt.GROUP, jt.SWAP_OPACITY, jt.PRIMARY, jt.SECONDARY]).concat($l.map(function(e) {
  return "".concat(e, "x");
})).concat(Ad.map(function(e) {
  return "w-".concat(e);
})), Wl = Ot.FontAwesomeConfig || {};
function kd(e) {
  var t = de.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function Id(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
if (de && typeof de.querySelector == "function") {
  var Dd = [["data-family-prefix", "familyPrefix"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  Dd.forEach(function(e) {
    var t = ki(e, 2), r = t[0], n = t[1], a = Id(kd(r));
    a != null && (Wl[n] = a);
  });
}
var Ld = {
  familyPrefix: jl,
  styleDefault: "solid",
  replacementClass: Bl,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
}, Tr = R(R({}, Ld), Wl);
Tr.autoReplaceSvg || (Tr.observeMutations = !1);
var B = {};
Object.keys(Tr).forEach(function(e) {
  Object.defineProperty(B, e, {
    enumerable: !0,
    set: function(r) {
      Tr[e] = r, Kr.forEach(function(n) {
        return n(B);
      });
    },
    get: function() {
      return Tr[e];
    }
  });
});
Ot.FontAwesomeConfig = B;
var Kr = [];
function jd(e) {
  return Kr.push(e), function() {
    Kr.splice(Kr.indexOf(e), 1);
  };
}
var wt = Ea, lt = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function Bd(e) {
  if (!(!e || !bt)) {
    var t = de.createElement("style");
    t.setAttribute("type", "text/css"), t.innerHTML = e;
    for (var r = de.head.childNodes, n = null, a = r.length - 1; a > -1; a--) {
      var i = r[a], o = (i.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(o) > -1 && (n = i);
    }
    return de.head.insertBefore(t, n), e;
  }
}
var Hd = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Mr() {
  for (var e = 12, t = ""; e-- > 0; )
    t += Hd[Math.random() * 62 | 0];
  return t;
}
function vr(e) {
  for (var t = [], r = (e || []).length >>> 0; r--; )
    t[r] = e[r];
  return t;
}
function Bi(e) {
  return e.classList ? vr(e.classList) : (e.getAttribute("class") || "").split(" ").filter(function(t) {
    return t;
  });
}
function Gl(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Fd(e) {
  return Object.keys(e || {}).reduce(function(t, r) {
    return t + "".concat(r, '="').concat(Gl(e[r]), '" ');
  }, "").trim();
}
function xn(e) {
  return Object.keys(e || {}).reduce(function(t, r) {
    return t + "".concat(r, ": ").concat(e[r].trim(), ";");
  }, "");
}
function Hi(e) {
  return e.size !== lt.size || e.x !== lt.x || e.y !== lt.y || e.rotate !== lt.rotate || e.flipX || e.flipY;
}
function Ud(e) {
  var t = e.transform, r = e.containerWidth, n = e.iconWidth, a = {
    transform: "translate(".concat(r / 2, " 256)")
  }, i = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), o = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), s = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(i, " ").concat(o, " ").concat(s)
  }, u = {
    transform: "translate(".concat(n / 2 * -1, " -256)")
  };
  return {
    outer: a,
    inner: l,
    path: u
  };
}
function $d(e) {
  var t = e.transform, r = e.width, n = r === void 0 ? Ea : r, a = e.height, i = a === void 0 ? Ea : a, o = e.startCentered, s = o === void 0 ? !1 : o, l = "";
  return s && Ll ? l += "translate(".concat(t.x / wt - n / 2, "em, ").concat(t.y / wt - i / 2, "em) ") : s ? l += "translate(calc(-50% + ".concat(t.x / wt, "em), calc(-50% + ").concat(t.y / wt, "em)) ") : l += "translate(".concat(t.x / wt, "em, ").concat(t.y / wt, "em) "), l += "scale(".concat(t.size / wt * (t.flipX ? -1 : 1), ", ").concat(t.size / wt * (t.flipY ? -1 : 1), ") "), l += "rotate(".concat(t.rotate, "deg) "), l;
}
var Wd = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function Yl() {
  var e = jl, t = Bl, r = B.familyPrefix, n = B.replacementClass, a = Wd;
  if (r !== e || n !== t) {
    var i = new RegExp("\\.".concat(e, "\\-"), "g"), o = new RegExp("\\--".concat(e, "\\-"), "g"), s = new RegExp("\\.".concat(t), "g");
    a = a.replace(i, ".".concat(r, "-")).replace(o, "--".concat(r, "-")).replace(s, ".".concat(n));
  }
  return a;
}
var es = !1;
function Wn() {
  B.autoAddCss && !es && (Bd(Yl()), es = !0);
}
var Gd = {
  mixout: function() {
    return {
      dom: {
        css: Yl,
        insertCss: Wn
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        Wn();
      },
      beforeI2svg: function() {
        Wn();
      }
    };
  }
}, vt = Ot || {};
vt[pt] || (vt[pt] = {});
vt[pt].styles || (vt[pt].styles = {});
vt[pt].hooks || (vt[pt].hooks = {});
vt[pt].shims || (vt[pt].shims = []);
var Je = vt[pt], zl = [], Yd = function e() {
  de.removeEventListener("DOMContentLoaded", e), cn = 1, zl.map(function(t) {
    return t();
  });
}, cn = !1;
bt && (cn = (de.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(de.readyState), cn || de.addEventListener("DOMContentLoaded", Yd));
function zd(e) {
  bt && (cn ? setTimeout(e, 0) : zl.push(e));
}
function Lr(e) {
  var t = e.tag, r = e.attributes, n = r === void 0 ? {} : r, a = e.children, i = a === void 0 ? [] : a;
  return typeof e == "string" ? Gl(e) : "<".concat(t, " ").concat(Fd(n), ">").concat(i.map(Lr).join(""), "</").concat(t, ">");
}
function ts(e, t, r) {
  if (e && e[t] && e[t][r])
    return {
      prefix: t,
      iconName: r,
      icon: e[t][r]
    };
}
var Vd = function(t, r) {
  return function(n, a, i, o) {
    return t.call(r, n, a, i, o);
  };
}, Gn = function(t, r, n, a) {
  var i = Object.keys(t), o = i.length, s = a !== void 0 ? Vd(r, a) : r, l, u, c;
  for (n === void 0 ? (l = 1, c = t[i[0]]) : (l = 0, c = n); l < o; l++)
    u = i[l], c = s(c, t[u], u, t);
  return c;
};
function qd(e) {
  for (var t = [], r = 0, n = e.length; r < n; ) {
    var a = e.charCodeAt(r++);
    if (a >= 55296 && a <= 56319 && r < n) {
      var i = e.charCodeAt(r++);
      (i & 64512) == 56320 ? t.push(((a & 1023) << 10) + (i & 1023) + 65536) : (t.push(a), r--);
    } else
      t.push(a);
  }
  return t;
}
function Pa(e) {
  var t = qd(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function Zd(e, t) {
  var r = e.length, n = e.charCodeAt(t), a;
  return n >= 55296 && n <= 56319 && r > t + 1 && (a = e.charCodeAt(t + 1), a >= 56320 && a <= 57343) ? (n - 55296) * 1024 + a - 56320 + 65536 : n;
}
function rs(e) {
  return Object.keys(e).reduce(function(t, r) {
    var n = e[r], a = !!n.icon;
    return a ? t[n.iconName] = n.icon : t[r] = n, t;
  }, {});
}
function Ca(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = r.skipHooks, a = n === void 0 ? !1 : n, i = rs(t);
  typeof Je.hooks.addPack == "function" && !a ? Je.hooks.addPack(e, rs(t)) : Je.styles[e] = R(R({}, Je.styles[e] || {}), i), e === "fas" && Ca("fa", t);
}
var Pr = Je.styles, Xd = Je.shims, Kd = Object.values(Fl), Fi = null, Vl = {}, ql = {}, Zl = {}, Xl = {}, Kl = {}, Jd = Object.keys(ji);
function Qd(e) {
  return ~Rd.indexOf(e);
}
function e1(e, t) {
  var r = t.split("-"), n = r[0], a = r.slice(1).join("-");
  return n === e && a !== "" && !Qd(a) ? a : null;
}
var Jl = function() {
  var t = function(i) {
    return Gn(Pr, function(o, s, l) {
      return o[l] = Gn(s, i, {}), o;
    }, {});
  };
  Vl = t(function(a, i, o) {
    if (i[3] && (a[i[3]] = o), i[2]) {
      var s = i[2].filter(function(l) {
        return typeof l == "number";
      });
      s.forEach(function(l) {
        a[l.toString(16)] = o;
      });
    }
    return a;
  }), ql = t(function(a, i, o) {
    if (a[o] = o, i[2]) {
      var s = i[2].filter(function(l) {
        return typeof l == "string";
      });
      s.forEach(function(l) {
        a[l] = o;
      });
    }
    return a;
  }), Kl = t(function(a, i, o) {
    var s = i[2];
    return a[o] = o, s.forEach(function(l) {
      a[l] = o;
    }), a;
  });
  var r = "far" in Pr || B.autoFetchSvg, n = Gn(Xd, function(a, i) {
    var o = i[0], s = i[1], l = i[2];
    return s === "far" && !r && (s = "fas"), typeof o == "string" && (a.names[o] = {
      prefix: s,
      iconName: l
    }), typeof o == "number" && (a.unicodes[o.toString(16)] = {
      prefix: s,
      iconName: l
    }), a;
  }, {
    names: {},
    unicodes: {}
  });
  Zl = n.names, Xl = n.unicodes, Fi = wn(B.styleDefault);
};
jd(function(e) {
  Fi = wn(e.styleDefault);
});
Jl();
function Ui(e, t) {
  return (Vl[e] || {})[t];
}
function t1(e, t) {
  return (ql[e] || {})[t];
}
function nr(e, t) {
  return (Kl[e] || {})[t];
}
function Ql(e) {
  return Zl[e] || {
    prefix: null,
    iconName: null
  };
}
function r1(e) {
  var t = Xl[e], r = Ui("fas", e);
  return t || (r ? {
    prefix: "fas",
    iconName: r
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Nt() {
  return Fi;
}
var $i = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function wn(e) {
  var t = ji[e], r = un[e] || un[t], n = e in Je.styles ? e : null;
  return r || n || null;
}
function En(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.skipLookups, n = r === void 0 ? !1 : r, a = null, i = e.reduce(function(o, s) {
    var l = e1(B.familyPrefix, s);
    if (Pr[s] ? (s = Kd.includes(s) ? Cd[s] : s, a = s, o.prefix = s) : Jd.indexOf(s) > -1 ? (a = s, o.prefix = wn(s)) : l ? o.iconName = l : s !== B.replacementClass && o.rest.push(s), !n && o.prefix && o.iconName) {
      var u = a === "fa" ? Ql(o.iconName) : {}, c = nr(o.prefix, o.iconName);
      u.prefix && (a = null), o.iconName = u.iconName || c || o.iconName, o.prefix = u.prefix || o.prefix, o.prefix === "far" && !Pr.far && Pr.fas && !B.autoFetchSvg && (o.prefix = "fas");
    }
    return o;
  }, $i());
  return (i.prefix === "fa" || a === "fa") && (i.prefix = Nt() || "fas"), i;
}
var n1 = /* @__PURE__ */ function() {
  function e() {
    md(this, e), this.definitions = {};
  }
  return hd(e, [{
    key: "add",
    value: function() {
      for (var r = this, n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      var o = a.reduce(this._pullDefinitions, {});
      Object.keys(o).forEach(function(s) {
        r.definitions[s] = R(R({}, r.definitions[s] || {}), o[s]), Ca(s, o[s]);
        var l = Fl[s];
        l && Ca(l, o[s]), Jl();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(r, n) {
      var a = n.prefix && n.iconName && n.icon ? {
        0: n
      } : n;
      return Object.keys(a).map(function(i) {
        var o = a[i], s = o.prefix, l = o.iconName, u = o.icon, c = u[2];
        r[s] || (r[s] = {}), c.length > 0 && c.forEach(function(d) {
          typeof d == "string" && (r[s][d] = u);
        }), r[s][l] = u;
      }), r;
    }
  }]), e;
}(), ns = [], ar = {}, lr = {}, a1 = Object.keys(lr);
function i1(e, t) {
  var r = t.mixoutsTo;
  return ns = e, ar = {}, Object.keys(lr).forEach(function(n) {
    a1.indexOf(n) === -1 && delete lr[n];
  }), ns.forEach(function(n) {
    var a = n.mixout ? n.mixout() : {};
    if (Object.keys(a).forEach(function(o) {
      typeof a[o] == "function" && (r[o] = a[o]), ln(a[o]) === "object" && Object.keys(a[o]).forEach(function(s) {
        r[o] || (r[o] = {}), r[o][s] = a[o][s];
      });
    }), n.hooks) {
      var i = n.hooks();
      Object.keys(i).forEach(function(o) {
        ar[o] || (ar[o] = []), ar[o].push(i[o]);
      });
    }
    n.provides && n.provides(lr);
  }), r;
}
function Sa(e, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    n[a - 2] = arguments[a];
  var i = ar[e] || [];
  return i.forEach(function(o) {
    t = o.apply(null, [t].concat(n));
  }), t;
}
function zt(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var a = ar[e] || [];
  a.forEach(function(i) {
    i.apply(null, r);
  });
}
function gt() {
  var e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return lr[e] ? lr[e].apply(null, t) : void 0;
}
function Oa(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  var t = e.iconName, r = e.prefix || Nt();
  if (t)
    return t = nr(r, t) || t, ts(eu.definitions, r, t) || ts(Je.styles, r, t);
}
var eu = new n1(), o1 = function() {
  B.autoReplaceSvg = !1, B.observeMutations = !1, zt("noAuto");
}, s1 = {
  i2svg: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return bt ? (zt("beforeI2svg", t), gt("pseudoElements2svg", t), gt("i2svg", t)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.autoReplaceSvgRoot;
    B.autoReplaceSvg === !1 && (B.autoReplaceSvg = !0), B.observeMutations = !0, zd(function() {
      u1({
        autoReplaceSvgRoot: r
      }), zt("watch", t);
    });
  }
}, l1 = {
  icon: function(t) {
    if (t === null)
      return null;
    if (ln(t) === "object" && t.prefix && t.iconName)
      return {
        prefix: t.prefix,
        iconName: nr(t.prefix, t.iconName) || t.iconName
      };
    if (Array.isArray(t) && t.length === 2) {
      var r = t[1].indexOf("fa-") === 0 ? t[1].slice(3) : t[1], n = wn(t[0]);
      return {
        prefix: n,
        iconName: nr(n, r) || r
      };
    }
    if (typeof t == "string" && (t.indexOf("".concat(B.familyPrefix, "-")) > -1 || t.match(Sd))) {
      var a = En(t.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: a.prefix || Nt(),
        iconName: nr(a.prefix, a.iconName) || a.iconName
      };
    }
    if (typeof t == "string") {
      var i = Nt();
      return {
        prefix: i,
        iconName: nr(i, t) || t
      };
    }
  }
}, Ge = {
  noAuto: o1,
  config: B,
  dom: s1,
  parse: l1,
  library: eu,
  findIconDefinition: Oa,
  toHtml: Lr
}, u1 = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.autoReplaceSvgRoot, n = r === void 0 ? de : r;
  (Object.keys(Je.styles).length > 0 || B.autoFetchSvg) && bt && B.autoReplaceSvg && Ge.dom.i2svg({
    node: n
  });
};
function Tn(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map(function(n) {
        return Lr(n);
      });
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (bt) {
        var n = de.createElement("div");
        return n.innerHTML = e.html, n.children;
      }
    }
  }), e;
}
function c1(e) {
  var t = e.children, r = e.main, n = e.mask, a = e.attributes, i = e.styles, o = e.transform;
  if (Hi(o) && r.found && !n.found) {
    var s = r.width, l = r.height, u = {
      x: s / l / 2,
      y: 0.5
    };
    a.style = xn(R(R({}, i), {}, {
      "transform-origin": "".concat(u.x + o.x / 16, "em ").concat(u.y + o.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: a,
    children: t
  }];
}
function f1(e) {
  var t = e.prefix, r = e.iconName, n = e.children, a = e.attributes, i = e.symbol, o = i === !0 ? "".concat(t, "-").concat(B.familyPrefix, "-").concat(r) : i;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: R(R({}, a), {}, {
        id: o
      }),
      children: n
    }]
  }];
}
function Wi(e) {
  var t = e.icons, r = t.main, n = t.mask, a = e.prefix, i = e.iconName, o = e.transform, s = e.symbol, l = e.title, u = e.maskId, c = e.titleId, d = e.extra, m = e.watchable, x = m === void 0 ? !1 : m, E = n.found ? n : r, P = E.width, w = E.height, b = a === "fak", p = [B.replacementClass, i ? "".concat(B.familyPrefix, "-").concat(i) : ""].filter(function(ae) {
    return d.classes.indexOf(ae) === -1;
  }).filter(function(ae) {
    return ae !== "" || !!ae;
  }).concat(d.classes).join(" "), g = {
    children: [],
    attributes: R(R({}, d.attributes), {}, {
      "data-prefix": a,
      "data-icon": i,
      class: p,
      role: d.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(P, " ").concat(w)
    })
  }, _ = b && !~d.classes.indexOf("fa-fw") ? {
    width: "".concat(P / w * 16 * 0.0625, "em")
  } : {};
  x && (g.attributes[Yt] = ""), l && (g.children.push({
    tag: "title",
    attributes: {
      id: g.attributes["aria-labelledby"] || "title-".concat(c || Mr())
    },
    children: [l]
  }), delete g.attributes.title);
  var y = R(R({}, g), {}, {
    prefix: a,
    iconName: i,
    main: r,
    mask: n,
    maskId: u,
    transform: o,
    symbol: s,
    styles: R(R({}, _), d.styles)
  }), O = n.found && r.found ? gt("generateAbstractMask", y) || {
    children: [],
    attributes: {}
  } : gt("generateAbstractIcon", y) || {
    children: [],
    attributes: {}
  }, j = O.children, ne = O.attributes;
  return y.children = j, y.attributes = ne, s ? f1(y) : c1(y);
}
function as(e) {
  var t = e.content, r = e.width, n = e.height, a = e.transform, i = e.title, o = e.extra, s = e.watchable, l = s === void 0 ? !1 : s, u = R(R(R({}, o.attributes), i ? {
    title: i
  } : {}), {}, {
    class: o.classes.join(" ")
  });
  l && (u[Yt] = "");
  var c = R({}, o.styles);
  Hi(a) && (c.transform = $d({
    transform: a,
    startCentered: !0,
    width: r,
    height: n
  }), c["-webkit-transform"] = c.transform);
  var d = xn(c);
  d.length > 0 && (u.style = d);
  var m = [];
  return m.push({
    tag: "span",
    attributes: u,
    children: [t]
  }), i && m.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [i]
  }), m;
}
function d1(e) {
  var t = e.content, r = e.title, n = e.extra, a = R(R(R({}, n.attributes), r ? {
    title: r
  } : {}), {}, {
    class: n.classes.join(" ")
  }), i = xn(n.styles);
  i.length > 0 && (a.style = i);
  var o = [];
  return o.push({
    tag: "span",
    attributes: a,
    children: [t]
  }), r && o.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [r]
  }), o;
}
var Yn = Je.styles;
function Na(e) {
  var t = e[0], r = e[1], n = e.slice(4), a = ki(n, 1), i = a[0], o = null;
  return Array.isArray(i) ? o = {
    tag: "g",
    attributes: {
      class: "".concat(B.familyPrefix, "-").concat(jt.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(B.familyPrefix, "-").concat(jt.SECONDARY),
        fill: "currentColor",
        d: i[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(B.familyPrefix, "-").concat(jt.PRIMARY),
        fill: "currentColor",
        d: i[1]
      }
    }]
  } : o = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: i
    }
  }, {
    found: !0,
    width: t,
    height: r,
    icon: o
  };
}
var m1 = {
  found: !1,
  width: 512,
  height: 512
};
function h1(e, t) {
  !Hl && !B.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function Aa(e, t) {
  var r = t;
  return t === "fa" && B.styleDefault !== null && (t = Nt()), new Promise(function(n, a) {
    if (gt("missingIconAbstract"), r === "fa") {
      var i = Ql(e) || {};
      e = i.iconName || e, t = i.prefix || t;
    }
    if (e && t && Yn[t] && Yn[t][e]) {
      var o = Yn[t][e];
      return n(Na(o));
    }
    h1(e, t), n(R(R({}, m1), {}, {
      icon: B.showMissingIcons && e ? gt("missingIconAbstract") || {} : {}
    }));
  });
}
var is = function() {
}, Ma = B.measurePerformance && Gr && Gr.mark && Gr.measure ? Gr : {
  mark: is,
  measure: is
}, Er = 'FA "6.1.1"', p1 = function(t) {
  return Ma.mark("".concat(Er, " ").concat(t, " begins")), function() {
    return tu(t);
  };
}, tu = function(t) {
  Ma.mark("".concat(Er, " ").concat(t, " ends")), Ma.measure("".concat(Er, " ").concat(t), "".concat(Er, " ").concat(t, " begins"), "".concat(Er, " ").concat(t, " ends"));
}, Gi = {
  begin: p1,
  end: tu
}, Jr = function() {
};
function os(e) {
  var t = e.getAttribute ? e.getAttribute(Yt) : null;
  return typeof t == "string";
}
function v1(e) {
  var t = e.getAttribute ? e.getAttribute(Di) : null, r = e.getAttribute ? e.getAttribute(Li) : null;
  return t && r;
}
function g1(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(B.replacementClass);
}
function b1() {
  if (B.autoReplaceSvg === !0)
    return Qr.replace;
  var e = Qr[B.autoReplaceSvg];
  return e || Qr.replace;
}
function y1(e) {
  return de.createElementNS("http://www.w3.org/2000/svg", e);
}
function _1(e) {
  return de.createElement(e);
}
function ru(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.ceFn, n = r === void 0 ? e.tag === "svg" ? y1 : _1 : r;
  if (typeof e == "string")
    return de.createTextNode(e);
  var a = n(e.tag);
  Object.keys(e.attributes || []).forEach(function(o) {
    a.setAttribute(o, e.attributes[o]);
  });
  var i = e.children || [];
  return i.forEach(function(o) {
    a.appendChild(ru(o, {
      ceFn: n
    }));
  }), a;
}
function x1(e) {
  var t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
var Qr = {
  replace: function(t) {
    var r = t[0];
    if (r.parentNode)
      if (t[1].forEach(function(a) {
        r.parentNode.insertBefore(ru(a), r);
      }), r.getAttribute(Yt) === null && B.keepOriginalSource) {
        var n = de.createComment(x1(r));
        r.parentNode.replaceChild(n, r);
      } else
        r.remove();
  },
  nest: function(t) {
    var r = t[0], n = t[1];
    if (~Bi(r).indexOf(B.replacementClass))
      return Qr.replace(t);
    var a = new RegExp("".concat(B.familyPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      var i = n[0].attributes.class.split(" ").reduce(function(s, l) {
        return l === B.replacementClass || l.match(a) ? s.toSvg.push(l) : s.toNode.push(l), s;
      }, {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = i.toSvg.join(" "), i.toNode.length === 0 ? r.removeAttribute("class") : r.setAttribute("class", i.toNode.join(" "));
    }
    var o = n.map(function(s) {
      return Lr(s);
    }).join(`
`);
    r.setAttribute(Yt, ""), r.innerHTML = o;
  }
};
function ss(e) {
  e();
}
function nu(e, t) {
  var r = typeof t == "function" ? t : Jr;
  if (e.length === 0)
    r();
  else {
    var n = ss;
    B.mutateApproach === Td && (n = Ot.requestAnimationFrame || ss), n(function() {
      var a = b1(), i = Gi.begin("mutate");
      e.map(a), i(), r();
    });
  }
}
var Yi = !1;
function au() {
  Yi = !0;
}
function Ra() {
  Yi = !1;
}
var fn = null;
function ls(e) {
  if (Jo && B.observeMutations) {
    var t = e.treeCallback, r = t === void 0 ? Jr : t, n = e.nodeCallback, a = n === void 0 ? Jr : n, i = e.pseudoElementsCallback, o = i === void 0 ? Jr : i, s = e.observeMutationsRoot, l = s === void 0 ? de : s;
    fn = new Jo(function(u) {
      if (!Yi) {
        var c = Nt();
        vr(u).forEach(function(d) {
          if (d.type === "childList" && d.addedNodes.length > 0 && !os(d.addedNodes[0]) && (B.searchPseudoElements && o(d.target), r(d.target)), d.type === "attributes" && d.target.parentNode && B.searchPseudoElements && o(d.target.parentNode), d.type === "attributes" && os(d.target) && ~Md.indexOf(d.attributeName))
            if (d.attributeName === "class" && v1(d.target)) {
              var m = En(Bi(d.target)), x = m.prefix, E = m.iconName;
              d.target.setAttribute(Di, x || c), E && d.target.setAttribute(Li, E);
            } else
              g1(d.target) && a(d.target);
        });
      }
    }), bt && fn.observe(l, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function w1() {
  fn && fn.disconnect();
}
function E1(e) {
  var t = e.getAttribute("style"), r = [];
  return t && (r = t.split(";").reduce(function(n, a) {
    var i = a.split(":"), o = i[0], s = i.slice(1);
    return o && s.length > 0 && (n[o] = s.join(":").trim()), n;
  }, {})), r;
}
function T1(e) {
  var t = e.getAttribute("data-prefix"), r = e.getAttribute("data-icon"), n = e.innerText !== void 0 ? e.innerText.trim() : "", a = En(Bi(e));
  return a.prefix || (a.prefix = Nt()), t && r && (a.prefix = t, a.iconName = r), a.iconName && a.prefix || a.prefix && n.length > 0 && (a.iconName = t1(a.prefix, e.innerText) || Ui(a.prefix, Pa(e.innerText))), a;
}
function P1(e) {
  var t = vr(e.attributes).reduce(function(a, i) {
    return a.name !== "class" && a.name !== "style" && (a[i.name] = i.value), a;
  }, {}), r = e.getAttribute("title"), n = e.getAttribute("data-fa-title-id");
  return B.autoA11y && (r ? t["aria-labelledby"] = "".concat(B.replacementClass, "-title-").concat(n || Mr()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function C1() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: lt,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function us(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, r = T1(e), n = r.iconName, a = r.prefix, i = r.rest, o = P1(e), s = Sa("parseNodeAttributes", {}, e), l = t.styleParser ? E1(e) : [];
  return R({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: a,
    transform: lt,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: i,
      styles: l,
      attributes: o
    }
  }, s);
}
var S1 = Je.styles;
function iu(e) {
  var t = B.autoReplaceSvg === "nest" ? us(e, {
    styleParser: !1
  }) : us(e);
  return ~t.extra.classes.indexOf(Ul) ? gt("generateLayersText", e, t) : gt("generateSvgReplacementMutation", e, t);
}
function cs(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!bt)
    return Promise.resolve();
  var r = de.documentElement.classList, n = function(d) {
    return r.add("".concat(Qo, "-").concat(d));
  }, a = function(d) {
    return r.remove("".concat(Qo, "-").concat(d));
  }, i = B.autoFetchSvg ? Object.keys(ji) : Object.keys(S1), o = [".".concat(Ul, ":not([").concat(Yt, "])")].concat(i.map(function(c) {
    return ".".concat(c, ":not([").concat(Yt, "])");
  })).join(", ");
  if (o.length === 0)
    return Promise.resolve();
  var s = [];
  try {
    s = vr(e.querySelectorAll(o));
  } catch {
  }
  if (s.length > 0)
    n("pending"), a("complete");
  else
    return Promise.resolve();
  var l = Gi.begin("onTree"), u = s.reduce(function(c, d) {
    try {
      var m = iu(d);
      m && c.push(m);
    } catch (x) {
      Hl || x.name === "MissingIcon" && console.error(x);
    }
    return c;
  }, []);
  return new Promise(function(c, d) {
    Promise.all(u).then(function(m) {
      nu(m, function() {
        n("active"), n("complete"), a("pending"), typeof t == "function" && t(), l(), c();
      });
    }).catch(function(m) {
      l(), d(m);
    });
  });
}
function O1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  iu(e).then(function(r) {
    r && nu([r], t);
  });
}
function N1(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = (t || {}).icon ? t : Oa(t || {}), a = r.mask;
    return a && (a = (a || {}).icon ? a : Oa(a || {})), e(n, R(R({}, r), {}, {
      mask: a
    }));
  };
}
var A1 = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.transform, a = n === void 0 ? lt : n, i = r.symbol, o = i === void 0 ? !1 : i, s = r.mask, l = s === void 0 ? null : s, u = r.maskId, c = u === void 0 ? null : u, d = r.title, m = d === void 0 ? null : d, x = r.titleId, E = x === void 0 ? null : x, P = r.classes, w = P === void 0 ? [] : P, b = r.attributes, p = b === void 0 ? {} : b, g = r.styles, _ = g === void 0 ? {} : g;
  if (t) {
    var y = t.prefix, O = t.iconName, j = t.icon;
    return Tn(R({
      type: "icon"
    }, t), function() {
      return zt("beforeDOMElementCreation", {
        iconDefinition: t,
        params: r
      }), B.autoA11y && (m ? p["aria-labelledby"] = "".concat(B.replacementClass, "-title-").concat(E || Mr()) : (p["aria-hidden"] = "true", p.focusable = "false")), Wi({
        icons: {
          main: Na(j),
          mask: l ? Na(l.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: y,
        iconName: O,
        transform: R(R({}, lt), a),
        symbol: o,
        title: m,
        maskId: c,
        titleId: E,
        extra: {
          attributes: p,
          styles: _,
          classes: w
        }
      });
    });
  }
}, M1 = {
  mixout: function() {
    return {
      icon: N1(A1)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(r) {
        return r.treeCallback = cs, r.nodeCallback = O1, r;
      }
    };
  },
  provides: function(t) {
    t.i2svg = function(r) {
      var n = r.node, a = n === void 0 ? de : n, i = r.callback, o = i === void 0 ? function() {
      } : i;
      return cs(a, o);
    }, t.generateSvgReplacementMutation = function(r, n) {
      var a = n.iconName, i = n.title, o = n.titleId, s = n.prefix, l = n.transform, u = n.symbol, c = n.mask, d = n.maskId, m = n.extra;
      return new Promise(function(x, E) {
        Promise.all([Aa(a, s), c.iconName ? Aa(c.iconName, c.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(P) {
          var w = ki(P, 2), b = w[0], p = w[1];
          x([r, Wi({
            icons: {
              main: b,
              mask: p
            },
            prefix: s,
            iconName: a,
            transform: l,
            symbol: u,
            maskId: d,
            title: i,
            titleId: o,
            extra: m,
            watchable: !0
          })]);
        }).catch(E);
      });
    }, t.generateAbstractIcon = function(r) {
      var n = r.children, a = r.attributes, i = r.main, o = r.transform, s = r.styles, l = xn(s);
      l.length > 0 && (a.style = l);
      var u;
      return Hi(o) && (u = gt("generateAbstractTransformGrouping", {
        main: i,
        transform: o,
        containerWidth: i.width,
        iconWidth: i.width
      })), n.push(u || i.icon), {
        children: n,
        attributes: a
      };
    };
  }
}, R1 = {
  mixout: function() {
    return {
      layer: function(r) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.classes, i = a === void 0 ? [] : a;
        return Tn({
          type: "layer"
        }, function() {
          zt("beforeDOMElementCreation", {
            assembler: r,
            params: n
          });
          var o = [];
          return r(function(s) {
            Array.isArray(s) ? s.map(function(l) {
              o = o.concat(l.abstract);
            }) : o = o.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(B.familyPrefix, "-layers")].concat(_n(i)).join(" ")
            },
            children: o
          }];
        });
      }
    };
  }
}, k1 = {
  mixout: function() {
    return {
      counter: function(r) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.title, i = a === void 0 ? null : a, o = n.classes, s = o === void 0 ? [] : o, l = n.attributes, u = l === void 0 ? {} : l, c = n.styles, d = c === void 0 ? {} : c;
        return Tn({
          type: "counter",
          content: r
        }, function() {
          return zt("beforeDOMElementCreation", {
            content: r,
            params: n
          }), d1({
            content: r.toString(),
            title: i,
            extra: {
              attributes: u,
              styles: d,
              classes: ["".concat(B.familyPrefix, "-layers-counter")].concat(_n(s))
            }
          });
        });
      }
    };
  }
}, I1 = {
  mixout: function() {
    return {
      text: function(r) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.transform, i = a === void 0 ? lt : a, o = n.title, s = o === void 0 ? null : o, l = n.classes, u = l === void 0 ? [] : l, c = n.attributes, d = c === void 0 ? {} : c, m = n.styles, x = m === void 0 ? {} : m;
        return Tn({
          type: "text",
          content: r
        }, function() {
          return zt("beforeDOMElementCreation", {
            content: r,
            params: n
          }), as({
            content: r,
            transform: R(R({}, lt), i),
            title: s,
            extra: {
              attributes: d,
              styles: x,
              classes: ["".concat(B.familyPrefix, "-layers-text")].concat(_n(u))
            }
          });
        });
      }
    };
  },
  provides: function(t) {
    t.generateLayersText = function(r, n) {
      var a = n.title, i = n.transform, o = n.extra, s = null, l = null;
      if (Ll) {
        var u = parseInt(getComputedStyle(r).fontSize, 10), c = r.getBoundingClientRect();
        s = c.width / u, l = c.height / u;
      }
      return B.autoA11y && !a && (o.attributes["aria-hidden"] = "true"), Promise.resolve([r, as({
        content: r.innerHTML,
        width: s,
        height: l,
        transform: i,
        title: a,
        extra: o,
        watchable: !0
      })]);
    };
  }
}, D1 = new RegExp('"', "ug"), fs = [1105920, 1112319];
function L1(e) {
  var t = e.replace(D1, ""), r = Zd(t, 0), n = r >= fs[0] && r <= fs[1], a = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: Pa(a ? t[0] : t),
    isSecondary: n || a
  };
}
function ds(e, t) {
  var r = "".concat(Ed).concat(t.replace(":", "-"));
  return new Promise(function(n, a) {
    if (e.getAttribute(r) !== null)
      return n();
    var i = vr(e.children), o = i.filter(function(O) {
      return O.getAttribute(Ta) === t;
    })[0], s = Ot.getComputedStyle(e, t), l = s.getPropertyValue("font-family").match(Od), u = s.getPropertyValue("font-weight"), c = s.getPropertyValue("content");
    if (o && !l)
      return e.removeChild(o), n();
    if (l && c !== "none" && c !== "") {
      var d = s.getPropertyValue("content"), m = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(l[2]) ? un[l[2].toLowerCase()] : Nd[u], x = L1(d), E = x.value, P = x.isSecondary, w = l[0].startsWith("FontAwesome"), b = Ui(m, E), p = b;
      if (w) {
        var g = r1(E);
        g.iconName && g.prefix && (b = g.iconName, m = g.prefix);
      }
      if (b && !P && (!o || o.getAttribute(Di) !== m || o.getAttribute(Li) !== p)) {
        e.setAttribute(r, p), o && e.removeChild(o);
        var _ = C1(), y = _.extra;
        y.attributes[Ta] = t, Aa(b, m).then(function(O) {
          var j = Wi(R(R({}, _), {}, {
            icons: {
              main: O,
              mask: $i()
            },
            prefix: m,
            iconName: p,
            extra: y,
            watchable: !0
          })), ne = de.createElement("svg");
          t === "::before" ? e.insertBefore(ne, e.firstChild) : e.appendChild(ne), ne.outerHTML = j.map(function(ae) {
            return Lr(ae);
          }).join(`
`), e.removeAttribute(r), n();
        }).catch(a);
      } else
        n();
    } else
      n();
  });
}
function j1(e) {
  return Promise.all([ds(e, "::before"), ds(e, "::after")]);
}
function B1(e) {
  return e.parentNode !== document.head && !~Pd.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Ta) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function ms(e) {
  if (bt)
    return new Promise(function(t, r) {
      var n = vr(e.querySelectorAll("*")).filter(B1).map(j1), a = Gi.begin("searchPseudoElements");
      au(), Promise.all(n).then(function() {
        a(), Ra(), t();
      }).catch(function() {
        a(), Ra(), r();
      });
    });
}
var H1 = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(r) {
        return r.pseudoElementsCallback = ms, r;
      }
    };
  },
  provides: function(t) {
    t.pseudoElements2svg = function(r) {
      var n = r.node, a = n === void 0 ? de : n;
      B.searchPseudoElements && ms(a);
    };
  }
}, hs = !1, F1 = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          au(), hs = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        ls(Sa("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        w1();
      },
      watch: function(r) {
        var n = r.observeMutationsRoot;
        hs ? Ra() : ls(Sa("mutationObserverCallbacks", {
          observeMutationsRoot: n
        }));
      }
    };
  }
}, ps = function(t) {
  var r = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return t.toLowerCase().split(" ").reduce(function(n, a) {
    var i = a.toLowerCase().split("-"), o = i[0], s = i.slice(1).join("-");
    if (o && s === "h")
      return n.flipX = !0, n;
    if (o && s === "v")
      return n.flipY = !0, n;
    if (s = parseFloat(s), isNaN(s))
      return n;
    switch (o) {
      case "grow":
        n.size = n.size + s;
        break;
      case "shrink":
        n.size = n.size - s;
        break;
      case "left":
        n.x = n.x - s;
        break;
      case "right":
        n.x = n.x + s;
        break;
      case "up":
        n.y = n.y - s;
        break;
      case "down":
        n.y = n.y + s;
        break;
      case "rotate":
        n.rotate = n.rotate + s;
        break;
    }
    return n;
  }, r);
}, U1 = {
  mixout: function() {
    return {
      parse: {
        transform: function(r) {
          return ps(r);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(r, n) {
        var a = n.getAttribute("data-fa-transform");
        return a && (r.transform = ps(a)), r;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractTransformGrouping = function(r) {
      var n = r.main, a = r.transform, i = r.containerWidth, o = r.iconWidth, s = {
        transform: "translate(".concat(i / 2, " 256)")
      }, l = "translate(".concat(a.x * 32, ", ").concat(a.y * 32, ") "), u = "scale(".concat(a.size / 16 * (a.flipX ? -1 : 1), ", ").concat(a.size / 16 * (a.flipY ? -1 : 1), ") "), c = "rotate(".concat(a.rotate, " 0 0)"), d = {
        transform: "".concat(l, " ").concat(u, " ").concat(c)
      }, m = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, x = {
        outer: s,
        inner: d,
        path: m
      };
      return {
        tag: "g",
        attributes: R({}, x.outer),
        children: [{
          tag: "g",
          attributes: R({}, x.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: R(R({}, n.icon.attributes), x.path)
          }]
        }]
      };
    };
  }
}, zn = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function vs(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function $1(e) {
  return e.tag === "g" ? e.children : [e];
}
var W1 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(r, n) {
        var a = n.getAttribute("data-fa-mask"), i = a ? En(a.split(" ").map(function(o) {
          return o.trim();
        })) : $i();
        return i.prefix || (i.prefix = Nt()), r.mask = i, r.maskId = n.getAttribute("data-fa-mask-id"), r;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractMask = function(r) {
      var n = r.children, a = r.attributes, i = r.main, o = r.mask, s = r.maskId, l = r.transform, u = i.width, c = i.icon, d = o.width, m = o.icon, x = Ud({
        transform: l,
        containerWidth: d,
        iconWidth: u
      }), E = {
        tag: "rect",
        attributes: R(R({}, zn), {}, {
          fill: "white"
        })
      }, P = c.children ? {
        children: c.children.map(vs)
      } : {}, w = {
        tag: "g",
        attributes: R({}, x.inner),
        children: [vs(R({
          tag: c.tag,
          attributes: R(R({}, c.attributes), x.path)
        }, P))]
      }, b = {
        tag: "g",
        attributes: R({}, x.outer),
        children: [w]
      }, p = "mask-".concat(s || Mr()), g = "clip-".concat(s || Mr()), _ = {
        tag: "mask",
        attributes: R(R({}, zn), {}, {
          id: p,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [E, b]
      }, y = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: g
          },
          children: $1(m)
        }, _]
      };
      return n.push(y, {
        tag: "rect",
        attributes: R({
          fill: "currentColor",
          "clip-path": "url(#".concat(g, ")"),
          mask: "url(#".concat(p, ")")
        }, zn)
      }), {
        children: n,
        attributes: a
      };
    };
  }
}, G1 = {
  provides: function(t) {
    var r = !1;
    Ot.matchMedia && (r = Ot.matchMedia("(prefers-reduced-motion: reduce)").matches), t.missingIconAbstract = function() {
      var n = [], a = {
        fill: "currentColor"
      }, i = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: R(R({}, a), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var o = R(R({}, i), {}, {
        attributeName: "opacity"
      }), s = {
        tag: "circle",
        attributes: R(R({}, a), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return r || s.children.push({
        tag: "animate",
        attributes: R(R({}, i), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: R(R({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(s), n.push({
        tag: "path",
        attributes: R(R({}, a), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: r ? [] : [{
          tag: "animate",
          attributes: R(R({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), r || n.push({
        tag: "path",
        attributes: R(R({}, a), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: R(R({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, Y1 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(r, n) {
        var a = n.getAttribute("data-fa-symbol"), i = a === null ? !1 : a === "" ? !0 : a;
        return r.symbol = i, r;
      }
    };
  }
}, z1 = [Gd, M1, R1, k1, I1, H1, F1, U1, W1, G1, Y1];
i1(z1, {
  mixoutsTo: Ge
});
Ge.noAuto;
Ge.config;
Ge.library;
Ge.dom;
var ka = Ge.parse;
Ge.findIconDefinition;
Ge.toHtml;
var V1 = Ge.icon;
Ge.layer;
Ge.text;
Ge.counter;
function gs(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ct(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gs(Object(r), !0).forEach(function(n) {
      ir(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gs(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function dn(e) {
  "@babel/helpers - typeof";
  return dn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, dn(e);
}
function ir(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function q1(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function ou(e, t) {
  if (e == null)
    return {};
  var r = q1(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Ia(e) {
  return Z1(e) || X1(e) || K1(e) || J1();
}
function Z1(e) {
  if (Array.isArray(e))
    return Da(e);
}
function X1(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function K1(e, t) {
  if (e) {
    if (typeof e == "string")
      return Da(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Da(e, t);
  }
}
function Da(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function J1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Q1(e) {
  var t, r = e.beat, n = e.fade, a = e.beatFade, i = e.bounce, o = e.shake, s = e.flash, l = e.spin, u = e.spinPulse, c = e.spinReverse, d = e.pulse, m = e.fixedWidth, x = e.inverse, E = e.border, P = e.listItem, w = e.flip, b = e.size, p = e.rotation, g = e.pull, _ = (t = {
    "fa-beat": r,
    "fa-fade": n,
    "fa-beat-fade": a,
    "fa-bounce": i,
    "fa-shake": o,
    "fa-flash": s,
    "fa-spin": l,
    "fa-spin-reverse": c,
    "fa-spin-pulse": u,
    "fa-pulse": d,
    "fa-fw": m,
    "fa-inverse": x,
    "fa-border": E,
    "fa-li": P,
    "fa-flip-horizontal": w === "horizontal" || w === "both",
    "fa-flip-vertical": w === "vertical" || w === "both"
  }, ir(t, "fa-".concat(b), typeof b < "u" && b !== null), ir(t, "fa-rotate-".concat(p), typeof p < "u" && p !== null && p !== 0), ir(t, "fa-pull-".concat(g), typeof g < "u" && g !== null), ir(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(_).map(function(y) {
    return _[y] ? y : null;
  }).filter(function(y) {
    return y;
  });
}
function em(e) {
  return e = e - 0, e === e;
}
function su(e) {
  return em(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, r) {
    return r ? r.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var tm = ["style"];
function rm(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function nm(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, r) {
    var n = r.indexOf(":"), a = su(r.slice(0, n)), i = r.slice(n + 1).trim();
    return a.startsWith("webkit") ? t[rm(a)] = i : t[a] = i, t;
  }, {});
}
function lu(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var n = (t.children || []).map(function(l) {
    return lu(e, l);
  }), a = Object.keys(t.attributes || {}).reduce(function(l, u) {
    var c = t.attributes[u];
    switch (u) {
      case "class":
        l.attrs.className = c, delete t.attributes.class;
        break;
      case "style":
        l.attrs.style = nm(c);
        break;
      default:
        u.indexOf("aria-") === 0 || u.indexOf("data-") === 0 ? l.attrs[u.toLowerCase()] = c : l.attrs[su(u)] = c;
    }
    return l;
  }, {
    attrs: {}
  }), i = r.style, o = i === void 0 ? {} : i, s = ou(r, tm);
  return a.attrs.style = Ct(Ct({}, a.attrs.style), o), e.apply(void 0, [t.tag, Ct(Ct({}, a.attrs), s)].concat(Ia(n)));
}
var uu = !1;
try {
  uu = process.env.NODE_ENV === "production";
} catch {
}
function am() {
  if (!uu && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function bs(e) {
  if (e && dn(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (ka.icon)
    return ka.icon(e);
  if (e === null)
    return null;
  if (e && dn(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function Vn(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? ir({}, e, t) : {};
}
var im = ["forwardedRef"];
function yt(e) {
  var t = e.forwardedRef, r = ou(e, im), n = r.icon, a = r.mask, i = r.symbol, o = r.className, s = r.title, l = r.titleId, u = r.maskId, c = bs(n), d = Vn("classes", [].concat(Ia(Q1(r)), Ia(o.split(" ")))), m = Vn("transform", typeof r.transform == "string" ? ka.transform(r.transform) : r.transform), x = Vn("mask", bs(a)), E = V1(c, Ct(Ct(Ct(Ct({}, d), m), x), {}, {
    symbol: i,
    title: s,
    titleId: l,
    maskId: u
  }));
  if (!E)
    return am("Could not find icon", c), null;
  var P = E.abstract, w = {
    ref: t
  };
  return Object.keys(r).forEach(function(b) {
    yt.defaultProps.hasOwnProperty(b) || (w[b] = r[b]);
  }), om(P[0], w);
}
yt.displayName = "FontAwesomeIcon";
yt.propTypes = {
  beat: Q.bool,
  border: Q.bool,
  bounce: Q.bool,
  className: Q.string,
  fade: Q.bool,
  flash: Q.bool,
  mask: Q.oneOfType([Q.object, Q.array, Q.string]),
  maskId: Q.string,
  fixedWidth: Q.bool,
  inverse: Q.bool,
  flip: Q.oneOf(["horizontal", "vertical", "both"]),
  icon: Q.oneOfType([Q.object, Q.array, Q.string]),
  listItem: Q.bool,
  pull: Q.oneOf(["right", "left"]),
  pulse: Q.bool,
  rotation: Q.oneOf([0, 90, 180, 270]),
  shake: Q.bool,
  size: Q.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: Q.bool,
  spinPulse: Q.bool,
  spinReverse: Q.bool,
  symbol: Q.oneOfType([Q.bool, Q.string]),
  title: Q.string,
  titleId: Q.string,
  transform: Q.oneOfType([Q.string, Q.object]),
  swapOpacity: Q.bool
};
yt.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: null,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var om = lu.bind(null, Rr.createElement);
/*! js-cookie v3.0.5 | MIT */
function Yr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      e[n] = r[n];
  }
  return e;
}
var sm = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function La(e, t) {
  function r(a, i, o) {
    if (!(typeof document > "u")) {
      o = Yr({}, t, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var l in o)
        o[l] && (s += "; " + l, o[l] !== !0 && (s += "=" + o[l].split(";")[0]));
      return document.cookie = a + "=" + e.write(i, a) + s;
    }
  }
  function n(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], o = {}, s = 0; s < i.length; s++) {
        var l = i[s].split("="), u = l.slice(1).join("=");
        try {
          var c = decodeURIComponent(l[0]);
          if (o[c] = e.read(u, c), a === c)
            break;
        } catch {
        }
      }
      return a ? o[a] : o;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(a, i) {
        r(
          a,
          "",
          Yr({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return La(this.converter, Yr({}, this.attributes, a));
      },
      withConverter: function(a) {
        return La(Yr({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var ys = La(sm, { path: "/" });
const lm = (e) => /* @__PURE__ */ h.createElement("svg", { id: "United_States_Dollar_USD_", "data-name": "United States Dollar (USD)", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 40, height: 40, viewBox: "0 0 40 40", ...e }, /* @__PURE__ */ h.createElement("rect", { id: "Rectangle_7205", "data-name": "Rectangle 7205", width: 40, height: 40, transform: "translate(689 509)", fill: "#fff", stroke: "#707070", strokeWidth: 1 }), `=
  `, /* @__PURE__ */ h.createElement("g", { id: "usd", transform: "translate(-689 -509)" }, /* @__PURE__ */ h.createElement("g", { id: "Group_28925", "data-name": "Group 28925", transform: "translate(689.001 509.005)" }, /* @__PURE__ */ h.createElement("circle", { id: "Ellipse_3164", "data-name": "Ellipse 3164", cx: 19.999, cy: 19.999, r: 19.999, fill: "#3cc391" }), /* @__PURE__ */ h.createElement("g", { id: "Group_28924", "data-name": "Group 28924", transform: "translate(12.205 7.74)" }, /* @__PURE__ */ h.createElement("g", { id: "Group_28923", "data-name": "Group 28923", transform: "translate(0 0)" }, /* @__PURE__ */ h.createElement("g", { id: "Group_28922", "data-name": "Group 28922" }, /* @__PURE__ */ h.createElement("g", { id: "Group_28921", "data-name": "Group 28921" }, /* @__PURE__ */ h.createElement("path", { id: "Path_32390", "data-name": "Path 32390", d: "M-3463.048-1374.2a8.965,8.965,0,0,0-3.258-1.377l-1.164-.254a.279.279,0,0,1-.222-.273v-4.941a.282.282,0,0,1,.172-.259.28.28,0,0,1,.224,0l.018.006a2.672,2.672,0,0,1,1.864,2.517h3.365a5.358,5.358,0,0,0-2.165-4.186,7.684,7.684,0,0,0-3.248-1.378.28.28,0,0,1-.23-.275v-2.47h-3.059v2.37a.28.28,0,0,1-.246.278,6.928,6.928,0,0,0-3.874,1.561,5.377,5.377,0,0,0-1.845,4.175,4.49,4.49,0,0,0,1.868,4,11.912,11.912,0,0,0,3.88,1.385.28.28,0,0,1,.217.273v5.3a.28.28,0,0,1-.111.224.279.279,0,0,1-.246.044,3.526,3.526,0,0,1-1.766-1.054,3.743,3.743,0,0,1-.793-1.839h-3.348a5.409,5.409,0,0,0,2.081,4.24,8.239,8.239,0,0,0,3.943,1.522.279.279,0,0,1,.241.277v1.759h3.059v-1.708a.281.281,0,0,1,.243-.278,7.882,7.882,0,0,0,4.087-1.619,5.4,5.4,0,0,0,1.94-4.271A4.477,4.477,0,0,0-3463.048-1374.2Zm-7.7-2.769a.277.277,0,0,1-.111.224.279.279,0,0,1-.168.056.262.262,0,0,1-.078-.011,6.377,6.377,0,0,1-1.284-.483A1.939,1.939,0,0,1-3473.5-1379a2.253,2.253,0,0,1,1.1-2.02,5.361,5.361,0,0,1,1.294-.542.284.284,0,0,1,.246.046.279.279,0,0,1,.111.224Zm4.049,9.387a3,3,0,0,1-.669.169.264.264,0,0,1-.042,0,.276.276,0,0,1-.183-.069.282.282,0,0,1-.1-.211v-4.537a.282.282,0,0,1,.114-.226.28.28,0,0,1,.251-.04,7.353,7.353,0,0,1,1.538.638,2.014,2.014,0,0,1,1,1.771A2.528,2.528,0,0,1-3466.7-1367.58Z", transform: "translate(3477.014 1387.084)", fill: "#fff" })))))))), um = (e) => /* @__PURE__ */ h.createElement("svg", { id: "Pound_Sterling_GBP_", "data-name": "Pound Sterling (GBP)", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 40, height: 40, viewBox: "0 0 40 40", ...e }, /* @__PURE__ */ h.createElement("rect", { id: "Rectangle_6714", "data-name": "Rectangle 6714", width: 40, height: 40, transform: "translate(0 -0.329)", fill: "#fff", stroke: "#707070", strokeWidth: 1 }), /* @__PURE__ */ h.createElement("g", { id: "gbp_", "data-name": "gbp ", transform: "translate(0 0.329)" }, /* @__PURE__ */ h.createElement("rect", { id: "Rectangle_6713", "data-name": "Rectangle 6713", width: 40, height: 40, fill: "#3c4fbc", stroke: "#707070", strokeWidth: 1 }), /* @__PURE__ */ h.createElement("g", { id: "Mask_Group_6231", "data-name": "Mask Group 6231", transform: "translate(0 -0.329)" }, /* @__PURE__ */ h.createElement("g", { id: "Group_19157", "data-name": "Group 19157", transform: "translate(0)" }, /* @__PURE__ */ h.createElement("circle", { id: "Ellipse_2993", "data-name": "Ellipse 2993", cx: 20, cy: 20, r: 20, fill: "#3c4fbc" }), /* @__PURE__ */ h.createElement("g", { id: "Group_19156", "data-name": "Group 19156", transform: "translate(12.186 8.763)" }, /* @__PURE__ */ h.createElement("path", { id: "Path_29822", "data-name": "Path 29822", d: "M-2917.459-1364.333v2.957h-16.926v-3.506l.48-.384a10.059,10.059,0,0,0,2.887-4.371h-3.367v-2.957h3.46c-.054-.282-.114-.57-.177-.872a17.958,17.958,0,0,1-.5-3.825,6.938,6.938,0,0,1,1.417-4.348,5.389,5.389,0,0,1,4.261-1.933h.108v.028a5.749,5.749,0,0,1,4.063,1.479,5.7,5.7,0,0,1,1.5,4.106v.107h-3v-.107a2.649,2.649,0,0,0-.667-1.984,2.741,2.741,0,0,0-2.014-.657,2.191,2.191,0,0,0-1.921.811,4.022,4.022,0,0,0-.755,2.515,12.6,12.6,0,0,0,.372,2.523c.146.686.3,1.4.4,2.174h4.8v2.957h-4.982a13.432,13.432,0,0,1-3,5.277Z", transform: "translate(2934.386 1383.574)", fill: "#fff" })))))), cm = (e) => /* @__PURE__ */ h.createElement("svg", { id: "Euro_EUR_", "data-name": "Euro (EUR)", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 40, height: 40, viewBox: "0 0 40 40", ...e }, /* @__PURE__ */ h.createElement("rect", { id: "Rectangle_7126", "data-name": "Rectangle 7126", width: 40, height: 40, transform: "translate(612 486)", fill: "#fff", stroke: "#707070", strokeWidth: 1 }), /* @__PURE__ */ h.createElement("g", { id: "eur", transform: "translate(-612 -486)" }, /* @__PURE__ */ h.createElement("g", { id: "Group_28318", "data-name": "Group 28318", transform: "translate(612.001 485.998)" }, /* @__PURE__ */ h.createElement("circle", { id: "Ellipse_3127", "data-name": "Ellipse 3127", cx: 20, cy: 20, r: 20, fill: "#3961fb" }), /* @__PURE__ */ h.createElement("path", { id: "Path_31759", "data-name": "Path 31759", d: "M-4062.658-1360.806a7.807,7.807,0,0,1-6.939-4.217h6.939v-2.409h-7.733a7.9,7.9,0,0,1-.1-1.205,7.884,7.884,0,0,1,.1-1.2h7.733v-2.41h-6.939a7.821,7.821,0,0,1,6.939-4.216,7.8,7.8,0,0,1,5.1,1.891l2.132-2.132a10.785,10.785,0,0,0-7.229-2.771,10.849,10.849,0,0,0-10.216,7.229h-4.24v2.41h3.687a10.015,10.015,0,0,0-.072,1.2,10.035,10.035,0,0,0,.072,1.205h-3.687v2.409h4.24a10.849,10.849,0,0,0,10.216,7.229,10.765,10.765,0,0,0,7.229-2.771l-2.145-2.132A7.718,7.718,0,0,1-4062.658-1360.806Z", transform: "translate(4083.946 1388.637)", fill: "#fff" })))), fm = "_modal_p4suz_1", dm = "_container_p4suz_24", mm = "_overlay_p4suz_41", hm = "_closeIcon_p4suz_51", pm = "_tabs_p4suz_81", vm = "_selectedCurr_p4suz_109", gm = "_active_p4suz_116", bm = "_languageContainer_p4suz_121", ym = "_currencyContainer_p4suz_144", _m = "_activeOption_p4suz_170", je = {
  modal: fm,
  container: dm,
  overlay: mm,
  closeIcon: hm,
  tabs: pm,
  selectedCurr: vm,
  active: gm,
  languageContainer: bm,
  currencyContainer: ym,
  activeOption: _m
}, zi = () => {
  const [e, t] = Te(0);
  return et(() => {
    const r = () => t(window.innerWidth);
    return window.addEventListener("resize", r), r(), () => window.removeEventListener("resize", r);
  }, []), e;
}, _s = {
  refCurrency: "primaryCurrency"
};
var Vt = /* @__PURE__ */ ((e) => (e.LANGUAGE = "LANGUAGE", e.REF_CURRENCY = "REF_CURRENCY", e))(Vt || {});
const mn = {
  en: "English",
  lt: "Lietuvių",
  ru: "Русский",
  fr: "Français",
  it: "Italiano",
  ar: "العربية",
  "es-ES": "Español",
  et: "Eesti"
  // 'uk-UA': 'Українська (UA)', TODO add when translations are ready
}, Cr = {
  languages: {
    id: "modal.languages",
    defaultMessage: "Language"
  },
  refCurrency: {
    id: "modal.refCurrency",
    defaultMessage: "Reference currency"
  },
  euro: {
    id: "modal.euro",
    defaultMessage: "Euro"
  },
  usd: {
    id: "modal.usd",
    defaultMessage: "United States Dollar"
  },
  gbp: {
    id: "modal.gbp",
    defaultMessage: "British Pound Sterling"
  }
}, Bt = {
  EUR: { label: Cr.euro, sign: "€", icon: cm },
  USD: { label: Cr.usd, sign: "$", icon: lm },
  GBP: { label: Cr.gbp, sign: "£", icon: um }
}, xm = ({ isOpen: e, toggle: t, changeLang: r, changeRefCurr: n }) => {
  const { locale: a, formatMessage: i } = be(), o = zi() < 768, {
    refCurr: { val: s, toggle: l },
    modalState: { val: u, toggle: c }
  } = Le(Re), d = Object.keys(mn).map((p) => ({
    value: p,
    label: mn[p] || p.toUpperCase()
  })), [m, x] = Te(Bt[Lt.USD]), [E, P] = Te(
    d.find((p) => p.value === a)
  ), w = (p) => {
    r(p.value), P(p), t(!1);
  }, b = (p) => {
    n(p), l(p), t(!1);
  };
  return et(() => {
    P(d.find((p) => p.value === a));
  }, [a]), et(() => {
    e && ys.get(_s.refCurrency) !== s && l(ys.get(_s.refCurrency));
  }, [e]), et(() => {
    Bt[s] && x(Bt[s]);
  }, [s]), e ? /* @__PURE__ */ f.jsx(
    Al,
    {
      isOpen: e,
      className: je.modal,
      overlayClassName: je.overlay,
      ariaHideApp: !1,
      onRequestClose: () => t(!1),
      children: /* @__PURE__ */ f.jsxs("div", { className: je.container, children: [
        /* @__PURE__ */ f.jsx("div", { onClick: () => t(!1), className: je.closeIcon, children: o && /* @__PURE__ */ f.jsx(yt, { width: 24, height: 24, icon: ud }) }),
        /* @__PURE__ */ f.jsxs("ul", { className: je.tabs, children: [
          /* @__PURE__ */ f.jsx(
            "li",
            {
              onClick: () => c(
                "LANGUAGE"
                /* LANGUAGE */
              ),
              className: q({
                [je.active]: u === "LANGUAGE"
                /* LANGUAGE */
              }),
              children: i(Cr.languages)
            }
          ),
          /* @__PURE__ */ f.jsxs(
            "li",
            {
              "data-cy": "ref_currency_option",
              onClick: () => c(
                "REF_CURRENCY"
                /* REF_CURRENCY */
              ),
              className: q({
                [je.active]: u === "REF_CURRENCY"
                /* REF_CURRENCY */
              }),
              children: [
                i(Cr.refCurrency),
                /* @__PURE__ */ f.jsx("span", { className: je.selectedCurr, children: m.sign })
              ]
            }
          )
        ] }),
        u === "LANGUAGE" && /* @__PURE__ */ f.jsx("ul", { className: je.languageContainer, children: d.sort((p) => p.value === (E == null ? void 0 : E.value) ? -1 : 1).map((p, g) => /* @__PURE__ */ f.jsx(
          "li",
          {
            className: q({
              [je.activeOption]: !g
            }),
            onClick: () => w(p),
            children: p.label
          },
          p.value
        )) }),
        u === "REF_CURRENCY" && /* @__PURE__ */ f.jsx("ul", { "data-cy": "ref_currency_list", className: je.currencyContainer, children: [Lt.USD, Lt.EUR, Lt.GBP].sort((p) => p === s ? -1 : 1).map((p, g) => {
          const { icon: _, label: y, sign: O } = Bt[p];
          return /* @__PURE__ */ f.jsxs(
            "li",
            {
              className: q(je.currOption, {
                [je.activeOption]: !g
              }),
              onClick: () => b(p),
              "data-cy": `ref_currency_${p}`,
              children: [
                /* @__PURE__ */ f.jsx(_, {}),
                /* @__PURE__ */ f.jsxs("div", { children: [
                  p,
                  " (",
                  O,
                  ")",
                  /* @__PURE__ */ f.jsx("br", {}),
                  /* @__PURE__ */ f.jsx("span", { children: i(y) })
                ] })
              ]
            },
            p
          );
        }) })
      ] })
    }
  ) : null;
};
var en = /* @__PURE__ */ ((e) => (e.EMAIL = "EMAIL", e.SMS = "SMS", e.GOOGLE_AUTH = "GOOGLE_AUTH", e.PUSH_ME = "PUSH_ME", e.DUO_PUSH = "DUO_PUSH", e))(en || {});
const Re = cc({
  config: { PROFILE_DOMAIN: "", SC_URL: "" },
  refCurr: { val: Lt.USD, toggle: () => console.log("changed ref curr") },
  modalState: { val: Vt.LANGUAGE, toggle: () => console.log("changed modal state") },
  accounts: [],
  currentAccount: void 0,
  setAccount: void 0,
  addAccount: void 0,
  twoFaType: void 0
}), Pn = (e, t) => {
  const r = Array.isArray(e) ? e : [e];
  et(() => {
    const n = (a) => {
      const i = (o) => !o.current || o.current.contains(a.target);
      r.some(i) || t(a);
    };
    return document.addEventListener("mousedown", n), document.addEventListener("touchstart", n), () => {
      document.removeEventListener("mousedown", n), document.removeEventListener("touchstart", n);
    };
  }, [...r, t]);
}, wm = "_profileComponent_dm8r0_1", Em = "_noPadding_dm8r0_16", Tm = "_open_dm8r0_38", Pm = "_dropdownIcon_dm8r0_41", Cm = "_profileIcon_dm8r0_44", Sm = "_list_dm8r0_53", Om = "_username_dm8r0_56", Nm = "_userMail_dm8r0_87", Am = "_separator_dm8r0_104", Mm = "_listItem_dm8r0_110", Rm = "_logoutButton_dm8r0_113", km = "_addAccountButton_dm8r0_139", Im = "_icon_dm8r0_165", Dm = "_button_dm8r0_172", Lm = "_rows_dm8r0_177", jm = "_grow_dm8r0_183", Bm = "_overflow_dm8r0_187", Hm = "_name_dm8r0_194", Fm = "_email_dm8r0_200", ce = {
  profileComponent: wm,
  noPadding: Em,
  open: Tm,
  dropdownIcon: Pm,
  profileIcon: Cm,
  list: Sm,
  username: Om,
  userMail: Nm,
  separator: Am,
  listItem: Mm,
  logoutButton: Rm,
  addAccountButton: km,
  icon: Im,
  "profile-component__icon": "_profile-component__icon_dm8r0_168",
  button: Dm,
  rows: Lm,
  grow: jm,
  overflow: Bm,
  name: Hm,
  email: Fm
}, Um = "_listItem_1c7ms_1", $m = "_link_1c7ms_4", Wm = "_logoutButton_1c7ms_24", Gm = "_icon_1c7ms_41", Ym = "_notificationIcon_1c7ms_55", zm = "_separator_1c7ms_59", Vm = "_button_1c7ms_65", qm = "_notification_1c7ms_55", Zm = "_notificationCount_1c7ms_77", Oe = {
  listItem: Um,
  link: $m,
  logoutButton: Wm,
  icon: Gm,
  "profile-component__icon": "_profile-component__icon_1c7ms_44",
  notificationIcon: Ym,
  separator: zm,
  button: Vm,
  notification: qm,
  notificationCount: Zm
}, Xm = (e) => /* @__PURE__ */ h.createElement("svg", { className: "profile-component__icon", id: "b908d541-73f0-4c07-97e9-ff8bd0f894d1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", ...e }, /* @__PURE__ */ h.createElement("defs", null, /* @__PURE__ */ h.createElement("style", null, `
            .e96acb7a-5bba-400c-a94a-6414010fb41e {
                fill: #8695b6;
            }
        `)), /* @__PURE__ */ h.createElement("g", { id: "ad258517-7474-4592-b3a9-3e54069d3935", "data-name": "Mask Group 6034" }, /* @__PURE__ */ h.createElement("g", { id: "a07f0adb-7292-4471-87e0-46be7bf06b4a", "data-name": "Group 13513" }, /* @__PURE__ */ h.createElement("g", { id: "a04314a7-ee09-4230-a699-120ece8579c0", "data-name": "Group 11536" }, /* @__PURE__ */ h.createElement("g", { id: "b26ee184-af21-4b5f-86cd-08a895385787", "data-name": "Group 11212" }, /* @__PURE__ */ h.createElement("path", { id: "e3122992-3b64-458e-b04f-8d0d3e4cb322", "data-name": "Path 21825", className: "e96acb7a-5bba-400c-a94a-6414010fb41e", d: "M1.5,14.06a5,5,0,0,1,10.08,0" }), /* @__PURE__ */ h.createElement("circle", { id: "b671ef85-09f4-4e6b-8a95-c4b74bfbf06a", "data-name": "Ellipse 1742", className: "e96acb7a-5bba-400c-a94a-6414010fb41e", cx: 6.54, cy: 6.19, r: 2.19 }))), /* @__PURE__ */ h.createElement("g", { id: "fff6b12a-65e0-4ff5-8319-92d277ed79f3", "data-name": "Group 13512" }, /* @__PURE__ */ h.createElement("path", { id: "e8469cb5-5e53-44ce-8134-1da26dd9d740", "data-name": "Rectangle 5437", className: "e96acb7a-5bba-400c-a94a-6414010fb41e", d: "M10.51,5.34h6.37a.51.51,0,0,1,.51.51h0a.5.5,0,0,1-.51.5H10.51a.5.5,0,0,1-.51-.5h0A.51.51,0,0,1,10.51,5.34Z" }), /* @__PURE__ */ h.createElement("path", { id: "b8a0aba5-4c93-4e44-80f9-3042a046637d", "data-name": "Rectangle 5438", className: "e96acb7a-5bba-400c-a94a-6414010fb41e", d: "M11.53,8.21h5.35a.51.51,0,0,1,.51.51h0a.51.51,0,0,1-.51.51H11.53A.51.51,0,0,1,11,8.72h0A.51.51,0,0,1,11.53,8.21Z" }), /* @__PURE__ */ h.createElement("path", { id: "f31bc7e3-340a-42a8-8228-5bdf0ada7050", "data-name": "Rectangle 5439", className: "e96acb7a-5bba-400c-a94a-6414010fb41e", d: "M13.67,11.09h3.21a.5.5,0,0,1,.51.5h0a.51.51,0,0,1-.51.51H13.67a.51.51,0,0,1-.51-.51h0A.5.5,0,0,1,13.67,11.09Z" }))))), cu = (e) => /* @__PURE__ */ h.createElement("svg", { className: "profile-component__icon profile-component__icon--notification", id: "e51479e8-0c09-4eca-88cb-4c268aa377c0", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", ...e }, /* @__PURE__ */ h.createElement("defs", null), /* @__PURE__ */ h.createElement("g", { id: "b7fa43fa-542c-4c8b-bb27-4c22f6f55112", "data-name": "Mask Group 6033" }, /* @__PURE__ */ h.createElement("path", { fill: "#4972F4", id: "aac7c1b9-d584-4314-a803-39485d989915", "data-name": "Path 23778", className: "b6ef006a-a14d-46fe-824a-8d9370ac5840", d: "M7.5,15.61a1.58,1.58,0,0,0,1.91-1.14h0l-3-.76a1.57,1.57,0,0,0,1.14,1.9Zm6-2.28c-.33-.61-1-1.57-.4-4A3.88,3.88,0,0,0,11,4.86l.12-.49a.78.78,0,0,0-.57-1h0A.79.79,0,0,0,9.59,4l-.12.49a3.88,3.88,0,0,0-4,2.94,4.64,4.64,0,0,1-2.24,3.35.71.71,0,0,0-.33.46.78.78,0,0,0,.57.95h0l9.14,2.28a.79.79,0,0,0,1-.57h0A.73.73,0,0,0,13.52,13.33Z" }))), Km = (e) => /* @__PURE__ */ h.createElement("svg", { className: "profile-component__icon", id: "ec1edd29-2be1-458c-82e8-0d3cd3d4894f", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", ...e }, /* @__PURE__ */ h.createElement("defs", null, /* @__PURE__ */ h.createElement("style", null, ".a09d6c83-8d0b-4ec8-9c9e-ae6a85d9ff10{fill:#8695b6;}")), /* @__PURE__ */ h.createElement("g", { id: "a4588497-8f8a-4cab-8a02-f23a8956a135", "data-name": "Mask Group 6036" }, /* @__PURE__ */ h.createElement("g", { id: "e7424fd7-cded-406b-9164-278a2ecf1152", "data-name": "Group 13519" }, /* @__PURE__ */ h.createElement("path", { id: "aa01ff1c-62bc-4fb5-bd1e-94f3dd35e9ca", "data-name": "Path 23781", className: "a09d6c83-8d0b-4ec8-9c9e-ae6a85d9ff10", d: "M6.82,6.2h-2v-2H3.18v2h-2V7.87h2v2H4.85v-2h2Z" }), /* @__PURE__ */ h.createElement("g", { id: "b01da1fc-47e6-4c74-8fcd-20e4038a2d8f", "data-name": "Group 13518" }, /* @__PURE__ */ h.createElement("g", { id: "e46f2b7e-6aa7-4ce3-8e1f-74ab8d280dd2", "data-name": "Group 13517" }, /* @__PURE__ */ h.createElement("path", { id: "adc40a14-1af6-4aab-8a4c-675d5a2bbaf4", "data-name": "Path 23782", className: "a09d6c83-8d0b-4ec8-9c9e-ae6a85d9ff10", d: "M6,14.6a5.42,5.42,0,0,1,10.84,0" })), /* @__PURE__ */ h.createElement("circle", { id: "e8cf729e-4039-4f5a-ba3c-13ca690eef10", "data-name": "Ellipse 1742", className: "a09d6c83-8d0b-4ec8-9c9e-ae6a85d9ff10", cx: 11.46, cy: 6.31, r: 2.31 }))))), Jm = (e) => /* @__PURE__ */ h.createElement("svg", { className: "profile-component__icon", id: "b74ddda4-d9e8-4c98-9084-3017ad8c70be", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", ...e }, /* @__PURE__ */ h.createElement("defs", null, /* @__PURE__ */ h.createElement("style", null, ".a8011b39-6e77-4006-b0b0-3df475c96e2d{fill:#8695b6;}")), /* @__PURE__ */ h.createElement("g", { id: "b89748d4-a4b9-4d55-967a-f8d6085ca100", "data-name": "Mask Group 6035" }, /* @__PURE__ */ h.createElement("g", { id: "ac578e8d-0a37-43ec-92e0-acb438aa7c96", "data-name": "Group 13516" }, /* @__PURE__ */ h.createElement("path", { id: "aad3d5f9-dfb7-4d25-a574-df9e0357e42c", "data-name": "Subtraction 6", className: "a8011b39-6e77-4006-b0b0-3df475c96e2d", d: "M9.06,16.76c-2.71,0-4.91-1.83-4.91-4.07V8.41a1,1,0,0,1,1-1H13a1,1,0,0,1,1,1v4.28C14,14.93,11.76,16.76,9.06,16.76Zm0-7.14a1.2,1.2,0,0,0-1.21,1.19,1.22,1.22,0,0,0,.51,1v1a.7.7,0,1,0,1.39.12.24.24,0,0,0,0-.12v-1a1.19,1.19,0,0,0,.3-1.67A1.22,1.22,0,0,0,9.06,9.62ZM7,6.46H5.66V6.29c0-.42,0-.89,0-1.48A3.51,3.51,0,0,1,9.06,1.3a3.51,3.51,0,0,1,3.41,3.51V6.45H11.18V4.81A2.21,2.21,0,0,0,9.06,2.59,2.21,2.21,0,0,0,6.94,4.81c0,.67,0,1.21,0,1.64H7Z" })))), Qe = {
  notifications: {
    id: "profileBubble.notifications",
    defaultMessage: "Notifications"
  },
  profileInformation: {
    id: "profileBubble.profileInformation",
    defaultMessage: "Profile information"
  },
  verification: {
    id: "profileBubble.verification",
    defaultMessage: "Verification"
  },
  settings: {
    id: "profileBubble.settings",
    defaultMessage: "Settings"
  },
  referral: {
    id: "profileBubble.referral",
    defaultMessage: "Referral"
  },
  linkedCards: {
    id: "profileBubble.linkedCards",
    defaultMessage: "Linked cards"
  },
  logout: {
    id: "profileBubble.logout",
    defaultMessage: "Logout"
  },
  personalProfile: {
    id: "profileBubble.personalProfile",
    defaultMessage: "Personal profile"
  },
  companyProfile: {
    id: "profileBubble.companyProfile",
    defaultMessage: "Company profile"
  },
  addOrSwitch: {
    id: "profileBubble.addOrSwitch",
    defaultMessage: "Add or switch profiles"
  },
  back: {
    id: "profileBubble.back",
    defaultMessage: "Back"
  },
  x_personal: {
    id: "profileBubble.x_personal",
    defaultMessage: "{Name} Personal"
  },
  addAccount: {
    id: "profileBubble.addAccount",
    defaultMessage: "Add new business"
  }
}, Qm = ({ totalCount: e }) => {
  const t = zi() < 768, { locale: r, formatMessage: n } = be(), { config: a } = Le(Re);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    e > 0 && t && /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx("li", { className: Oe.listItem, children: /* @__PURE__ */ f.jsxs(
      "a",
      {
        className: Oe.link,
        href: `${window.location.origin}/${r}/notifications`,
        id: "more",
        children: [
          /* @__PURE__ */ f.jsx(
            cu,
            {
              className: q(Oe.icon, Oe.notificationIcon)
            }
          ),
          /* @__PURE__ */ f.jsxs("div", { className: Oe.notification, children: [
            /* @__PURE__ */ f.jsx("span", { children: n(Qe.notifications) }),
            e > 0 && /* @__PURE__ */ f.jsx("span", { className: Oe.notificationCount, children: e })
          ] })
        ]
      }
    ) }) }),
    /* @__PURE__ */ f.jsx("li", { className: Oe.listItem, children: /* @__PURE__ */ f.jsxs("a", { href: `${a.PROFILE_DOMAIN}/${r}/details`, className: Oe.link, children: [
      /* @__PURE__ */ f.jsx(Xm, { className: Oe.icon }),
      n(Qe.profileInformation)
    ] }) }),
    /* @__PURE__ */ f.jsx("li", { className: Oe.listItem, children: /* @__PURE__ */ f.jsxs("a", { href: `${window.location.origin}/${r}/referrals`, className: Oe.link, children: [
      /* @__PURE__ */ f.jsx(Km, { className: Oe.icon }),
      n(Qe.referral)
    ] }) }),
    /* @__PURE__ */ f.jsx("li", { className: Oe.listItem, children: /* @__PURE__ */ f.jsxs("a", { href: `${window.location.origin}/${r}/settings`, className: Oe.link, children: [
      /* @__PURE__ */ f.jsx(Jm, { className: Oe.icon }),
      n(Qe.settings)
    ] }) })
  ] });
}, eh = "_listItem_1d6w1_1", th = "_text_1d6w1_11", rh = "_active_1d6w1_14", nh = "_disabled_1d6w1_17", ah = "_icon_1d6w1_33", Sr = {
  listItem: eh,
  text: th,
  active: rh,
  disabled: nh,
  icon: ah
};
var Ue = /* @__PURE__ */ ((e) => (e.PRIVATE_PERSON = "PRIVATE_PERSON", e.COMPANY_REPRESENTATIVE = "COMPANY_REPRESENTATIVE", e))(Ue || {}), fu = /* @__PURE__ */ ((e) => (e.BANNED = "BANNED", e.ACTIVE = "ACTIVE", e))(fu || {});
const ih = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 18, height: 17.961, viewBox: "0 0 18 17.961", ...e }, /* @__PURE__ */ h.createElement("g", { id: "Group_273996", "data-name": "Group 273996", transform: "translate(0 0)" }, /* @__PURE__ */ h.createElement("g", { id: "Group_273886", "data-name": "Group 273886", transform: "translate(0 0)" }, /* @__PURE__ */ h.createElement("path", { id: "Path_44657", "data-name": "Path 44657", d: "M0,14.566a9,9,0,0,1,18,0", transform: "translate(0 3.396)", fill: "currentColor" }), /* @__PURE__ */ h.createElement("path", { id: "Path_44658", "data-name": "Path 44658", d: "M7.081,0A3.912,3.912,0,1,1,3.169,3.912,3.912,3.912,0,0,1,7.081,0", transform: "translate(1.924 0)", fill: "currentColor" })))), oh = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 18, height: 16.363, viewBox: "0 0 18 16.363", ...e }, /* @__PURE__ */ h.createElement("g", { id: "Group_273995", "data-name": "Group 273995", transform: "translate(0 0.001)" }, /* @__PURE__ */ h.createElement("g", { id: "Group_273889", "data-name": "Group 273889", transform: "translate(0 -0.001)" }, /* @__PURE__ */ h.createElement("path", { id: "Path_44659", "data-name": "Path 44659", d: "M17.428,3.856H13.748V.686A.686.686,0,0,0,13.062,0H4.938a.685.685,0,0,0-.685.687v3.17H.572A.573.573,0,0,0,0,4.428V15.79a.573.573,0,0,0,.572.572H17.428A.573.573,0,0,0,18,15.79V4.428a.573.573,0,0,0-.572-.572M6.651,2.4h4.7V3.856h-4.7Z", transform: "translate(0 0)", fill: "currentColor" })))), sh = "_icon_1c0n7_1", lh = "_active_1c0n7_9", xs = {
  icon: sh,
  active: lh
}, Or = ({
  type: e,
  bubbleSize: t,
  iconSize: r,
  classname: n,
  isActive: a = !1
}) => /* @__PURE__ */ f.jsx(
  "div",
  {
    className: q(xs.icon, n, a && xs.active),
    style: { height: t, width: t },
    children: e === Ue.PRIVATE_PERSON ? /* @__PURE__ */ f.jsx(ih, { height: `${r}px`, width: `${r}px` }) : /* @__PURE__ */ f.jsx(oh, { height: `${r}px`, width: `${r}px` })
  }
), uh = ({ firstname: e, lastname: t, username: r, userGuid: n }) => {
  const { currentAccount: a } = Le(Re), i = a.userGuid === n, o = e && r ? `${e} ${t}` : e || t || r.split("@")[0].replace(/\W/g, " ");
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      Or,
      {
        bubbleSize: 24,
        iconSize: 10,
        type: Ue.PRIVATE_PERSON,
        isActive: i
      }
    ),
    /* @__PURE__ */ f.jsx("span", { className: Sr.text, children: /* @__PURE__ */ f.jsx(yl, { ...Qe.x_personal, values: { Name: o } }) })
  ] });
}, ch = ({ companyName: e, userGuid: t, username: r }) => {
  const { currentAccount: n } = Le(Re), a = n.userGuid === t;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      Or,
      {
        bubbleSize: 24,
        iconSize: 10,
        type: Ue.COMPANY_REPRESENTATIVE,
        isActive: a
      }
    ),
    /* @__PURE__ */ f.jsx("span", { className: Sr.text, children: e || r })
  ] });
}, fh = (e) => {
  const { setAccount: t, currentAccount: r } = Le(Re), n = r.userGuid === e.userGuid, a = e.status !== fu.ACTIVE;
  return /* @__PURE__ */ f.jsx(
    "li",
    {
      className: q(
        Sr.listItem,
        n && Sr.active,
        a && Sr.disabled
      ),
      onClick: () => {
        n || a || t(e.userGuid);
      },
      children: e.type === Ue.PRIVATE_PERSON ? /* @__PURE__ */ f.jsx(uh, { ...e }) : /* @__PURE__ */ f.jsx(ch, { ...e })
    },
    e.userGuid
  );
}, ws = {
  [Ue.PRIVATE_PERSON]: 1,
  [Ue.COMPANY_REPRESENTATIVE]: 2
}, dh = (e, t) => {
  const r = (n) => n.type === Ue.COMPANY_REPRESENTATIVE ? n.companyName || n.username : n.firstname || n.lastname || n.username;
  return (ws[e.type] || 0) - (ws[t.type] || 0) || r(e).localeCompare(r(t), void 0, {
    numeric: !0,
    sensitivity: "base"
  });
}, mh = () => {
  const { accounts: e } = Le(Re), { currentAccount: t } = Le(Re), r = fc(() => [...e].sort(dh), [e]);
  return e.length < 1 || !t ? null : /* @__PURE__ */ f.jsx(f.Fragment, { children: r.map((n) => /* @__PURE__ */ f.jsx(fh, { ...n }, n.userGuid)) });
}, ja = (e) => /* @__PURE__ */ h.createElement("svg", { id: "Chevron_Left", "data-name": "Chevron Left", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 24, height: 24, viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ h.createElement("g", { id: "Arrow_Down" }, /* @__PURE__ */ h.createElement("path", { id: "Path_31786", "data-name": "Path 31786", d: "M.126,2.058a.608.608,0,0,1,.05-.8L1.256.178a.608.608,0,0,1,.79-.06l4.7,4.7,4.7-4.7a.607.607,0,0,1,.79.06l1.08,1.08a.609.609,0,0,1,.06.8l-6.19,6.2a.588.588,0,0,1-.65.14.483.483,0,0,1-.22-.15", transform: "translate(16.219 5.472) rotate(90)", fill: "#102d6f" }))), hh = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 22.281, height: 14.996, viewBox: "0 0 22.281 14.996", ...e }, /* @__PURE__ */ h.createElement("g", { id: "Group_273883", "data-name": "Group 273883", transform: "translate(0 0)" }, /* @__PURE__ */ h.createElement("g", { id: "Group_273882", "data-name": "Group 273882" }, /* @__PURE__ */ h.createElement("path", { id: "Path_44652", "data-name": "Path 44652", d: "M.084,6.8a.406.406,0,0,1,.034-.533l.72-.72a.4.4,0,0,1,.527-.04L4.5,8.641,7.631,5.508a.4.4,0,0,1,.527.04l.72.72a.406.406,0,0,1,.04.533L4.791,10.934a.393.393,0,0,1-.433.093.331.331,0,0,1-.147-.1", fill: "#8695b6" }), /* @__PURE__ */ h.createElement("path", { id: "Path_44653", "data-name": "Path 44653", d: "M4.181,10.269A7.491,7.491,0,0,1,16.729,2.51a.441.441,0,0,1-.065.631l-.654.514a.434.434,0,0,1-.593-.061A5.79,5.79,0,0,0,5.761,9.638Z", fill: "#8695b6" }), /* @__PURE__ */ h.createElement("path", { id: "Path_44654", "data-name": "Path 44654", d: "M22.2,8.2a.406.406,0,0,1-.034.533l-.72.72a.4.4,0,0,1-.527.04L17.781,6.356,14.65,9.489a.4.4,0,0,1-.527-.04l-.72-.72a.406.406,0,0,1-.04-.533L17.49,4.063a.393.393,0,0,1,.433-.093.331.331,0,0,1,.147.1", fill: "#8695b6" }), /* @__PURE__ */ h.createElement("path", { id: "Path_44655", "data-name": "Path 44655", d: "M11.13,15a7.449,7.449,0,0,1-5.577-2.509.44.44,0,0,1,.065-.632l.653-.514a.434.434,0,0,1,.592.061A5.791,5.791,0,0,0,16.52,5.357l1.58-.631A7.5,7.5,0,0,1,11.13,15", fill: "#8695b6" })))), ph = "_listItem_1dgax_1", vh = "_text_1dgax_15", gh = "_small_1dgax_19", bh = "_icon_1dgax_24", yh = "_chevron_1dgax_29", _h = "_fliped_1dgax_33", xh = "_rows_1dgax_40", wh = "_grow_1dgax_46", Eh = "_overflow_1dgax_50", Xe = {
  listItem: ph,
  text: vh,
  small: gh,
  icon: bh,
  chevron: yh,
  fliped: _h,
  rows: xh,
  grow: wh,
  overflow: Eh
}, Th = ({ isActive: e, onOpen: t, onCancel: r }) => {
  const { formatMessage: n } = be(), { currentAccount: a } = Le(Re);
  return a ? /* @__PURE__ */ f.jsx(f.Fragment, { children: e ? /* @__PURE__ */ f.jsxs(
    "li",
    {
      className: Xe.listItem,
      onClick: (i) => {
        i.stopPropagation(), r();
      },
      children: [
        /* @__PURE__ */ f.jsx(ja, { width: 24, height: 24, className: Xe.chevron }),
        /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("span", { children: n(Qe.back) }) })
      ]
    }
  ) : /* @__PURE__ */ f.jsxs(
    "li",
    {
      className: Xe.listItem,
      onClick: (i) => {
        i.stopPropagation(), t();
      },
      children: [
        /* @__PURE__ */ f.jsx(hh, { className: Xe.icon }),
        /* @__PURE__ */ f.jsxs("div", { className: q(Xe.rows, Xe.grow, Xe.overflow), children: [
          /* @__PURE__ */ f.jsx("span", { className: q(Xe.overflow), children: a.type === Ue.PRIVATE_PERSON ? n(Qe.personalProfile) : n(Qe.companyProfile) }),
          /* @__PURE__ */ f.jsx("span", { className: Xe.small, children: n(Qe.addOrSwitch) })
        ] }),
        /* @__PURE__ */ f.jsx(
          ja,
          {
            width: 24,
            height: 24,
            className: q(Xe.chevron, Xe.fliped)
          }
        )
      ]
    }
  ) }) : null;
};
/**
 * @remix-run/router v1.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Ba() {
  return Ba = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ba.apply(this, arguments);
}
var Es;
(function(e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(Es || (Es = {}));
function ge(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function gr(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function Ha(e) {
  let {
    pathname: t = "/",
    search: r = "",
    hash: n = ""
  } = e;
  return r && r !== "?" && (t += r.charAt(0) === "?" ? r : "?" + r), n && n !== "#" && (t += n.charAt(0) === "#" ? n : "#" + n), t;
}
function du(e) {
  let t = {};
  if (e) {
    let r = e.indexOf("#");
    r >= 0 && (t.hash = e.substr(r), e = e.substr(0, r));
    let n = e.indexOf("?");
    n >= 0 && (t.search = e.substr(n), e = e.substr(0, n)), e && (t.pathname = e);
  }
  return t;
}
var Ts;
(function(e) {
  e.data = "data", e.deferred = "deferred", e.redirect = "redirect", e.error = "error";
})(Ts || (Ts = {}));
function Ps(e, t) {
  typeof e == "string" && (e = {
    path: e,
    caseSensitive: !1,
    end: !0
  });
  let [r, n] = Ph(e.path, e.caseSensitive, e.end), a = t.match(r);
  if (!a)
    return null;
  let i = a[0], o = i.replace(/(.)\/+$/, "$1"), s = a.slice(1);
  return {
    params: n.reduce((u, c, d) => {
      let {
        paramName: m,
        isOptional: x
      } = c;
      if (m === "*") {
        let P = s[d] || "";
        o = i.slice(0, i.length - P.length).replace(/(.)\/+$/, "$1");
      }
      const E = s[d];
      return x && !E ? u[m] = void 0 : u[m] = Ch(E || "", m), u;
    }, {}),
    pathname: i,
    pathnameBase: o,
    pattern: e
  };
}
function Ph(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !0), gr(e === "*" || !e.endsWith("*") || e.endsWith("/*"), 'Route path "' + e + '" will be treated as if it were ' + ('"' + e.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + e.replace(/\*$/, "/*") + '".'));
  let n = [], a = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (o, s, l) => (n.push({
    paramName: s,
    isOptional: l != null
  }), l ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return e.endsWith("*") ? (n.push({
    paramName: "*"
  }), a += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : r ? a += "\\/*$" : e !== "" && e !== "/" && (a += "(?:(?=\\/|$))"), [new RegExp(a, t ? void 0 : "i"), n];
}
function Ch(e, t) {
  try {
    return decodeURIComponent(e);
  } catch (r) {
    return gr(!1, 'The value for the URL param "' + t + '" will not be decoded because' + (' the string "' + e + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + r + ").")), e;
  }
}
function fr(e, t) {
  if (t === "/")
    return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let r = t.endsWith("/") ? t.length - 1 : t.length, n = e.charAt(r);
  return n && n !== "/" ? null : e.slice(r) || "/";
}
function Sh(e, t) {
  t === void 0 && (t = "/");
  let {
    pathname: r,
    search: n = "",
    hash: a = ""
  } = typeof e == "string" ? du(e) : e;
  return {
    pathname: r ? r.startsWith("/") ? r : Oh(r, t) : t,
    search: Ah(n),
    hash: Mh(a)
  };
}
function Oh(e, t) {
  let r = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((a) => {
    a === ".." ? r.length > 1 && r.pop() : a !== "." && r.push(a);
  }), r.length > 1 ? r.join("/") : "/";
}
function qn(e, t, r, n) {
  return "Cannot include a '" + e + "' character in a manually specified " + ("`to." + t + "` field [" + JSON.stringify(n) + "].  Please separate it out to the ") + ("`to." + r + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function Nh(e) {
  return e.filter((t, r) => r === 0 || t.route.path && t.route.path.length > 0);
}
function mu(e, t) {
  let r = Nh(e);
  return t ? r.map((n, a) => a === e.length - 1 ? n.pathname : n.pathnameBase) : r.map((n) => n.pathnameBase);
}
function hu(e, t, r, n) {
  n === void 0 && (n = !1);
  let a;
  typeof e == "string" ? a = du(e) : (a = Ba({}, e), ge(!a.pathname || !a.pathname.includes("?"), qn("?", "pathname", "search", a)), ge(!a.pathname || !a.pathname.includes("#"), qn("#", "pathname", "hash", a)), ge(!a.search || !a.search.includes("#"), qn("#", "search", "hash", a)));
  let i = e === "" || a.pathname === "", o = i ? "/" : a.pathname, s;
  if (o == null)
    s = r;
  else {
    let d = t.length - 1;
    if (!n && o.startsWith("..")) {
      let m = o.split("/");
      for (; m[0] === ".."; )
        m.shift(), d -= 1;
      a.pathname = m.join("/");
    }
    s = d >= 0 ? t[d] : "/";
  }
  let l = Sh(a, s), u = o && o !== "/" && o.endsWith("/"), c = (i || o === ".") && r.endsWith("/");
  return !l.pathname.endsWith("/") && (u || c) && (l.pathname += "/"), l;
}
const Vi = (e) => e.join("/").replace(/\/\/+/g, "/"), Ah = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, Mh = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e, pu = ["post", "put", "patch", "delete"];
new Set(pu);
const Rh = ["get", ...pu];
new Set(Rh);
/**
 * React Router v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Fa() {
  return Fa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fa.apply(this, arguments);
}
const Cn = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (Cn.displayName = "DataRouter");
const vu = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (vu.displayName = "DataRouterState");
const kh = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (kh.displayName = "Await");
const _t = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (_t.displayName = "Navigation");
const qi = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (qi.displayName = "Location");
const br = /* @__PURE__ */ h.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (br.displayName = "Route");
const Ih = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (Ih.displayName = "RouteError");
function Dh(e, t) {
  let {
    relative: r
  } = t === void 0 ? {} : t;
  Zi() || (process.env.NODE_ENV !== "production" ? ge(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  ) : ge(!1));
  let {
    basename: n,
    navigator: a
  } = h.useContext(_t), {
    hash: i,
    pathname: o,
    search: s
  } = Br(e, {
    relative: r
  }), l = o;
  return n !== "/" && (l = o === "/" ? n : Vi([n, o])), a.createHref({
    pathname: l,
    search: s,
    hash: i
  });
}
function Zi() {
  return h.useContext(qi) != null;
}
function jr() {
  return Zi() || (process.env.NODE_ENV !== "production" ? ge(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : ge(!1)), h.useContext(qi).location;
}
const gu = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function bu(e) {
  h.useContext(_t).static || h.useLayoutEffect(e);
}
function Lh() {
  let {
    isDataRoute: e
  } = h.useContext(br);
  return e ? Uh() : jh();
}
function jh() {
  Zi() || (process.env.NODE_ENV !== "production" ? ge(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : ge(!1));
  let e = h.useContext(Cn), {
    basename: t,
    future: r,
    navigator: n
  } = h.useContext(_t), {
    matches: a
  } = h.useContext(br), {
    pathname: i
  } = jr(), o = JSON.stringify(mu(a, r.v7_relativeSplatPath)), s = h.useRef(!1);
  return bu(() => {
    s.current = !0;
  }), h.useCallback(function(u, c) {
    if (c === void 0 && (c = {}), process.env.NODE_ENV !== "production" && gr(s.current, gu), !s.current)
      return;
    if (typeof u == "number") {
      n.go(u);
      return;
    }
    let d = hu(u, JSON.parse(o), i, c.relative === "path");
    e == null && t !== "/" && (d.pathname = d.pathname === "/" ? t : Vi([t, d.pathname])), (c.replace ? n.replace : n.push)(d, c.state, c);
  }, [t, n, o, i, e]);
}
function Br(e, t) {
  let {
    relative: r
  } = t === void 0 ? {} : t, {
    future: n
  } = h.useContext(_t), {
    matches: a
  } = h.useContext(br), {
    pathname: i
  } = jr(), o = JSON.stringify(mu(a, n.v7_relativeSplatPath));
  return h.useMemo(() => hu(e, JSON.parse(o), i, r === "path"), [e, o, i, r]);
}
var yu = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e;
}(yu || {}), Xi = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseLoaderData = "useLoaderData", e.UseActionData = "useActionData", e.UseRouteError = "useRouteError", e.UseNavigation = "useNavigation", e.UseRouteLoaderData = "useRouteLoaderData", e.UseMatches = "useMatches", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e.UseRouteId = "useRouteId", e;
}(Xi || {});
function _u(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function Bh(e) {
  let t = h.useContext(Cn);
  return t || (process.env.NODE_ENV !== "production" ? ge(!1, _u(e)) : ge(!1)), t;
}
function Hh(e) {
  let t = h.useContext(br);
  return t || (process.env.NODE_ENV !== "production" ? ge(!1, _u(e)) : ge(!1)), t;
}
function xu(e) {
  let t = Hh(e), r = t.matches[t.matches.length - 1];
  return r.route.id || (process.env.NODE_ENV !== "production" ? ge(!1, e + ' can only be used on routes that contain a unique "id"') : ge(!1)), r.route.id;
}
function Fh() {
  return xu(Xi.UseRouteId);
}
function Uh() {
  let {
    router: e
  } = Bh(yu.UseNavigateStable), t = xu(Xi.UseNavigateStable), r = h.useRef(!1);
  return bu(() => {
    r.current = !0;
  }), h.useCallback(function(a, i) {
    i === void 0 && (i = {}), process.env.NODE_ENV !== "production" && gr(r.current, gu), r.current && (typeof a == "number" ? e.navigate(a) : e.navigate(a, Fa({
      fromRouteId: t
    }, i)));
  }, [e, t]);
}
new Promise(() => {
});
/**
 * React Router DOM v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function dr() {
  return dr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dr.apply(this, arguments);
}
function Ki(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
const tn = "get", rn = "application/x-www-form-urlencoded";
function Sn(e) {
  return e != null && typeof e.tagName == "string";
}
function $h(e) {
  return Sn(e) && e.tagName.toLowerCase() === "button";
}
function Wh(e) {
  return Sn(e) && e.tagName.toLowerCase() === "form";
}
function Gh(e) {
  return Sn(e) && e.tagName.toLowerCase() === "input";
}
function Yh(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function zh(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !Yh(e);
}
let zr = null;
function Vh() {
  if (zr === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), zr = !1;
    } catch {
      zr = !0;
    }
  return zr;
}
const qh = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function Zn(e) {
  return e != null && !qh.has(e) ? (process.env.NODE_ENV !== "production" && gr(!1, '"' + e + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + rn + '"')), null) : e;
}
function Zh(e, t) {
  let r, n, a, i, o;
  if (Wh(e)) {
    let s = e.getAttribute("action");
    n = s ? fr(s, t) : null, r = e.getAttribute("method") || tn, a = Zn(e.getAttribute("enctype")) || rn, i = new FormData(e);
  } else if ($h(e) || Gh(e) && (e.type === "submit" || e.type === "image")) {
    let s = e.form;
    if (s == null)
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    let l = e.getAttribute("formaction") || s.getAttribute("action");
    if (n = l ? fr(l, t) : null, r = e.getAttribute("formmethod") || s.getAttribute("method") || tn, a = Zn(e.getAttribute("formenctype")) || Zn(s.getAttribute("enctype")) || rn, i = new FormData(s, e), !Vh()) {
      let {
        name: u,
        type: c,
        value: d
      } = e;
      if (c === "image") {
        let m = u ? u + "." : "";
        i.append(m + "x", "0"), i.append(m + "y", "0");
      } else
        u && i.append(u, d);
    }
  } else {
    if (Sn(e))
      throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    r = tn, n = null, a = rn, o = e;
  }
  return i && a === "text/plain" && (o = i, i = void 0), {
    action: n,
    method: r.toLowerCase(),
    encType: a,
    formData: i,
    body: o
  };
}
const Xh = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "unstable_viewTransition"], Kh = ["aria-current", "caseSensitive", "className", "end", "style", "to", "unstable_viewTransition", "children"], Jh = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "unstable_viewTransition"], wu = /* @__PURE__ */ h.createContext({
  isTransitioning: !1
});
process.env.NODE_ENV !== "production" && (wu.displayName = "ViewTransition");
const Qh = /* @__PURE__ */ h.createContext(/* @__PURE__ */ new Map());
process.env.NODE_ENV !== "production" && (Qh.displayName = "Fetchers");
process.env.NODE_ENV;
const ep = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", tp = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, Ji = /* @__PURE__ */ h.forwardRef(function(t, r) {
  let {
    onClick: n,
    relative: a,
    reloadDocument: i,
    replace: o,
    state: s,
    target: l,
    to: u,
    preventScrollReset: c,
    unstable_viewTransition: d
  } = t, m = Ki(t, Xh), {
    basename: x
  } = h.useContext(_t), E, P = !1;
  if (typeof u == "string" && tp.test(u) && (E = u, ep))
    try {
      let g = new URL(window.location.href), _ = u.startsWith("//") ? new URL(g.protocol + u) : new URL(u), y = fr(_.pathname, x);
      _.origin === g.origin && y != null ? u = y + _.search + _.hash : P = !0;
    } catch {
      process.env.NODE_ENV !== "production" && gr(!1, '<Link to="' + u + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.');
    }
  let w = Dh(u, {
    relative: a
  }), b = ip(u, {
    replace: o,
    state: s,
    target: l,
    preventScrollReset: c,
    relative: a,
    unstable_viewTransition: d
  });
  function p(g) {
    n && n(g), g.defaultPrevented || b(g);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ h.createElement("a", dr({}, m, {
      href: E || w,
      onClick: P || i ? n : p,
      ref: r,
      target: l
    }))
  );
});
process.env.NODE_ENV !== "production" && (Ji.displayName = "Link");
const rp = /* @__PURE__ */ h.forwardRef(function(t, r) {
  let {
    "aria-current": n = "page",
    caseSensitive: a = !1,
    className: i = "",
    end: o = !1,
    style: s,
    to: l,
    unstable_viewTransition: u,
    children: c
  } = t, d = Ki(t, Kh), m = Br(l, {
    relative: d.relative
  }), x = jr(), E = h.useContext(vu), {
    navigator: P,
    basename: w
  } = h.useContext(_t), b = E != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  fp(m) && u === !0, p = P.encodeLocation ? P.encodeLocation(m).pathname : m.pathname, g = x.pathname, _ = E && E.navigation && E.navigation.location ? E.navigation.location.pathname : null;
  a || (g = g.toLowerCase(), _ = _ ? _.toLowerCase() : null, p = p.toLowerCase()), _ && w && (_ = fr(_, w) || _);
  const y = p !== "/" && p.endsWith("/") ? p.length - 1 : p.length;
  let O = g === p || !o && g.startsWith(p) && g.charAt(y) === "/", j = _ != null && (_ === p || !o && _.startsWith(p) && _.charAt(p.length) === "/"), ne = {
    isActive: O,
    isPending: j,
    isTransitioning: b
  }, ae = O ? n : void 0, Ee;
  typeof i == "function" ? Ee = i(ne) : Ee = [i, O ? "active" : null, j ? "pending" : null, b ? "transitioning" : null].filter(Boolean).join(" ");
  let Ie = typeof s == "function" ? s(ne) : s;
  return /* @__PURE__ */ h.createElement(Ji, dr({}, d, {
    "aria-current": ae,
    className: Ee,
    ref: r,
    style: Ie,
    to: l,
    unstable_viewTransition: u
  }), typeof c == "function" ? c(ne) : c);
});
process.env.NODE_ENV !== "production" && (rp.displayName = "NavLink");
const np = /* @__PURE__ */ h.forwardRef((e, t) => {
  let {
    fetcherKey: r,
    navigate: n,
    reloadDocument: a,
    replace: i,
    state: o,
    method: s = tn,
    action: l,
    onSubmit: u,
    relative: c,
    preventScrollReset: d,
    unstable_viewTransition: m
  } = e, x = Ki(e, Jh), E = up(), P = cp(l, {
    relative: c
  }), w = s.toLowerCase() === "get" ? "get" : "post", b = (p) => {
    if (u && u(p), p.defaultPrevented)
      return;
    p.preventDefault();
    let g = p.nativeEvent.submitter, _ = (g == null ? void 0 : g.getAttribute("formmethod")) || s;
    E(g || p.currentTarget, {
      fetcherKey: r,
      method: _,
      navigate: n,
      replace: i,
      state: o,
      relative: c,
      preventScrollReset: d,
      unstable_viewTransition: m
    });
  };
  return /* @__PURE__ */ h.createElement("form", dr({
    ref: t,
    method: w,
    action: P,
    onSubmit: a ? u : b
  }, x));
});
process.env.NODE_ENV !== "production" && (np.displayName = "Form");
process.env.NODE_ENV;
var hn;
(function(e) {
  e.UseScrollRestoration = "useScrollRestoration", e.UseSubmit = "useSubmit", e.UseSubmitFetcher = "useSubmitFetcher", e.UseFetcher = "useFetcher", e.useViewTransitionState = "useViewTransitionState";
})(hn || (hn = {}));
var Cs;
(function(e) {
  e.UseFetcher = "useFetcher", e.UseFetchers = "useFetchers", e.UseScrollRestoration = "useScrollRestoration";
})(Cs || (Cs = {}));
function ap(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function Eu(e) {
  let t = h.useContext(Cn);
  return t || (process.env.NODE_ENV !== "production" ? ge(!1, ap(e)) : ge(!1)), t;
}
function ip(e, t) {
  let {
    target: r,
    replace: n,
    state: a,
    preventScrollReset: i,
    relative: o,
    unstable_viewTransition: s
  } = t === void 0 ? {} : t, l = Lh(), u = jr(), c = Br(e, {
    relative: o
  });
  return h.useCallback((d) => {
    if (zh(d, r)) {
      d.preventDefault();
      let m = n !== void 0 ? n : Ha(u) === Ha(c);
      l(e, {
        replace: m,
        state: a,
        preventScrollReset: i,
        relative: o,
        unstable_viewTransition: s
      });
    }
  }, [u, l, c, n, a, r, e, i, o, s]);
}
function op() {
  if (typeof document > "u")
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let sp = 0, lp = () => "__" + String(++sp) + "__";
function up() {
  let {
    router: e
  } = Eu(hn.UseSubmit), {
    basename: t
  } = h.useContext(_t), r = Fh();
  return h.useCallback(function(n, a) {
    a === void 0 && (a = {}), op();
    let {
      action: i,
      method: o,
      encType: s,
      formData: l,
      body: u
    } = Zh(n, t);
    if (a.navigate === !1) {
      let c = a.fetcherKey || lp();
      e.fetch(c, r, a.action || i, {
        preventScrollReset: a.preventScrollReset,
        formData: l,
        body: u,
        formMethod: a.method || o,
        formEncType: a.encType || s,
        unstable_flushSync: a.unstable_flushSync
      });
    } else
      e.navigate(a.action || i, {
        preventScrollReset: a.preventScrollReset,
        formData: l,
        body: u,
        formMethod: a.method || o,
        formEncType: a.encType || s,
        replace: a.replace,
        state: a.state,
        fromRouteId: r,
        unstable_flushSync: a.unstable_flushSync,
        unstable_viewTransition: a.unstable_viewTransition
      });
  }, [e, t, r]);
}
function cp(e, t) {
  let {
    relative: r
  } = t === void 0 ? {} : t, {
    basename: n
  } = h.useContext(_t), a = h.useContext(br);
  a || (process.env.NODE_ENV !== "production" ? ge(!1, "useFormAction must be used inside a RouteContext") : ge(!1));
  let [i] = a.matches.slice(-1), o = dr({}, Br(e || ".", {
    relative: r
  })), s = jr();
  if (e == null) {
    o.search = s.search;
    let l = new URLSearchParams(o.search);
    l.has("index") && l.get("index") === "" && (l.delete("index"), o.search = l.toString() ? "?" + l.toString() : "");
  }
  return (!e || e === ".") && i.route.index && (o.search = o.search ? o.search.replace(/^\?/, "?index&") : "?index"), n !== "/" && (o.pathname = o.pathname === "/" ? n : Vi([n, o.pathname])), Ha(o);
}
function fp(e, t) {
  t === void 0 && (t = {});
  let r = h.useContext(wu);
  r == null && (process.env.NODE_ENV !== "production" ? ge(!1, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?") : ge(!1));
  let {
    basename: n
  } = Eu(hn.useViewTransitionState), a = Br(e, {
    relative: t.relative
  });
  if (!r.isTransitioning)
    return !1;
  let i = fr(r.currentLocation.pathname, n) || r.currentLocation.pathname, o = fr(r.nextLocation.pathname, n) || r.nextLocation.pathname;
  return Ps(a.pathname, o) != null || Ps(a.pathname, i) != null;
}
const dp = "_button_1jru5_1", mp = "_primary_1jru5_17", hp = "_secondary_1jru5_34", pp = "_tertiary_1jru5_53", vp = "_borderless_1jru5_63", gp = "_link_1jru5_63", bp = "_hasTransition_1jru5_71", yp = "_icon_1jru5_74", mt = {
  button: dp,
  primary: mp,
  secondary: hp,
  tertiary: pp,
  borderless: vp,
  link: gp,
  hasTransition: bp,
  icon: yp
}, _p = "_ldsRing_xh4nr_1", xp = {
  ldsRing: _p,
  "lds-ring": "_lds-ring_xh4nr_1"
}, Xn = ({ className: e, ...t }) => /* @__PURE__ */ f.jsxs("div", { className: q(xp.ldsRing, e), "data-cy": "Loader", ...t, children: [
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {}),
  /* @__PURE__ */ f.jsx("div", {})
] });
var $e = /* @__PURE__ */ ((e) => (e.BORDERLESS = "borderless", e.LINK = "link", e.PRIMARY = "primary", e.SECONDARY = "secondary", e.SECONDARY_WITHOUT_BORDER = "secondaryWithoutBorder", e.TERTIARY = "tertiary", e))($e || {}), We = /* @__PURE__ */ ((e) => (e.ANCHOR_LINK = "a", e.BUTTON = "button", e.LINK = "link", e.SUBMIT = "submit", e))(We || {});
const ze = ({
  buttonStyle: e = "primary",
  className: t,
  hasIcon: r = !1,
  hasTransition: n = !1,
  link: a,
  text: i,
  type: o,
  children: s,
  isDisabled: l = !1,
  isLoading: u = !1,
  plusIcon: c = !1,
  minWidth: d,
  ...m
}) => {
  const { formatMessage: x } = be(), E = q(
    mt.button,
    mt[e],
    n && mt.hasTransition,
    l && mt.disabled,
    t
  ), P = i && typeof i != "string" ? x(i) : i, w = a, b = {
    // this is for testing purposes. since anchor does not carry a disabled indicator assign a custom attribute for asserts
    ...l ? { "data-disabled": !0 } : {},
    ...m
  }, p = /* @__PURE__ */ f.jsx(f.Fragment, { children: s || /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    c && /* @__PURE__ */ f.jsx("span", { className: mt.plus, children: "+" }),
    P,
    r && /* @__PURE__ */ f.jsx(
      yt,
      {
        className: mt.icon,
        icon: fd,
        size: "1x"
      }
    )
  ] }) });
  switch (o) {
    case "button":
    case "submit":
      return /* @__PURE__ */ f.jsx(
        "button",
        {
          className: E,
          type: o,
          ...b,
          disabled: l || u,
          style: { minWidth: `${d}px` },
          children: u ? /* @__PURE__ */ f.jsx(Xn, { className: mt.loader }) : p
        }
      );
    case "link":
      return /* @__PURE__ */ f.jsx(
        Ji,
        {
          className: E,
          to: w,
          ...b,
          style: { minWidth: `${d}px` },
          children: /* @__PURE__ */ f.jsx("div", { children: u ? /* @__PURE__ */ f.jsx(Xn, { className: mt.loader }) : p })
        }
      );
    case "a":
    default:
      return /* @__PURE__ */ f.jsx(
        "a",
        {
          href: w,
          className: E,
          ...b,
          style: { minWidth: `${d}px` },
          children: /* @__PURE__ */ f.jsx("div", { children: u ? /* @__PURE__ */ f.jsx(Xn, { className: mt.loader }) : p })
        }
      );
  }
}, wp = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ h.createElement("path", { d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" })), Ep = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ h.createElement("g", { id: "Group_273879", "data-name": "Group 273879", transform: "translate(2005 -2770)" }, /* @__PURE__ */ h.createElement("circle", { id: "Ellipse_3458", "data-name": "Ellipse 3458", cx: 12, cy: 12, r: 12, transform: "translate(-2005 2770)", fill: "#4972f4" }), /* @__PURE__ */ h.createElement("path", { id: "Path_44650", "data-name": "Path 44650", d: "M14.958,1.748V4.7h2.809a.453.453,0,0,1,.453.453V6a.453.453,0,0,1-.453.453H14.958V9.437a.452.452,0,0,1-.453.452h-.9a.452.452,0,0,1-.453-.452V6.449h-2.81A.453.453,0,0,1,9.885,6V5.157a.453.453,0,0,1,.453-.453h2.81V1.748a.453.453,0,0,1,.453-.453h.9a.453.453,0,0,1,.453.453", transform: "translate(-2007.052 2776.408)", fill: "#fff" }))), Tp = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 15.329, height: 12.662, viewBox: "0 0 15.329 12.662", ...e }, /* @__PURE__ */ h.createElement("g", { id: "Group_273964", "data-name": "Group 273964", transform: "translate(0 0)" }, /* @__PURE__ */ h.createElement("rect", { id: "Rectangle_12534", "data-name": "Rectangle 12534", width: 15.329, height: 12.662, transform: "translate(0 0)", fill: "#fff" }), /* @__PURE__ */ h.createElement("g", { id: "Group_273866", "data-name": "Group 273866" }, /* @__PURE__ */ h.createElement("path", { id: "Path_44644", "data-name": "Path 44644", d: "M9.8,2.272l.476-.476a.513.513,0,0,1,.725,0l0,0,4.172,4.17a.513.513,0,0,1,0,.725l0,0-4.172,4.172a.513.513,0,0,1-.725,0l0,0L9.8,10.39a.515.515,0,0,1,0-.73l.006-.006L12.4,7.189H5.5a.514.514,0,0,1-.515-.513V5.987A.514.514,0,0,1,5.5,5.472h6.9L9.809,3.008a.512.512,0,0,1-.021-.724L9.8,2.272Z", fill: "currentColor" }), /* @__PURE__ */ h.createElement("path", { id: "Path_44645", "data-name": "Path 44645", d: "M7.522,12.662H.42a.42.42,0,0,1-.42-.42V.42A.42.42,0,0,1,.42,0h7.1a.42.42,0,0,1,.42.42v.861a.42.42,0,0,1-.42.42H1.7v9.26H7.522a.42.42,0,0,1,.42.42v.861a.42.42,0,0,1-.42.42", fill: "currentColor" })))), Tu = ({ logout: e, totalCount: t, showLinks: r = !0 }) => {
  const { formatMessage: n } = be(), { currentAccount: a, addAccount: i } = Le(Re), [o, s] = Te(!1), l = St(), { firstname: u = "", lastname: c = "", username: d = "" } = a ?? {}, [m, x] = Te("links"), E = u && c ? `${u} ${c}` : u || c || d.split("@")[0].replace(/\W/g, " ");
  return Pn(l, () => {
    s(!1), x("links");
  }), /* @__PURE__ */ f.jsxs(
    "div",
    {
      id: "profile-component",
      className: q(ce.profileComponent, {
        [ce.open]: o,
        [ce.noPadding]: !a
      }),
      ref: l,
      onClick: () => {
        s(!o), x("links");
      },
      children: [
        a ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsx(
            Or,
            {
              classname: ce.profileIcon,
              bubbleSize: 36,
              iconSize: 12,
              type: a.type
            }
          ),
          /* @__PURE__ */ f.jsx("div", { className: q(ce.rows, ce.grow, ce.overflow), children: /* @__PURE__ */ f.jsx("span", { className: q(ce.overflow, ce.name), children: a.type === Ue.PRIVATE_PERSON ? E : a.companyName || a.username }) }),
          /* @__PURE__ */ f.jsx(wp, { height: 12, width: 12 })
        ] }) : /* @__PURE__ */ f.jsx(
          Or,
          {
            classname: ce.profileIcon,
            bubbleSize: 36,
            iconSize: 12,
            type: Ue.PRIVATE_PERSON
          }
        ),
        /* @__PURE__ */ f.jsxs("ul", { id: "notification", className: ce.list, children: [
          a && /* @__PURE__ */ f.jsxs("li", { className: q(ce.userMail), children: [
            /* @__PURE__ */ f.jsx(
              Or,
              {
                classname: ce.profileIcon,
                bubbleSize: 48,
                iconSize: 18,
                type: a.type
              }
            ),
            /* @__PURE__ */ f.jsxs("div", { className: q(ce.rows, ce.grow, ce.overflow), children: [
              /* @__PURE__ */ f.jsx("span", { className: q(ce.overflow, ce.name), children: a.type === Ue.PRIVATE_PERSON ? E : a.companyName }),
              /* @__PURE__ */ f.jsx("span", { className: q(ce.email), children: a.username })
            ] })
          ] }),
          /* @__PURE__ */ f.jsx(
            Th,
            {
              isActive: m === "accounts",
              onCancel: () => x("links"),
              onOpen: () => x("accounts")
            }
          ),
          r && m === "links" && /* @__PURE__ */ f.jsx(Qm, { totalCount: t }),
          m === "accounts" && /* @__PURE__ */ f.jsx(mh, {}),
          m === "links" && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
            /* @__PURE__ */ f.jsx("hr", { className: ce.separator }),
            /* @__PURE__ */ f.jsx("li", { className: q(ce.listItem, ce.logoutButton), children: /* @__PURE__ */ f.jsxs(
              ze,
              {
                buttonStyle: $e.BORDERLESS,
                type: We.BUTTON,
                className: ce.button,
                onClick: e,
                children: [
                  /* @__PURE__ */ f.jsx(Tp, {}),
                  n(Qe.logout)
                ]
              }
            ) })
          ] }),
          m === "accounts" && /* @__PURE__ */ f.jsx("li", { className: q(ce.listItem, ce.addAccountButton), children: /* @__PURE__ */ f.jsxs(
            ze,
            {
              buttonStyle: $e.BORDERLESS,
              type: We.BUTTON,
              className: ce.button,
              onClick: i,
              children: [
                /* @__PURE__ */ f.jsx(Ep, {}),
                n(Qe.addAccount)
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, Pp = "_container_feg5d_1", Cp = "_header_feg5d_11", Sp = "_logo_feg5d_33", Op = "_componentsRow_feg5d_39", Np = "_navMenu_feg5d_50", Ap = "_open_feg5d_68", Mp = "_navMenulist_feg5d_72", Rp = "_navMenuList_feg5d_76", kp = "_navTrigger_feg5d_116", Ip = "_languageSwitcher_feg5d_158", Dp = "_icon_feg5d_162", Lp = "_navlistItem_feg5d_178", jp = "_borderTop_feg5d_202", Bp = "_fullScreen_feg5d_208", _e = {
  container: Pp,
  header: Cp,
  logo: Sp,
  componentsRow: Op,
  navMenu: Np,
  open: Ap,
  navMenulist: Mp,
  navMenuList: Rp,
  navTrigger: kp,
  languageSwitcher: Ip,
  icon: Dp,
  navlistItem: Lp,
  borderTop: jp,
  fullScreen: Bp
}, Hp = "_container_1ioxp_1", Fp = "_header_1ioxp_1", Up = "_reactiveLogo_1ioxp_14", $p = "_logoWrapper_1ioxp_17", Wp = "_logo_1ioxp_17", Gp = "_logoSmall_1ioxp_25", er = {
  container: Hp,
  header: Fp,
  reactiveLogo: Up,
  logoWrapper: $p,
  logo: Wp,
  logoSmall: Gp
}, Qi = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 131.617, height: 34.066, viewBox: "0 0 131.617 34.066", ...e }, /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M0,1.42A14.684,14.684,0,0,1,2.869,3.744H5.652A15.323,15.323,0,0,0,1.739,0,13.764,13.764,0,0,1,0,1.42", transform: "translate(23.274 5.164)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M15.492,14.546V14.5a14.494,14.494,0,0,1-5.218-1.247h-.044l-.044-.044A13.859,13.859,0,0,1,3.014,5.466a14.746,14.746,0,0,1-.826-3.829A6.99,6.99,0,0,1,.362.345,2.622,2.622,0,0,1,.014,0,15.841,15.841,0,0,0,.971,6.2,15.739,15.739,0,0,0,9.1,15.062l.13.044A15.789,15.789,0,0,0,18.1,16.439a7.839,7.839,0,0,1-2.434-1.721l-.174-.172", transform: "translate(0 17.471)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M0,2.668.826,6.412a4.294,4.294,0,0,0,.3-.645l.044-.129A16.154,16.154,0,0,0,2.652,0,13.637,13.637,0,0,1,.435.473,13.076,13.076,0,0,1,0,2.668", transform: "translate(29.318 19.279)" }), /* @__PURE__ */ h.createElement("g", { transform: "translate(0.088)" }, /* @__PURE__ */ h.createElement("path", { fill: "none", d: "M0,0H38.49V32.77H0Z" }), /* @__PURE__ */ h.createElement("g", null, /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M21.949,32.771a7.44,7.44,0,0,1-.978-.065,5.806,5.806,0,0,1-1.87-.559,6.232,6.232,0,0,1-2-1.42,5.692,5.692,0,0,1-1.043-1.464,11.558,11.558,0,0,1-2.13-.172,12.177,12.177,0,0,1-2.7-.86A11.221,11.221,0,0,1,6.145,23.54a11.607,11.607,0,0,1-1.39-5.767,4.8,4.8,0,0,1-1.13-.258A5.323,5.323,0,0,1,1.711,16.31,5.471,5.471,0,0,1,.1,13.384a5.191,5.191,0,0,1,.435-3.313l.217-.388.435-.817.869.388L14.58,15.019a10.765,10.765,0,0,1,3.3,2.238,6.35,6.35,0,0,1,1.652,3.1l1.3,5.982a6.231,6.231,0,0,1,1.609.645A4.509,4.509,0,0,1,23.8,28.145l-1.522,1.161a1.975,1.975,0,0,0-.782-.645,5.258,5.258,0,0,0-1.653-.56l-.609-.129-.13-.6-1.217-5.636a6.762,6.762,0,0,1-.826.344,4.111,4.111,0,0,1-1.032.131,3.973,3.973,0,0,1-1.534-.3l-.217-.087a3.889,3.889,0,0,1-2.044-2.194,3.694,3.694,0,0,1,.088-2.884l.043-.128a1.719,1.719,0,0,1,.212-.379l.006-.008L2.1,11.4a3.141,3.141,0,0,0-.088,1.678,3.582,3.582,0,0,0,1.044,1.937,3.65,3.65,0,0,0,1.217.775,3.555,3.555,0,0,0,.652.171h.043c.022-.128.076-.322.129-.51s.11-.392.132-.523l1.043.474.652.3-.087.3a8.68,8.68,0,0,0-.217,3.184,9.868,9.868,0,0,0,1.087,3.485,9.22,9.22,0,0,0,4.216,3.916,8.75,8.75,0,0,0,2.217.689,10.806,10.806,0,0,0,1.741.145c.19,0,.379-.006.563-.016l.7-.043.261.647a4.054,4.054,0,0,0,.956,1.462A4.355,4.355,0,0,0,19.8,30.511a3.739,3.739,0,0,0,1.349.388,10.751,10.751,0,0,0,1.174.043l4.13-2.841-1.565-7.272-.044-.172a8.844,8.844,0,0,0,.3-2.282A9.069,9.069,0,0,0,19.8,9.984c-.246-.122-.457-.206-.661-.288L19.1,9.683a3.7,3.7,0,0,0-.739-.215,4.659,4.659,0,0,0-.739-.172h-.087a5.6,5.6,0,0,1-2.479,2.238,5.4,5.4,0,0,1-2.246.489,5.666,5.666,0,0,1-1.058-.1,15.93,15.93,0,0,1-2.783-.989A15.539,15.539,0,0,1,6.58,9.726,5.323,5.323,0,0,1,4.624,6.713a5.64,5.64,0,0,1,.347-3.572A5.757,5.757,0,0,1,6.841.947,5.512,5.512,0,0,1,9.58,0h.088L24.492.043h1.652l-.868,1.42a11.123,11.123,0,0,1-4.087,4.046,10.966,10.966,0,0,1-5.522,1.463H9.8l.044-1.937H15.71a9.165,9.165,0,0,0,4.564-1.2,10.193,10.193,0,0,0,2.392-1.936H9.711a3.35,3.35,0,0,0-1.7.6A3.568,3.568,0,0,0,6.8,3.916,3.656,3.656,0,0,0,6.536,6.24,3.732,3.732,0,0,0,7.8,8.219a21.364,21.364,0,0,0,1.957.947,13.956,13.956,0,0,0,2.391.86,3.921,3.921,0,0,0,.674.058,3.59,3.59,0,0,0,1.5-.316,3.321,3.321,0,0,0,1.566-1.421l.261-.517.3-.6.7.086.415.061c.146.022.3.045.454.067a5.173,5.173,0,0,1,.871.216c.157.044.3.089.447.133s.275.084.422.126c.116.049.226.092.332.134.171.067.333.13.494.21a11.359,11.359,0,0,1,3.652,2.669h14.26l-.869,1.42a11.248,11.248,0,0,1-3.565,3.7,10.508,10.508,0,0,1-4.826,1.721h-.086l-.087-1.85h.087A9.08,9.08,0,0,0,33.1,14.5a10.067,10.067,0,0,0,1.912-1.678H25.665c.021.041.053.093.084.144s.068.112.091.157A11.071,11.071,0,0,1,26.97,20.1l-.087.517,1.652,7.617.13.6-.522.344-4.825,3.357-.174.128-.218.043A7.44,7.44,0,0,1,21.949,32.771ZM14.276,17.042c-.025.037-.051.071-.075.1a.855.855,0,0,0-.143.241,1.933,1.933,0,0,0-.086,1.549A2.09,2.09,0,0,0,15.014,20.1a2.159,2.159,0,0,0,.886.2,1.778,1.778,0,0,0,.506-.073,2.226,2.226,0,0,0,.782-.387,3.139,3.139,0,0,0-.782-1.248A7.7,7.7,0,0,0,14.276,17.042Z", transform: "translate(-0.001 0)" }))), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M6.695,5.509a5.122,5.122,0,0,0-1.217-.516c-.435-.129-.826-.258-1.217-.388a2.778,2.778,0,0,1-.957-.43A.866.866,0,0,1,2.912,3.4a.922.922,0,0,1,.174-.516,1.022,1.022,0,0,1,.392-.344A1.337,1.337,0,0,1,4,2.324a2.717,2.717,0,0,1,.566-.043,2.647,2.647,0,0,1,.956.172,1.874,1.874,0,0,1,.826.559L7.956,1.162a3.818,3.818,0,0,0-1.565-.9A6.679,6.679,0,0,0,4.565,0,6.547,6.547,0,0,0,3,.215,4.42,4.42,0,0,0,1.652.9,3.375,3.375,0,0,0,.7,2.022a3.413,3.413,0,0,0-.347,1.55A2.534,2.534,0,0,0,.739,5.035a2.716,2.716,0,0,0,.956.9,4.675,4.675,0,0,0,1.261.56c.435.129.869.259,1.261.388a3.94,3.94,0,0,1,.956.473.867.867,0,0,1,.392.775.915.915,0,0,1-.13.516,1.029,1.029,0,0,1-.392.345,2.179,2.179,0,0,1-.565.214,2.967,2.967,0,0,1-.609.087,2.9,2.9,0,0,1-1.174-.259,2.392,2.392,0,0,1-.956-.774L0,10.156a5,5,0,0,0,1.739,1.076,5.9,5.9,0,0,0,2,.345,6.926,6.926,0,0,0,1.652-.215,4.95,4.95,0,0,0,1.348-.688A2.664,2.664,0,0,0,7.7,9.553a3.579,3.579,0,0,0,.348-1.591A2.61,2.61,0,0,0,6.695,5.509", transform: "translate(43.056 11.145)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M2.348,11.317H0V.258H2.262v.989H2.3a2.636,2.636,0,0,1,.171-.214C2.532.966,2.591.9,2.651.817a2.6,2.6,0,0,1,.34-.259c.062-.042.125-.086.183-.128a4.543,4.543,0,0,1,.645-.3l.007,0A2.329,2.329,0,0,1,4.608,0,3.372,3.372,0,0,1,6.131.3,2.845,2.845,0,0,1,7.3,1.119a4.066,4.066,0,0,1,.782,1.248,4.472,4.472,0,0,1,.261,1.55,4.4,4.4,0,0,1-.261,1.505,4.64,4.64,0,0,1-.7,1.291,3.149,3.149,0,0,1-1.087.9,3.246,3.246,0,0,1-1.479.344,4.877,4.877,0,0,1-1.391-.215,1.87,1.87,0,0,1-1.043-.774H2.348v4.345ZM4.087,2.151A1.855,1.855,0,0,0,2.7,2.667a2.045,2.045,0,0,0-.477,1.378A2.041,2.041,0,0,0,2.7,5.422a1.853,1.853,0,0,0,1.392.517,1.852,1.852,0,0,0,1.391-.517,1.837,1.837,0,0,0,.478-1.377,2.042,2.042,0,0,0-.478-1.378A1.854,1.854,0,0,0,4.087,2.151Z", transform: "translate(52.404 14.675)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M4.261,8a4.324,4.324,0,0,1-1.652-.3,3.833,3.833,0,0,1-1.347-.817A3.692,3.692,0,0,1,.348,5.637a4.013,4.013,0,0,1,0-3.27,3.682,3.682,0,0,1,.914-1.248A4.625,4.625,0,0,1,2.608.3,5.264,5.264,0,0,1,4.261,0,3.215,3.215,0,0,1,5.739.3a3,3,0,0,1,1.131.817,3.147,3.147,0,0,1,.7,1.248A4.737,4.737,0,0,1,7.826,4v.733H2.348A1.9,1.9,0,0,0,2.957,5.81,1.762,1.762,0,0,0,4.13,6.2a1.927,1.927,0,0,0,1-.258,2.443,2.443,0,0,0,.7-.647L7.478,6.5A4.015,4.015,0,0,1,6.043,7.617,4.256,4.256,0,0,1,4.261,8Zm-.217-6.24a1.853,1.853,0,0,0-.7.128,2.054,2.054,0,0,0-.522.3,3.056,3.056,0,0,0-.348.431,1.138,1.138,0,0,0-.131.516H5.471a1.345,1.345,0,0,0-.384-.946A1.292,1.292,0,0,0,4.044,1.764Z", transform: "translate(61.62 14.675)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M4.261,2.151a1.292,1.292,0,0,1,.7.172,1.549,1.549,0,0,1,.478.43L7,.99A3.392,3.392,0,0,0,5.7.214,6.142,6.142,0,0,0,4.261,0,5.336,5.336,0,0,0,2.608.3a4.705,4.705,0,0,0-1.348.817A3.737,3.737,0,0,0,.347,2.367a4.024,4.024,0,0,0,0,3.27A3.734,3.734,0,0,0,1.26,6.885,3.912,3.912,0,0,0,2.608,7.7,4.326,4.326,0,0,0,4.261,8,5.539,5.539,0,0,0,5.7,7.789,2.526,2.526,0,0,0,7,7.014L5.434,5.379a4.7,4.7,0,0,1-.478.388,1.292,1.292,0,0,1-.7.172,1.844,1.844,0,0,1-1.391-.516A2.04,2.04,0,0,1,2.39,4.045a1.844,1.844,0,0,1,.479-1.377,1.844,1.844,0,0,1,1.391-.517", transform: "translate(70.359 14.632)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M3.869,0H1.521V2.238H0v1.85H1.521V7.66a2.637,2.637,0,0,0,.218,1.076,2.347,2.347,0,0,0,.609.689,2.675,2.675,0,0,0,.869.387A4.193,4.193,0,0,0,4.3,9.941,5.5,5.5,0,0,0,5.129,9.9a2.573,2.573,0,0,0,.826-.172V7.788a1.207,1.207,0,0,1-.478.172A1.978,1.978,0,0,1,5,8a1.224,1.224,0,0,1-.608-.085.8.8,0,0,1-.348-.3,1.25,1.25,0,0,1-.13-.431,2.234,2.234,0,0,1-.044-.559V4.088H5.956V2.238H3.869Z", transform: "translate(77.707 12.695)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M4.565,0a2.432,2.432,0,0,0-1.3.345,2.708,2.708,0,0,0-.913,1.033H2.3V.172H0V7.7H2.348V4.562a7.671,7.671,0,0,1,.043-1.033,2.014,2.014,0,0,1,.261-.817,1.438,1.438,0,0,1,.609-.516,2.614,2.614,0,0,1,1.086-.172,2.108,2.108,0,0,1,.522.044c.13.043.3.086.478.129V.043C5.218.043,5.087,0,4.957,0Z", transform: "translate(84.966 14.76)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M4.261,8a4.312,4.312,0,0,1-1.652-.3,3.841,3.841,0,0,1-1.347-.818A3.682,3.682,0,0,1,.348,5.636,3.456,3.456,0,0,1,0,4,3.943,3.943,0,0,1,.348,2.366a3.687,3.687,0,0,1,.914-1.248A4.61,4.61,0,0,1,2.608.3,5.261,5.261,0,0,1,4.261,0,4.3,4.3,0,0,1,5.913.3a3.841,3.841,0,0,1,1.348.817,3.674,3.674,0,0,1,.912,1.248,4.013,4.013,0,0,1,0,3.27,3.668,3.668,0,0,1-.912,1.248A4.646,4.646,0,0,1,5.913,7.7,5.278,5.278,0,0,1,4.261,8Zm-.043-5.9a1.849,1.849,0,0,0-1.391.517A2.036,2.036,0,0,0,2.348,4a2.038,2.038,0,0,0,.479,1.377,1.852,1.852,0,0,0,1.391.516A1.852,1.852,0,0,0,5.61,5.379,1.842,1.842,0,0,0,6.087,4,2.039,2.039,0,0,0,5.61,2.625,1.85,1.85,0,0,0,4.218,2.108Z", transform: "translate(90.836 14.718)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M7,8.951a2.7,2.7,0,0,1-1.349.3,2.937,2.937,0,0,1-1.217-.257,3.309,3.309,0,0,1-1-.732,4,4,0,0,1-.652-1.119,3.756,3.756,0,0,1-.261-1.42A3.756,3.756,0,0,1,2.783,4.3a3.268,3.268,0,0,1,.7-1.118,2.852,2.852,0,0,1,1-.732A3,3,0,0,1,5.739,2.2a2.674,2.674,0,0,1,1.217.214,2.663,2.663,0,0,1,.869.689L9.782,1.636A4.607,4.607,0,0,0,8.956.861,4.142,4.142,0,0,0,8,.345,3.766,3.766,0,0,0,7,.087,8.625,8.625,0,0,0,6,0a7.132,7.132,0,0,0-2.39.388A5.061,5.061,0,0,0,1.7,1.55,4.541,4.541,0,0,0,.435,3.358,6.253,6.253,0,0,0,0,5.768a6.116,6.116,0,0,0,.435,2.41A5.915,5.915,0,0,0,1.7,9.985a5.409,5.409,0,0,0,1.913,1.161A7.112,7.112,0,0,0,6,11.534a5.872,5.872,0,0,0,2.218-.473A4.849,4.849,0,0,0,10,9.6L7.956,8.091A3.041,3.041,0,0,1,7,8.951", transform: "translate(100.184 11.231)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M4.261,8a4.312,4.312,0,0,1-1.652-.3,3.842,3.842,0,0,1-1.347-.818A3.689,3.689,0,0,1,.348,5.636,3.456,3.456,0,0,1,0,4,3.943,3.943,0,0,1,.348,2.366a3.7,3.7,0,0,1,.913-1.248A4.613,4.613,0,0,1,2.608.3,5.261,5.261,0,0,1,4.261,0,4.3,4.3,0,0,1,5.913.3a3.829,3.829,0,0,1,1.347.817,3.675,3.675,0,0,1,.913,1.248,4.013,4.013,0,0,1,0,3.27A3.669,3.669,0,0,1,7.26,6.884,4.631,4.631,0,0,1,5.913,7.7,5.287,5.287,0,0,1,4.261,8Zm-.044-5.9a1.846,1.846,0,0,0-1.39.517A2.036,2.036,0,0,0,2.348,4a2.038,2.038,0,0,0,.479,1.377,1.848,1.848,0,0,0,1.39.516,1.852,1.852,0,0,0,1.392-.516A1.839,1.839,0,0,0,6.087,4a2.036,2.036,0,0,0-.478-1.377A1.85,1.85,0,0,0,4.217,2.108Z", transform: "translate(110.574 14.718)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M1.349,0A1.353,1.353,0,0,0,.392.388,1.256,1.256,0,0,0,0,1.334a1.329,1.329,0,0,0,.392.948,1.284,1.284,0,0,0,.957.387A1.354,1.354,0,0,0,2.3,2.281,1.34,1.34,0,0,0,2.3.388,1.28,1.28,0,0,0,1.349,0", transform: "translate(120.052 11.232)" }), /* @__PURE__ */ h.createElement("path", { fill: "none", d: "M0,34.066H131.617V0H0Z" }), /* @__PURE__ */ h.createElement("g", { className: "d" }, /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M0,7.575H2.348V0H0Z", transform: "translate(120.27 14.933)" }), /* @__PURE__ */ h.createElement("path", { fill: "#102d6f", d: "M6.782,1.033a2.146,2.146,0,0,0-.87-.774A3.275,3.275,0,0,0,4.478,0,2.488,2.488,0,0,0,3.7.129a2.282,2.282,0,0,0-.652.3,4.587,4.587,0,0,0-.478.387,2.6,2.6,0,0,0-.3.431H2.217V.215H0V7.746H2.347V4a3.883,3.883,0,0,1,.044-.732,2.5,2.5,0,0,1,.217-.6,1.381,1.381,0,0,1,.435-.43,1.257,1.257,0,0,1,.739-.172,1.114,1.114,0,0,1,.7.172,1.352,1.352,0,0,1,.348.473,1.719,1.719,0,0,1,.13.645A3.888,3.888,0,0,1,5,4.045v3.7H7.348V3.571a7.148,7.148,0,0,0-.131-1.42,2.868,2.868,0,0,0-.435-1.118", transform: "translate(124.27 14.718)" }))), Pu = (e) => /* @__PURE__ */ h.createElement("svg", { id: "SC_Full_Horizontal_Blue", "data-name": "SC Full Horizontal Blue", xmlns: "http://www.w3.org/2000/svg", width: 57, height: 51.152, viewBox: "0 0 57 51.152", ...e }, /* @__PURE__ */ h.createElement("g", { id: "Group_43106", "data-name": "Group 43106" }, /* @__PURE__ */ h.createElement("g", { id: "Group_11371", "data-name": "Group 11371" }, /* @__PURE__ */ h.createElement("path", { id: "Path_21649", "data-name": "Path 21649", d: "M-2162.76,948.614l-.184.078a14.331,14.331,0,0,1-3.077.756l-.1.026v.1a20.654,20.654,0,0,1-1.07,4.771v.027l1.148,5.266.156-.286a23.077,23.077,0,0,0,3.1-10.533Z", transform: "translate(2210.134 -920.089)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21650", "data-name": "Path 21650", d: "M-2176.751,928.653l-.156.13.182.1a20.036,20.036,0,0,1,5.217,4.276l.053.052h4.147l-.157-.208a23.466,23.466,0,0,0-6.782-6.439l-.1-.052-.078.077A19.659,19.659,0,0,1-2176.751,928.653Z", transform: "translate(2210.561 -919.107)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21651", "data-name": "Path 21651", d: "M-2176.343,935.112h0a16.227,16.227,0,0,0-5.374-4.015c-.339-.157-.756-.339-1.251-.524-.313-.13-.652-.208-.966-.312l-.313-.105c-.444-.13-.886-.234-1.3-.312l-.261-.053c-.339-.053-.7-.13-1.043-.157l-1.07-.1-.835,1.773a5.067,5.067,0,0,1-2.27,2.033,5.151,5.151,0,0,1-3.1.365,26.2,26.2,0,0,1-3.5-1.3,21.449,21.449,0,0,1-2.843-1.409,5.234,5.234,0,0,1-1.826-2.842,5.125,5.125,0,0,1,.365-3.362,5.034,5.034,0,0,1,1.722-2.033,5.159,5.159,0,0,1,2.427-.887l18.65.078a13.32,13.32,0,0,1-9.86,4.379l-8.685-.026-.027,3.05,8.739.027a16.461,16.461,0,0,0,14.162-8.183l1.381-2.294-24.385-.134h-.053a8.153,8.153,0,0,0-7.59,8.68h0a8.267,8.267,0,0,0,.207,1.359,8.286,8.286,0,0,0,2.9,4.563,17.561,17.561,0,0,0,3.522,1.8,28.943,28.943,0,0,0,4.121,1.487,8.139,8.139,0,0,0,4.93-.6,8.263,8.263,0,0,0,3.652-3.234h.027a9.125,9.125,0,0,1,1.017.234h.026c.338.1.678.208,1.043.339.286.1.6.261.992.443a13.386,13.386,0,0,1,6.235,5.943,13.832,13.832,0,0,1,1.513,6.362,12.756,12.756,0,0,1-.469,3.311l-.027.077,2.348,10.951-5.95,4.12a6.849,6.849,0,0,1-1.643-.053,6.632,6.632,0,0,1-1.9-.573,7.051,7.051,0,0,1-2.06-1.487,6.78,6.78,0,0,1-1.356-2.137l-.392-1.043-1.095.077a13.366,13.366,0,0,1-3.364-.208,12.715,12.715,0,0,1-3.208-1.042,13.216,13.216,0,0,1-6.077-5.736,13.463,13.463,0,0,1-1.592-5.084,24.761,24.761,0,0,1,.391-5.006l.027-.208-2.79-1.278-.079.286c0,.053-.234.887-.338,1.278a4.81,4.81,0,0,1-.861-.235,5.591,5.591,0,0,1-1.773-1.147,5.512,5.512,0,0,1-1.49-2.788,5.268,5.268,0,0,1,.1-2.293l15.024,7.065a3.443,3.443,0,0,0-.235.443l-.077.182a5.944,5.944,0,0,0,2.92,7.717l.184.078a5.893,5.893,0,0,0,3.834.286,10.935,10.935,0,0,0,1.094-.418l1.931,9.126.99.208a7.943,7.943,0,0,1,2.374.835,3.957,3.957,0,0,1,1.017.86l.156.183,2.478-1.878-.183-.208a6.69,6.69,0,0,0-1.9-1.618,9.183,9.183,0,0,0-2.292-.936l-1.853-8.786a9.313,9.313,0,0,0-2.427-4.64,15.8,15.8,0,0,0-4.852-3.364l-19.641-9.229-.966,1.929-.026.078a7.884,7.884,0,0,0-.625,4.9,8.293,8.293,0,0,0,5.188,6.232,7.673,7.673,0,0,0,1.565.392,16.8,16.8,0,0,0,2.009,8.473,16.33,16.33,0,0,0,7.46,7.014,16.944,16.944,0,0,0,3.939,1.277,16.269,16.269,0,0,0,3.052.286,9.8,9.8,0,0,0,1.512,2.112,10.051,10.051,0,0,0,2.973,2.164,8.989,8.989,0,0,0,2.766.834,11.85,11.85,0,0,0,1.38.1,10.012,10.012,0,0,0,1.512-.1l.365-.053,8.216-5.708-2.582-12.254.131-.756a16.521,16.521,0,0,0-1.592-10.4,1.262,1.262,0,0,1-.1-.391h13.119a9.574,9.574,0,0,1-2.555,2.4,12.664,12.664,0,0,1-5.085,1.982l-.208.026v3.077l.285-.052a16.479,16.479,0,0,0,11.92-8l1.357-2.294Zm-14.736,9.752.078-.156a11.316,11.316,0,0,1,2.683,2.033,7.915,7.915,0,0,1,1.047,1.46,2.813,2.813,0,0,1-.756.338,2.564,2.564,0,0,1-1.8-.182,2.646,2.646,0,0,1-1.253-3.493Z", transform: "translate(2212.109 -918.762)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21652", "data-name": "Path 21652", d: "M-2185.63,970.691a12.371,12.371,0,0,1-3.469-2.608l-.285-.312h-.053a20.682,20.682,0,0,1-7.591-1.851l-.131-.053a20.054,20.054,0,0,1-10.407-11.395,20.6,20.6,0,0,1-1.174-5.632v-.077l-.078-.027a11.1,11.1,0,0,1-2.635-1.9,3.436,3.436,0,0,1-.417-.443l-.186-.234-.026.313a23.464,23.464,0,0,0,13.307,22.343l.156.078a23.309,23.309,0,0,0,9.99,2.242,22.186,22.186,0,0,0,2.947-.182l.418-.052Z", transform: "translate(2212.11 -919.98)", fill: "#102d6f" })))), pn = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 18, height: 18, viewBox: "0 0 18 18", ...e }, /* @__PURE__ */ h.createElement("defs", null, /* @__PURE__ */ h.createElement("clipPath", { id: "clip-path" }, /* @__PURE__ */ h.createElement("rect", { id: "Rectangle_12524", "data-name": "Rectangle 12524", width: 18, height: 18, transform: "translate(7731 7200)", fill: "currentColor", stroke: "#707070", strokeWidth: 1 }))), /* @__PURE__ */ h.createElement("g", { id: "Mask_Group_40037", "data-name": "Mask Group 40037", transform: "translate(-7731 -7200)", clipPath: "url(#clip-path)" }, /* @__PURE__ */ h.createElement("path", { id: "Path_44639", "data-name": "Path 44639", d: "M7.063,15.042a10.231,10.231,0,0,0,1.26,3.276,8.1,8.1,0,0,1-3.87-2.484A12.186,12.186,0,0,1,7.063,15.042Zm-.219-1.129h0a21.528,21.528,0,0,1,0-6.7A13.078,13.078,0,0,1,3.76,6.243a8.04,8.04,0,0,0,0,8.643,13.076,13.076,0,0,1,3.084-.973ZM8.334,2.826a8.1,8.1,0,0,0-3.87,2.484,12.184,12.184,0,0,0,2.6.786,10.223,10.223,0,0,1,1.27-3.281Zm4.46,0h0A10.222,10.222,0,0,1,14.053,6.1a12.14,12.14,0,0,0,2.6-.786,8.1,8.1,0,0,0-3.86-2.5Zm.128,3.455c-.549-2.3-1.487-3.78-2.358-3.78S8.754,3.968,8.205,6.281a19.407,19.407,0,0,0,2.358.141A19.407,19.407,0,0,0,12.922,6.281ZM7.734,10.564a19.79,19.79,0,0,0,.252,3.162,20.519,20.519,0,0,1,2.578-.161,20.046,20.046,0,0,1,2.583.164,19.839,19.839,0,0,0,.252-3.165A19.79,19.79,0,0,0,13.146,7.4a20.5,20.5,0,0,1-2.583.161A20.5,20.5,0,0,1,7.981,7.4a19.787,19.787,0,0,0-.247,3.162Zm2.83,8.063c.872,0,1.809-1.467,2.358-3.78a19.788,19.788,0,0,0-4.717,0c.549,2.313,1.487,3.78,2.358,3.78Zm3.981-8.063a21.3,21.3,0,0,1-.252,3.349,13.076,13.076,0,0,1,3.074.973,8.04,8.04,0,0,0,0-8.643,13.076,13.076,0,0,1-3.084.973,21.3,21.3,0,0,1,.262,3.349Zm2.119,5.266h0a12.329,12.329,0,0,0-2.6-.789,10.2,10.2,0,0,1-1.26,3.276,8.09,8.09,0,0,0,3.86-2.487Z", transform: "translate(7729.437 7198.436)", fill: "#3d72fc" }))), Tt = (e) => {
  const { formatMessage: t, locale: r } = be();
  return typeof e == "string" ? e : e ? `/${r}/${t(e)}.html` : r === "en" ? "/" : `/${r}`;
}, Yp = "_navlistItem_1tl7r_1", zp = "_active_1tl7r_7", Vp = "_link_1tl7r_7", kt = {
  navlistItem: Yp,
  active: zp,
  link: Vp
}, ht = ({
  push: e,
  isExternalLink: t = !1,
  text: r,
  url: n,
  isAnchorLink: a = !1,
  onLinkClick: i,
  activeLink: o = "",
  children: s,
  className: l,
  linkClassName: u
}) => {
  const { formatMessage: c } = be(), d = (w) => w && typeof w != "string" ? c(w) : w, m = Tt(n), x = d(r), E = (w, b) => (w.preventDefault(), typeof i == "function" && i(), typeof e == "function" ? e(b) : null), P = Fs((w) => {
    const b = m;
    return w.includes(b);
  }, []);
  return /* @__PURE__ */ f.jsx("li", { className: q(kt.navlistItem, l), children: t ? /* @__PURE__ */ f.jsxs(
    "a",
    {
      className: q(kt.link, u, {
        [kt.active]: P(o)
      }),
      href: m,
      target: "_blank",
      rel: "noreferrer noopener",
      children: [
        s,
        x
      ]
    }
  ) : /* @__PURE__ */ f.jsxs(dc, { children: [
    a && /* @__PURE__ */ f.jsxs(
      "a",
      {
        href: m,
        className: q(kt.link, u, {
          [kt.active]: P(o)
        }),
        children: [
          s,
          x
        ]
      }
    ),
    !a && e && /* @__PURE__ */ f.jsxs(
      "a",
      {
        className: q(kt.link, u, {
          [kt.active]: P(o)
        }),
        href: m,
        onClick: (w) => E(w, m),
        children: [
          s,
          x
        ]
      }
    )
  ] }) });
}, Ae = {
  logIn: {
    id: "header.logIn",
    defaultMessage: "Log in"
  },
  signUp: {
    id: "header.signUp",
    defaultMessage: "Sign up"
  },
  wallet: {
    id: "header.wallet",
    defaultMessage: "Wallet"
  },
  exchange: {
    id: "header.exchange",
    defaultMessage: "Exchange"
  },
  deposit: {
    id: "header.deposit",
    defaultMessage: "Deposit"
  },
  withdraw: {
    id: "header.withdraw",
    defaultMessage: "Withdraw"
  },
  cards: {
    id: "header.cards",
    defaultMessage: "Cards"
  },
  spectrocoinPro: {
    id: "header.spectrocoinPro",
    defaultMessage: "Pro"
  },
  loans: {
    id: "header.loans",
    defaultMessage: "Loans"
  },
  merchantProjects: {
    id: "header.merchantProjects",
    defaultMessage: "Merchant projects"
  },
  card: {
    id: "header.card",
    defaultMessage: "Card"
  },
  buyAndSell: {
    id: "header.buyAndSell",
    defaultMessage: "Buy & Sell"
  },
  business: {
    id: "header.business",
    defaultMessage: "Business"
  },
  account: {
    id: "base.account",
    defaultMessage: "Account"
  },
  bitcoinExchange: {
    id: "base.bitcoinExchange",
    defaultMessage: "Exchange"
  }
}, qp = "_banner_82yj4_1", Zp = "_text_82yj4_5", Xp = "_icon_82yj4_11", Kp = "_button_82yj4_16", Vr = {
  banner: qp,
  text: Zp,
  icon: Xp,
  button: Kp
}, Ss = {
  reverificationBannerDescription: {
    id: "verify.reverification_banner_description",
    defaultMessage: "To continue using our services, please verify your account details."
  },
  verifyNowButton: {
    id: "base.verify_now",
    defaultMessage: "Verify now"
  }
}, Cu = (e) => /* @__PURE__ */ h.createElement("svg", { id: "Notice_notification", "data-name": "Notice notification", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 24, height: 24, viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ h.createElement("defs", null, /* @__PURE__ */ h.createElement("clipPath", { id: "clip-path" })), /* @__PURE__ */ h.createElement("circle", { id: "Ellipse_3045", "data-name": "Ellipse 3045", cx: 12, cy: 12, r: 12, fill: "currentColor" }), /* @__PURE__ */ h.createElement("g", { id: "Exclamation_mark", "data-name": "Exclamation mark", transform: "translate(4 4)" }, /* @__PURE__ */ h.createElement("rect", { id: "Rectangle_9022", "data-name": "Rectangle 9022", width: 16, height: 16, transform: "translate(4370 -3386)", fill: "none", stroke: "#707070", strokeWidth: 1 }), /* @__PURE__ */ h.createElement("g", { id: "Mask_Group_6750", "data-name": "Mask Group 6750", transform: "translate(-4370 3386)" }, /* @__PURE__ */ h.createElement("g", { id: "Group_38816", "data-name": "Group 38816", transform: "translate(0 57.535)" }, /* @__PURE__ */ h.createElement("g", { id: "Group_30097", "data-name": "Group 30097", transform: "translate(4376.714 -3443)" }, /* @__PURE__ */ h.createElement("path", { id: "Path_30646", "data-name": "Path 30646", d: "M816.022,758.191a1.289,1.289,0,0,1,1.1-1.4,1.331,1.331,0,0,1,1.467,1.4,1.257,1.257,0,0,1-1.182,1.285A1.323,1.323,0,0,1,816.022,758.191Zm.523-3.916-.269-9.215a.492.492,0,0,1,.492-.507h1.079a.492.492,0,0,1,.492.507l-.269,9.215a.763.763,0,0,1-.763.741h0A.763.763,0,0,1,816.544,754.274Z", transform: "translate(-816.021 -744.553)", fill: "#fff" })))))), Jp = "_content_roug8_1", Qp = "_contentWrapper_roug8_13", ev = "_text_roug8_21", tv = "_icon_roug8_27", rv = "_action_roug8_31", qr = {
  content: Jp,
  contentWrapper: Qp,
  text: ev,
  icon: tv,
  action: rv
}, Su = ({ icon: e, className: t, children: r }) => /* @__PURE__ */ f.jsx("div", { className: q(qr.content, t), children: /* @__PURE__ */ f.jsxs("div", { className: qr.contentWrapper, children: [
  /* @__PURE__ */ f.jsx("div", { className: qr.icon, children: e }),
  /* @__PURE__ */ f.jsx("span", { className: qr.text, children: r })
] }) }), Ou = ({ user: e }) => {
  const { locale: t, formatMessage: r } = be(), { config: n } = Le(Re), a = e == null ? void 0 : e.isReverificationForced;
  return a != null && a.reverificationForced ? /* @__PURE__ */ f.jsx(
    Su,
    {
      icon: /* @__PURE__ */ f.jsx(Cu, { className: Vr.icon, height: "26", width: "26" }),
      className: Vr.banner,
      children: /* @__PURE__ */ f.jsxs("span", { className: Vr.text, children: [
        r(Ss.reverificationBannerDescription),
        /* @__PURE__ */ f.jsx(
          "a",
          {
            className: Vr.button,
            href: `${n.PROFILE_DOMAIN}/${t}/verification/verify/forced`,
            children: r(Ss.verifyNowButton)
          }
        )
      ] })
    }
  ) : null;
}, nv = (e) => /* @__PURE__ */ h.createElement("svg", { id: "Empty_state_illustration", "data-name": "Empty state illustration", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 206, height: 130, viewBox: "0 0 206 130", ...e }, /* @__PURE__ */ h.createElement("g", { id: "There_are_no_transactions_yet", "data-name": "There are no transactions yet" }, /* @__PURE__ */ h.createElement("g", { id: "Group_38780", "data-name": "Group 38780", transform: "translate(22.785 18.673)" }, /* @__PURE__ */ h.createElement("path", { id: "Path_36485", "data-name": "Path 36485", d: "M-5308.112-78.041l-40.315,23.163V-101.2l20.157,11.582Z", transform: "translate(5429.061 124.367)", fill: "#4972f4" }), /* @__PURE__ */ h.createElement("path", { id: "Path_36486", "data-name": "Path 36486", d: "M-5594.785-101.2v46.327l-20.159-11.582L-5635.1-78.041l20.158-11.582Z", transform: "translate(5675.419 124.367)", fill: "#001536" }), /* @__PURE__ */ h.createElement("g", { id: "Group_38779", "data-name": "Group 38779" }, /* @__PURE__ */ h.createElement("path", { id: "Path_36487", "data-name": "Path 36487", d: "M-5841.142,87.466l-20.16,11.582-20.158,11.582-20.158-11.582-20.159-11.582,20.159-11.582,20.158-11.582,20.158,11.582Z", transform: "translate(5921.776 -17.976)", fill: "#4972f4", opacity: 0.2 }), /* @__PURE__ */ h.createElement("path", { id: "Path_36488", "data-name": "Path 36488", d: "M-5267.794-243.548l-20.158,11.582-20.16,11.582-20.158-11.582-20.157-11.582,20.157-11.582,20.158-11.582,20.16,11.582Z", transform: "translate(5429.061 266.712)", fill: "#4972f4", opacity: 0.2 }), /* @__PURE__ */ h.createElement("path", { id: "Path_36489", "data-name": "Path 36489", d: "M-5841.142-243.548l-20.16,11.582-20.158,11.582-20.158-11.582-20.159-11.582,20.159-11.582,20.158-11.582,20.158,11.582Z", transform: "translate(5921.776 266.712)", fill: "#4972f4", opacity: 0.2 }), /* @__PURE__ */ h.createElement("path", { id: "Path_36490", "data-name": "Path 36490", d: "M-5267.794,87.466l-20.158,11.582-20.16,11.582-20.158-11.582-20.157-11.582,40.315-23.163,20.16,11.582Z", transform: "translate(5429.061 -17.976)", fill: "#4972f4", opacity: 0.2 }))))), av = "_profileComponent_1k3rt_1", iv = "_open_1k3rt_34", ov = "_body_1k3rt_40", sv = "_button_1k3rt_66", lv = "_profileIcon_1k3rt_70", uv = "_count_1k3rt_74", cv = "_list_1k3rt_90", fv = "_row_1k3rt_95", dv = "_header_1k3rt_122", mv = "_title_1k3rt_129", hv = "_action_1k3rt_133", pv = "_withIcon_1k3rt_139", vv = "_empty_1k3rt_150", He = {
  profileComponent: av,
  open: iv,
  body: ov,
  button: sv,
  profileIcon: lv,
  count: uv,
  list: cv,
  row: fv,
  header: dv,
  title: mv,
  action: hv,
  withIcon: pv,
  empty: vv
}, nn = {
  newNtifications: {
    id: "notifications.newNotifications",
    defaultMessage: "New notifications"
  },
  markAsRead: {
    id: "notifications.markAsRead",
    defaultMessage: "Mark as read"
  },
  viewAll: {
    id: "notifications.viewAll",
    defaultMessage: "View all notifications"
  },
  thereAreNoNew: {
    id: "notifications.thereAreNoNew",
    defaultMessage: "There are no new notifications"
  }
};
var eo = {}, Nu = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "far", r = "xmark", n = 320, a = 512, i = [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], o = "f00d", s = "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z";
  e.definition = {
    prefix: t,
    iconName: r,
    icon: [
      n,
      a,
      i,
      o,
      s
    ]
  }, e.faXmark = e.definition, e.prefix = t, e.iconName = r, e.width = n, e.height = a, e.ligatures = i, e.unicode = o, e.svgPathData = s, e.aliases = i;
})(Nu);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = Nu;
  e.definition = {
    prefix: t.prefix,
    iconName: t.iconName,
    icon: [
      t.width,
      t.height,
      t.aliases,
      t.unicode,
      t.svgPathData
    ]
  }, e.faTimes = e.definition, e.prefix = t.prefix, e.iconName = t.iconName, e.width = t.width, e.height = t.height, e.ligatures = t.aliases, e.unicode = t.unicode, e.svgPathData = t.svgPathData, e.aliases = t.aliases;
})(eo);
var Ua = { exports: {} }, Au = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Au);
var me = Au.exports, $a = { exports: {} }, Wa = { exports: {} }, Mu = { exports: {} };
(function(e) {
  function t(r) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Mu);
var Ru = Mu.exports, Ga = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n, a) {
    if (a.length < n)
      throw new TypeError(n + " argument" + (n > 1 ? "s" : "") + " required, but only " + a.length + " present");
  }
  e.exports = t.default;
})(Ga, Ga.exports);
var ke = Ga.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = r(Ru), a = r(ke);
  function i(o) {
    return (0, a.default)(1, arguments), o instanceof Date || (0, n.default)(o) === "object" && Object.prototype.toString.call(o) === "[object Date]";
  }
  e.exports = t.default;
})(Wa, Wa.exports);
var gv = Wa.exports, Ya = { exports: {} };
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = r(Ru), a = r(ke);
  function i(o) {
    (0, a.default)(1, arguments);
    var s = Object.prototype.toString.call(o);
    return o instanceof Date || (0, n.default)(o) === "object" && s === "[object Date]" ? new Date(o.getTime()) : typeof o == "number" || s === "[object Number]" ? new Date(o) : ((typeof o == "string" || s === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  e.exports = t.default;
})(Ya, Ya.exports);
var ct = Ya.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(gv), a = r(ct), i = r(ke);
  function o(s) {
    if ((0, i.default)(1, arguments), !(0, n.default)(s) && typeof s != "number")
      return !1;
    var l = (0, a.default)(s);
    return !isNaN(Number(l));
  }
  e.exports = t.default;
})($a, $a.exports);
var bv = $a.exports, za = { exports: {} }, Va = { exports: {} }, qa = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    if (n === null || n === !0 || n === !1)
      return NaN;
    var a = Number(n);
    return isNaN(a) ? a : a < 0 ? Math.ceil(a) : Math.floor(a);
  }
  e.exports = t.default;
})(qa, qa.exports);
var Xt = qa.exports;
const yv = /* @__PURE__ */ qt(Xt);
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(Xt), a = r(ct), i = r(ke);
  function o(s, l) {
    (0, i.default)(2, arguments);
    var u = (0, a.default)(s).getTime(), c = (0, n.default)(l);
    return new Date(u + c);
  }
  e.exports = t.default;
})(Va, Va.exports);
var _v = Va.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(_v), a = r(ke), i = r(Xt);
  function o(s, l) {
    (0, a.default)(2, arguments);
    var u = (0, i.default)(l);
    return (0, n.default)(s, -u);
  }
  e.exports = t.default;
})(za, za.exports);
var xv = za.exports, Za = { exports: {} }, Xa = { exports: {} };
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(ct), a = r(ke), i = 864e5;
  function o(s) {
    (0, a.default)(1, arguments);
    var l = (0, n.default)(s), u = l.getTime();
    l.setUTCMonth(0, 1), l.setUTCHours(0, 0, 0, 0);
    var c = l.getTime(), d = u - c;
    return Math.floor(d / i) + 1;
  }
  e.exports = t.default;
})(Xa, Xa.exports);
var wv = Xa.exports, Ka = { exports: {} }, Ja = { exports: {} };
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = r(ct), a = r(ke);
  function i(o) {
    (0, a.default)(1, arguments);
    var s = 1, l = (0, n.default)(o), u = l.getUTCDay(), c = (u < s ? 7 : 0) + u - s;
    return l.setUTCDate(l.getUTCDate() - c), l.setUTCHours(0, 0, 0, 0), l;
  }
  e.exports = t.default;
})(Ja, Ja.exports);
var to = Ja.exports, Qa = { exports: {} }, ei = { exports: {} };
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(ct), a = r(ke), i = r(to);
  function o(s) {
    (0, a.default)(1, arguments);
    var l = (0, n.default)(s), u = l.getUTCFullYear(), c = /* @__PURE__ */ new Date(0);
    c.setUTCFullYear(u + 1, 0, 4), c.setUTCHours(0, 0, 0, 0);
    var d = (0, i.default)(c), m = /* @__PURE__ */ new Date(0);
    m.setUTCFullYear(u, 0, 4), m.setUTCHours(0, 0, 0, 0);
    var x = (0, i.default)(m);
    return l.getTime() >= d.getTime() ? u + 1 : l.getTime() >= x.getTime() ? u : u - 1;
  }
  e.exports = t.default;
})(ei, ei.exports);
var ku = ei.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var n = r(ku), a = r(to), i = r(ke);
  function o(s) {
    (0, i.default)(1, arguments);
    var l = (0, n.default)(s), u = /* @__PURE__ */ new Date(0);
    u.setUTCFullYear(l, 0, 4), u.setUTCHours(0, 0, 0, 0);
    var c = (0, a.default)(u);
    return c;
  }
  e.exports = t.default;
})(Qa, Qa.exports);
var Ev = Qa.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var n = r(ct), a = r(to), i = r(Ev), o = r(ke), s = 6048e5;
  function l(u) {
    (0, o.default)(1, arguments);
    var c = (0, n.default)(u), d = (0, a.default)(c).getTime() - (0, i.default)(c).getTime();
    return Math.round(d / s) + 1;
  }
  e.exports = t.default;
})(Ka, Ka.exports);
var Tv = Ka.exports, ti = { exports: {} }, ri = { exports: {} }, Kt = {};
Object.defineProperty(Kt, "__esModule", {
  value: !0
});
Kt.getDefaultOptions = Pv;
Kt.setDefaultOptions = Cv;
var Iu = {};
function Pv() {
  return Iu;
}
function Cv(e) {
  Iu = e;
}
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var n = r(ct), a = r(ke), i = r(Xt), o = Kt;
  function s(l, u) {
    var c, d, m, x, E, P, w, b;
    (0, a.default)(1, arguments);
    var p = (0, o.getDefaultOptions)(), g = (0, i.default)((c = (d = (m = (x = u == null ? void 0 : u.weekStartsOn) !== null && x !== void 0 ? x : u == null || (E = u.locale) === null || E === void 0 || (P = E.options) === null || P === void 0 ? void 0 : P.weekStartsOn) !== null && m !== void 0 ? m : p.weekStartsOn) !== null && d !== void 0 ? d : (w = p.locale) === null || w === void 0 || (b = w.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && c !== void 0 ? c : 0);
    if (!(g >= 0 && g <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var _ = (0, n.default)(l), y = _.getUTCDay(), O = (y < g ? 7 : 0) + y - g;
    return _.setUTCDate(_.getUTCDate() - O), _.setUTCHours(0, 0, 0, 0), _;
  }
  e.exports = t.default;
})(ri, ri.exports);
var ro = ri.exports, ni = { exports: {} }, ai = { exports: {} };
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var n = r(ct), a = r(ke), i = r(ro), o = r(Xt), s = Kt;
  function l(u, c) {
    var d, m, x, E, P, w, b, p;
    (0, a.default)(1, arguments);
    var g = (0, n.default)(u), _ = g.getUTCFullYear(), y = (0, s.getDefaultOptions)(), O = (0, o.default)((d = (m = (x = (E = c == null ? void 0 : c.firstWeekContainsDate) !== null && E !== void 0 ? E : c == null || (P = c.locale) === null || P === void 0 || (w = P.options) === null || w === void 0 ? void 0 : w.firstWeekContainsDate) !== null && x !== void 0 ? x : y.firstWeekContainsDate) !== null && m !== void 0 ? m : (b = y.locale) === null || b === void 0 || (p = b.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && d !== void 0 ? d : 1);
    if (!(O >= 1 && O <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var j = /* @__PURE__ */ new Date(0);
    j.setUTCFullYear(_ + 1, 0, O), j.setUTCHours(0, 0, 0, 0);
    var ne = (0, i.default)(j, c), ae = /* @__PURE__ */ new Date(0);
    ae.setUTCFullYear(_, 0, O), ae.setUTCHours(0, 0, 0, 0);
    var Ee = (0, i.default)(ae, c);
    return g.getTime() >= ne.getTime() ? _ + 1 : g.getTime() >= Ee.getTime() ? _ : _ - 1;
  }
  e.exports = t.default;
})(ai, ai.exports);
var Du = ai.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var n = r(Du), a = r(ke), i = r(ro), o = r(Xt), s = Kt;
  function l(u, c) {
    var d, m, x, E, P, w, b, p;
    (0, a.default)(1, arguments);
    var g = (0, s.getDefaultOptions)(), _ = (0, o.default)((d = (m = (x = (E = c == null ? void 0 : c.firstWeekContainsDate) !== null && E !== void 0 ? E : c == null || (P = c.locale) === null || P === void 0 || (w = P.options) === null || w === void 0 ? void 0 : w.firstWeekContainsDate) !== null && x !== void 0 ? x : g.firstWeekContainsDate) !== null && m !== void 0 ? m : (b = g.locale) === null || b === void 0 || (p = b.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && d !== void 0 ? d : 1), y = (0, n.default)(u, c), O = /* @__PURE__ */ new Date(0);
    O.setUTCFullYear(y, 0, _), O.setUTCHours(0, 0, 0, 0);
    var j = (0, i.default)(O, c);
    return j;
  }
  e.exports = t.default;
})(ni, ni.exports);
var Sv = ni.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var n = r(ct), a = r(ro), i = r(Sv), o = r(ke), s = 6048e5;
  function l(u, c) {
    (0, o.default)(1, arguments);
    var d = (0, n.default)(u), m = (0, a.default)(d, c).getTime() - (0, i.default)(d, c).getTime();
    return Math.round(m / s) + 1;
  }
  e.exports = t.default;
})(ti, ti.exports);
var Ov = ti.exports, ii = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n, a) {
    for (var i = n < 0 ? "-" : "", o = Math.abs(n).toString(); o.length < a; )
      o = "0" + o;
    return i + o;
  }
  e.exports = t.default;
})(ii, ii.exports);
var Lu = ii.exports, oi = { exports: {} };
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = r(Lu), a = {
    // Year
    y: function(s, l) {
      var u = s.getUTCFullYear(), c = u > 0 ? u : 1 - u;
      return (0, n.default)(l === "yy" ? c % 100 : c, l.length);
    },
    // Month
    M: function(s, l) {
      var u = s.getUTCMonth();
      return l === "M" ? String(u + 1) : (0, n.default)(u + 1, 2);
    },
    // Day of the month
    d: function(s, l) {
      return (0, n.default)(s.getUTCDate(), l.length);
    },
    // AM or PM
    a: function(s, l) {
      var u = s.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (l) {
        case "a":
        case "aa":
          return u.toUpperCase();
        case "aaa":
          return u;
        case "aaaaa":
          return u[0];
        case "aaaa":
        default:
          return u === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(s, l) {
      return (0, n.default)(s.getUTCHours() % 12 || 12, l.length);
    },
    // Hour [0-23]
    H: function(s, l) {
      return (0, n.default)(s.getUTCHours(), l.length);
    },
    // Minute
    m: function(s, l) {
      return (0, n.default)(s.getUTCMinutes(), l.length);
    },
    // Second
    s: function(s, l) {
      return (0, n.default)(s.getUTCSeconds(), l.length);
    },
    // Fraction of second
    S: function(s, l) {
      var u = l.length, c = s.getUTCMilliseconds(), d = Math.floor(c * Math.pow(10, u - 3));
      return (0, n.default)(d, l.length);
    }
  }, i = a;
  t.default = i, e.exports = t.default;
})(oi, oi.exports);
var Nv = oi.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = r(wv), a = r(Tv), i = r(ku), o = r(Ov), s = r(Du), l = r(Lu), u = r(Nv), c = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, d = {
    // Era
    G: function(b, p, g) {
      var _ = b.getUTCFullYear() > 0 ? 1 : 0;
      switch (p) {
        case "G":
        case "GG":
        case "GGG":
          return g.era(_, {
            width: "abbreviated"
          });
        case "GGGGG":
          return g.era(_, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return g.era(_, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(b, p, g) {
      if (p === "yo") {
        var _ = b.getUTCFullYear(), y = _ > 0 ? _ : 1 - _;
        return g.ordinalNumber(y, {
          unit: "year"
        });
      }
      return u.default.y(b, p);
    },
    // Local week-numbering year
    Y: function(b, p, g, _) {
      var y = (0, s.default)(b, _), O = y > 0 ? y : 1 - y;
      if (p === "YY") {
        var j = O % 100;
        return (0, l.default)(j, 2);
      }
      return p === "Yo" ? g.ordinalNumber(O, {
        unit: "year"
      }) : (0, l.default)(O, p.length);
    },
    // ISO week-numbering year
    R: function(b, p) {
      var g = (0, i.default)(b);
      return (0, l.default)(g, p.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(b, p) {
      var g = b.getUTCFullYear();
      return (0, l.default)(g, p.length);
    },
    // Quarter
    Q: function(b, p, g) {
      var _ = Math.ceil((b.getUTCMonth() + 1) / 3);
      switch (p) {
        case "Q":
          return String(_);
        case "QQ":
          return (0, l.default)(_, 2);
        case "Qo":
          return g.ordinalNumber(_, {
            unit: "quarter"
          });
        case "QQQ":
          return g.quarter(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return g.quarter(_, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return g.quarter(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(b, p, g) {
      var _ = Math.ceil((b.getUTCMonth() + 1) / 3);
      switch (p) {
        case "q":
          return String(_);
        case "qq":
          return (0, l.default)(_, 2);
        case "qo":
          return g.ordinalNumber(_, {
            unit: "quarter"
          });
        case "qqq":
          return g.quarter(_, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return g.quarter(_, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return g.quarter(_, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(b, p, g) {
      var _ = b.getUTCMonth();
      switch (p) {
        case "M":
        case "MM":
          return u.default.M(b, p);
        case "Mo":
          return g.ordinalNumber(_ + 1, {
            unit: "month"
          });
        case "MMM":
          return g.month(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return g.month(_, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return g.month(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(b, p, g) {
      var _ = b.getUTCMonth();
      switch (p) {
        case "L":
          return String(_ + 1);
        case "LL":
          return (0, l.default)(_ + 1, 2);
        case "Lo":
          return g.ordinalNumber(_ + 1, {
            unit: "month"
          });
        case "LLL":
          return g.month(_, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return g.month(_, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return g.month(_, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(b, p, g, _) {
      var y = (0, o.default)(b, _);
      return p === "wo" ? g.ordinalNumber(y, {
        unit: "week"
      }) : (0, l.default)(y, p.length);
    },
    // ISO week of year
    I: function(b, p, g) {
      var _ = (0, a.default)(b);
      return p === "Io" ? g.ordinalNumber(_, {
        unit: "week"
      }) : (0, l.default)(_, p.length);
    },
    // Day of the month
    d: function(b, p, g) {
      return p === "do" ? g.ordinalNumber(b.getUTCDate(), {
        unit: "date"
      }) : u.default.d(b, p);
    },
    // Day of year
    D: function(b, p, g) {
      var _ = (0, n.default)(b);
      return p === "Do" ? g.ordinalNumber(_, {
        unit: "dayOfYear"
      }) : (0, l.default)(_, p.length);
    },
    // Day of week
    E: function(b, p, g) {
      var _ = b.getUTCDay();
      switch (p) {
        case "E":
        case "EE":
        case "EEE":
          return g.day(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return g.day(_, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return g.day(_, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return g.day(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(b, p, g, _) {
      var y = b.getUTCDay(), O = (y - _.weekStartsOn + 8) % 7 || 7;
      switch (p) {
        case "e":
          return String(O);
        case "ee":
          return (0, l.default)(O, 2);
        case "eo":
          return g.ordinalNumber(O, {
            unit: "day"
          });
        case "eee":
          return g.day(y, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return g.day(y, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return g.day(y, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return g.day(y, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(b, p, g, _) {
      var y = b.getUTCDay(), O = (y - _.weekStartsOn + 8) % 7 || 7;
      switch (p) {
        case "c":
          return String(O);
        case "cc":
          return (0, l.default)(O, p.length);
        case "co":
          return g.ordinalNumber(O, {
            unit: "day"
          });
        case "ccc":
          return g.day(y, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return g.day(y, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return g.day(y, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return g.day(y, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(b, p, g) {
      var _ = b.getUTCDay(), y = _ === 0 ? 7 : _;
      switch (p) {
        case "i":
          return String(y);
        case "ii":
          return (0, l.default)(y, p.length);
        case "io":
          return g.ordinalNumber(y, {
            unit: "day"
          });
        case "iii":
          return g.day(_, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return g.day(_, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return g.day(_, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return g.day(_, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(b, p, g) {
      var _ = b.getUTCHours(), y = _ / 12 >= 1 ? "pm" : "am";
      switch (p) {
        case "a":
        case "aa":
          return g.dayPeriod(y, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return g.dayPeriod(y, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return g.dayPeriod(y, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return g.dayPeriod(y, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(b, p, g) {
      var _ = b.getUTCHours(), y;
      switch (_ === 12 ? y = c.noon : _ === 0 ? y = c.midnight : y = _ / 12 >= 1 ? "pm" : "am", p) {
        case "b":
        case "bb":
          return g.dayPeriod(y, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return g.dayPeriod(y, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return g.dayPeriod(y, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return g.dayPeriod(y, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(b, p, g) {
      var _ = b.getUTCHours(), y;
      switch (_ >= 17 ? y = c.evening : _ >= 12 ? y = c.afternoon : _ >= 4 ? y = c.morning : y = c.night, p) {
        case "B":
        case "BB":
        case "BBB":
          return g.dayPeriod(y, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return g.dayPeriod(y, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return g.dayPeriod(y, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(b, p, g) {
      if (p === "ho") {
        var _ = b.getUTCHours() % 12;
        return _ === 0 && (_ = 12), g.ordinalNumber(_, {
          unit: "hour"
        });
      }
      return u.default.h(b, p);
    },
    // Hour [0-23]
    H: function(b, p, g) {
      return p === "Ho" ? g.ordinalNumber(b.getUTCHours(), {
        unit: "hour"
      }) : u.default.H(b, p);
    },
    // Hour [0-11]
    K: function(b, p, g) {
      var _ = b.getUTCHours() % 12;
      return p === "Ko" ? g.ordinalNumber(_, {
        unit: "hour"
      }) : (0, l.default)(_, p.length);
    },
    // Hour [1-24]
    k: function(b, p, g) {
      var _ = b.getUTCHours();
      return _ === 0 && (_ = 24), p === "ko" ? g.ordinalNumber(_, {
        unit: "hour"
      }) : (0, l.default)(_, p.length);
    },
    // Minute
    m: function(b, p, g) {
      return p === "mo" ? g.ordinalNumber(b.getUTCMinutes(), {
        unit: "minute"
      }) : u.default.m(b, p);
    },
    // Second
    s: function(b, p, g) {
      return p === "so" ? g.ordinalNumber(b.getUTCSeconds(), {
        unit: "second"
      }) : u.default.s(b, p);
    },
    // Fraction of second
    S: function(b, p) {
      return u.default.S(b, p);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(b, p, g, _) {
      var y = _._originalDate || b, O = y.getTimezoneOffset();
      if (O === 0)
        return "Z";
      switch (p) {
        case "X":
          return x(O);
        case "XXXX":
        case "XX":
          return E(O);
        case "XXXXX":
        case "XXX":
        default:
          return E(O, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(b, p, g, _) {
      var y = _._originalDate || b, O = y.getTimezoneOffset();
      switch (p) {
        case "x":
          return x(O);
        case "xxxx":
        case "xx":
          return E(O);
        case "xxxxx":
        case "xxx":
        default:
          return E(O, ":");
      }
    },
    // Timezone (GMT)
    O: function(b, p, g, _) {
      var y = _._originalDate || b, O = y.getTimezoneOffset();
      switch (p) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + m(O, ":");
        case "OOOO":
        default:
          return "GMT" + E(O, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(b, p, g, _) {
      var y = _._originalDate || b, O = y.getTimezoneOffset();
      switch (p) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + m(O, ":");
        case "zzzz":
        default:
          return "GMT" + E(O, ":");
      }
    },
    // Seconds timestamp
    t: function(b, p, g, _) {
      var y = _._originalDate || b, O = Math.floor(y.getTime() / 1e3);
      return (0, l.default)(O, p.length);
    },
    // Milliseconds timestamp
    T: function(b, p, g, _) {
      var y = _._originalDate || b, O = y.getTime();
      return (0, l.default)(O, p.length);
    }
  };
  function m(w, b) {
    var p = w > 0 ? "-" : "+", g = Math.abs(w), _ = Math.floor(g / 60), y = g % 60;
    if (y === 0)
      return p + String(_);
    var O = b || "";
    return p + String(_) + O + (0, l.default)(y, 2);
  }
  function x(w, b) {
    if (w % 60 === 0) {
      var p = w > 0 ? "-" : "+";
      return p + (0, l.default)(Math.abs(w) / 60, 2);
    }
    return E(w, b);
  }
  function E(w, b) {
    var p = b || "", g = w > 0 ? "-" : "+", _ = Math.abs(w), y = (0, l.default)(Math.floor(_ / 60), 2), O = (0, l.default)(_ % 60, 2);
    return g + y + p + O;
  }
  var P = d;
  t.default = P, e.exports = t.default;
})(Za, Za.exports);
var Av = Za.exports, si = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = function(l, u) {
    switch (l) {
      case "P":
        return u.date({
          width: "short"
        });
      case "PP":
        return u.date({
          width: "medium"
        });
      case "PPP":
        return u.date({
          width: "long"
        });
      case "PPPP":
      default:
        return u.date({
          width: "full"
        });
    }
  }, n = function(l, u) {
    switch (l) {
      case "p":
        return u.time({
          width: "short"
        });
      case "pp":
        return u.time({
          width: "medium"
        });
      case "ppp":
        return u.time({
          width: "long"
        });
      case "pppp":
      default:
        return u.time({
          width: "full"
        });
    }
  }, a = function(l, u) {
    var c = l.match(/(P+)(p+)?/) || [], d = c[1], m = c[2];
    if (!m)
      return r(l, u);
    var x;
    switch (d) {
      case "P":
        x = u.dateTime({
          width: "short"
        });
        break;
      case "PP":
        x = u.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        x = u.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        x = u.dateTime({
          width: "full"
        });
        break;
    }
    return x.replace("{{date}}", r(d, u)).replace("{{time}}", n(m, u));
  }, i = {
    p: n,
    P: a
  }, o = i;
  t.default = o, e.exports = t.default;
})(si, si.exports);
var Mv = si.exports, li = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    var a = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
    return a.setUTCFullYear(n.getFullYear()), n.getTime() - a.getTime();
  }
  e.exports = t.default;
})(li, li.exports);
var ju = li.exports;
const Os = /* @__PURE__ */ qt(ju);
var Hr = {};
Object.defineProperty(Hr, "__esModule", {
  value: !0
});
Hr.isProtectedDayOfYearToken = Iv;
Hr.isProtectedWeekYearToken = Dv;
Hr.throwProtectedError = Lv;
var Rv = ["D", "DD"], kv = ["YY", "YYYY"];
function Iv(e) {
  return Rv.indexOf(e) !== -1;
}
function Dv(e) {
  return kv.indexOf(e) !== -1;
}
function Lv(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var ui = { exports: {} }, ci = { exports: {} }, fi = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, n = function(o, s, l) {
    var u, c = r[o];
    return typeof c == "string" ? u = c : s === 1 ? u = c.one : u = c.other.replace("{{count}}", s.toString()), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "in " + u : u + " ago" : u;
  }, a = n;
  t.default = a, e.exports = t.default;
})(fi, fi.exports);
var jv = fi.exports, di = { exports: {} }, mi = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    return function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = a.width ? String(a.width) : n.defaultWidth, o = n.formats[i] || n.formats[n.defaultWidth];
      return o;
    };
  }
  e.exports = t.default;
})(mi, mi.exports);
var Bv = mi.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = r(Bv), a = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, i = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, o = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, n.default)({
      formats: a,
      defaultWidth: "full"
    }),
    time: (0, n.default)({
      formats: i,
      defaultWidth: "full"
    }),
    dateTime: (0, n.default)({
      formats: o,
      defaultWidth: "full"
    })
  }, l = s;
  t.default = l, e.exports = t.default;
})(di, di.exports);
var Hv = di.exports, hi = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, n = function(o, s, l, u) {
    return r[o];
  }, a = n;
  t.default = a, e.exports = t.default;
})(hi, hi.exports);
var Fv = hi.exports, pi = { exports: {} }, vi = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    return function(a, i) {
      var o = i != null && i.context ? String(i.context) : "standalone", s;
      if (o === "formatting" && n.formattingValues) {
        var l = n.defaultFormattingWidth || n.defaultWidth, u = i != null && i.width ? String(i.width) : l;
        s = n.formattingValues[u] || n.formattingValues[l];
      } else {
        var c = n.defaultWidth, d = i != null && i.width ? String(i.width) : n.defaultWidth;
        s = n.values[d] || n.values[c];
      }
      var m = n.argumentCallback ? n.argumentCallback(a) : a;
      return s[m];
    };
  }
  e.exports = t.default;
})(vi, vi.exports);
var Uv = vi.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = r(Uv), a = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, i = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, o = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, s = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, u = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, c = function(E, P) {
    var w = Number(E), b = w % 100;
    if (b > 20 || b < 10)
      switch (b % 10) {
        case 1:
          return w + "st";
        case 2:
          return w + "nd";
        case 3:
          return w + "rd";
      }
    return w + "th";
  }, d = {
    ordinalNumber: c,
    era: (0, n.default)({
      values: a,
      defaultWidth: "wide"
    }),
    quarter: (0, n.default)({
      values: i,
      defaultWidth: "wide",
      argumentCallback: function(E) {
        return E - 1;
      }
    }),
    month: (0, n.default)({
      values: o,
      defaultWidth: "wide"
    }),
    day: (0, n.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, n.default)({
      values: l,
      defaultWidth: "wide",
      formattingValues: u,
      defaultFormattingWidth: "wide"
    })
  }, m = d;
  t.default = m, e.exports = t.default;
})(pi, pi.exports);
var $v = pi.exports, gi = { exports: {} }, bi = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(i) {
    return function(o) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = s.width, u = l && i.matchPatterns[l] || i.matchPatterns[i.defaultMatchWidth], c = o.match(u);
      if (!c)
        return null;
      var d = c[0], m = l && i.parsePatterns[l] || i.parsePatterns[i.defaultParseWidth], x = Array.isArray(m) ? a(m, function(w) {
        return w.test(d);
      }) : n(m, function(w) {
        return w.test(d);
      }), E;
      E = i.valueCallback ? i.valueCallback(x) : x, E = s.valueCallback ? s.valueCallback(E) : E;
      var P = o.slice(d.length);
      return {
        value: E,
        rest: P
      };
    };
  }
  function n(i, o) {
    for (var s in i)
      if (i.hasOwnProperty(s) && o(i[s]))
        return s;
  }
  function a(i, o) {
    for (var s = 0; s < i.length; s++)
      if (o(i[s]))
        return s;
  }
  e.exports = t.default;
})(bi, bi.exports);
var Wv = bi.exports, yi = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    return function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.match(n.matchPattern);
      if (!o)
        return null;
      var s = o[0], l = a.match(n.parsePattern);
      if (!l)
        return null;
      var u = n.valueCallback ? n.valueCallback(l[0]) : l[0];
      u = i.valueCallback ? i.valueCallback(u) : u;
      var c = a.slice(s.length);
      return {
        value: u,
        rest: c
      };
    };
  }
  e.exports = t.default;
})(yi, yi.exports);
var Gv = yi.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = r(Wv), a = r(Gv), i = /^(\d+)(th|st|nd|rd)?/i, o = /\d+/i, s = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, l = {
    any: [/^b/i, /^(a|c)/i]
  }, u = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, c = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, d = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, m = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, x = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, E = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, P = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, w = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, b = {
    ordinalNumber: (0, a.default)({
      matchPattern: i,
      parsePattern: o,
      valueCallback: function(_) {
        return parseInt(_, 10);
      }
    }),
    era: (0, n.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any"
    }),
    quarter: (0, n.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: c,
      defaultParseWidth: "any",
      valueCallback: function(_) {
        return _ + 1;
      }
    }),
    month: (0, n.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    day: (0, n.default)({
      matchPatterns: x,
      defaultMatchWidth: "wide",
      parsePatterns: E,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, n.default)({
      matchPatterns: P,
      defaultMatchWidth: "any",
      parsePatterns: w,
      defaultParseWidth: "any"
    })
  }, p = b;
  t.default = p, e.exports = t.default;
})(gi, gi.exports);
var Yv = gi.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = r(jv), a = r(Hv), i = r(Fv), o = r($v), s = r(Yv), l = {
    code: "en-US",
    formatDistance: n.default,
    formatLong: a.default,
    formatRelative: i.default,
    localize: o.default,
    match: s.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, u = l;
  t.default = u, e.exports = t.default;
})(ci, ci.exports);
var zv = ci.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = r(zv), a = n.default;
  t.default = a, e.exports = t.default;
})(ui, ui.exports);
var Vv = ui.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = g;
  var n = r(bv), a = r(xv), i = r(ct), o = r(Av), s = r(Mv), l = r(ju), u = Hr, c = r(Xt), d = r(ke), m = Kt, x = r(Vv), E = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, P = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, w = /^'([^]*?)'?$/, b = /''/g, p = /[a-zA-Z]/;
  function g(y, O, j) {
    var ne, ae, Ee, Ie, Ce, he, I, L, X, T, D, le, C, N, U, H, F, Z;
    (0, d.default)(2, arguments);
    var G = String(O), $ = (0, m.getDefaultOptions)(), z = (ne = (ae = j == null ? void 0 : j.locale) !== null && ae !== void 0 ? ae : $.locale) !== null && ne !== void 0 ? ne : x.default, K = (0, c.default)((Ee = (Ie = (Ce = (he = j == null ? void 0 : j.firstWeekContainsDate) !== null && he !== void 0 ? he : j == null || (I = j.locale) === null || I === void 0 || (L = I.options) === null || L === void 0 ? void 0 : L.firstWeekContainsDate) !== null && Ce !== void 0 ? Ce : $.firstWeekContainsDate) !== null && Ie !== void 0 ? Ie : (X = $.locale) === null || X === void 0 || (T = X.options) === null || T === void 0 ? void 0 : T.firstWeekContainsDate) !== null && Ee !== void 0 ? Ee : 1);
    if (!(K >= 1 && K <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var V = (0, c.default)((D = (le = (C = (N = j == null ? void 0 : j.weekStartsOn) !== null && N !== void 0 ? N : j == null || (U = j.locale) === null || U === void 0 || (H = U.options) === null || H === void 0 ? void 0 : H.weekStartsOn) !== null && C !== void 0 ? C : $.weekStartsOn) !== null && le !== void 0 ? le : (F = $.locale) === null || F === void 0 || (Z = F.options) === null || Z === void 0 ? void 0 : Z.weekStartsOn) !== null && D !== void 0 ? D : 0);
    if (!(V >= 0 && V <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!z.localize)
      throw new RangeError("locale must contain localize property");
    if (!z.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var pe = (0, i.default)(y);
    if (!(0, n.default)(pe))
      throw new RangeError("Invalid time value");
    var A = (0, l.default)(pe), De = (0, a.default)(pe, A), xt = {
      firstWeekContainsDate: K,
      weekStartsOn: V,
      locale: z,
      _originalDate: pe
    }, ft = G.match(P).map(function(xe) {
      var Ze = xe[0];
      if (Ze === "p" || Ze === "P") {
        var Mt = s.default[Ze];
        return Mt(xe, z.formatLong);
      }
      return xe;
    }).join("").match(E).map(function(xe) {
      if (xe === "''")
        return "'";
      var Ze = xe[0];
      if (Ze === "'")
        return _(xe);
      var Mt = o.default[Ze];
      if (Mt)
        return !(j != null && j.useAdditionalWeekYearTokens) && (0, u.isProtectedWeekYearToken)(xe) && (0, u.throwProtectedError)(xe, O, String(y)), !(j != null && j.useAdditionalDayOfYearTokens) && (0, u.isProtectedDayOfYearToken)(xe) && (0, u.throwProtectedError)(xe, O, String(y)), Mt(De, xe, z.localize, xt);
      if (Ze.match(p))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + Ze + "`");
      return xe;
    }).join("");
    return ft;
  }
  function _(y) {
    var O = y.match(w);
    return O ? O[1].replace(b, "'") : y;
  }
  e.exports = t.default;
})(Ua, Ua.exports);
var qv = Ua.exports;
const Zv = /* @__PURE__ */ qt(qv);
function Ns(e, t, r) {
  var n = Jv(e, r.timeZone, r.locale);
  return n.formatToParts ? Xv(n, t) : Kv(n, t);
}
function Xv(e, t) {
  for (var r = e.formatToParts(t), n = r.length - 1; n >= 0; --n)
    if (r[n].type === "timeZoneName")
      return r[n].value;
}
function Kv(e, t) {
  var r = e.format(t).replace(/\u200E/g, ""), n = / [\w-+ ]+$/.exec(r);
  return n ? n[0].substr(1) : "";
}
function Jv(e, t, r) {
  if (r && !r.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(r ? [r.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function Qv(e, t) {
  var r = n2(t);
  return r.formatToParts ? t2(r, e) : r2(r, e);
}
var e2 = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function t2(e, t) {
  try {
    for (var r = e.formatToParts(t), n = [], a = 0; a < r.length; a++) {
      var i = e2[r[a].type];
      i >= 0 && (n[i] = parseInt(r[a].value, 10));
    }
    return n;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function r2(e, t) {
  var r = e.format(t).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
var Kn = {};
function n2(e) {
  if (!Kn[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), r = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Kn[e] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Kn[e];
}
function Bu(e, t, r, n, a, i, o) {
  var s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, t, r), s.setUTCHours(n, a, i, o), s;
}
var As = 36e5, a2 = 6e4, Jn = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function no(e, t, r) {
  var n, a;
  if (!e || (n = Jn.timezoneZ.exec(e), n))
    return 0;
  var i;
  if (n = Jn.timezoneHH.exec(e), n)
    return i = parseInt(n[1], 10), Ms(i) ? -(i * As) : NaN;
  if (n = Jn.timezoneHHMM.exec(e), n) {
    i = parseInt(n[1], 10);
    var o = parseInt(n[2], 10);
    return Ms(i, o) ? (a = Math.abs(i) * As + o * a2, i > 0 ? -a : a) : NaN;
  }
  if (s2(e)) {
    t = new Date(t || Date.now());
    var s = r ? t : i2(t), l = _i(s, e), u = r ? l : o2(t, l, e);
    return -u;
  }
  return NaN;
}
function i2(e) {
  return Bu(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function _i(e, t) {
  var r = Qv(e, t), n = Bu(
    r[0],
    r[1] - 1,
    r[2],
    r[3] % 24,
    r[4],
    r[5],
    0
  ).getTime(), a = e.getTime(), i = a % 1e3;
  return a -= i >= 0 ? i : 1e3 + i, n - a;
}
function o2(e, t, r) {
  var n = e.getTime(), a = n - t, i = _i(new Date(a), r);
  if (t === i)
    return t;
  a -= i - t;
  var o = _i(new Date(a), r);
  return i === o ? i : Math.max(i, o);
}
function Ms(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var Rs = {};
function s2(e) {
  if (Rs[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), Rs[e] = !0, !0;
  } catch {
    return !1;
  }
}
var l2 = 60 * 1e3, u2 = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r, n) {
    var a = Qn(n.timeZone, n._originalDate || e);
    if (a === 0)
      return "Z";
    switch (t) {
      case "X":
        return ks(a);
      case "XXXX":
      case "XX":
        return tr(a);
      case "XXXXX":
      case "XXX":
      default:
        return tr(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r, n) {
    var a = Qn(n.timeZone, n._originalDate || e);
    switch (t) {
      case "x":
        return ks(a);
      case "xxxx":
      case "xx":
        return tr(a);
      case "xxxxx":
      case "xxx":
      default:
        return tr(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r, n) {
    var a = Qn(n.timeZone, n._originalDate || e);
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + c2(a, ":");
      case "OOOO":
      default:
        return "GMT" + tr(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r, n) {
    var a = n._originalDate || e;
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return Ns("short", a, n);
      case "zzzz":
      default:
        return Ns("long", a, n);
    }
  }
};
function Qn(e, t) {
  var r = e ? no(e, t, !0) / l2 : t.getTimezoneOffset();
  if (Number.isNaN(r))
    throw new RangeError("Invalid time zone specified: " + e);
  return r;
}
function vn(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
function tr(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", a = Math.abs(e), i = vn(Math.floor(a / 60), 2), o = vn(Math.floor(a % 60), 2);
  return n + i + r + o;
}
function ks(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + vn(Math.abs(e) / 60, 2);
  }
  return tr(e, t);
}
function c2(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return r + String(a);
  var o = t || "";
  return r + String(a) + o + vn(i, 2);
}
var f2 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, ea = 36e5, Is = 6e4, d2 = 2, Me = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: f2
};
function Hu(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var r = t || {}, n = r.additionalDigits == null ? d2 : yv(r.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = m2(e), i = h2(a.date, n), o = i.year, s = i.restDateString, l = p2(s, o);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var u = l.getTime(), c = 0, d;
    if (a.time && (c = v2(a.time), isNaN(c)))
      return /* @__PURE__ */ new Date(NaN);
    if (a.timeZone || r.timeZone) {
      if (d = no(a.timeZone || r.timeZone, new Date(u + c)), isNaN(d))
        return /* @__PURE__ */ new Date(NaN);
    } else
      d = Os(new Date(u + c)), d = Os(new Date(u + c + d));
    return new Date(u + c + d);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function m2(e) {
  var t = {}, r = Me.dateTimePattern.exec(e), n;
  if (r ? (t.date = r[1], n = r[3]) : (r = Me.datePattern.exec(e), r ? (t.date = r[1], n = r[2]) : (t.date = null, n = e)), n) {
    var a = Me.timeZone.exec(n);
    a ? (t.time = n.replace(a[1], ""), t.timeZone = a[1].trim()) : t.time = n;
  }
  return t;
}
function h2(e, t) {
  var r = Me.YYY[t], n = Me.YYYYY[t], a;
  if (a = Me.YYYY.exec(e) || n.exec(e), a) {
    var i = a[1];
    return {
      year: parseInt(i, 10),
      restDateString: e.slice(i.length)
    };
  }
  if (a = Me.YY.exec(e) || r.exec(e), a) {
    var o = a[1];
    return {
      year: parseInt(o, 10) * 100,
      restDateString: e.slice(o.length)
    };
  }
  return {
    year: null
  };
}
function p2(e, t) {
  if (t === null)
    return null;
  var r, n, a, i;
  if (e.length === 0)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  if (r = Me.MM.exec(e), r)
    return n = /* @__PURE__ */ new Date(0), a = parseInt(r[1], 10) - 1, Ls(t, a) ? (n.setUTCFullYear(t, a), n) : /* @__PURE__ */ new Date(NaN);
  if (r = Me.DDD.exec(e), r) {
    n = /* @__PURE__ */ new Date(0);
    var o = parseInt(r[1], 10);
    return y2(t, o) ? (n.setUTCFullYear(t, 0, o), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Me.MMDD.exec(e), r) {
    n = /* @__PURE__ */ new Date(0), a = parseInt(r[1], 10) - 1;
    var s = parseInt(r[2], 10);
    return Ls(t, a, s) ? (n.setUTCFullYear(t, a, s), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Me.Www.exec(e), r)
    return i = parseInt(r[1], 10) - 1, js(t, i) ? Ds(t, i) : /* @__PURE__ */ new Date(NaN);
  if (r = Me.WwwD.exec(e), r) {
    i = parseInt(r[1], 10) - 1;
    var l = parseInt(r[2], 10) - 1;
    return js(t, i, l) ? Ds(t, i, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function v2(e) {
  var t, r, n;
  if (t = Me.HH.exec(e), t)
    return r = parseFloat(t[1].replace(",", ".")), ta(r) ? r % 24 * ea : NaN;
  if (t = Me.HHMM.exec(e), t)
    return r = parseInt(t[1], 10), n = parseFloat(t[2].replace(",", ".")), ta(r, n) ? r % 24 * ea + n * Is : NaN;
  if (t = Me.HHMMSS.exec(e), t) {
    r = parseInt(t[1], 10), n = parseInt(t[2], 10);
    var a = parseFloat(t[3].replace(",", "."));
    return ta(r, n, a) ? r % 24 * ea + n * Is + a * 1e3 : NaN;
  }
  return null;
}
function Ds(e, t, r) {
  t = t || 0, r = r || 0;
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  var a = n.getUTCDay() || 7, i = t * 7 + r + 1 - a;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
var g2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], b2 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Fu(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Ls(e, t, r) {
  if (t < 0 || t > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    var n = Fu(e);
    if (n && r > b2[t] || !n && r > g2[t])
      return !1;
  }
  return !0;
}
function y2(e, t) {
  if (t < 1)
    return !1;
  var r = Fu(e);
  return !(r && t > 366 || !r && t > 365);
}
function js(e, t, r) {
  return !(t < 0 || t > 52 || r != null && (r < 0 || r > 6));
}
function ta(e, t, r) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || r != null && (r < 0 || r >= 60));
}
var _2 = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function x2(e, t, r) {
  var n = String(t), a = r || {}, i = n.match(_2);
  if (i) {
    var o = Hu(e, a);
    n = i.reduce(function(s, l) {
      if (l[0] === "'")
        return s;
      var u = s.indexOf(l), c = s[u - 1] === "'", d = s.replace(
        l,
        "'" + u2[l[0]](o, l, null, a) + "'"
      );
      return c ? d.substring(0, u - 1) + d.substring(u + 1) : d;
    }, n);
  }
  return Zv(e, n, a);
}
var xi = { exports: {} }, wi = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n, a) {
    if (n == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var i in a)
      Object.prototype.hasOwnProperty.call(a, i) && (n[i] = a[i]);
    return n;
  }
  e.exports = t.default;
})(wi, wi.exports);
var w2 = wi.exports;
(function(e, t) {
  var r = me.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = r(w2);
  function a(i) {
    return (0, n.default)({}, i);
  }
  e.exports = t.default;
})(xi, xi.exports);
var E2 = xi.exports;
const T2 = /* @__PURE__ */ qt(E2);
function P2(e, t, r) {
  var n = Hu(e, r), a = no(t, n, !0), i = new Date(n.getTime() - a), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), o.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), o;
}
function C2(e, t, r, n) {
  var a = T2(n);
  return a.timeZone = t, x2(P2(e, t), r, a);
}
const S2 = "_container_1h8zt_1", O2 = "_header_1h8zt_7", N2 = "_closeIcon_1h8zt_11", A2 = "_icon_1h8zt_14", M2 = "_body_1h8zt_22", R2 = "_title_1h8zt_29", k2 = "_date_1h8zt_37", I2 = "_message_1h8zt_42", D2 = "_modal_1h8zt_61", L2 = "_overlay_1h8zt_78", at = {
  container: S2,
  header: O2,
  closeIcon: N2,
  icon: A2,
  body: M2,
  title: R2,
  date: k2,
  message: I2,
  modal: D2,
  overlay: L2
}, j2 = (e) => /z/i.test(e) ? e : `${e}Z`, B2 = (e, t) => C2(
  j2(e),
  Intl.DateTimeFormat().resolvedOptions().timeZone,
  t
), H2 = ({ notification: e, setNotification: t, ref: r }) => {
  const { locale: n } = be();
  if (!e)
    return null;
  const a = Us(e, n);
  return a ? /* @__PURE__ */ f.jsx(
    Al,
    {
      isOpen: !!a,
      className: at.modal,
      overlayClassName: at.overlay,
      ariaHideApp: !1,
      onRequestClose: () => t(null),
      ref: r,
      children: /* @__PURE__ */ f.jsxs("div", { className: at.container, children: [
        /* @__PURE__ */ f.jsx("div", { className: at.header, children: /* @__PURE__ */ f.jsx(
          yt,
          {
            className: at.closeIcon,
            icon: eo.faTimes,
            onClick: () => t(null),
            size: "lg"
          }
        ) }),
        /* @__PURE__ */ f.jsx("div", { className: at.icon, children: /* @__PURE__ */ f.jsx("img", { src: a.icon }) }),
        /* @__PURE__ */ f.jsxs("div", { className: at.body, children: [
          /* @__PURE__ */ f.jsxs("div", { className: at.title, children: [
            /* @__PURE__ */ f.jsx("div", { dangerouslySetInnerHTML: { __html: a.subject } }),
            a.date && /* @__PURE__ */ f.jsx("div", { className: at.date, children: B2(a.date, "yyyy-MM-dd HH:mm:ss") })
          ] }),
          /* @__PURE__ */ f.jsx(
            "div",
            {
              className: at.message,
              dangerouslySetInnerHTML: { __html: a.body }
            }
          )
        ] })
      ] })
    }
  ) : null;
}, F2 = ({
  notification: e,
  ...t
}) => {
  const { locale: r } = be(), [n] = Te(() => Us(e, r));
  return n ? /* @__PURE__ */ f.jsx("div", { className: He.row, ...t, children: /* @__PURE__ */ f.jsx(pc, { lang: r, notification: e }, e.id) }) : null;
}, U2 = () => {
  const { formatMessage: e } = be();
  return /* @__PURE__ */ f.jsxs("div", { className: He.empty, children: [
    /* @__PURE__ */ f.jsx(nv, {}),
    /* @__PURE__ */ f.jsx("span", { children: e(nn.thereAreNoNew) })
  ] });
}, $2 = ({ notifications: e, markAsRead: t, totalCount: r }) => {
  const { locale: n, formatMessage: a } = be(), [i, o] = Te(!1), s = St(), l = St(), [u, c] = Te(null), d = e.map((x) => x.id), m = Fs(() => {
    t.handler(d);
  }, [t.handler, JSON.stringify(d)]);
  return Pn(
    [s, ...u ? [l] : []],
    () => o(!1)
  ), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        id: "notification-component",
        className: q(He.profileComponent, {
          [He.open]: i
        }),
        ref: s,
        onClick: () => o(!i),
        children: [
          r > 0 && /* @__PURE__ */ f.jsx("div", { className: He.count, children: r }),
          /* @__PURE__ */ f.jsx(cu, { className: He.profileIcon, width: 22, height: 22 }),
          /* @__PURE__ */ f.jsxs(
            "div",
            {
              id: "notification",
              className: He.body,
              onClick: (x) => {
                x.stopPropagation();
              },
              children: [
                /* @__PURE__ */ f.jsxs("div", { className: He.header, children: [
                  /* @__PURE__ */ f.jsx("div", { className: He.title, children: a(nn.newNtifications) }),
                  /* @__PURE__ */ f.jsx(
                    ze,
                    {
                      className: He.action,
                      type: We.BUTTON,
                      buttonStyle: $e.BORDERLESS,
                      onClick: m,
                      isDisabled: t.isDisabled,
                      children: e.length > 0 && /* @__PURE__ */ f.jsxs("div", { className: He.withIcon, children: [
                        /* @__PURE__ */ f.jsx(yt, { icon: dd }),
                        /* @__PURE__ */ f.jsx("span", { children: a(nn.markAsRead) })
                      ] })
                    }
                  )
                ] }),
                e.length > 0 ? /* @__PURE__ */ f.jsx("div", { className: He.list, children: e.map((x) => /* @__PURE__ */ f.jsx(
                  F2,
                  {
                    notification: x,
                    onClick: () => {
                      t.isDisabled || (c(x), t.handler([x.id]));
                    }
                  },
                  x.id
                )) }) : /* @__PURE__ */ f.jsx(U2, {}),
                /* @__PURE__ */ f.jsx(
                  ze,
                  {
                    buttonStyle: $e.TERTIARY,
                    type: We.ANCHOR_LINK,
                    className: He.button,
                    link: `/${n}/notifications`,
                    children: a(nn.viewAll)
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ f.jsx(
      H2,
      {
        ref: l,
        setNotification: c,
        notification: u
      }
    )
  ] });
}, gn = ({
  container: e,
  condition: t,
  children: r
}) => {
  const [n, a] = Te(!1);
  return et(() => {
    if (!e.current)
      return () => 0;
    const i = new ResizeObserver((o) => {
      if (o.length !== 1)
        return;
      const s = o[0].contentBoxSize[0], l = o[0].borderBoxSize[0];
      e.current && a(t({ contentBox: s, borderBox: l }));
    });
    return i.observe(e.current), () => i.disconnect();
  }, [t, e]), /* @__PURE__ */ f.jsx(f.Fragment, { children: n && r });
}, W2 = "_banner_1izyc_1", G2 = "_text_1izyc_5", Y2 = "_icon_1izyc_11", z2 = "_button_1izyc_16", Zr = {
  banner: W2,
  text: G2,
  icon: Y2,
  button: z2
}, Bs = {
  reverificationBannerDescription: {
    id: "verify.twofa_banner_description",
    defaultMessage: "You have linked accounts that require strong customer authentication. Please change your 2FA method to SMS or a mobile app."
  },
  verifyNowButton: {
    id: "base.change_now",
    defaultMessage: "Change now"
  }
}, Uu = () => {
  const { locale: e, formatMessage: t } = be(), { config: r, accounts: n, currentAccount: a, twoFaType: i } = Le(Re);
  return !((a == null ? void 0 : a.type) === Ue.PRIVATE_PERSON ? n.find(
    (s) => s.userGuid !== (a == null ? void 0 : a.userGuid) && s.scaRequired && s.fullAccess
  ) : null) || !i || [en.DUO_PUSH, en.PUSH_ME, en.SMS].includes(i) ? null : /* @__PURE__ */ f.jsx(
    Su,
    {
      icon: /* @__PURE__ */ f.jsx(Cu, { className: Zr.icon, height: "26", width: "26" }),
      className: Zr.banner,
      children: /* @__PURE__ */ f.jsxs("span", { className: Zr.text, children: [
        t(Bs.reverificationBannerDescription),
        /* @__PURE__ */ f.jsx("a", { className: Zr.button, href: `${r.PROFILE_DOMAIN}/${e}/security`, children: t(Bs.verifyNowButton) })
      ] })
    }
  );
};
function V2({
  isNavOpen: e,
  setIsNavOpen: t,
  history: r,
  cardLink: n,
  isAuthenticated: a,
  logout: i,
  user: o,
  setModalOpen: s,
  origin: l,
  notifications: u
}) {
  const { locale: c, formatMessage: d } = be(), {
    refCurr: { val: m },
    modalState: { toggle: x }
  } = Le(Re), [{ icon: E, sign: P }, w] = Te(Bt[Lt.USD]), { push: b } = r, p = zi() < 768, g = St(null), _ = `${l !== "loans" ? `${window.location.origin}` : ""}/${c}/crypto-loans/app`, [y, O] = Te(
    window.location.pathname.includes("crypto-loans/app") ? _ : window.location.pathname
  ), j = St();
  return Pn(j, () => t(!1)), et(() => {
    m && w(Bt[m]);
  }, [m]), et(() => {
    const ne = r.listen(({ pathname: ae }) => {
      O(ae);
    });
    return () => {
      ne();
    };
  }, []), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("div", { className: q(_e.container, er.container), children: /* @__PURE__ */ f.jsxs(
      "header",
      {
        id: "header",
        className: q(_e.header, er.header),
        ref: j,
        children: [
          /* @__PURE__ */ f.jsx(
            "a",
            {
              href: `/${c}/account`,
              className: q(_e.logoWrapper, er.logoWrapper),
              children: /* @__PURE__ */ f.jsxs("div", { ref: g, className: er.reactiveLogo, children: [
                /* @__PURE__ */ f.jsx(
                  gn,
                  {
                    container: g,
                    condition: ({ contentBox: ne }) => ne.inlineSize >= 200,
                    children: /* @__PURE__ */ f.jsx(Qi, { className: er.logo })
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  gn,
                  {
                    container: g,
                    condition: ({ contentBox: ne }) => ne.inlineSize < 200,
                    children: /* @__PURE__ */ f.jsx(Pu, { className: er.logoSmall })
                  }
                )
              ] })
            }
          ),
          /* @__PURE__ */ f.jsx(
            "nav",
            {
              className: q(_e.navMenu, {
                [_e.open]: e
              }),
              children: /* @__PURE__ */ f.jsxs(
                "ul",
                {
                  className: q(_e.navMenuList, {
                    [_e.fullScreen]: e && p
                  }),
                  "data-method": () => t(!1),
                  children: [
                    /* @__PURE__ */ f.jsx(
                      ht,
                      {
                        activeLink: y,
                        push: b,
                        isAnchorLink: l !== "internal",
                        text: d(Ae.wallet),
                        url: `${l !== "internal" ? `${window.location.origin}` : ""}/${c}/account`
                      }
                    ),
                    /* @__PURE__ */ f.jsx(
                      ht,
                      {
                        activeLink: y,
                        push: b,
                        isAnchorLink: l !== "internal",
                        text: d(Ae.exchange),
                        url: `${l !== "internal" ? `${window.location.origin}` : ""}/${c}/convert`
                      }
                    ),
                    /* @__PURE__ */ f.jsx(
                      ht,
                      {
                        activeLink: y,
                        push: b,
                        isAnchorLink: l !== "internal",
                        text: d(Ae.deposit),
                        url: `${l !== "internal" ? `${window.location.origin}` : ""}/${c}/deposit`
                      }
                    ),
                    /* @__PURE__ */ f.jsx(
                      ht,
                      {
                        activeLink: y,
                        push: b,
                        isAnchorLink: l !== "internal",
                        text: d(Ae.withdraw),
                        url: `${l !== "internal" ? `${window.location.origin}` : ""}/${c}/withdraw`
                      }
                    ),
                    /* @__PURE__ */ f.jsx(
                      ht,
                      {
                        activeLink: y,
                        push: b,
                        isAnchorLink: l !== "internal",
                        text: d(Ae.cards),
                        url: n || `${l !== "internal" ? `${window.location.origin}` : ""}/${c}/cards`
                      }
                    ),
                    /* @__PURE__ */ f.jsx(
                      ht,
                      {
                        activeLink: y,
                        push: b,
                        isAnchorLink: !0,
                        text: d(Ae.loans),
                        url: _
                      }
                    ),
                    /* @__PURE__ */ f.jsx(
                      ht,
                      {
                        activeLink: y,
                        push: b,
                        isAnchorLink: l !== "internal",
                        text: d(Ae.merchantProjects),
                        url: `${l !== "internal" ? `${window.location.origin}` : ""}/${c}/merchants`
                      }
                    ),
                    e && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
                      /* @__PURE__ */ f.jsxs(
                        "li",
                        {
                          className: q(
                            _e.navlistItem,
                            _e.borderTop
                          ),
                          onClick: () => {
                            x(Vt.LANGUAGE), s(!0);
                          },
                          children: [
                            /* @__PURE__ */ f.jsx(pn, { width: 22, height: 22 }),
                            mn[c]
                          ]
                        }
                      ),
                      /* @__PURE__ */ f.jsxs(
                        "li",
                        {
                          className: q(_e.navlistItem),
                          onClick: () => {
                            x(Vt.REF_CURRENCY), s(!0);
                          },
                          children: [
                            /* @__PURE__ */ f.jsx(E, {}),
                            m,
                            " (",
                            P,
                            ")"
                          ]
                        }
                      )
                    ] }),
                    /* @__PURE__ */ f.jsx(
                      "li",
                      {
                        className: _e.closeNav,
                        onClick: () => t(!1)
                      }
                    )
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ f.jsxs("div", { className: _e.componentsRow, children: [
            a && /* @__PURE__ */ f.jsx(Tu, { logout: i, totalCount: u.totalCount }),
            /* @__PURE__ */ f.jsx("div", { className: _e.languageSwitcher, children: /* @__PURE__ */ f.jsx(
              pn,
              {
                onClick: () => s(!0),
                className: _e.icon
              }
            ) }),
            a && !p && /* @__PURE__ */ f.jsx(
              $2,
              {
                notifications: u.data,
                markAsRead: u.markAsRead,
                totalCount: u.totalCount
              }
            ),
            /* @__PURE__ */ f.jsxs(
              "button",
              {
                className: q(_e.navTrigger, {
                  [_e.open]: e
                }),
                onClick: () => t(!e),
                children: [
                  /* @__PURE__ */ f.jsx("span", {}),
                  /* @__PURE__ */ f.jsx("span", {}),
                  /* @__PURE__ */ f.jsx("span", {})
                ]
              }
            )
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ f.jsx(Ou, { user: o }),
    /* @__PURE__ */ f.jsx(Uu, {})
  ] });
}
const wr = {
  card: {
    id: "routes.card",
    defaultMessage: "bitcoin-debit-card"
  },
  loans: {
    id: "routes.loans",
    defaultMessage: "crypto-loans"
  },
  business: {
    id: "routes.business",
    defaultMessage: "accept-bitcoin-payments"
  },
  buyBitcoin: {
    id: "routes.buyBitcoin",
    defaultMessage: "buy-bitcoin"
  },
  bitcoinWallet: {
    id: "routes.bitcoinWallet",
    defaultMessage: "bitcoin-wallet"
  }
};
var $u = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = "fas", r = "bars", n = 448, a = 512, i = ["navicon"], o = "f0c9", s = "M0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128H32C14.33 128 0 113.7 0 96zM0 256C0 238.3 14.33 224 32 224H416C433.7 224 448 238.3 448 256C448 273.7 433.7 288 416 288H32C14.33 288 0 273.7 0 256zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z";
  e.definition = {
    prefix: t,
    iconName: r,
    icon: [
      n,
      a,
      i,
      o,
      s
    ]
  }, e.faBars = e.definition, e.prefix = t, e.iconName = r, e.width = n, e.height = a, e.ligatures = i, e.unicode = o, e.svgPathData = s, e.aliases = i;
})($u);
const q2 = () => {
  mc(() => {
    const e = window.getComputedStyle(document.body).overflow;
    return document.body.style.overflow = "hidden", () => {
      document.body.style.overflow = e;
    };
  }, []);
}, Z2 = "_list_19bxa_1", X2 = "_listItem_19bxa_8", K2 = "_listItemContent_19bxa_19", J2 = "_icon_19bxa_24", Q2 = "_name_19bxa_30", eg = "_link_19bxa_40", or = {
  list: Z2,
  listItem: X2,
  listItemContent: K2,
  icon: J2,
  name: Q2,
  link: eg
}, tg = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 40, viewBox: "0 0 40 40", ...e }, /* @__PURE__ */ h.createElement("defs", null, /* @__PURE__ */ h.createElement("style", null, ".a,.b{fill:#49c5b6;}.a{opacity:0.104;}")), /* @__PURE__ */ h.createElement("g", { transform: "translate(-1099 -121)" }, /* @__PURE__ */ h.createElement("rect", { className: "a", width: 40, height: 40, rx: 20, transform: "translate(1099 121)" }), /* @__PURE__ */ h.createElement("g", { transform: "translate(642.023 -352.426)" }, /* @__PURE__ */ h.createElement("g", { transform: "translate(468.977 484.716)" }, /* @__PURE__ */ h.createElement("path", { className: "b", d: "M468.977,645.534h10.364c3.619,0,5.346,2.358,5.346,4.661a4.084,4.084,0,0,1-3.125,4.195,4.38,4.38,0,0,1,3.482,4.469c0,2.66-1.782,4.963-5.374,4.963H468.977Zm9.295,7.073a1.548,1.548,0,0,0,1.617-1.59,1.527,1.527,0,0,0-1.617-1.563h-4.579v3.153Zm.164,7.293a1.637,1.637,0,0,0,1.81-1.672,1.692,1.692,0,0,0-1.81-1.728h-4.743v3.4Z", transform: "translate(-468.977 -645.534)" }))))), rg = ({ icon: e, link: t, name: r }) => /* @__PURE__ */ f.jsxs("li", { "data-cy": "ext-item", className: or.listItem, children: [
  /* @__PURE__ */ f.jsxs("div", { className: or.listItemContent, children: [
    e,
    /* @__PURE__ */ f.jsx("span", { className: or.name, children: r })
  ] }),
  /* @__PURE__ */ f.jsx("a", { className: or.link, target: "_blank", rel: "noopener noreferrer", href: t })
] }), Wu = () => /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx("ul", { className: or.list, children: /* @__PURE__ */ f.jsx(
  rg,
  {
    icon: /* @__PURE__ */ f.jsx(tg, { className: or.icon, height: "40", width: "40" }),
    link: "https://bankera.com/",
    name: "Bankera"
  }
) }) }), ng = "_header_e2z05_1", ag = "_open_e2z05_4", ig = "_content_e2z05_17", og = "_buttons_e2z05_23", sg = "_visible_e2z05_29", lg = "_buttonWrapper_e2z05_33", ug = "_button_e2z05_23", cg = "_overlayButton_e2z05_50", fg = "_logo_e2z05_54", dg = "_menuIcon_e2z05_60", mg = "_list_e2z05_66", hg = "_overlay_e2z05_50", pg = "_languageSwitcher_e2z05_80", vg = "_externalProducts_e2z05_84", gg = "_externalProductsHeading_e2z05_88", bg = "_changeContainer_e2z05_95", we = {
  header: ng,
  open: ag,
  content: ig,
  buttons: og,
  visible: sg,
  buttonWrapper: lg,
  button: ug,
  overlayButton: cg,
  logo: fg,
  menuIcon: dg,
  list: mg,
  overlay: hg,
  languageSwitcher: pg,
  externalProducts: vg,
  externalProductsHeading: gg,
  changeContainer: bg
}, sr = {
  logIn: {
    id: "header.logIn",
    defaultMessage: "Log in"
  },
  signUp: {
    id: "header.signUp",
    defaultMessage: "Sign up"
  },
  ecosystem: {
    id: "header.ecosystem",
    defaultMessage: "Ecosystem"
  },
  account: {
    id: "base.account",
    defaultMessage: "Account"
  }
}, yg = ({
  isAuthenticated: e,
  isPageNavigationVisible: t,
  links: r,
  openModal: n
}) => {
  const {
    refCurr: { val: a },
    modalState: { toggle: i }
  } = Le(Re), { icon: o, sign: s } = Bt[a ?? Lt.USD], { locale: l } = be();
  return q2(), /* @__PURE__ */ f.jsxs("div", { className: we.overlay, children: [
    /* @__PURE__ */ f.jsx("ul", { className: we.list, children: t && r }),
    /* @__PURE__ */ f.jsxs("ul", { className: we.changeContainer, children: [
      /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: () => {
            i(Vt.LANGUAGE), n();
          },
          children: [
            /* @__PURE__ */ f.jsx(pn, { width: 22, height: 22 }),
            mn[l]
          ]
        }
      ),
      /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: () => {
            i(Vt.REF_CURRENCY), n();
          },
          children: [
            /* @__PURE__ */ f.jsx("img", { src: o, alt: `${a} icon` }),
            a,
            " (",
            s,
            ")"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: we.buttonWrapper, children: e ? /* @__PURE__ */ f.jsx(
      ze,
      {
        buttonStyle: $e.PRIMARY,
        className: we.overlayButton,
        link: `/${l}/account`,
        text: sr.account,
        type: We.ANCHOR_LINK
      }
    ) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx(
        ze,
        {
          buttonStyle: $e.TERTIARY,
          className: we.overlayButton,
          link: `/${l}/login`,
          text: sr.logIn,
          type: We.ANCHOR_LINK
        }
      ),
      /* @__PURE__ */ f.jsx(
        ze,
        {
          buttonStyle: $e.PRIMARY,
          className: we.overlayButton,
          link: `/${l}/signup`,
          text: sr.signUp,
          type: We.ANCHOR_LINK
        }
      )
    ] }) }),
    t && /* @__PURE__ */ f.jsxs("div", { className: we.externalProducts, children: [
      /* @__PURE__ */ f.jsx("div", { className: we.externalProductsHeading, children: /* @__PURE__ */ f.jsx(yl, { ...sr.ecosystem }) }),
      /* @__PURE__ */ f.jsx(Wu, {})
    ] })
  ] });
}, _g = ({
  isAuthenticated: e,
  links: t,
  setIsNavOpen: r,
  isNavOpen: n,
  openModal: a,
  isPageNavigationVisible: i
}) => {
  const { locale: o } = be(), s = Tt();
  return et(() => {
    document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    const l = () => document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    return window.addEventListener("resize", l), () => window.removeEventListener("resize", l);
  }, []), /* @__PURE__ */ f.jsxs(
    "header",
    {
      className: q(we.header, {
        [we.open]: n
      }),
      children: [
        /* @__PURE__ */ f.jsxs("div", { className: we.content, children: [
          /* @__PURE__ */ f.jsx("a", { href: s, children: /* @__PURE__ */ f.jsx(Qi, { className: we.logo }) }),
          /* @__PURE__ */ f.jsxs(
            "div",
            {
              className: q(we.buttons, {
                [we.visible]: !0
                // session.isSessionReady || session.isSessionError, TODO
              }),
              children: [
                !n && /* @__PURE__ */ f.jsx(f.Fragment, { children: e ? /* @__PURE__ */ f.jsx(
                  ze,
                  {
                    buttonStyle: $e.PRIMARY,
                    className: we.button,
                    link: `/${o}/account`,
                    text: sr.account,
                    type: We.ANCHOR_LINK
                  }
                ) : /* @__PURE__ */ f.jsx(
                  ze,
                  {
                    buttonStyle: $e.PRIMARY,
                    className: we.button,
                    link: `/${o}/login`,
                    text: sr.logIn,
                    type: We.ANCHOR_LINK
                  }
                ) }),
                /* @__PURE__ */ f.jsx(
                  yt,
                  {
                    fixedWidth: !0,
                    onClick: () => r(!n),
                    className: we.menuIcon,
                    size: "1x",
                    icon: n ? eo.faTimes : $u.faBars
                  }
                )
              ]
            }
          )
        ] }),
        n && /* @__PURE__ */ f.jsx(
          yg,
          {
            openModal: a,
            isAuthenticated: e,
            links: t,
            isPageNavigationVisible: i
          }
        )
      ]
    }
  );
}, xg = "_container_edf0k_1", wg = "_moreOptionsMenu_edf0k_5", Eg = "_square_edf0k_14", Tg = "_topLeftSquareMove_edf0k_1", Pg = "_topRightSquareMove_edf0k_1", Cg = "_bottomRightSquareMove_edf0k_1", Sg = "_bottomLeftSquareMove_edf0k_1", Og = "_externalProducts_edf0k_145", Ng = "_visible_edf0k_171", Et = {
  container: xg,
  moreOptionsMenu: wg,
  square: Eg,
  topLeftSquareMove: Tg,
  topRightSquareMove: Pg,
  bottomRightSquareMove: Cg,
  bottomLeftSquareMove: Sg,
  externalProducts: Og,
  visible: Ng
}, Ag = ({ className: e }) => {
  const [t, r] = Te(!1), n = St();
  return Pn(n, () => r(!1)), /* @__PURE__ */ f.jsxs("div", { ref: n, className: Et.container, children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        "data-cy": "ext-dropdown",
        onClick: () => r(!t),
        className: q(Et.moreOptionsMenu, e),
        children: [
          /* @__PURE__ */ f.jsx("div", { className: Et.square }),
          /* @__PURE__ */ f.jsx("div", { className: Et.square }),
          /* @__PURE__ */ f.jsx("div", { className: Et.square }),
          /* @__PURE__ */ f.jsx("div", { className: Et.square })
        ]
      }
    ),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        className: q(Et.externalProducts, {
          [Et.visible]: t
        }),
        children: /* @__PURE__ */ f.jsx(Wu, {})
      }
    )
  ] });
}, Mg = "_header_1qgg9_1", Rg = "_navContainer_1qgg9_12", kg = "_content_1qgg9_18", Ig = "_buttons_1qgg9_26", Dg = "_button_1qgg9_26", Lg = "_moreOptionsButton_1qgg9_50", jg = "_logo_1qgg9_54", Bg = "_list_1qgg9_66", Hg = "_listItem_1qgg9_80", Fg = "_link_1qgg9_90", Ug = "_activeLink_1qgg9_109", $g = "_languageSwitcher_1qgg9_113", Wg = "_icon_1qgg9_113", Be = {
  header: Mg,
  navContainer: Rg,
  content: kg,
  buttons: Ig,
  button: Dg,
  moreOptionsButton: Lg,
  logo: jg,
  list: Bg,
  listItem: Hg,
  link: Fg,
  activeLink: Ug,
  languageSwitcher: $g,
  icon: Wg
};
function Gg({
  isNavOpen: e,
  setIsNavOpen: t,
  setModalOpen: r,
  isAuthenticated: n,
  isPageNavigationVisible: a,
  isLangSwitcherVisible: i,
  history: o
}) {
  const { locale: s, formatMessage: l } = be(), u = Tt(), { pathname: c } = window.location, { push: d } = o, [m, x] = Te(c);
  et(() => {
    x(c);
  }, [c]);
  const E = [
    {
      url: Tt(wr.bitcoinWallet),
      text: l(Ae.wallet)
    },
    {
      url: Tt(wr.card),
      text: l(Ae.card)
    },
    {
      url: Tt(wr.buyBitcoin),
      text: l(Ae.buyAndSell)
    },
    {
      url: Tt(wr.loans),
      text: l(Ae.loans)
    },
    {
      url: Tt(wr.business),
      text: l(Ae.business)
    }
  ];
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      _g,
      {
        isAuthenticated: n,
        links: E.map(({ url: P, text: w }) => /* @__PURE__ */ f.jsx(
          ht,
          {
            push: d,
            text: w,
            url: P,
            onLinkClick: () => t(!1),
            activeLink: m
          },
          P
        )),
        openModal: () => r(!0),
        isNavOpen: e,
        setIsNavOpen: t,
        isPageNavigationVisible: a
      }
    ),
    /* @__PURE__ */ f.jsx("header", { "data-cy": "desktop_header", className: Be.header, children: /* @__PURE__ */ f.jsxs("div", { className: Be.content, children: [
      /* @__PURE__ */ f.jsx("a", { href: u, children: /* @__PURE__ */ f.jsx(Qi, { className: Be.logo }) }),
      /* @__PURE__ */ f.jsxs("div", { className: Be.navContainer, children: [
        a && /* @__PURE__ */ f.jsx("nav", { className: Be.nav, children: /* @__PURE__ */ f.jsx("ul", { className: Be.list, children: E.map(({ url: P, text: w }) => /* @__PURE__ */ f.jsx(
          ht,
          {
            push: d,
            text: w,
            url: P,
            activeLink: m
          },
          P
        )) }) }),
        /* @__PURE__ */ f.jsxs("div", { className: Be.buttons, children: [
          n ? /* @__PURE__ */ f.jsx(
            ze,
            {
              buttonStyle: $e.PRIMARY,
              className: Be.button,
              link: `/${s}/account`,
              text: Ae.account,
              type: We.ANCHOR_LINK
            }
          ) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
            /* @__PURE__ */ f.jsx(
              ze,
              {
                "data-cy": "b-login",
                buttonStyle: $e.TERTIARY,
                className: Be.button,
                link: `/${s}/login`,
                text: Ae.logIn,
                type: We.ANCHOR_LINK
              }
            ),
            /* @__PURE__ */ f.jsx(
              ze,
              {
                "data-cy": "b-signup",
                buttonStyle: $e.PRIMARY,
                className: Be.button,
                link: `/${s}/signup`,
                text: Ae.signUp,
                type: We.ANCHOR_LINK
              }
            )
          ] }),
          a && /* @__PURE__ */ f.jsx(Ag, { className: Be.moreOptionsButton }),
          i && /* @__PURE__ */ f.jsx("div", { className: Be.languageSwitcher, children: /* @__PURE__ */ f.jsx(
            pn,
            {
              onClick: () => r(!0),
              className: Be.icon
            }
          ) })
        ] })
      ] })
    ] }) })
  ] });
}
const Yg = "_container_1uo4l_1", zg = "_header_1uo4l_1", Vg = "_logoWrapper_1uo4l_9", qg = "_logoContainer_1uo4l_13", Zg = "_leftIcon_1uo4l_17", It = {
  container: Yg,
  header: zg,
  logoWrapper: Vg,
  logoContainer: qg,
  leftIcon: Zg
}, Xg = (e) => /* @__PURE__ */ h.createElement("svg", { id: "SC_Full_Horizontal_Blue", "data-name": "SC Full Horizontal Blue", xmlns: "http://www.w3.org/2000/svg", width: 294.589, height: 51.152, viewBox: "0 0 294.589 51.152", ...e }, /* @__PURE__ */ h.createElement("g", { id: "Group_43106", "data-name": "Group 43106" }, /* @__PURE__ */ h.createElement("g", { id: "Group_11371", "data-name": "Group 11371" }, /* @__PURE__ */ h.createElement("path", { id: "Path_21649", "data-name": "Path 21649", d: "M-2162.76,948.614l-.184.078a14.331,14.331,0,0,1-3.077.756l-.1.026v.1a20.654,20.654,0,0,1-1.07,4.771v.027l1.148,5.266.156-.286a23.077,23.077,0,0,0,3.1-10.533Z", transform: "translate(2210.134 -920.089)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21650", "data-name": "Path 21650", d: "M-2176.751,928.653l-.156.13.182.1a20.036,20.036,0,0,1,5.217,4.276l.053.052h4.147l-.157-.208a23.466,23.466,0,0,0-6.782-6.439l-.1-.052-.078.077A19.659,19.659,0,0,1-2176.751,928.653Z", transform: "translate(2210.561 -919.107)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21651", "data-name": "Path 21651", d: "M-2176.343,935.112h0a16.227,16.227,0,0,0-5.374-4.015c-.339-.157-.756-.339-1.251-.524-.313-.13-.652-.208-.966-.312l-.313-.105c-.444-.13-.886-.234-1.3-.312l-.261-.053c-.339-.053-.7-.13-1.043-.157l-1.07-.1-.835,1.773a5.067,5.067,0,0,1-2.27,2.033,5.151,5.151,0,0,1-3.1.365,26.2,26.2,0,0,1-3.5-1.3,21.449,21.449,0,0,1-2.843-1.409,5.234,5.234,0,0,1-1.826-2.842,5.125,5.125,0,0,1,.365-3.362,5.034,5.034,0,0,1,1.722-2.033,5.159,5.159,0,0,1,2.427-.887l18.65.078a13.32,13.32,0,0,1-9.86,4.379l-8.685-.026-.027,3.05,8.739.027a16.461,16.461,0,0,0,14.162-8.183l1.381-2.294-24.385-.134h-.053a8.153,8.153,0,0,0-7.59,8.68h0a8.267,8.267,0,0,0,.207,1.359,8.286,8.286,0,0,0,2.9,4.563,17.561,17.561,0,0,0,3.522,1.8,28.943,28.943,0,0,0,4.121,1.487,8.139,8.139,0,0,0,4.93-.6,8.263,8.263,0,0,0,3.652-3.234h.027a9.125,9.125,0,0,1,1.017.234h.026c.338.1.678.208,1.043.339.286.1.6.261.992.443a13.386,13.386,0,0,1,6.235,5.943,13.832,13.832,0,0,1,1.513,6.362,12.756,12.756,0,0,1-.469,3.311l-.027.077,2.348,10.951-5.95,4.12a6.849,6.849,0,0,1-1.643-.053,6.632,6.632,0,0,1-1.9-.573,7.051,7.051,0,0,1-2.06-1.487,6.78,6.78,0,0,1-1.356-2.137l-.392-1.043-1.095.077a13.366,13.366,0,0,1-3.364-.208,12.715,12.715,0,0,1-3.208-1.042,13.216,13.216,0,0,1-6.077-5.736,13.463,13.463,0,0,1-1.592-5.084,24.761,24.761,0,0,1,.391-5.006l.027-.208-2.79-1.278-.079.286c0,.053-.234.887-.338,1.278a4.81,4.81,0,0,1-.861-.235,5.591,5.591,0,0,1-1.773-1.147,5.512,5.512,0,0,1-1.49-2.788,5.268,5.268,0,0,1,.1-2.293l15.024,7.065a3.443,3.443,0,0,0-.235.443l-.077.182a5.944,5.944,0,0,0,2.92,7.717l.184.078a5.893,5.893,0,0,0,3.834.286,10.935,10.935,0,0,0,1.094-.418l1.931,9.126.99.208a7.943,7.943,0,0,1,2.374.835,3.957,3.957,0,0,1,1.017.86l.156.183,2.478-1.878-.183-.208a6.69,6.69,0,0,0-1.9-1.618,9.183,9.183,0,0,0-2.292-.936l-1.853-8.786a9.313,9.313,0,0,0-2.427-4.64,15.8,15.8,0,0,0-4.852-3.364l-19.641-9.229-.966,1.929-.026.078a7.884,7.884,0,0,0-.625,4.9,8.293,8.293,0,0,0,5.188,6.232,7.673,7.673,0,0,0,1.565.392,16.8,16.8,0,0,0,2.009,8.473,16.33,16.33,0,0,0,7.46,7.014,16.944,16.944,0,0,0,3.939,1.277,16.269,16.269,0,0,0,3.052.286,9.8,9.8,0,0,0,1.512,2.112,10.051,10.051,0,0,0,2.973,2.164,8.989,8.989,0,0,0,2.766.834,11.85,11.85,0,0,0,1.38.1,10.012,10.012,0,0,0,1.512-.1l.365-.053,8.216-5.708-2.582-12.254.131-.756a16.521,16.521,0,0,0-1.592-10.4,1.262,1.262,0,0,1-.1-.391h13.119a9.574,9.574,0,0,1-2.555,2.4,12.664,12.664,0,0,1-5.085,1.982l-.208.026v3.077l.285-.052a16.479,16.479,0,0,0,11.92-8l1.357-2.294Zm-14.736,9.752.078-.156a11.316,11.316,0,0,1,2.683,2.033,7.915,7.915,0,0,1,1.047,1.46,2.813,2.813,0,0,1-.756.338,2.564,2.564,0,0,1-1.8-.182,2.646,2.646,0,0,1-1.253-3.493Z", transform: "translate(2212.109 -918.762)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21652", "data-name": "Path 21652", d: "M-2185.63,970.691a12.371,12.371,0,0,1-3.469-2.608l-.285-.312h-.053a20.682,20.682,0,0,1-7.591-1.851l-.131-.053a20.054,20.054,0,0,1-10.407-11.395,20.6,20.6,0,0,1-1.174-5.632v-.077l-.078-.027a11.1,11.1,0,0,1-2.635-1.9,3.436,3.436,0,0,1-.417-.443l-.186-.234-.026.313a23.464,23.464,0,0,0,13.307,22.343l.156.078a23.309,23.309,0,0,0,9.99,2.242,22.186,22.186,0,0,0,2.947-.182l.418-.052Z", transform: "translate(2212.11 -919.98)", fill: "#102d6f" })), /* @__PURE__ */ h.createElement("g", { id: "Group_43105", "data-name": "Group 43105", transform: "translate(61.154 11.076)" }, /* @__PURE__ */ h.createElement("g", { id: "Group_11372", "data-name": "Group 11372", transform: "translate(0 5.573)" }, /* @__PURE__ */ h.createElement("path", { id: "Path_21653", "data-name": "Path 21653", d: "M-2104.77,947.161a5.655,5.655,0,0,0-1.643-4.165,5.513,5.513,0,0,0-4.053-1.615,6.048,6.048,0,0,0-4.449,1.7,5.78,5.78,0,0,0-1.672,4.307,5.85,5.85,0,0,0,1.7,4.307,6.693,6.693,0,0,0,8.646.226l-2.152-2.154a2.152,2.152,0,0,1-1.955.85,2.733,2.733,0,0,1-2.892-2.04h8.391A8.239,8.239,0,0,0-2104.77,947.161Zm-8.5-.907a2.586,2.586,0,0,1,2.721-2.154,2.333,2.333,0,0,1,2.467,2.154Z", transform: "translate(2146.752 -936.417)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21654", "data-name": "Path 21654", d: "M-2136.969,937.3a5.34,5.34,0,0,1,2.552,4.278h-3.431c-.227-1.615-1.275-2.408-3.09-2.408-1.73,0-2.834.737-2.834,1.983,0,1.049.737,1.559,2.3,1.871l2.013.4c3.344.679,4.96,1.983,4.96,4.618a4.567,4.567,0,0,1-1.786,3.768,7.392,7.392,0,0,1-4.707,1.417,8.017,8.017,0,0,1-4.961-1.5,5.6,5.6,0,0,1-2.183-4.222h3.459c.254,1.643,1.7,2.692,3.883,2.692,1.729,0,2.693-.624,2.693-1.758,0-.879-.68-1.417-2.042-1.672l-2.664-.509c-3.09-.568-4.649-2.239-4.649-4.817a4.754,4.754,0,0,1,1.7-3.8,6.86,6.86,0,0,1,4.535-1.446A8.737,8.737,0,0,1-2136.969,937.3Z", transform: "translate(2148.14 -936.186)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21655", "data-name": "Path 21655", d: "M-2120.756,943.138a6.238,6.238,0,0,1,0,8.5,5.321,5.321,0,0,1-4.025,1.728,5.992,5.992,0,0,1-3.259-.907v6.234h-3.346V941.637h3.344v.679a5.993,5.993,0,0,1,3.259-.907A5.307,5.307,0,0,1-2120.756,943.138Zm-2.494,6.488a3.292,3.292,0,0,0,0-4.477,2.692,2.692,0,0,0-2.126-.963,3.209,3.209,0,0,0-2.722,1.332V949.2a3.285,3.285,0,0,0,2.722,1.332,2.784,2.784,0,0,0,2.125-.908Z", transform: "translate(2147.403 -936.419)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21656", "data-name": "Path 21656", d: "M-2091.754,951.638c-.142.141-.283.283-.453.424a6.473,6.473,0,0,1-8.306-.368,5.794,5.794,0,0,1-1.786-4.307,5.679,5.679,0,0,1,1.786-4.278,6.43,6.43,0,0,1,8.306-.4c.142.113.283.254.424.368l-2.239,2.238a2.387,2.387,0,0,0-2.1-1.02,3.036,3.036,0,0,0-2.891,3.174h0a3.036,3.036,0,0,0,2.891,2.889,2.441,2.441,0,0,0,2.126-1.02Z", transform: "translate(2146.122 -936.418)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21657", "data-name": "Path 21657", d: "M-2076.06,942.907a5.756,5.756,0,0,1,4.025-1.5v3.173a5.551,5.551,0,0,0-4.025,1.643v6.856h-3.345v-11.5h3.345Z", transform: "translate(2145.115 -936.419)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21658", "data-name": "Path 21658", d: "M-2059.906,943.081a5.642,5.642,0,0,1,1.758,4.307,5.765,5.765,0,0,1-1.758,4.363,5.9,5.9,0,0,1-4.366,1.729,6.028,6.028,0,0,1-4.422-1.729,5.8,5.8,0,0,1-1.758-4.363,5.64,5.64,0,0,1,1.758-4.307,6.53,6.53,0,0,1,8.789,0Zm-1.559,4.307a2.825,2.825,0,0,0-2.835-3.032,2.852,2.852,0,0,0-2.9,2.805c0,.075,0,.151.006.227a2.908,2.908,0,0,0,2.892,3.117A2.881,2.881,0,0,0-2061.466,947.388Z", transform: "translate(2144.721 -936.417)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21659", "data-name": "Path 21659", d: "M-2041.232,950.672l-.68.68a7.856,7.856,0,0,1-5.358,1.9,8.3,8.3,0,0,1-6.066-2.409,8.172,8.172,0,0,1-2.438-6.092,8.326,8.326,0,0,1,8.119-8.528h0c.129,0,.258,0,.385,0a7.843,7.843,0,0,1,5.357,1.9c.085.085.17.141.256.227l-2.409,2.408a4.432,4.432,0,0,0-3.232-1.218,4.788,4.788,0,0,0-3.6,1.446,5.641,5.641,0,0,0,0,7.48,4.787,4.787,0,0,0,3.6,1.445,4.226,4.226,0,0,0,3.6-1.7Z", transform: "translate(2144.076 -936.188)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21660", "data-name": "Path 21660", d: "M-2082.016,952.755a9.992,9.992,0,0,1-3.09.538c-2.777,0-4.62-1.955-4.62-4.958v-9.944l3.316-1.814v4.845h4.168v2.806h-4.168v4.08c0,1.275.68,1.9,2.014,1.9a7.23,7.23,0,0,0,1.956-.31Z", transform: "translate(2145.569 -936.204)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21661", "data-name": "Path 21661", d: "M-2028.625,943.081a5.641,5.641,0,0,1,1.759,4.307,5.767,5.767,0,0,1-1.759,4.363,5.9,5.9,0,0,1-4.365,1.729,6.026,6.026,0,0,1-4.423-1.729,5.806,5.806,0,0,1-1.759-4.363,5.643,5.643,0,0,1,1.759-4.307,6.528,6.528,0,0,1,8.787,0Zm-1.559,4.307a2.824,2.824,0,0,0-2.835-3.032,2.852,2.852,0,0,0-2.9,2.805h0c0,.075,0,.151.006.227a2.907,2.907,0,0,0,2.891,3.117A2.881,2.881,0,0,0-2030.184,947.388Z", transform: "translate(2143.345 -936.417)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21662", "data-name": "Path 21662", d: "M-2020.349,939.918h-3.4v-3.4h3.4Zm-.029,13.006h-3.345v-11.5h3.345Z", transform: "translate(2142.666 -936.201)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("path", { id: "Path_21663", "data-name": "Path 21663", d: "M-2006.789,942.763a5.7,5.7,0,0,1,1.389,4.023V953.1h-3.345v-6.032c0-1.813-.908-2.8-2.467-2.8a3.335,3.335,0,0,0-2.523,1.448v7.394h-3.345V941.6h3.345v.821a5.16,5.16,0,0,1,3.289-1.189A4.882,4.882,0,0,1-2006.789,942.763Z", transform: "translate(2142.373 -936.411)", fill: "#102d6f" })), /* @__PURE__ */ h.createElement("path", { id: "Path_36943", "data-name": "Path 36943", d: "M2.016,0V-16.8H9.528a6.3,6.3,0,0,1,2.968.661A4.8,4.8,0,0,1,14.448-14.3a5.28,5.28,0,0,1,.693,2.731,5.147,5.147,0,0,1-.693,2.67A4.809,4.809,0,0,1,12.5-7.069a6.3,6.3,0,0,1-2.968.661H4.9V0ZM4.9-8.763H9.073a3.28,3.28,0,0,0,2.351-.776,2.69,2.69,0,0,0,.816-2.043,2.63,2.63,0,0,0-.816-2.024,3.314,3.314,0,0,0-2.34-.757H4.9ZM17.908,0V-12.016h2.719v2.585a4.969,4.969,0,0,1,1.362-2.087,2.923,2.923,0,0,1,1.945-.711,5.044,5.044,0,0,1,.62.052,2.238,2.238,0,0,1,.572.181V-9.62a3.43,3.43,0,0,0-.715-.215,4.1,4.1,0,0,0-.78-.076,3.042,3.042,0,0,0-1.759.532,3.781,3.781,0,0,0-1.244,1.464V0ZM32.286.214A5.941,5.941,0,0,1,29.2-.6a5.9,5.9,0,0,1-2.165-2.222A6.362,6.362,0,0,1,26.238-6a6.351,6.351,0,0,1,.793-3.175,5.91,5.91,0,0,1,2.164-2.22,5.93,5.93,0,0,1,3.085-.814,5.888,5.888,0,0,1,3.083.814,5.944,5.944,0,0,1,2.153,2.216A6.347,6.347,0,0,1,38.309-6a6.346,6.346,0,0,1-.793,3.175A5.959,5.959,0,0,1,35.364-.6,5.864,5.864,0,0,1,32.286.214Zm-.014-2.307A3.074,3.074,0,0,0,34.021-2.6,3.46,3.46,0,0,0,35.213-4a4.52,4.52,0,0,0,.434-2,4.465,4.465,0,0,0-.435-2.006,3.48,3.48,0,0,0-1.194-1.385,3.064,3.064,0,0,0-1.74-.506,3.1,3.1,0,0,0-1.746.507,3.438,3.438,0,0,0-1.2,1.387A4.49,4.49,0,0,0,28.9-6a4.537,4.537,0,0,0,.432,2.009,3.415,3.415,0,0,0,1.2,1.394A3.093,3.093,0,0,0,32.272-2.094ZM42.193,0V-9.87H39.6v-2.146h2.594v-2.079a3.979,3.979,0,0,1,1.075-2.99,4.242,4.242,0,0,1,3.081-1.045,8.849,8.849,0,0,1,.974.053,3.807,3.807,0,0,1,.827.173v2.312a6.634,6.634,0,0,0-.761-.146,5.845,5.845,0,0,0-.687-.037,1.9,1.9,0,0,0-1.356.416,1.741,1.741,0,0,0-.434,1.309v2.033H48.15V-9.87H44.912V0Zm8.2,0V-12.016h2.719V0Zm1.369-14.464a1.634,1.634,0,0,1-1.191-.492,1.6,1.6,0,0,1-.5-1.183,1.6,1.6,0,0,1,.5-1.18,1.639,1.639,0,0,1,1.193-.488,1.624,1.624,0,0,1,1.189.489,1.6,1.6,0,0,1,.492,1.178,1.614,1.614,0,0,1-.493,1.182A1.619,1.619,0,0,1,51.767-14.464ZM56.455,0V-17.219l2.719-.469V0ZM68.112.24A5.972,5.972,0,0,1,65-.586a6.145,6.145,0,0,1-2.207-2.237A6.208,6.208,0,0,1,61.974-6a6.476,6.476,0,0,1,.77-3.173,5.906,5.906,0,0,1,2.094-2.22,5.54,5.54,0,0,1,2.975-.819,5.411,5.411,0,0,1,2.945.807,5.706,5.706,0,0,1,2.023,2.2,6.7,6.7,0,0,1,.741,3.185v.669H64.635a4.229,4.229,0,0,0,.633,1.73,3.51,3.51,0,0,0,1.271,1.184,3.473,3.473,0,0,0,1.7.426,4.339,4.339,0,0,0,1.6-.3,3.532,3.532,0,0,0,1.27-.827L72.87-1.515A7.657,7.657,0,0,1,70.63-.182,7.231,7.231,0,0,1,68.112.24ZM64.661-7.024h6.286a3.882,3.882,0,0,0-.587-1.553,3.32,3.32,0,0,0-1.1-1.053,2.852,2.852,0,0,0-1.462-.382,2.911,2.911,0,0,0-1.451.37A3.061,3.061,0,0,0,65.258-8.6,4.374,4.374,0,0,0,64.661-7.024Z", transform: "translate(159.912 23)", fill: "#102d6f" }), /* @__PURE__ */ h.createElement("line", { id: "Line_1031", "data-name": "Line 1031", y2: 31, transform: "translate(148.412)", fill: "none", stroke: "#102d6f", strokeWidth: 2 }))));
function Kg({ isAuthenticated: e, logout: t, user: r }) {
  const { locale: n } = be(), a = St(), { config: i } = Le(Re), o = St(null);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("div", { className: q(_e.container, It.container), children: /* @__PURE__ */ f.jsxs(
      "header",
      {
        id: "header",
        className: q(_e.header, It.header),
        ref: a,
        children: [
          /* @__PURE__ */ f.jsxs("a", { className: It.logoWrapper, href: `${i.SC_URL}/${n}/account`, children: [
            /* @__PURE__ */ f.jsx(ja, { width: 24, height: 24, className: It.leftIcon }),
            /* @__PURE__ */ f.jsxs("div", { ref: o, className: It.logoContainer, children: [
              /* @__PURE__ */ f.jsx(
                gn,
                {
                  container: o,
                  condition: ({ contentBox: s }) => s.inlineSize >= 320,
                  children: /* @__PURE__ */ f.jsx(Xg, { className: It.logoProfile })
                }
              ),
              /* @__PURE__ */ f.jsx(
                gn,
                {
                  container: o,
                  condition: ({ contentBox: s }) => s.inlineSize < 320,
                  children: /* @__PURE__ */ f.jsx(Pu, { className: It.logoProfileSmall })
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ f.jsx("div", { className: _e.componentsRow, children: e && /* @__PURE__ */ f.jsx(Tu, { logout: t, totalCount: 0, showLinks: !1 }) })
        ]
      }
    ) }),
    /* @__PURE__ */ f.jsx(Ou, { user: r }),
    /* @__PURE__ */ f.jsx(Uu, {})
  ] });
}
const Jg = ({
  origin: e,
  history: t,
  cardLink: r,
  isAuthenticated: n,
  logout: a,
  user: i,
  config: o,
  changeLang: s,
  changeRefCurr: l,
  currentRefCurr: u,
  isPageNavigationVisible: c,
  isLangSwitcherVisible: d,
  notifications: m = {
    data: [],
    totalCount: 0,
    markAsRead: {
      handler: () => !1,
      isDisabled: !0
    }
  },
  accounts: x = [],
  currentAccount: E = null,
  setAccount: P,
  addAccount: w,
  twoFaType: b
}) => {
  const [p, g] = Te(!1), [_, y] = Te(!1), [O, j] = Te(u), [ne, ae] = Te(Vt.LANGUAGE);
  return et(() => g(!1), [window.location.pathname]), /* @__PURE__ */ f.jsxs(
    Re.Provider,
    {
      value: {
        config: o,
        refCurr: { val: O, toggle: j },
        modalState: { val: ne, toggle: ae },
        accounts: x,
        currentAccount: E,
        setAccount: P,
        addAccount: w,
        twoFaType: b
      },
      children: [
        /* @__PURE__ */ f.jsx(
          xm,
          {
            isOpen: _,
            changeRefCurr: l,
            changeLang: s,
            toggle: y
          }
        ),
        (e === "internal" || e === "loans") && /* @__PURE__ */ f.jsx(
          V2,
          {
            history: t,
            user: i,
            cardLink: r,
            setModalOpen: y,
            isAuthenticated: n,
            logout: a,
            isNavOpen: p,
            setIsNavOpen: g,
            origin: e,
            notifications: m
          }
        ),
        e === "landing" && /* @__PURE__ */ f.jsx(
          Gg,
          {
            history: t,
            isAuthenticated: n,
            isNavOpen: p,
            setModalOpen: y,
            setIsNavOpen: g,
            isPageNavigationVisible: c || !1,
            isLangSwitcherVisible: d || !1
          }
        ),
        e === "profile" && /* @__PURE__ */ f.jsx(Kg, { user: i, isAuthenticated: n, logout: a })
      ]
    }
  );
}, Qg = {
  "base.account": "الحساب",
  "base.bitcoinExchange": "Pro",
  "base.verify_now": "تحقق الآن",
  "header.business": "تجاري",
  "header.buyAndSell": "صرافة",
  "header.card": "بطاقة",
  "header.cards": "البطاقات",
  "header.deposit": "إيداع",
  "header.ecosystem": "النظام البيئي",
  "header.exchange": "صرافة",
  "header.loans": "القروض",
  "header.logIn": "تسجيل الدخول",
  "header.merchantProjects": "تجاري",
  "header.signUp": "التسجيل",
  "header.spectrocoinPro": "Pro",
  "header.wallet": "محفظة",
  "header.withdraw": "سحب",
  "modal.euro": "يورو",
  "modal.gbp": "الجنيه البريطاني",
  "modal.languages": "اللغة",
  "modal.refCurrency": "العملة المرجعية",
  "modal.usd": "الدولار الأميركي",
  "profileBubble.download_documents": "تحميل الوثائق",
  "profileBubble.linkedCards": "البطاقات الموصولة",
  "profileBubble.logout": "تسجيل الخروج",
  "profileBubble.notifications": "الاشعارات",
  "profileBubble.profileInformation": "الملف الشخصي",
  "profileBubble.referral": "الإحالة",
  "profileBubble.verification": "التوثيق",
  "profileBubble.waletApi": "API المحافظ",
  "verify.reverification_banner_description": "لمواصلة استخدام خدماتنا ، يرجى التحقق من تفاصيل حسابك.",
  "notifications.markAsRead": "ضع إشارة مقروء",
  "notifications.newNotifications": "إشعارات جديدة",
  "notifications.thereAreNoNew": "لا توجد إشعارات جديدة",
  "notifications.viewAll": "عرض جميع الإخطارات",
  "profileBubble.addOrSwitch": "إضافة أو تبديل الملفات الشخصية",
  "profileBubble.back": "",
  "profileBubble.companyProfile": "",
  "profileBubble.personalProfile": "",
  "profileBubble.settings": "",
  "profileBubble.x_personal": ""
}, eb = {
  "base.account": "Konto",
  "base.bitcoinExchange": "Pro",
  "base.verify_now": "Verify now",
  "header.business": "Business",
  "header.buyAndSell": "Umtausch",
  "header.card": "Karte",
  "header.cards": "Karte",
  "header.deposit": "Deposit",
  "header.ecosystem": "Ökosystem",
  "header.exchange": "Convert",
  "header.loans": "Kredite",
  "header.logIn": "Anmelden",
  "header.merchantProjects": "Business",
  "header.signUp": "Registrieren",
  "header.spectrocoinPro": "Pro",
  "header.wallet": "Wallet",
  "header.withdraw": "Withdraw",
  "modal.euro": "",
  "modal.gbp": "",
  "modal.languages": "",
  "modal.refCurrency": "",
  "modal.usd": "",
  "profileBubble.download_documents": "",
  "profileBubble.linkedCards": "Linked cards",
  "profileBubble.logout": "Logout",
  "profileBubble.notifications": "Notifications",
  "profileBubble.profileInformation": "Profil",
  "profileBubble.referral": "Referral",
  "profileBubble.verification": "Verification",
  "profileBubble.waletApi": "Wallet API",
  "verify.reverification_banner_description": "To continue using our services, please verify your account details.",
  "notifications.markAsRead": "Als gelesen markieren",
  "notifications.newNotifications": "Neue Benachrichtigungen",
  "notifications.thereAreNoNew": "Es liegen keine neuen Benachrichtigungen vor",
  "notifications.viewAll": "Alle Benachrichtigungen anzeigen",
  "profileBubble.addOrSwitch": "Profile hinzufügen oder wechseln",
  "profileBubble.back": "",
  "profileBubble.companyProfile": "",
  "profileBubble.personalProfile": "",
  "profileBubble.settings": "",
  "profileBubble.x_personal": ""
}, tb = {
  "base.account": "Account",
  "base.bitcoinExchange": "Pro",
  "base.verify_now": "Verify now",
  "header.business": "Business",
  "header.buyAndSell": "Exchange",
  "header.card": "Card",
  "header.cards": "Card",
  "header.deposit": "Deposit",
  "header.ecosystem": "Ecosystem",
  "header.exchange": "Exchange",
  "header.loans": "Loans",
  "header.logIn": "Log in",
  "header.merchantProjects": "Business",
  "header.signUp": "Sign up",
  "header.spectrocoinPro": "Pro",
  "header.wallet": "Wallet",
  "header.withdraw": "Withdraw",
  "modal.euro": "Euro",
  "modal.gbp": "British Pound",
  "modal.languages": "Language",
  "modal.refCurrency": "Reference currency",
  "modal.usd": "United States Dollar",
  "profileBubble.download_documents": "Download documents",
  "profileBubble.linkedCards": "Linked cards",
  "profileBubble.logout": "Logout",
  "profileBubble.notifications": "Notifications",
  "profileBubble.profileInformation": "Profile",
  "profileBubble.referral": "Referral",
  "profileBubble.verification": "Verification",
  "profileBubble.waletApi": "Wallet API",
  "verify.reverification_banner_description": "To continue using our services, please verify your account details.",
  "notifications.markAsRead": "Mark as read",
  "notifications.newNotifications": "New notifications",
  "notifications.thereAreNoNew": "There are no new notifications",
  "notifications.viewAll": "View all notifications",
  "profileBubble.addOrSwitch": "Add or switch profiles",
  "profileBubble.back": "",
  "profileBubble.companyProfile": "",
  "profileBubble.personalProfile": "",
  "profileBubble.settings": "",
  "profileBubble.x_personal": ""
}, rb = {
  "base.account": "Cuenta",
  "base.bitcoinExchange": "Pro",
  "base.verify_now": "Verifica ahora",
  "header.business": "Negocios",
  "header.buyAndSell": "Cambiar",
  "header.card": "Tarjeta",
  "header.cards": "Tarjeta",
  "header.deposit": "Depositar",
  "header.ecosystem": "Ecosistema",
  "header.exchange": "Cambiar",
  "header.loans": "Préstamos",
  "header.logIn": "Iniciar sesión",
  "header.merchantProjects": "Negocios",
  "header.signUp": "Registrarse",
  "header.spectrocoinPro": "Pro",
  "header.wallet": "Cartera",
  "header.withdraw": "Retirar",
  "modal.euro": "Euro",
  "modal.gbp": "Libra británica",
  "modal.languages": "Idioma",
  "modal.refCurrency": "Moneda de referencia",
  "modal.usd": "Dólar estadounidense",
  "profileBubble.download_documents": "Descargar documentos",
  "profileBubble.linkedCards": "Tarjetas vinculadas",
  "profileBubble.logout": "Cerrar sesión",
  "profileBubble.notifications": "Notificaciones",
  "profileBubble.profileInformation": "Perfil",
  "profileBubble.referral": "Recomendar",
  "profileBubble.verification": "Verificación",
  "profileBubble.waletApi": "Cartera API",
  "verify.reverification_banner_description": "Para continuar utilizando nuestros servicios, por favor, verifique los detalles de su cuenta.",
  "notifications.markAsRead": "Marcar como leído",
  "notifications.newNotifications": "Nuevas Notificaciones",
  "notifications.thereAreNoNew": "No hay nuevas notificaciones",
  "notifications.viewAll": "Ver todas las notificaciones",
  "profileBubble.addOrSwitch": "Agregar o cambiar perfiles",
  "profileBubble.back": "",
  "profileBubble.companyProfile": "",
  "profileBubble.personalProfile": "",
  "profileBubble.settings": "",
  "profileBubble.x_personal": ""
}, nb = {
  "base.account": "Konto",
  "base.bitcoinExchange": "Pro",
  "base.verify_now": "Tuvasta kohe",
  "header.business": "Äriühingutele",
  "header.buyAndSell": "Vahetus",
  "header.card": "Kaart",
  "header.cards": "Kaardid",
  "header.deposit": "Sissemakse",
  "header.ecosystem": "Ökosüsteem",
  "header.exchange": "Vahetus",
  "header.loans": "Laenud",
  "header.logIn": "Logi sisse",
  "header.merchantProjects": "Äriühingutele",
  "header.signUp": "Registreeru",
  "header.spectrocoinPro": "Pro",
  "header.wallet": "Rahakott",
  "header.withdraw": "Väljamakse",
  "modal.euro": "Euro",
  "modal.gbp": "Suurbritannia nael",
  "modal.languages": "Keel",
  "modal.refCurrency": "Võrdlusvääring",
  "modal.usd": "Ameerika Ühendriikide dollar",
  "profileBubble.download_documents": "Dokumentide allalaadimine",
  "profileBubble.linkedCards": "Seotud kaardid",
  "profileBubble.logout": "Logi välja",
  "profileBubble.notifications": "Teated",
  "profileBubble.profileInformation": "Profiil",
  "profileBubble.referral": "Soovitusprogramm",
  "profileBubble.verification": "Tuvastus",
  "profileBubble.waletApi": "Rahakoti API",
  "verify.reverification_banner_description": "Meie teenuste kasutamise jätkamiseks kinnita oma konto andmed.",
  "notifications.markAsRead": "Märgi loetuks",
  "notifications.newNotifications": "Uued teated",
  "notifications.thereAreNoNew": "Uusi teateid pole",
  "notifications.viewAll": "Kuva kõik teatised",
  "profileBubble.addOrSwitch": "Lisage või vahetage profiile",
  "profileBubble.back": "",
  "profileBubble.companyProfile": "",
  "profileBubble.personalProfile": "",
  "profileBubble.settings": "",
  "profileBubble.x_personal": ""
}, ab = {
  "base.account": "Compte",
  "base.bitcoinExchange": "Pro",
  "base.verify_now": "Vérifier maintenant",
  "header.business": "Business",
  "header.buyAndSell": "Échange",
  "header.card": "Carte",
  "header.cards": "Carte",
  "header.deposit": "Dépôt",
  "header.ecosystem": "Écosystème",
  "header.exchange": "Échange",
  "header.loans": "Prêts",
  "header.logIn": "Connexion",
  "header.merchantProjects": "Business",
  "header.signUp": "S'inscrire",
  "header.spectrocoinPro": "Pro",
  "header.wallet": "Portefeuille",
  "header.withdraw": "Retrait",
  "modal.euro": "Euro",
  "modal.gbp": "Livre sterling",
  "modal.languages": "Language",
  "modal.refCurrency": "Devise de référence",
  "modal.usd": "Dollar américain",
  "profileBubble.download_documents": "Télécharger les documents",
  "profileBubble.linkedCards": "Cartes liées",
  "profileBubble.logout": "Déconnexion",
  "profileBubble.notifications": "Notifications",
  "profileBubble.profileInformation": "Profil",
  "profileBubble.referral": "Parrainage",
  "profileBubble.verification": "Vérification",
  "profileBubble.waletApi": "Portefeuille API ",
  "verify.reverification_banner_description": "Pour continuer à utiliser nos services,  veuillez vérifier les détails de votre compte. ",
  "notifications.markAsRead": "Marquer comme lu",
  "notifications.newNotifications": "Nouvelles notifications",
  "notifications.thereAreNoNew": "Il n'y a pas de nouvelles notifications",
  "notifications.viewAll": "Afficher toutes les notifications",
  "profileBubble.addOrSwitch": "Ajouter ou changer de profil",
  "profileBubble.back": "",
  "profileBubble.companyProfile": "",
  "profileBubble.personalProfile": "",
  "profileBubble.settings": "",
  "profileBubble.x_personal": ""
}, ib = {
  "base.account": "Conto",
  "base.bitcoinExchange": "Pro",
  "base.verify_now": "Verifica ora",
  "header.business": "Business",
  "header.buyAndSell": "Scambio",
  "header.card": "Carta",
  "header.cards": "Carta",
  "header.deposit": "Deposito",
  "header.ecosystem": "Ecosistema",
  "header.exchange": "Scambio",
  "header.loans": "Prestiti",
  "header.logIn": "Accedi",
  "header.merchantProjects": "Business",
  "header.signUp": "Iscriviti",
  "header.spectrocoinPro": "Pro",
  "header.wallet": "Portafoglio",
  "header.withdraw": "Prelievo",
  "modal.euro": "Euro",
  "modal.gbp": "Sterlina Inglese",
  "modal.languages": "Lingua",
  "modal.refCurrency": "Valuta di riferimento",
  "modal.usd": "Dollaro Statunitense",
  "profileBubble.download_documents": "Scarica documenti",
  "profileBubble.linkedCards": "Carte collegate",
  "profileBubble.logout": "Esci",
  "profileBubble.notifications": "Notifiche",
  "profileBubble.profileInformation": "Profilo",
  "profileBubble.referral": "Raccomandazione",
  "profileBubble.verification": "Verifica",
  "profileBubble.waletApi": "API del portafoglio",
  "verify.reverification_banner_description": "Per continuare ad utilizzare i nostri servizi, verifica i dati del tuo conto.",
  "notifications.markAsRead": "Segna come letto",
  "notifications.newNotifications": "Nuove notifiche",
  "notifications.thereAreNoNew": "Non ci sono nuove notifiche",
  "notifications.viewAll": "Visualizza tutte le notifiche",
  "profileBubble.addOrSwitch": "Aggiungi o cambia profili",
  "profileBubble.back": "",
  "profileBubble.companyProfile": "",
  "profileBubble.personalProfile": "",
  "profileBubble.settings": "",
  "profileBubble.x_personal": ""
}, ob = {
  "base.account": "Paskyra",
  "base.bitcoinExchange": "Pro",
  "base.verify_now": "Patvirtinti dabar",
  "header.business": "Verslui",
  "header.buyAndSell": "Keitykla",
  "header.card": "Kortelė",
  "header.cards": "Kortelė",
  "header.deposit": "Įnešti lėšas",
  "header.ecosystem": "Ekosistema",
  "header.exchange": "Keitykla",
  "header.loans": "Paskolos",
  "header.logIn": "Jungtis",
  "header.merchantProjects": "Verslui",
  "header.signUp": "Registruotis",
  "header.spectrocoinPro": "Pro",
  "header.wallet": "Piniginė",
  "header.withdraw": "Išimti lėšas",
  "modal.euro": "Euras",
  "modal.gbp": "Svaras sterlingų",
  "modal.languages": "Kalba",
  "modal.refCurrency": "Referencinė valiuta",
  "modal.usd": "Jungtinių Valstijų doleris",
  "profileBubble.download_documents": "Atsisiųsti dokumentus",
  "profileBubble.linkedCards": "Susietos kortelės",
  "profileBubble.logout": "Atsijungti",
  "profileBubble.notifications": "Pranešimai",
  "profileBubble.profileInformation": "Profilis",
  "profileBubble.referral": "Rekomenduok ir užsidirbk",
  "profileBubble.verification": "Verifikacija",
  "profileBubble.waletApi": "Piniginės API",
  "verify.reverification_banner_description": "Norėdami toliau naudotis mūsų paslaugomis, patvirtinkite paskyros informaciją.",
  "notifications.markAsRead": "Pažymėti kaip perskaitytą",
  "notifications.newNotifications": "Nauji pranešimai",
  "notifications.thereAreNoNew": "Naujų pranešimų nėra",
  "notifications.viewAll": "Peržiūrėti visus pranešimus",
  "profileBubble.addOrSwitch": "Pridėkite arba perjunkite profilį",
  "profileBubble.back": "",
  "profileBubble.companyProfile": "",
  "profileBubble.personalProfile": "",
  "profileBubble.settings": "",
  "profileBubble.x_personal": ""
}, sb = {
  "base.account": "Аккаунт",
  "base.bitcoinExchange": "Pro",
  "base.verify_now": "Верифицировать сейчас",
  "header.business": "Бизнес",
  "header.buyAndSell": "Обмен",
  "header.card": "Карта",
  "header.cards": "Карта",
  "header.deposit": "Внесение",
  "header.ecosystem": "Экосистема",
  "header.exchange": "Обмен",
  "header.loans": "Кредиты",
  "header.logIn": "Войти",
  "header.merchantProjects": "Бизнес",
  "header.signUp": "Регистрация",
  "header.spectrocoinPro": "Pro",
  "header.wallet": "Кошелек",
  "header.withdraw": "Вывод",
  "modal.euro": "Евро",
  "modal.gbp": "Британский фунт",
  "modal.languages": "Язык",
  "modal.refCurrency": "Базовая валюта",
  "modal.usd": "Доллар США",
  "profileBubble.download_documents": "Загрузить документы",
  "profileBubble.linkedCards": "Привязанные карты",
  "profileBubble.logout": "Выйти",
  "profileBubble.notifications": "Уведомления",
  "profileBubble.profileInformation": "Профиль",
  "profileBubble.referral": "Рекомендуй и заработай",
  "profileBubble.verification": "Верификация",
  "profileBubble.waletApi": "API кошелька",
  "verify.reverification_banner_description": "Чтобы продолжить пользоваться нашими услугами, пожалуйста верифицируйте информацию своего аккаунта.",
  "notifications.markAsRead": "Пометить, как прочитанное",
  "notifications.newNotifications": "Новые уведомления",
  "notifications.thereAreNoNew": "Новых уведомлений нет",
  "notifications.viewAll": "Просмотреть все уведомления",
  "profileBubble.addOrSwitch": "Добавить или переключить профили",
  "profileBubble.back": "",
  "profileBubble.companyProfile": "",
  "profileBubble.personalProfile": "",
  "profileBubble.settings": "",
  "profileBubble.x_personal": ""
}, lb = {
  "base.account": "Акаунт",
  "base.bitcoinExchange": "Pro",
  "base.verify_now": "Верифікувати зараз",
  "header.business": "Бізнес",
  "header.buyAndSell": "Обмін",
  "header.card": "Картка",
  "header.cards": "Картка",
  "header.deposit": "Deposit",
  "header.ecosystem": "Екосистема",
  "header.exchange": "Обмін",
  "header.loans": "Кредити",
  "header.logIn": "Увійти",
  "header.merchantProjects": "Бізнес",
  "header.signUp": "Реєстрація",
  "header.spectrocoinPro": "Pro",
  "header.wallet": "Гаманець",
  "header.withdraw": "Withdraw",
  "modal.euro": "Євро",
  "modal.gbp": "Британський фунт",
  "modal.languages": "Мова",
  "modal.refCurrency": "Основна валюта",
  "modal.usd": "Долар США",
  "profileBubble.download_documents": "Завантажити документи",
  "profileBubble.linkedCards": "Linked cards",
  "profileBubble.logout": "Logout",
  "profileBubble.notifications": "Notifications",
  "profileBubble.profileInformation": "Профіль",
  "profileBubble.referral": "Referral",
  "profileBubble.verification": "Verification",
  "profileBubble.waletApi": "Wallet API",
  "verify.reverification_banner_description": "To continue using our services, please verify your account details.",
  "notifications.markAsRead": "Відзначити як прочитане",
  "notifications.newNotifications": "Нові повідомлення",
  "notifications.thereAreNoNew": "Немає нових сповіщень",
  "notifications.viewAll": "Переглянути всі сповіщення",
  "profileBubble.addOrSwitch": "Додайте або переключіть профілі",
  "profileBubble.back": "",
  "profileBubble.companyProfile": "",
  "profileBubble.personalProfile": "",
  "profileBubble.settings": "",
  "profileBubble.x_personal": ""
}, ub = {
  "base.account": "",
  "base.bitcoinExchange": "",
  "header.business": "",
  "header.buyAndSell": "",
  "header.card": "",
  "header.ecosystem": "",
  "header.logIn": "",
  "header.signUp": "",
  "base.verify_now": "",
  "header.cards": "",
  "header.deposit": "",
  "header.exchange": "",
  "header.loans": "",
  "header.merchantProjects": "",
  "header.spectrocoinPro": "",
  "header.wallet": "",
  "header.withdraw": "",
  "profileBubble.download_documents": "",
  "profileBubble.linkedCards": "",
  "profileBubble.logout": "",
  "profileBubble.notifications": "",
  "profileBubble.profileInformation": "",
  "profileBubble.referral": "",
  "profileBubble.verification": "",
  "profileBubble.waletApi": "",
  "verify.reverification_banner_description": ""
}, Hs = {
  ar: Qg,
  de: eb,
  en: tb,
  "es-ES": rb,
  et: nb,
  fr: ab,
  it: ib,
  lt: ob,
  ru: sb,
  uk: lb,
  "zh-TW": ub
}, cb = {
  "routes.bitcoinWallet": "محفظة-بيتكوين",
  "routes.business": "اقبل-الدفع-ببيتكوين",
  "routes.buyBitcoin": "شراء-العملة-المشفرة",
  "routes.card": "بطاقة-الدفع",
  "routes.loans": "قروض-crypto"
}, fb = {
  "routes.bitcoinWallet": "bitcoin-wallet",
  "routes.business": "accept-bitcoin-payments",
  "routes.buyBitcoin": "buy-crypto",
  "routes.card": "bitcoin-debit-card",
  "routes.loans": "crypto-loans"
}, db = {
  "routes.bitcoinWallet": "bitcoin-wallet",
  "routes.business": "accept-bitcoin-payments",
  "routes.buyBitcoin": "buy-crypto",
  "routes.card": "bitcoin-debit-card",
  "routes.loans": "crypto-loans"
}, mb = {
  "routes.bitcoinWallet": "cartera-bitcoin",
  "routes.business": "aceptar-pagos-bitcoin",
  "routes.buyBitcoin": "comprar-cripto",
  "routes.card": "tarjeta-de-debito-bitcoin",
  "routes.loans": "prestamos-cripto"
}, hb = {
  "routes.bitcoinWallet": "bitcoin-rahakott",
  "routes.business": "bitcoin-maksete-aktsepteerimine",
  "routes.buyBitcoin": "osta-kruptot",
  "routes.card": "bitcoini-deebetkaart",
  "routes.loans": "kruptolaenud"
}, pb = {
  "routes.bitcoinWallet": "bitcoin-portefeuille",
  "routes.business": "accepter-bitcoin-paiements",
  "routes.buyBitcoin": "acheter-de-la-crypto",
  "routes.card": "bitcoin-débit-carte",
  "routes.loans": "prets-crypto"
}, vb = {
  "routes.bitcoinWallet": "portafoglio-bitcoin",
  "routes.business": "accetta-pagamenti-bitcoin",
  "routes.buyBitcoin": "compra-crypto",
  "routes.card": "carta-di-debito-bitcoin",
  "routes.loans": "prestiti-cripto"
}, gb = {
  "routes.bitcoinWallet": "bitkoin-pinigine",
  "routes.business": "verslui",
  "routes.buyBitcoin": "pirkti-kripto",
  "routes.card": "bitkoin-kortele",
  "routes.loans": "kriptovaliutu-paskolos"
}, bb = {
  "routes.bitcoinWallet": "биткоин-кошелек",
  "routes.business": "принимать-биткоин-платежи",
  "routes.buyBitcoin": "купить-крипто",
  "routes.card": "биткоин-дебит-карта",
  "routes.loans": "крипто-кредиты"
}, yb = {
  "routes.bitcoinWallet": "bitcoin-гаманець",
  "routes.business": "приймати-платежі-у-біткойнах",
  "routes.buyBitcoin": "купити-крипто",
  "routes.card": "дебетова-картка-bitcoin",
  "routes.loans": "крипто-кредити"
}, _b = {
  "routes.bitcoinWallet": "比特幣錢包",
  "routes.business": "比特幣支付",
  "routes.buyBitcoin": "買比特幣",
  "routes.card": "比特幣金融卡",
  "routes.loans": "加密貨幣借貸"
}, xb = {
  ar: cb,
  de: fb,
  en: db,
  "es-ES": mb,
  et: hb,
  fr: pb,
  it: vb,
  lt: gb,
  ru: bb,
  uk: yb,
  "zh-TW": _b
};
let Ei = {};
for (const e in Hs) {
  const t = { ...xb[e], ...Hs[e] };
  Ei = {
    ...Ei,
    [e]: {
      ...t
    }
  };
}
const Cb = ({
  activeLanguage: e,
  history: t,
  user: r,
  cardLink: n,
  isAuthenticated: a,
  origin: i,
  logout: o,
  config: s,
  changeLang: l,
  changeRefCurr: u,
  currentRefCurr: c,
  isPageNavigationVisible: d,
  isLangSwitcherVisible: m,
  notifications: x,
  accounts: E,
  currentAccount: P,
  setAccount: w,
  addAccount: b,
  twoFaType: p
}) => /* @__PURE__ */ f.jsx(zf, { locale: e, messages: Ei[e], children: /* @__PURE__ */ f.jsx(
  Jg,
  {
    accounts: E,
    activeLanguage: e,
    history: t,
    user: r,
    currentRefCurr: c,
    cardLink: n,
    isAuthenticated: a,
    origin: i,
    logout: o,
    config: s,
    changeLang: l,
    isPageNavigationVisible: d,
    isLangSwitcherVisible: m,
    changeRefCurr: u,
    notifications: x,
    currentAccount: P,
    setAccount: w,
    addAccount: b,
    twoFaType: p
  }
) });
export {
  Cb as Header
};
